var Sf = Object.defineProperty;
var yf = (e, t, r) => t in e ? Sf(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var vn = (e, t, r) => yf(e, typeof t != "symbol" ? t + "" : t, r);
class Cf extends Error {
  constructor(r, a, n) {
    super(`${r} ${a}${n ? `: ${n}` : ""}`);
    vn(this, "status");
    this.status = r, this.name = "ApiError";
  }
}
class yk {
  constructor(t) {
    vn(this, "config");
    this.config = t;
  }
  async headers() {
    const t = {
      "Content-Type": "application/json"
    }, r = await this.config.getAccessToken();
    return r && (t.Authorization = `Bearer ${r}`), t;
  }
  async request(t, r, a) {
    var i, s;
    const n = await fetch(`${this.config.baseUrl}${r}`, {
      method: t,
      headers: await this.headers(),
      body: a ? JSON.stringify(a) : void 0
    });
    if (!n.ok) {
      const c = await n.text().catch(() => {
      }), f = new Cf(n.status, n.statusText, c);
      throw (s = (i = this.config).onError) == null || s.call(i, f), f;
    }
    if (n.status !== 204)
      return n.json();
  }
  get(t, r) {
    const a = r ? `?${new URLSearchParams(r).toString()}` : "";
    return this.request("GET", `${t}${a}`);
  }
  post(t, r) {
    return this.request("POST", t, r);
  }
  put(t, r) {
    return this.request("PUT", t, r);
  }
  delete(t) {
    return this.request("DELETE", t);
  }
}
function Of(e) {
  return {
    id: e._id,
    userId: e.userId,
    inForCtp: e.inForCtp,
    inForAce: e.inForAce,
    score: e.score ?? void 0,
    incomingTagId: e.incomingTagId,
    outgoingTagId: e.outgoingTagId ?? void 0
  };
}
function ya(e) {
  return {
    id: e._id,
    seasonId: e.seasonId,
    created: new Date(e.created),
    completed: e.completed ? new Date(e.completed) : void 0,
    name: e.name,
    notes: e.notes ?? void 0,
    players: e.players.map(Of),
    ctpStartingBalance: e.ctpStartingBalance,
    aceStartingBalance: e.aceStartingBalance,
    ctpPerPlayer: e.ctpPerPlayer,
    acePerPlayer: e.acePerPlayer,
    ctpUserIds: e.ctpUserIds,
    aceUserIds: e.aceUserIds,
    ctpHole: e.ctpHole ?? void 0
  };
}
function Cn(e) {
  return {
    id: e._id,
    name: e.name,
    udiscId: e.udiscId,
    pdgaNumber: e.pdgaNumber,
    imageUrl: e.imageUrl,
    isAdmin: !1,
    isAuthorized: !1,
    isReadonly: !1,
    seasons: []
  };
}
function y0(e) {
  return {
    ...Cn(e),
    seasonId: e.seasonId,
    tagId: e.tagId,
    entryPaid: e.entryPaid
  };
}
function If(e) {
  return {
    id: e._id,
    courseId: e.courseId,
    name: e.name,
    start: new Date(e.start),
    end: e.end ? new Date(e.end) : void 0,
    password: e.password,
    ctpPerPlayer: e.ctpInPennies,
    acePerPlayer: e.aceInPennies,
    course: {
      id: e.course._id,
      name: e.course.name,
      udiscId: e.course.udiscId,
      holeCount: e.course.holeCount
    }
  };
}
function gn(e) {
  return {
    accessToken: e.accessToken,
    refreshToken: e.refreshToken,
    id: e._id ?? "",
    name: e.name ?? "",
    phoneNumber: e.phoneNumber,
    udiscId: e.udiscId,
    pdgaNumber: e.pdgaNumber,
    imageUrl: e.imageUrl,
    isAdmin: e.isAdmin ?? !1,
    isAuthorized: e.isAuthorized ?? !1,
    isReadonly: e.isReadonly ?? !1,
    seasons: e.seasons.map(If)
  };
}
function Ck(e, t) {
  if (!e)
    return 1;
  const r = e + 1;
  return r > ((t == null ? void 0 : t.course.holeCount) ?? 18) ? 1 : r;
}
function Ok(e) {
  return {
    sendCode(t) {
      return e.post("/auth/send-code", { phoneNumber: t });
    },
    verifyCode(t, r) {
      return e.post("/auth/verify-code", { phoneNumber: t, code: r }).then(gn);
    },
    refresh() {
      return e.post("/auth/refresh").then(gn);
    },
    exchange(t) {
      return e.post("/auth/exchange", { refreshToken: t }).then(gn);
    },
    verifyRecaptcha(t, r) {
      return e.post("/recaptcha/verify", { recaptchaToken: t, key: r });
    }
  };
}
function Ik(e) {
  function t(r) {
    if (typeof r == "string")
      return t([r]);
    const a = r != null && r.length ? { seasonIds: r.join(",") } : void 0;
    return e.get("/events", a).then((n) => n.map(ya));
  }
  return {
    getById(r) {
      return e.get(`/events/${r}`).then(ya);
    },
    getNext(r) {
      const a = r != null && r.length ? { seasonIds: r.join(",") } : void 0;
      return e.get("/events/next", a).then(ya);
    },
    getLast(r) {
      const a = r != null && r.length ? { seasonIds: r.join(",") } : void 0;
      return e.get("/events/last", a).then(ya);
    },
    getList: t,
    create(r) {
      return e.post("/events", r);
    },
    update(r, a) {
      return e.put(`/events/${r}`, a);
    },
    complete(r, a) {
      return e.put(`/events/${r}/complete`, a);
    },
    uncomplete(r) {
      return e.put(`/events/${r}/uncomplete`);
    },
    remove(r) {
      return e.delete(`/events/${r}`);
    }
  };
}
function Dk(e) {
  var r;
  return (r = e.ctpUserIds) != null && r.length ? 0 : Df(e);
}
function Df(e) {
  return (e.players ?? []).reduce((r, { inForCtp: a }) => a ? r + (e.ctpPerPlayer ?? 0) : r, e.ctpStartingBalance ?? 0);
}
function Rk(e) {
  var r;
  return (r = e.aceUserIds) != null && r.length ? 0 : Rf(e);
}
function Rf(e) {
  return (e.players ?? []).reduce((r, { inForAce: a }) => a ? r + (e.acePerPlayer ?? 0) : r, e.aceStartingBalance ?? 0);
}
function Nk(e) {
  return !e.completed;
}
function bk(e, t) {
  return Math.floor(e / t);
}
function Pk(e) {
  return {
    name: e.name,
    notes: e.notes ?? void 0,
    players: e.players,
    ctpUserIds: e.ctpUserIds,
    aceUserIds: e.aceUserIds,
    ctpPerPlayer: e.ctpPerPlayer / 100,
    acePerPlayer: e.acePerPlayer / 100,
    ctpStartingBalance: e.ctpStartingBalance / 100,
    aceStartingBalance: e.aceStartingBalance / 100,
    ctpHole: e.ctpHole
  };
}
function Lk(e) {
  return {
    authenticate() {
      return e.get("/imagekit/auth");
    }
  };
}
function Mk(e) {
  return {
    getById(t) {
      return e.get(`/users/${t}`).then(Cn);
    },
    getList(t) {
      const r = t != null && t.length ? { seasonIds: t.join(",") } : void 0;
      return e.get("/users", r).then((a) => a.map(Cn));
    },
    getSeasonsForUser() {
      return e.get("/users/seasons").then((t) => t.map(y0));
    },
    getUsersInSeason(t) {
      return e.get(`/users/seasons/${t}`).then((r) => r.map(y0));
    },
    create(t) {
      return e.post("/users", t);
    },
    update(t, r) {
      return e.put(`/users/${t}`, r);
    },
    remove(t) {
      return e.delete(`/users/${t}`);
    },
    checkin(t, r) {
      return e.put(`/users/${t}/checkin`, r);
    },
    signup(t) {
      return e.post("/users/signup", t);
    }
  };
}
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var es = 1252, Nf = [874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1e4], Hn = {
  /*::[*/
  0: 1252,
  /* ANSI */
  /*::[*/
  1: 65001,
  /* DEFAULT */
  /*::[*/
  2: 65001,
  /* SYMBOL */
  /*::[*/
  77: 1e4,
  /* MAC */
  /*::[*/
  128: 932,
  /* SHIFTJIS */
  /*::[*/
  129: 949,
  /* HANGUL */
  /*::[*/
  130: 1361,
  /* JOHAB */
  /*::[*/
  134: 936,
  /* GB2312 */
  /*::[*/
  136: 950,
  /* CHINESEBIG5 */
  /*::[*/
  161: 1253,
  /* GREEK */
  /*::[*/
  162: 1254,
  /* TURKISH */
  /*::[*/
  163: 1258,
  /* VIETNAMESE */
  /*::[*/
  177: 1255,
  /* HEBREW */
  /*::[*/
  178: 1256,
  /* ARABIC */
  /*::[*/
  186: 1257,
  /* BALTIC */
  /*::[*/
  204: 1251,
  /* RUSSIAN */
  /*::[*/
  222: 874,
  /* THAI */
  /*::[*/
  238: 1250,
  /* EASTEUROPE */
  /*::[*/
  255: 1252,
  /* OEM */
  /*::[*/
  69: 6969
  /* MISC */
}, Wn = function(e) {
  Nf.indexOf(e) != -1 && (es = Hn[0] = e);
};
function bf() {
  Wn(1252);
}
var Nr = function(e) {
  Wn(e);
};
function rs() {
  Nr(1200), bf();
}
function C0(e) {
  for (var t = [], r = 0, a = e.length; r < a; ++r) t[r] = e.charCodeAt(r);
  return t;
}
function Pf(e) {
  for (var t = [], r = 0; r < e.length >> 1; ++r) t[r] = String.fromCharCode(e.charCodeAt(2 * r) + (e.charCodeAt(2 * r + 1) << 8));
  return t.join("");
}
function ts(e) {
  for (var t = [], r = 0; r < e.length >> 1; ++r) t[r] = String.fromCharCode(e.charCodeAt(2 * r + 1) + (e.charCodeAt(2 * r) << 8));
  return t.join("");
}
var jt = function(e) {
  var t = e.charCodeAt(0), r = e.charCodeAt(1);
  return t == 255 && r == 254 ? Pf(e.slice(2)) : t == 254 && r == 255 ? ts(e.slice(2)) : t == 65279 ? e.slice(1) : e;
}, Ca = function(t) {
  return String.fromCharCode(t);
}, O0 = function(t) {
  return String.fromCharCode(t);
}, fa, tt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function I0(e) {
  for (var t = "", r = 0, a = 0, n = 0, i = 0, s = 0, c = 0, f = 0, o = 0; o < e.length; )
    r = e.charCodeAt(o++), i = r >> 2, a = e.charCodeAt(o++), s = (r & 3) << 4 | a >> 4, n = e.charCodeAt(o++), c = (a & 15) << 2 | n >> 6, f = n & 63, isNaN(a) ? c = f = 64 : isNaN(n) && (f = 64), t += tt.charAt(i) + tt.charAt(s) + tt.charAt(c) + tt.charAt(f);
  return t;
}
function Er(e) {
  var t = "", r = 0, a = 0, n = 0, i = 0, s = 0, c = 0, f = 0;
  e = e.replace(/[^\w\+\/\=]/g, "");
  for (var o = 0; o < e.length; )
    i = tt.indexOf(e.charAt(o++)), s = tt.indexOf(e.charAt(o++)), r = i << 2 | s >> 4, t += String.fromCharCode(r), c = tt.indexOf(e.charAt(o++)), a = (s & 15) << 4 | c >> 2, c !== 64 && (t += String.fromCharCode(a)), f = tt.indexOf(e.charAt(o++)), n = (c & 3) << 6 | f, f !== 64 && (t += String.fromCharCode(n));
  return t;
}
var _e = /* @__PURE__ */ function() {
  return typeof Buffer < "u" && typeof process < "u" && typeof process.versions < "u" && !!process.versions.node;
}(), Et = /* @__PURE__ */ function() {
  if (typeof Buffer < "u") {
    var e = !Buffer.from;
    if (!e) try {
      Buffer.from("foo", "utf8");
    } catch {
      e = !0;
    }
    return e ? function(t, r) {
      return r ? new Buffer(t, r) : new Buffer(t);
    } : Buffer.from.bind(Buffer);
  }
  return function() {
  };
}();
function it(e) {
  return _e ? Buffer.alloc ? Buffer.alloc(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
function D0(e) {
  return _e ? Buffer.allocUnsafe ? Buffer.allocUnsafe(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
var Rr = function(t) {
  return _e ? Et(t, "binary") : t.split("").map(function(r) {
    return r.charCodeAt(0) & 255;
  });
};
function Tt(e) {
  if (Array.isArray(e)) return e.map(function(a) {
    return String.fromCharCode(a);
  }).join("");
  for (var t = [], r = 0; r < e.length; ++r) t[r] = String.fromCharCode(e[r]);
  return t.join("");
}
function Zn(e) {
  if (typeof ArrayBuffer > "u") throw new Error("Unsupported");
  if (e instanceof ArrayBuffer) return Zn(new Uint8Array(e));
  for (var t = new Array(e.length), r = 0; r < e.length; ++r) t[r] = e[r];
  return t;
}
var rt = _e ? function(e) {
  return Buffer.concat(e.map(function(t) {
    return Buffer.isBuffer(t) ? t : Et(t);
  }));
} : function(e) {
  if (typeof Uint8Array < "u") {
    var t = 0, r = 0;
    for (t = 0; t < e.length; ++t) r += e[t].length;
    var a = new Uint8Array(r), n = 0;
    for (t = 0, r = 0; t < e.length; r += n, ++t)
      if (n = e[t].length, e[t] instanceof Uint8Array) a.set(e[t], r);
      else {
        if (typeof e[t] == "string")
          throw "wtf";
        a.set(new Uint8Array(e[t]), r);
      }
    return a;
  }
  return [].concat.apply([], e.map(function(i) {
    return Array.isArray(i) ? i : [].slice.call(i);
  }));
};
function Lf(e) {
  for (var t = [], r = 0, a = e.length + 250, n = it(e.length + 255), i = 0; i < e.length; ++i) {
    var s = e.charCodeAt(i);
    if (s < 128) n[r++] = s;
    else if (s < 2048)
      n[r++] = 192 | s >> 6 & 31, n[r++] = 128 | s & 63;
    else if (s >= 55296 && s < 57344) {
      s = (s & 1023) + 64;
      var c = e.charCodeAt(++i) & 1023;
      n[r++] = 240 | s >> 8 & 7, n[r++] = 128 | s >> 2 & 63, n[r++] = 128 | c >> 6 & 15 | (s & 3) << 4, n[r++] = 128 | c & 63;
    } else
      n[r++] = 224 | s >> 12 & 15, n[r++] = 128 | s >> 6 & 63, n[r++] = 128 | s & 63;
    r > a && (t.push(n.slice(0, r)), r = 0, n = it(65535), a = 65530);
  }
  return t.push(n.slice(0, r)), rt(t);
}
var dr = /\u0000/g, Xt = /[\u0001-\u0006]/g;
function Rt(e) {
  for (var t = "", r = e.length - 1; r >= 0; ) t += e.charAt(r--);
  return t;
}
function br(e, t) {
  var r = "" + e;
  return r.length >= t ? r : be("0", t - r.length) + r;
}
function Gn(e, t) {
  var r = "" + e;
  return r.length >= t ? r : be(" ", t - r.length) + r;
}
function Wa(e, t) {
  var r = "" + e;
  return r.length >= t ? r : r + be(" ", t - r.length);
}
function Mf(e, t) {
  var r = "" + Math.round(e);
  return r.length >= t ? r : be("0", t - r.length) + r;
}
function Bf(e, t) {
  var r = "" + e;
  return r.length >= t ? r : be("0", t - r.length) + r;
}
var R0 = /* @__PURE__ */ Math.pow(2, 32);
function Ct(e, t) {
  if (e > R0 || e < -R0) return Mf(e, t);
  var r = Math.round(e);
  return Bf(r, t);
}
function Za(e, t) {
  return t = t || 0, e.length >= 7 + t && (e.charCodeAt(t) | 32) === 103 && (e.charCodeAt(t + 1) | 32) === 101 && (e.charCodeAt(t + 2) | 32) === 110 && (e.charCodeAt(t + 3) | 32) === 101 && (e.charCodeAt(t + 4) | 32) === 114 && (e.charCodeAt(t + 5) | 32) === 97 && (e.charCodeAt(t + 6) | 32) === 108;
}
var N0 = [
  ["Sun", "Sunday"],
  ["Mon", "Monday"],
  ["Tue", "Tuesday"],
  ["Wed", "Wednesday"],
  ["Thu", "Thursday"],
  ["Fri", "Friday"],
  ["Sat", "Saturday"]
], mn = [
  ["J", "Jan", "January"],
  ["F", "Feb", "February"],
  ["M", "Mar", "March"],
  ["A", "Apr", "April"],
  ["M", "May", "May"],
  ["J", "Jun", "June"],
  ["J", "Jul", "July"],
  ["A", "Aug", "August"],
  ["S", "Sep", "September"],
  ["O", "Oct", "October"],
  ["N", "Nov", "November"],
  ["D", "Dec", "December"]
];
function Uf(e) {
  return e || (e = {}), e[0] = "General", e[1] = "0", e[2] = "0.00", e[3] = "#,##0", e[4] = "#,##0.00", e[9] = "0%", e[10] = "0.00%", e[11] = "0.00E+00", e[12] = "# ?/?", e[13] = "# ??/??", e[14] = "m/d/yy", e[15] = "d-mmm-yy", e[16] = "d-mmm", e[17] = "mmm-yy", e[18] = "h:mm AM/PM", e[19] = "h:mm:ss AM/PM", e[20] = "h:mm", e[21] = "h:mm:ss", e[22] = "m/d/yy h:mm", e[37] = "#,##0 ;(#,##0)", e[38] = "#,##0 ;[Red](#,##0)", e[39] = "#,##0.00;(#,##0.00)", e[40] = "#,##0.00;[Red](#,##0.00)", e[45] = "mm:ss", e[46] = "[h]:mm:ss", e[47] = "mmss.0", e[48] = "##0.0E+0", e[49] = "@", e[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "', e;
}
var ve = {
  0: "General",
  1: "0",
  2: "0.00",
  3: "#,##0",
  4: "#,##0.00",
  9: "0%",
  10: "0.00%",
  11: "0.00E+00",
  12: "# ?/?",
  13: "# ??/??",
  14: "m/d/yy",
  15: "d-mmm-yy",
  16: "d-mmm",
  17: "mmm-yy",
  18: "h:mm AM/PM",
  19: "h:mm:ss AM/PM",
  20: "h:mm",
  21: "h:mm:ss",
  22: "m/d/yy h:mm",
  37: "#,##0 ;(#,##0)",
  38: "#,##0 ;[Red](#,##0)",
  39: "#,##0.00;(#,##0.00)",
  40: "#,##0.00;[Red](#,##0.00)",
  45: "mm:ss",
  46: "[h]:mm:ss",
  47: "mmss.0",
  48: "##0.0E+0",
  49: "@",
  56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
}, b0 = {
  5: 37,
  6: 38,
  7: 39,
  8: 40,
  //  5 -> 37 ...  8 -> 40
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  // 23 ->  0 ... 26 ->  0
  27: 14,
  28: 14,
  29: 14,
  30: 14,
  31: 14,
  // 27 -> 14 ... 31 -> 14
  50: 14,
  51: 14,
  52: 14,
  53: 14,
  54: 14,
  // 50 -> 14 ... 58 -> 14
  55: 14,
  56: 14,
  57: 14,
  58: 14,
  59: 1,
  60: 2,
  61: 3,
  62: 4,
  // 59 ->  1 ... 62 ->  4
  67: 9,
  68: 10,
  // 67 ->  9 ... 68 -> 10
  69: 12,
  70: 13,
  71: 14,
  // 69 -> 12 ... 71 -> 14
  72: 14,
  73: 15,
  74: 16,
  75: 17,
  // 72 -> 14 ... 75 -> 17
  76: 20,
  77: 21,
  78: 22,
  // 76 -> 20 ... 78 -> 22
  79: 45,
  80: 46,
  81: 47,
  // 79 -> 45 ... 81 -> 47
  82: 0
  // 82 ->  0 ... 65536 -> 0 (omitted)
}, zf = {
  //  5 -- Currency,   0 decimal, black negative
  5: '"$"#,##0_);\\("$"#,##0\\)',
  63: '"$"#,##0_);\\("$"#,##0\\)',
  //  6 -- Currency,   0 decimal, red   negative
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  //  7 -- Currency,   2 decimal, black negative
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  //  8 -- Currency,   2 decimal, red   negative
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  // 41 -- Accounting, 0 decimal, No Symbol
  41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
  // 42 -- Accounting, 0 decimal, $  Symbol
  42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
  // 43 -- Accounting, 2 decimal, No Symbol
  43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
  // 44 -- Accounting, 2 decimal, $  Symbol
  44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function Ga(e, t, r) {
  for (var a = e < 0 ? -1 : 1, n = e * a, i = 0, s = 1, c = 0, f = 1, o = 0, u = 0, l = Math.floor(n); o < t && (l = Math.floor(n), c = l * s + i, u = l * o + f, !(n - l < 5e-8)); )
    n = 1 / (n - l), i = s, s = c, f = o, o = u;
  if (u > t && (o > t ? (u = f, c = i) : (u = o, c = s)), !r) return [0, a * c, u];
  var h = Math.floor(a * c / u);
  return [h, a * c - h * u, u];
}
function xt(e, t, r) {
  if (e > 2958465 || e < 0) return null;
  var a = e | 0, n = Math.floor(86400 * (e - a)), i = 0, s = [], c = { D: a, T: n, u: 86400 * (e - a) - n, y: 0, m: 0, d: 0, H: 0, M: 0, S: 0, q: 0 };
  if (Math.abs(c.u) < 1e-6 && (c.u = 0), t && t.date1904 && (a += 1462), c.u > 0.9999 && (c.u = 0, ++n == 86400 && (c.T = n = 0, ++a, ++c.D)), a === 60)
    s = r ? [1317, 10, 29] : [1900, 2, 29], i = 3;
  else if (a === 0)
    s = r ? [1317, 8, 29] : [1900, 1, 0], i = 6;
  else {
    a > 60 && --a;
    var f = new Date(1900, 0, 1);
    f.setDate(f.getDate() + a - 1), s = [f.getFullYear(), f.getMonth() + 1, f.getDate()], i = f.getDay(), a < 60 && (i = (i + 6) % 7), r && (i = Gf(f, s));
  }
  return c.y = s[0], c.m = s[1], c.d = s[2], c.S = n % 60, n = Math.floor(n / 60), c.M = n % 60, n = Math.floor(n / 60), c.H = n, c.q = i, c;
}
var as = /* @__PURE__ */ new Date(1899, 11, 31, 0, 0, 0), $f = /* @__PURE__ */ as.getTime(), Vf = /* @__PURE__ */ new Date(1900, 2, 1, 0, 0, 0);
function ns(e, t) {
  var r = /* @__PURE__ */ e.getTime();
  return t ? r -= 1461 * 24 * 60 * 60 * 1e3 : e >= Vf && (r += 24 * 60 * 60 * 1e3), (r - ($f + (/* @__PURE__ */ e.getTimezoneOffset() - /* @__PURE__ */ as.getTimezoneOffset()) * 6e4)) / (24 * 60 * 60 * 1e3);
}
function jn(e) {
  return e.indexOf(".") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
function Hf(e) {
  return e.indexOf("E") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
function Wf(e) {
  var t = e < 0 ? 12 : 11, r = jn(e.toFixed(12));
  return r.length <= t || (r = e.toPrecision(10), r.length <= t) ? r : e.toExponential(5);
}
function Zf(e) {
  var t = jn(e.toFixed(11));
  return t.length > (e < 0 ? 12 : 11) || t === "0" || t === "-0" ? e.toPrecision(6) : t;
}
function oa(e) {
  var t = Math.floor(Math.log(Math.abs(e)) * Math.LOG10E), r;
  return t >= -4 && t <= -1 ? r = e.toPrecision(10 + t) : Math.abs(t) <= 9 ? r = Wf(e) : t === 10 ? r = e.toFixed(10).substr(0, 12) : r = Zf(e), jn(Hf(r.toUpperCase()));
}
function vt(e, t) {
  switch (typeof e) {
    case "string":
      return e;
    case "boolean":
      return e ? "TRUE" : "FALSE";
    case "number":
      return (e | 0) === e ? e.toString(10) : oa(e);
    case "undefined":
      return "";
    case "object":
      if (e == null) return "";
      if (e instanceof Date) return yr(14, ns(e, t && t.date1904), t);
  }
  throw new Error("unsupported value in General format: " + e);
}
function Gf(e, t) {
  t[0] -= 581;
  var r = e.getDay();
  return e < 60 && (r = (r + 6) % 7), r;
}
function jf(e, t, r, a) {
  var n = "", i = 0, s = 0, c = r.y, f, o = 0;
  switch (e) {
    case 98:
      c = r.y + 543;
    case 121:
      switch (t.length) {
        case 1:
        case 2:
          f = c % 100, o = 2;
          break;
        default:
          f = c % 1e4, o = 4;
          break;
      }
      break;
    case 109:
      switch (t.length) {
        case 1:
        case 2:
          f = r.m, o = t.length;
          break;
        case 3:
          return mn[r.m - 1][1];
        case 5:
          return mn[r.m - 1][0];
        default:
          return mn[r.m - 1][2];
      }
      break;
    case 100:
      switch (t.length) {
        case 1:
        case 2:
          f = r.d, o = t.length;
          break;
        case 3:
          return N0[r.q][0];
        default:
          return N0[r.q][1];
      }
      break;
    case 104:
      switch (t.length) {
        case 1:
        case 2:
          f = 1 + (r.H + 11) % 12, o = t.length;
          break;
        default:
          throw "bad hour format: " + t;
      }
      break;
    case 72:
      switch (t.length) {
        case 1:
        case 2:
          f = r.H, o = t.length;
          break;
        default:
          throw "bad hour format: " + t;
      }
      break;
    case 77:
      switch (t.length) {
        case 1:
        case 2:
          f = r.M, o = t.length;
          break;
        default:
          throw "bad minute format: " + t;
      }
      break;
    case 115:
      if (t != "s" && t != "ss" && t != ".0" && t != ".00" && t != ".000") throw "bad second format: " + t;
      return r.u === 0 && (t == "s" || t == "ss") ? br(r.S, t.length) : (a >= 2 ? s = a === 3 ? 1e3 : 100 : s = a === 1 ? 10 : 1, i = Math.round(s * (r.S + r.u)), i >= 60 * s && (i = 0), t === "s" ? i === 0 ? "0" : "" + i / s : (n = br(i, 2 + a), t === "ss" ? n.substr(0, 2) : "." + n.substr(2, t.length - 1)));
    case 90:
      switch (t) {
        case "[h]":
        case "[hh]":
          f = r.D * 24 + r.H;
          break;
        case "[m]":
        case "[mm]":
          f = (r.D * 24 + r.H) * 60 + r.M;
          break;
        case "[s]":
        case "[ss]":
          f = ((r.D * 24 + r.H) * 60 + r.M) * 60 + Math.round(r.S + r.u);
          break;
        default:
          throw "bad abstime format: " + t;
      }
      o = t.length === 3 ? 1 : 2;
      break;
    case 101:
      f = c, o = 1;
      break;
  }
  var u = o > 0 ? br(f, o) : "";
  return u;
}
function at(e) {
  var t = 3;
  if (e.length <= t) return e;
  for (var r = e.length % t, a = e.substr(0, r); r != e.length; r += t) a += (a.length > 0 ? "," : "") + e.substr(r, t);
  return a;
}
var is = /%/g;
function Xf(e, t, r) {
  var a = t.replace(is, ""), n = t.length - a.length;
  return Xr(e, a, r * Math.pow(10, 2 * n)) + be("%", n);
}
function Kf(e, t, r) {
  for (var a = t.length - 1; t.charCodeAt(a - 1) === 44; ) --a;
  return Xr(e, t.substr(0, a), r / Math.pow(10, 3 * (t.length - a)));
}
function ss(e, t) {
  var r, a = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0) return "0.0E+0";
    if (t < 0) return "-" + ss(e, -t);
    var n = e.indexOf(".");
    n === -1 && (n = e.indexOf("E"));
    var i = Math.floor(Math.log(t) * Math.LOG10E) % n;
    if (i < 0 && (i += n), r = (t / Math.pow(10, i)).toPrecision(a + 1 + (n + i) % n), r.indexOf("e") === -1) {
      var s = Math.floor(Math.log(t) * Math.LOG10E);
      for (r.indexOf(".") === -1 ? r = r.charAt(0) + "." + r.substr(1) + "E+" + (s - r.length + i) : r += "E+" + (s - i); r.substr(0, 2) === "0."; )
        r = r.charAt(0) + r.substr(2, n) + "." + r.substr(2 + n), r = r.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
      r = r.replace(/\+-/, "-");
    }
    r = r.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(c, f, o, u) {
      return f + o + u.substr(0, (n + i) % n) + "." + u.substr(i) + "E";
    });
  } else r = t.toExponential(a);
  return e.match(/E\+00$/) && r.match(/e[+-]\d$/) && (r = r.substr(0, r.length - 1) + "0" + r.charAt(r.length - 1)), e.match(/E\-/) && r.match(/e\+/) && (r = r.replace(/e\+/, "e")), r.replace("e", "E");
}
var cs = /# (\?+)( ?)\/( ?)(\d+)/;
function Yf(e, t, r) {
  var a = parseInt(e[4], 10), n = Math.round(t * a), i = Math.floor(n / a), s = n - i * a, c = a;
  return r + (i === 0 ? "" : "" + i) + " " + (s === 0 ? be(" ", e[1].length + 1 + e[4].length) : Gn(s, e[1].length) + e[2] + "/" + e[3] + br(c, e[4].length));
}
function Jf(e, t, r) {
  return r + (t === 0 ? "" : "" + t) + be(" ", e[1].length + 2 + e[4].length);
}
var fs = /^#*0*\.([0#]+)/, os = /\).*[0#]/, us = /\(###\) ###\\?-####/;
function lr(e) {
  for (var t = "", r, a = 0; a != e.length; ++a) switch (r = e.charCodeAt(a)) {
    case 35:
      break;
    case 63:
      t += " ";
      break;
    case 48:
      t += "0";
      break;
    default:
      t += String.fromCharCode(r);
  }
  return t;
}
function P0(e, t) {
  var r = Math.pow(10, t);
  return "" + Math.round(e * r) / r;
}
function L0(e, t) {
  var r = e - Math.floor(e), a = Math.pow(10, t);
  return t < ("" + Math.round(r * a)).length ? 0 : Math.round(r * a);
}
function qf(e, t) {
  return t < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, t))).length ? 1 : 0;
}
function Qf(e) {
  return e < 2147483647 && e > -2147483648 ? "" + (e >= 0 ? e | 0 : e - 1 | 0) : "" + Math.floor(e);
}
function Fr(e, t, r) {
  if (e.charCodeAt(0) === 40 && !t.match(os)) {
    var a = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return r >= 0 ? Fr("n", a, r) : "(" + Fr("n", a, -r) + ")";
  }
  if (t.charCodeAt(t.length - 1) === 44) return Kf(e, t, r);
  if (t.indexOf("%") !== -1) return Xf(e, t, r);
  if (t.indexOf("E") !== -1) return ss(t, r);
  if (t.charCodeAt(0) === 36) return "$" + Fr(e, t.substr(t.charAt(1) == " " ? 2 : 1), r);
  var n, i, s, c, f = Math.abs(r), o = r < 0 ? "-" : "";
  if (t.match(/^00+$/)) return o + Ct(f, t.length);
  if (t.match(/^[#?]+$/))
    return n = Ct(r, 0), n === "0" && (n = ""), n.length > t.length ? n : lr(t.substr(0, t.length - n.length)) + n;
  if (i = t.match(cs)) return Yf(i, f, o);
  if (t.match(/^#+0+$/)) return o + Ct(f, t.length - t.indexOf("0"));
  if (i = t.match(fs))
    return n = P0(r, i[1].length).replace(/^([^\.]+)$/, "$1." + lr(i[1])).replace(/\.$/, "." + lr(i[1])).replace(/\.(\d*)$/, function(p, x) {
      return "." + x + be("0", lr(
        /*::(*/
        i[1]
      ).length - x.length);
    }), t.indexOf("0.") !== -1 ? n : n.replace(/^0\./, ".");
  if (t = t.replace(/^#+([0.])/, "$1"), i = t.match(/^(0*)\.(#*)$/))
    return o + P0(f, i[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, i[1].length ? "0." : ".");
  if (i = t.match(/^#{1,3},##0(\.?)$/)) return o + at(Ct(f, 0));
  if (i = t.match(/^#,##0\.([#0]*0)$/))
    return r < 0 ? "-" + Fr(e, t, -r) : at("" + (Math.floor(r) + qf(r, i[1].length))) + "." + br(L0(r, i[1].length), i[1].length);
  if (i = t.match(/^#,#*,#0/)) return Fr(e, t.replace(/^#,#*,/, ""), r);
  if (i = t.match(/^([0#]+)(\\?-([0#]+))+$/))
    return n = Rt(Fr(e, t.replace(/[\\-]/g, ""), r)), s = 0, Rt(Rt(t.replace(/\\/g, "")).replace(/[0#]/g, function(p) {
      return s < n.length ? n.charAt(s++) : p === "0" ? "0" : "";
    }));
  if (t.match(us))
    return n = Fr(e, "##########", r), "(" + n.substr(0, 3) + ") " + n.substr(3, 3) + "-" + n.substr(6);
  var u = "";
  if (i = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return s = Math.min(
      /*::String(*/
      i[4].length,
      7
    ), c = Ga(f, Math.pow(10, s) - 1, !1), n = "" + o, u = Xr(
      "n",
      /*::String(*/
      i[1],
      c[1]
    ), u.charAt(u.length - 1) == " " && (u = u.substr(0, u.length - 1) + "0"), n += u + /*::String(*/
    i[2] + "/" + /*::String(*/
    i[3], u = Wa(c[2], s), u.length < i[4].length && (u = lr(i[4].substr(i[4].length - u.length)) + u), n += u, n;
  if (i = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return s = Math.min(Math.max(i[1].length, i[4].length), 7), c = Ga(f, Math.pow(10, s) - 1, !0), o + (c[0] || (c[1] ? "" : "0")) + " " + (c[1] ? Gn(c[1], s) + i[2] + "/" + i[3] + Wa(c[2], s) : be(" ", 2 * s + 1 + i[2].length + i[3].length));
  if (i = t.match(/^[#0?]+$/))
    return n = Ct(r, 0), t.length <= n.length ? n : lr(t.substr(0, t.length - n.length)) + n;
  if (i = t.match(/^([#0?]+)\.([#0]+)$/)) {
    n = "" + r.toFixed(Math.min(i[2].length, 10)).replace(/([^0])0+$/, "$1"), s = n.indexOf(".");
    var l = t.indexOf(".") - s, h = t.length - n.length - l;
    return lr(t.substr(0, l) + n + t.substr(t.length - h));
  }
  if (i = t.match(/^00,000\.([#0]*0)$/))
    return s = L0(r, i[1].length), r < 0 ? "-" + Fr(e, t, -r) : at(Qf(r)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(p) {
      return "00," + (p.length < 3 ? br(0, 3 - p.length) : "") + p;
    }) + "." + br(s, i[1].length);
  switch (t) {
    case "###,##0.00":
      return Fr(e, "#,##0.00", r);
    case "###,###":
    case "##,###":
    case "#,###":
      var d = at(Ct(f, 0));
      return d !== "0" ? o + d : "";
    case "###,###.00":
      return Fr(e, "###,##0.00", r).replace(/^0\./, ".");
    case "#,###.00":
      return Fr(e, "#,##0.00", r).replace(/^0\./, ".");
  }
  throw new Error("unsupported format |" + t + "|");
}
function eo(e, t, r) {
  for (var a = t.length - 1; t.charCodeAt(a - 1) === 44; ) --a;
  return Xr(e, t.substr(0, a), r / Math.pow(10, 3 * (t.length - a)));
}
function ro(e, t, r) {
  var a = t.replace(is, ""), n = t.length - a.length;
  return Xr(e, a, r * Math.pow(10, 2 * n)) + be("%", n);
}
function ls(e, t) {
  var r, a = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0) return "0.0E+0";
    if (t < 0) return "-" + ls(e, -t);
    var n = e.indexOf(".");
    n === -1 && (n = e.indexOf("E"));
    var i = Math.floor(Math.log(t) * Math.LOG10E) % n;
    if (i < 0 && (i += n), r = (t / Math.pow(10, i)).toPrecision(a + 1 + (n + i) % n), !r.match(/[Ee]/)) {
      var s = Math.floor(Math.log(t) * Math.LOG10E);
      r.indexOf(".") === -1 ? r = r.charAt(0) + "." + r.substr(1) + "E+" + (s - r.length + i) : r += "E+" + (s - i), r = r.replace(/\+-/, "-");
    }
    r = r.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(c, f, o, u) {
      return f + o + u.substr(0, (n + i) % n) + "." + u.substr(i) + "E";
    });
  } else r = t.toExponential(a);
  return e.match(/E\+00$/) && r.match(/e[+-]\d$/) && (r = r.substr(0, r.length - 1) + "0" + r.charAt(r.length - 1)), e.match(/E\-/) && r.match(/e\+/) && (r = r.replace(/e\+/, "e")), r.replace("e", "E");
}
function zr(e, t, r) {
  if (e.charCodeAt(0) === 40 && !t.match(os)) {
    var a = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return r >= 0 ? zr("n", a, r) : "(" + zr("n", a, -r) + ")";
  }
  if (t.charCodeAt(t.length - 1) === 44) return eo(e, t, r);
  if (t.indexOf("%") !== -1) return ro(e, t, r);
  if (t.indexOf("E") !== -1) return ls(t, r);
  if (t.charCodeAt(0) === 36) return "$" + zr(e, t.substr(t.charAt(1) == " " ? 2 : 1), r);
  var n, i, s, c, f = Math.abs(r), o = r < 0 ? "-" : "";
  if (t.match(/^00+$/)) return o + br(f, t.length);
  if (t.match(/^[#?]+$/))
    return n = "" + r, r === 0 && (n = ""), n.length > t.length ? n : lr(t.substr(0, t.length - n.length)) + n;
  if (i = t.match(cs)) return Jf(i, f, o);
  if (t.match(/^#+0+$/)) return o + br(f, t.length - t.indexOf("0"));
  if (i = t.match(fs))
    return n = ("" + r).replace(/^([^\.]+)$/, "$1." + lr(i[1])).replace(/\.$/, "." + lr(i[1])), n = n.replace(/\.(\d*)$/, function(p, x) {
      return "." + x + be("0", lr(i[1]).length - x.length);
    }), t.indexOf("0.") !== -1 ? n : n.replace(/^0\./, ".");
  if (t = t.replace(/^#+([0.])/, "$1"), i = t.match(/^(0*)\.(#*)$/))
    return o + ("" + f).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, i[1].length ? "0." : ".");
  if (i = t.match(/^#{1,3},##0(\.?)$/)) return o + at("" + f);
  if (i = t.match(/^#,##0\.([#0]*0)$/))
    return r < 0 ? "-" + zr(e, t, -r) : at("" + r) + "." + be("0", i[1].length);
  if (i = t.match(/^#,#*,#0/)) return zr(e, t.replace(/^#,#*,/, ""), r);
  if (i = t.match(/^([0#]+)(\\?-([0#]+))+$/))
    return n = Rt(zr(e, t.replace(/[\\-]/g, ""), r)), s = 0, Rt(Rt(t.replace(/\\/g, "")).replace(/[0#]/g, function(p) {
      return s < n.length ? n.charAt(s++) : p === "0" ? "0" : "";
    }));
  if (t.match(us))
    return n = zr(e, "##########", r), "(" + n.substr(0, 3) + ") " + n.substr(3, 3) + "-" + n.substr(6);
  var u = "";
  if (i = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return s = Math.min(
      /*::String(*/
      i[4].length,
      7
    ), c = Ga(f, Math.pow(10, s) - 1, !1), n = "" + o, u = Xr(
      "n",
      /*::String(*/
      i[1],
      c[1]
    ), u.charAt(u.length - 1) == " " && (u = u.substr(0, u.length - 1) + "0"), n += u + /*::String(*/
    i[2] + "/" + /*::String(*/
    i[3], u = Wa(c[2], s), u.length < i[4].length && (u = lr(i[4].substr(i[4].length - u.length)) + u), n += u, n;
  if (i = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return s = Math.min(Math.max(i[1].length, i[4].length), 7), c = Ga(f, Math.pow(10, s) - 1, !0), o + (c[0] || (c[1] ? "" : "0")) + " " + (c[1] ? Gn(c[1], s) + i[2] + "/" + i[3] + Wa(c[2], s) : be(" ", 2 * s + 1 + i[2].length + i[3].length));
  if (i = t.match(/^[#0?]+$/))
    return n = "" + r, t.length <= n.length ? n : lr(t.substr(0, t.length - n.length)) + n;
  if (i = t.match(/^([#0]+)\.([#0]+)$/)) {
    n = "" + r.toFixed(Math.min(i[2].length, 10)).replace(/([^0])0+$/, "$1"), s = n.indexOf(".");
    var l = t.indexOf(".") - s, h = t.length - n.length - l;
    return lr(t.substr(0, l) + n + t.substr(t.length - h));
  }
  if (i = t.match(/^00,000\.([#0]*0)$/))
    return r < 0 ? "-" + zr(e, t, -r) : at("" + r).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(p) {
      return "00," + (p.length < 3 ? br(0, 3 - p.length) : "") + p;
    }) + "." + br(0, i[1].length);
  switch (t) {
    case "###,###":
    case "##,###":
    case "#,###":
      var d = at("" + f);
      return d !== "0" ? o + d : "";
    default:
      if (t.match(/\.[0#?]*$/)) return zr(e, t.slice(0, t.lastIndexOf(".")), r) + lr(t.slice(t.lastIndexOf(".")));
  }
  throw new Error("unsupported format |" + t + "|");
}
function Xr(e, t, r) {
  return (r | 0) === r ? zr(e, t, r) : Fr(e, t, r);
}
function to(e) {
  for (var t = [], r = !1, a = 0, n = 0; a < e.length; ++a) switch (
    /*cc=*/
    e.charCodeAt(a)
  ) {
    case 34:
      r = !r;
      break;
    case 95:
    case 42:
    case 92:
      ++a;
      break;
    case 59:
      t[t.length] = e.substr(n, a - n), n = a + 1;
  }
  if (t[t.length] = e.substr(n), r === !0) throw new Error("Format |" + e + "| unterminated string ");
  return t;
}
var hs = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function Bt(e) {
  for (var t = 0, r = "", a = ""; t < e.length; )
    switch (r = e.charAt(t)) {
      case "G":
        Za(e, t) && (t += 6), t++;
        break;
      case '"':
        for (
          ;
          /*cc=*/
          e.charCodeAt(++t) !== 34 && t < e.length;
        )
          ;
        ++t;
        break;
      case "\\":
        t += 2;
        break;
      case "_":
        t += 2;
        break;
      case "@":
        ++t;
        break;
      case "B":
      case "b":
        if (e.charAt(t + 1) === "1" || e.charAt(t + 1) === "2") return !0;
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        return !0;
      case "A":
      case "a":
      case "上":
        if (e.substr(t, 3).toUpperCase() === "A/P" || e.substr(t, 5).toUpperCase() === "AM/PM" || e.substr(t, 5).toUpperCase() === "上午/下午") return !0;
        ++t;
        break;
      case "[":
        for (a = r; e.charAt(t++) !== "]" && t < e.length; ) a += e.charAt(t);
        if (a.match(hs)) return !0;
        break;
      case ".":
      case "0":
      case "#":
        for (; t < e.length && ("0#?.,E+-%".indexOf(r = e.charAt(++t)) > -1 || r == "\\" && e.charAt(t + 1) == "-" && "0#".indexOf(e.charAt(t + 2)) > -1); )
          ;
        break;
      case "?":
        for (; e.charAt(++t) === r; )
          ;
        break;
      case "*":
        ++t, (e.charAt(t) == " " || e.charAt(t) == "*") && ++t;
        break;
      case "(":
      case ")":
        ++t;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (; t < e.length && "0123456789".indexOf(e.charAt(++t)) > -1; )
          ;
        break;
      case " ":
        ++t;
        break;
      default:
        ++t;
        break;
    }
  return !1;
}
function ao(e, t, r, a) {
  for (var n = [], i = "", s = 0, c = "", f = "t", o, u, l, h = "H"; s < e.length; )
    switch (c = e.charAt(s)) {
      case "G":
        if (!Za(e, s)) throw new Error("unrecognized character " + c + " in " + e);
        n[n.length] = { t: "G", v: "General" }, s += 7;
        break;
      case '"':
        for (i = ""; (l = e.charCodeAt(++s)) !== 34 && s < e.length; ) i += String.fromCharCode(l);
        n[n.length] = { t: "t", v: i }, ++s;
        break;
      case "\\":
        var d = e.charAt(++s), p = d === "(" || d === ")" ? d : "t";
        n[n.length] = { t: p, v: d }, ++s;
        break;
      case "_":
        n[n.length] = { t: "t", v: " " }, s += 2;
        break;
      case "@":
        n[n.length] = { t: "T", v: t }, ++s;
        break;
      case "B":
      case "b":
        if (e.charAt(s + 1) === "1" || e.charAt(s + 1) === "2") {
          if (o == null && (o = xt(t, r, e.charAt(s + 1) === "2"), o == null))
            return "";
          n[n.length] = { t: "X", v: e.substr(s, 2) }, f = c, s += 2;
          break;
        }
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
        c = c.toLowerCase();
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        if (t < 0 || o == null && (o = xt(t, r), o == null))
          return "";
        for (i = c; ++s < e.length && e.charAt(s).toLowerCase() === c; ) i += c;
        c === "m" && f.toLowerCase() === "h" && (c = "M"), c === "h" && (c = h), n[n.length] = { t: c, v: i }, f = c;
        break;
      case "A":
      case "a":
      case "上":
        var x = { t: c, v: c };
        if (o == null && (o = xt(t, r)), e.substr(s, 3).toUpperCase() === "A/P" ? (o != null && (x.v = o.H >= 12 ? "P" : "A"), x.t = "T", h = "h", s += 3) : e.substr(s, 5).toUpperCase() === "AM/PM" ? (o != null && (x.v = o.H >= 12 ? "PM" : "AM"), x.t = "T", s += 5, h = "h") : e.substr(s, 5).toUpperCase() === "上午/下午" ? (o != null && (x.v = o.H >= 12 ? "下午" : "上午"), x.t = "T", s += 5, h = "h") : (x.t = "t", ++s), o == null && x.t === "T") return "";
        n[n.length] = x, f = c;
        break;
      case "[":
        for (i = c; e.charAt(s++) !== "]" && s < e.length; ) i += e.charAt(s);
        if (i.slice(-1) !== "]") throw 'unterminated "[" block: |' + i + "|";
        if (i.match(hs)) {
          if (o == null && (o = xt(t, r), o == null))
            return "";
          n[n.length] = { t: "Z", v: i.toLowerCase() }, f = i.charAt(1);
        } else i.indexOf("$") > -1 && (i = (i.match(/\$([^-\[\]]*)/) || [])[1] || "$", Bt(e) || (n[n.length] = { t: "t", v: i }));
        break;
      case ".":
        if (o != null) {
          for (i = c; ++s < e.length && (c = e.charAt(s)) === "0"; ) i += c;
          n[n.length] = { t: "s", v: i };
          break;
        }
      case "0":
      case "#":
        for (i = c; ++s < e.length && "0#?.,E+-%".indexOf(c = e.charAt(s)) > -1; ) i += c;
        n[n.length] = { t: "n", v: i };
        break;
      case "?":
        for (i = c; e.charAt(++s) === c; ) i += c;
        n[n.length] = { t: c, v: i }, f = c;
        break;
      case "*":
        ++s, (e.charAt(s) == " " || e.charAt(s) == "*") && ++s;
        break;
      case "(":
      case ")":
        n[n.length] = { t: a === 1 ? "t" : c, v: c }, ++s;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (i = c; s < e.length && "0123456789".indexOf(e.charAt(++s)) > -1; ) i += e.charAt(s);
        n[n.length] = { t: "D", v: i };
        break;
      case " ":
        n[n.length] = { t: c, v: c }, ++s;
        break;
      case "$":
        n[n.length] = { t: "t", v: "$" }, ++s;
        break;
      default:
        if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error("unrecognized character " + c + " in " + e);
        n[n.length] = { t: "t", v: c }, ++s;
        break;
    }
  var g = 0, F = 0, C;
  for (s = n.length - 1, f = "t"; s >= 0; --s)
    switch (n[s].t) {
      case "h":
      case "H":
        n[s].t = h, f = "h", g < 1 && (g = 1);
        break;
      case "s":
        (C = n[s].v.match(/\.0+$/)) && (F = Math.max(F, C[0].length - 1)), g < 3 && (g = 3);
      case "d":
      case "y":
      case "M":
      case "e":
        f = n[s].t;
        break;
      case "m":
        f === "s" && (n[s].t = "M", g < 2 && (g = 2));
        break;
      case "X":
        break;
      case "Z":
        g < 1 && n[s].v.match(/[Hh]/) && (g = 1), g < 2 && n[s].v.match(/[Mm]/) && (g = 2), g < 3 && n[s].v.match(/[Ss]/) && (g = 3);
    }
  switch (g) {
    case 0:
      break;
    case 1:
      o.u >= 0.5 && (o.u = 0, ++o.S), o.S >= 60 && (o.S = 0, ++o.M), o.M >= 60 && (o.M = 0, ++o.H);
      break;
    case 2:
      o.u >= 0.5 && (o.u = 0, ++o.S), o.S >= 60 && (o.S = 0, ++o.M);
      break;
  }
  var _ = "", I;
  for (s = 0; s < n.length; ++s)
    switch (n[s].t) {
      case "t":
      case "T":
      case " ":
      case "D":
        break;
      case "X":
        n[s].v = "", n[s].t = ";";
        break;
      case "d":
      case "m":
      case "y":
      case "h":
      case "H":
      case "M":
      case "s":
      case "e":
      case "b":
      case "Z":
        n[s].v = jf(n[s].t.charCodeAt(0), n[s].v, o, F), n[s].t = "t";
        break;
      case "n":
      case "?":
        for (I = s + 1; n[I] != null && ((c = n[I].t) === "?" || c === "D" || (c === " " || c === "t") && n[I + 1] != null && (n[I + 1].t === "?" || n[I + 1].t === "t" && n[I + 1].v === "/") || n[s].t === "(" && (c === " " || c === "n" || c === ")") || c === "t" && (n[I].v === "/" || n[I].v === " " && n[I + 1] != null && n[I + 1].t == "?")); )
          n[s].v += n[I].v, n[I] = { v: "", t: ";" }, ++I;
        _ += n[s].v, s = I - 1;
        break;
      case "G":
        n[s].t = "t", n[s].v = vt(t, r);
        break;
    }
  var P = "", O, A;
  if (_.length > 0) {
    _.charCodeAt(0) == 40 ? (O = t < 0 && _.charCodeAt(0) === 45 ? -t : t, A = Xr("n", _, O)) : (O = t < 0 && a > 1 ? -t : t, A = Xr("n", _, O), O < 0 && n[0] && n[0].t == "t" && (A = A.substr(1), n[0].v = "-" + n[0].v)), I = A.length - 1;
    var V = n.length;
    for (s = 0; s < n.length; ++s) if (n[s] != null && n[s].t != "t" && n[s].v.indexOf(".") > -1) {
      V = s;
      break;
    }
    var D = n.length;
    if (V === n.length && A.indexOf("E") === -1) {
      for (s = n.length - 1; s >= 0; --s)
        n[s] == null || "n?".indexOf(n[s].t) === -1 || (I >= n[s].v.length - 1 ? (I -= n[s].v.length, n[s].v = A.substr(I + 1, n[s].v.length)) : I < 0 ? n[s].v = "" : (n[s].v = A.substr(0, I + 1), I = -1), n[s].t = "t", D = s);
      I >= 0 && D < n.length && (n[D].v = A.substr(0, I + 1) + n[D].v);
    } else if (V !== n.length && A.indexOf("E") === -1) {
      for (I = A.indexOf(".") - 1, s = V; s >= 0; --s)
        if (!(n[s] == null || "n?".indexOf(n[s].t) === -1)) {
          for (u = n[s].v.indexOf(".") > -1 && s === V ? n[s].v.indexOf(".") - 1 : n[s].v.length - 1, P = n[s].v.substr(u + 1); u >= 0; --u)
            I >= 0 && (n[s].v.charAt(u) === "0" || n[s].v.charAt(u) === "#") && (P = A.charAt(I--) + P);
          n[s].v = P, n[s].t = "t", D = s;
        }
      for (I >= 0 && D < n.length && (n[D].v = A.substr(0, I + 1) + n[D].v), I = A.indexOf(".") + 1, s = V; s < n.length; ++s)
        if (!(n[s] == null || "n?(".indexOf(n[s].t) === -1 && s !== V)) {
          for (u = n[s].v.indexOf(".") > -1 && s === V ? n[s].v.indexOf(".") + 1 : 0, P = n[s].v.substr(0, u); u < n[s].v.length; ++u)
            I < A.length && (P += A.charAt(I++));
          n[s].v = P, n[s].t = "t", D = s;
        }
    }
  }
  for (s = 0; s < n.length; ++s) n[s] != null && "n?".indexOf(n[s].t) > -1 && (O = a > 1 && t < 0 && s > 0 && n[s - 1].v === "-" ? -t : t, n[s].v = Xr(n[s].t, n[s].v, O), n[s].t = "t");
  var G = "";
  for (s = 0; s !== n.length; ++s) n[s] != null && (G += n[s].v);
  return G;
}
var M0 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function B0(e, t) {
  if (t == null) return !1;
  var r = parseFloat(t[2]);
  switch (t[1]) {
    case "=":
      if (e == r) return !0;
      break;
    case ">":
      if (e > r) return !0;
      break;
    case "<":
      if (e < r) return !0;
      break;
    case "<>":
      if (e != r) return !0;
      break;
    case ">=":
      if (e >= r) return !0;
      break;
    case "<=":
      if (e <= r) return !0;
      break;
  }
  return !1;
}
function no(e, t) {
  var r = to(e), a = r.length, n = r[a - 1].indexOf("@");
  if (a < 4 && n > -1 && --a, r.length > 4) throw new Error("cannot find right format for |" + r.join("|") + "|");
  if (typeof t != "number") return [4, r.length === 4 || n > -1 ? r[r.length - 1] : "@"];
  switch (r.length) {
    case 1:
      r = n > -1 ? ["General", "General", "General", r[0]] : [r[0], r[0], r[0], "@"];
      break;
    case 2:
      r = n > -1 ? [r[0], r[0], r[0], r[1]] : [r[0], r[1], r[0], "@"];
      break;
    case 3:
      r = n > -1 ? [r[0], r[1], r[0], r[2]] : [r[0], r[1], r[2], "@"];
      break;
  }
  var i = t > 0 ? r[0] : t < 0 ? r[1] : r[2];
  if (r[0].indexOf("[") === -1 && r[1].indexOf("[") === -1) return [a, i];
  if (r[0].match(/\[[=<>]/) != null || r[1].match(/\[[=<>]/) != null) {
    var s = r[0].match(M0), c = r[1].match(M0);
    return B0(t, s) ? [a, r[0]] : B0(t, c) ? [a, r[1]] : [a, r[s != null && c != null ? 2 : 1]];
  }
  return [a, i];
}
function yr(e, t, r) {
  r == null && (r = {});
  var a = "";
  switch (typeof e) {
    case "string":
      e == "m/d/yy" && r.dateNF ? a = r.dateNF : a = e;
      break;
    case "number":
      e == 14 && r.dateNF ? a = r.dateNF : a = (r.table != null ? r.table : ve)[e], a == null && (a = r.table && r.table[b0[e]] || ve[b0[e]]), a == null && (a = zf[e] || "General");
      break;
  }
  if (Za(a, 0)) return vt(t, r);
  t instanceof Date && (t = ns(t, r.date1904));
  var n = no(a, t);
  if (Za(n[1])) return vt(t, r);
  if (t === !0) t = "TRUE";
  else if (t === !1) t = "FALSE";
  else if (t === "" || t == null) return "";
  return ao(n[1], t, r, n[0]);
}
function dt(e, t) {
  if (typeof t != "number") {
    t = +t || -1;
    for (var r = 0; r < 392; ++r) {
      if (ve[r] == null) {
        t < 0 && (t = r);
        continue;
      }
      if (ve[r] == e) {
        t = r;
        break;
      }
    }
    t < 0 && (t = 391);
  }
  return ve[t] = e, t;
}
function xs() {
  ve = Uf();
}
var io = {
  5: '"$"#,##0_);\\("$"#,##0\\)',
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  23: "General",
  24: "General",
  25: "General",
  26: "General",
  27: "m/d/yy",
  28: "m/d/yy",
  29: "m/d/yy",
  30: "m/d/yy",
  31: "m/d/yy",
  32: "h:mm:ss",
  33: "h:mm:ss",
  34: "h:mm:ss",
  35: "h:mm:ss",
  36: "m/d/yy",
  41: '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
  42: '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
  43: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
  44: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
  50: "m/d/yy",
  51: "m/d/yy",
  52: "m/d/yy",
  53: "m/d/yy",
  54: "m/d/yy",
  55: "m/d/yy",
  56: "m/d/yy",
  57: "m/d/yy",
  58: "m/d/yy",
  59: "0",
  60: "0.00",
  61: "#,##0",
  62: "#,##0.00",
  63: '"$"#,##0_);\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  67: "0%",
  68: "0.00%",
  69: "# ?/?",
  70: "# ??/??",
  71: "m/d/yy",
  72: "m/d/yy",
  73: "d-mmm-yy",
  74: "d-mmm",
  75: "mmm-yy",
  76: "h:mm",
  77: "h:mm:ss",
  78: "m/d/yy h:mm",
  79: "mm:ss",
  80: "[h]:mm:ss",
  81: "mmss.0"
}, ds = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function so(e) {
  var t = typeof e == "number" ? ve[e] : e;
  return t = t.replace(ds, "(\\d+)"), new RegExp("^" + t + "$");
}
function co(e, t, r) {
  var a = -1, n = -1, i = -1, s = -1, c = -1, f = -1;
  (t.match(ds) || []).forEach(function(l, h) {
    var d = parseInt(r[h + 1], 10);
    switch (l.toLowerCase().charAt(0)) {
      case "y":
        a = d;
        break;
      case "d":
        i = d;
        break;
      case "h":
        s = d;
        break;
      case "s":
        f = d;
        break;
      case "m":
        s >= 0 ? c = d : n = d;
        break;
    }
  }), f >= 0 && c == -1 && n >= 0 && (c = n, n = -1);
  var o = ("" + (a >= 0 ? a : (/* @__PURE__ */ new Date()).getFullYear())).slice(-4) + "-" + ("00" + (n >= 1 ? n : 1)).slice(-2) + "-" + ("00" + (i >= 1 ? i : 1)).slice(-2);
  o.length == 7 && (o = "0" + o), o.length == 8 && (o = "20" + o);
  var u = ("00" + (s >= 0 ? s : 0)).slice(-2) + ":" + ("00" + (c >= 0 ? c : 0)).slice(-2) + ":" + ("00" + (f >= 0 ? f : 0)).slice(-2);
  return s == -1 && c == -1 && f == -1 ? o : a == -1 && n == -1 && i == -1 ? u : o + "T" + u;
}
var fo = /* @__PURE__ */ function() {
  var e = {};
  e.version = "1.2.0";
  function t() {
    for (var A = 0, V = new Array(256), D = 0; D != 256; ++D)
      A = D, A = A & 1 ? -306674912 ^ A >>> 1 : A >>> 1, A = A & 1 ? -306674912 ^ A >>> 1 : A >>> 1, A = A & 1 ? -306674912 ^ A >>> 1 : A >>> 1, A = A & 1 ? -306674912 ^ A >>> 1 : A >>> 1, A = A & 1 ? -306674912 ^ A >>> 1 : A >>> 1, A = A & 1 ? -306674912 ^ A >>> 1 : A >>> 1, A = A & 1 ? -306674912 ^ A >>> 1 : A >>> 1, A = A & 1 ? -306674912 ^ A >>> 1 : A >>> 1, V[D] = A;
    return typeof Int32Array < "u" ? new Int32Array(V) : V;
  }
  var r = t();
  function a(A) {
    var V = 0, D = 0, G = 0, W = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
    for (G = 0; G != 256; ++G) W[G] = A[G];
    for (G = 0; G != 256; ++G)
      for (D = A[G], V = 256 + G; V < 4096; V += 256) D = W[V] = D >>> 8 ^ A[D & 255];
    var b = [];
    for (G = 1; G != 16; ++G) b[G - 1] = typeof Int32Array < "u" ? W.subarray(G * 256, G * 256 + 256) : W.slice(G * 256, G * 256 + 256);
    return b;
  }
  var n = a(r), i = n[0], s = n[1], c = n[2], f = n[3], o = n[4], u = n[5], l = n[6], h = n[7], d = n[8], p = n[9], x = n[10], g = n[11], F = n[12], C = n[13], _ = n[14];
  function I(A, V) {
    for (var D = V ^ -1, G = 0, W = A.length; G < W; ) D = D >>> 8 ^ r[(D ^ A.charCodeAt(G++)) & 255];
    return ~D;
  }
  function P(A, V) {
    for (var D = V ^ -1, G = A.length - 15, W = 0; W < G; ) D = _[A[W++] ^ D & 255] ^ C[A[W++] ^ D >> 8 & 255] ^ F[A[W++] ^ D >> 16 & 255] ^ g[A[W++] ^ D >>> 24] ^ x[A[W++]] ^ p[A[W++]] ^ d[A[W++]] ^ h[A[W++]] ^ l[A[W++]] ^ u[A[W++]] ^ o[A[W++]] ^ f[A[W++]] ^ c[A[W++]] ^ s[A[W++]] ^ i[A[W++]] ^ r[A[W++]];
    for (G += 15; W < G; ) D = D >>> 8 ^ r[(D ^ A[W++]) & 255];
    return ~D;
  }
  function O(A, V) {
    for (var D = V ^ -1, G = 0, W = A.length, b = 0, J = 0; G < W; )
      b = A.charCodeAt(G++), b < 128 ? D = D >>> 8 ^ r[(D ^ b) & 255] : b < 2048 ? (D = D >>> 8 ^ r[(D ^ (192 | b >> 6 & 31)) & 255], D = D >>> 8 ^ r[(D ^ (128 | b & 63)) & 255]) : b >= 55296 && b < 57344 ? (b = (b & 1023) + 64, J = A.charCodeAt(G++) & 1023, D = D >>> 8 ^ r[(D ^ (240 | b >> 8 & 7)) & 255], D = D >>> 8 ^ r[(D ^ (128 | b >> 2 & 63)) & 255], D = D >>> 8 ^ r[(D ^ (128 | J >> 6 & 15 | (b & 3) << 4)) & 255], D = D >>> 8 ^ r[(D ^ (128 | J & 63)) & 255]) : (D = D >>> 8 ^ r[(D ^ (224 | b >> 12 & 15)) & 255], D = D >>> 8 ^ r[(D ^ (128 | b >> 6 & 63)) & 255], D = D >>> 8 ^ r[(D ^ (128 | b & 63)) & 255]);
    return ~D;
  }
  return e.table = r, e.bstr = I, e.buf = P, e.str = O, e;
}(), ke = /* @__PURE__ */ function() {
  var t = {};
  t.version = "1.2.1";
  function r(v, E) {
    for (var m = v.split("/"), k = E.split("/"), T = 0, w = 0, M = Math.min(m.length, k.length); T < M; ++T) {
      if (w = m[T].length - k[T].length) return w;
      if (m[T] != k[T]) return m[T] < k[T] ? -1 : 1;
    }
    return m.length - k.length;
  }
  function a(v) {
    if (v.charAt(v.length - 1) == "/") return v.slice(0, -1).indexOf("/") === -1 ? v : a(v.slice(0, -1));
    var E = v.lastIndexOf("/");
    return E === -1 ? v : v.slice(0, E + 1);
  }
  function n(v) {
    if (v.charAt(v.length - 1) == "/") return n(v.slice(0, -1));
    var E = v.lastIndexOf("/");
    return E === -1 ? v : v.slice(E + 1);
  }
  function i(v, E) {
    typeof E == "string" && (E = new Date(E));
    var m = E.getHours();
    m = m << 6 | E.getMinutes(), m = m << 5 | E.getSeconds() >>> 1, v.write_shift(2, m);
    var k = E.getFullYear() - 1980;
    k = k << 4 | E.getMonth() + 1, k = k << 5 | E.getDate(), v.write_shift(2, k);
  }
  function s(v) {
    var E = v.read_shift(2) & 65535, m = v.read_shift(2) & 65535, k = /* @__PURE__ */ new Date(), T = m & 31;
    m >>>= 5;
    var w = m & 15;
    m >>>= 4, k.setMilliseconds(0), k.setFullYear(m + 1980), k.setMonth(w - 1), k.setDate(T);
    var M = E & 31;
    E >>>= 5;
    var Z = E & 63;
    return E >>>= 6, k.setHours(E), k.setMinutes(Z), k.setSeconds(M << 1), k;
  }
  function c(v) {
    Je(v, 0);
    for (var E = (
      /*::(*/
      {}
    ), m = 0; v.l <= v.length - 4; ) {
      var k = v.read_shift(2), T = v.read_shift(2), w = v.l + T, M = {};
      switch (k) {
        case 21589:
          m = v.read_shift(1), m & 1 && (M.mtime = v.read_shift(4)), T > 5 && (m & 2 && (M.atime = v.read_shift(4)), m & 4 && (M.ctime = v.read_shift(4))), M.mtime && (M.mt = new Date(M.mtime * 1e3));
          break;
      }
      v.l = w, E[k] = M;
    }
    return E;
  }
  var f;
  function o() {
    return f || (f = {});
  }
  function u(v, E) {
    if (v[0] == 80 && v[1] == 75) return S0(v, E);
    if ((v[0] | 32) == 109 && (v[1] | 32) == 105) return kf(v, E);
    if (v.length < 512) throw new Error("CFB file size " + v.length + " < 512");
    var m = 3, k = 512, T = 0, w = 0, M = 0, Z = 0, L = 0, B = [], z = (
      /*::(*/
      v.slice(0, 512)
    );
    Je(z, 0);
    var K = l(z);
    switch (m = K[0], m) {
      case 3:
        k = 512;
        break;
      case 4:
        k = 4096;
        break;
      case 0:
        if (K[1] == 0) return S0(v, E);
      default:
        throw new Error("Major Version: Expected 3 or 4 saw " + m);
    }
    k !== 512 && (z = /*::(*/
    v.slice(0, k), Je(
      z,
      28
      /* blob.l */
    ));
    var ee = v.slice(0, k);
    h(z, m);
    var se = z.read_shift(4, "i");
    if (m === 3 && se !== 0) throw new Error("# Directory Sectors: Expected 0 saw " + se);
    z.l += 4, M = z.read_shift(4, "i"), z.l += 4, z.chk("00100000", "Mini Stream Cutoff Size: "), Z = z.read_shift(4, "i"), T = z.read_shift(4, "i"), L = z.read_shift(4, "i"), w = z.read_shift(4, "i");
    for (var q = -1, ne = 0; ne < 109 && (q = z.read_shift(4, "i"), !(q < 0)); ++ne)
      B[ne] = q;
    var pe = d(v, k);
    g(L, w, pe, k, B);
    var De = C(pe, M, B, k);
    De[M].name = "!Directory", T > 0 && Z !== J && (De[Z].name = "!MiniFAT"), De[B[0]].name = "!FAT", De.fat_addrs = B, De.ssz = k;
    var Re = {}, rr = [], Wt = [], Zt = [];
    _(M, De, pe, rr, T, Re, Wt, Z), p(Wt, Zt, rr), rr.shift();
    var Gt = {
      FileIndex: Wt,
      FullPaths: Zt
    };
    return E && E.raw && (Gt.raw = { header: ee, sectors: pe }), Gt;
  }
  function l(v) {
    if (v[v.l] == 80 && v[v.l + 1] == 75) return [0, 0];
    v.chk(oe, "Header Signature: "), v.l += 16;
    var E = v.read_shift(2, "u");
    return [v.read_shift(2, "u"), E];
  }
  function h(v, E) {
    var m = 9;
    switch (v.l += 2, m = v.read_shift(2)) {
      case 9:
        if (E != 3) throw new Error("Sector Shift: Expected 9 saw " + m);
        break;
      case 12:
        if (E != 4) throw new Error("Sector Shift: Expected 12 saw " + m);
        break;
      default:
        throw new Error("Sector Shift: Expected 9 or 12 saw " + m);
    }
    v.chk("0600", "Mini Sector Shift: "), v.chk("000000000000", "Reserved: ");
  }
  function d(v, E) {
    for (var m = Math.ceil(v.length / E) - 1, k = [], T = 1; T < m; ++T) k[T - 1] = v.slice(T * E, (T + 1) * E);
    return k[m - 1] = v.slice(m * E), k;
  }
  function p(v, E, m) {
    for (var k = 0, T = 0, w = 0, M = 0, Z = 0, L = m.length, B = [], z = []; k < L; ++k)
      B[k] = z[k] = k, E[k] = m[k];
    for (; Z < z.length; ++Z)
      k = z[Z], T = v[k].L, w = v[k].R, M = v[k].C, B[k] === k && (T !== -1 && B[T] !== T && (B[k] = B[T]), w !== -1 && B[w] !== w && (B[k] = B[w])), M !== -1 && (B[M] = k), T !== -1 && k != B[k] && (B[T] = B[k], z.lastIndexOf(T) < Z && z.push(T)), w !== -1 && k != B[k] && (B[w] = B[k], z.lastIndexOf(w) < Z && z.push(w));
    for (k = 1; k < L; ++k) B[k] === k && (w !== -1 && B[w] !== w ? B[k] = B[w] : T !== -1 && B[T] !== T && (B[k] = B[T]));
    for (k = 1; k < L; ++k)
      if (v[k].type !== 0) {
        if (Z = k, Z != B[Z]) do
          Z = B[Z], E[k] = E[Z] + "/" + E[k];
        while (Z !== 0 && B[Z] !== -1 && Z != B[Z]);
        B[k] = -1;
      }
    for (E[0] += "/", k = 1; k < L; ++k)
      v[k].type !== 2 && (E[k] += "/");
  }
  function x(v, E, m) {
    for (var k = v.start, T = v.size, w = [], M = k; m && T > 0 && M >= 0; )
      w.push(E.slice(M * b, M * b + b)), T -= b, M = ht(m, M * 4);
    return w.length === 0 ? Ge(0) : rt(w).slice(0, v.size);
  }
  function g(v, E, m, k, T) {
    var w = J;
    if (v === J) {
      if (E !== 0) throw new Error("DIFAT chain shorter than expected");
    } else if (v !== -1) {
      var M = m[v], Z = (k >>> 2) - 1;
      if (!M) return;
      for (var L = 0; L < Z && (w = ht(M, L * 4)) !== J; ++L)
        T.push(w);
      g(ht(M, k - 4), E - 1, m, k, T);
    }
  }
  function F(v, E, m, k, T) {
    var w = [], M = [];
    T || (T = []);
    var Z = k - 1, L = 0, B = 0;
    for (L = E; L >= 0; ) {
      T[L] = !0, w[w.length] = L, M.push(v[L]);
      var z = m[Math.floor(L * 4 / k)];
      if (B = L * 4 & Z, k < 4 + B) throw new Error("FAT boundary crossed: " + L + " 4 " + k);
      if (!v[z]) break;
      L = ht(v[z], B);
    }
    return { nodes: w, data: X0([M]) };
  }
  function C(v, E, m, k) {
    var T = v.length, w = [], M = [], Z = [], L = [], B = k - 1, z = 0, K = 0, ee = 0, se = 0;
    for (z = 0; z < T; ++z)
      if (Z = [], ee = z + E, ee >= T && (ee -= T), !M[ee]) {
        L = [];
        var q = [];
        for (K = ee; K >= 0; ) {
          q[K] = !0, M[K] = !0, Z[Z.length] = K, L.push(v[K]);
          var ne = m[Math.floor(K * 4 / k)];
          if (se = K * 4 & B, k < 4 + se) throw new Error("FAT boundary crossed: " + K + " 4 " + k);
          if (!v[ne] || (K = ht(v[ne], se), q[K])) break;
        }
        w[ee] = { nodes: Z, data: X0([L]) };
      }
    return w;
  }
  function _(v, E, m, k, T, w, M, Z) {
    for (var L = 0, B = k.length ? 2 : 0, z = E[v].data, K = 0, ee = 0, se; K < z.length; K += 128) {
      var q = (
        /*::(*/
        z.slice(K, K + 128)
      );
      Je(q, 64), ee = q.read_shift(2), se = qn(q, 0, ee - B), k.push(se);
      var ne = {
        name: se,
        type: q.read_shift(1),
        color: q.read_shift(1),
        L: q.read_shift(4, "i"),
        R: q.read_shift(4, "i"),
        C: q.read_shift(4, "i"),
        clsid: q.read_shift(16),
        state: q.read_shift(4, "i"),
        start: 0,
        size: 0
      }, pe = q.read_shift(2) + q.read_shift(2) + q.read_shift(2) + q.read_shift(2);
      pe !== 0 && (ne.ct = I(q, q.l - 8));
      var De = q.read_shift(2) + q.read_shift(2) + q.read_shift(2) + q.read_shift(2);
      De !== 0 && (ne.mt = I(q, q.l - 8)), ne.start = q.read_shift(4, "i"), ne.size = q.read_shift(4, "i"), ne.size < 0 && ne.start < 0 && (ne.size = ne.type = 0, ne.start = J, ne.name = ""), ne.type === 5 ? (L = ne.start, T > 0 && L !== J && (E[L].name = "!StreamData")) : ne.size >= 4096 ? (ne.storage = "fat", E[ne.start] === void 0 && (E[ne.start] = F(m, ne.start, E.fat_addrs, E.ssz)), E[ne.start].name = ne.name, ne.content = E[ne.start].data.slice(0, ne.size)) : (ne.storage = "minifat", ne.size < 0 ? ne.size = 0 : L !== J && ne.start !== J && E[L] && (ne.content = x(ne, E[L].data, (E[Z] || {}).data))), ne.content && Je(ne.content, 0), w[se] = ne, M.push(ne);
    }
  }
  function I(v, E) {
    return new Date((_r(v, E + 4) / 1e7 * Math.pow(2, 32) + _r(v, E) / 1e7 - 11644473600) * 1e3);
  }
  function P(v, E) {
    return o(), u(f.readFileSync(v), E);
  }
  function O(v, E) {
    var m = E && E.type;
    switch (m || _e && Buffer.isBuffer(v) && (m = "buffer"), m || "base64") {
      case "file":
        return P(v, E);
      case "base64":
        return u(Rr(Er(v)), E);
      case "binary":
        return u(Rr(v), E);
    }
    return u(
      /*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */
      v,
      E
    );
  }
  function A(v, E) {
    var m = E || {}, k = m.root || "Root Entry";
    if (v.FullPaths || (v.FullPaths = []), v.FileIndex || (v.FileIndex = []), v.FullPaths.length !== v.FileIndex.length) throw new Error("inconsistent CFB structure");
    v.FullPaths.length === 0 && (v.FullPaths[0] = k + "/", v.FileIndex[0] = { name: k, type: 5 }), m.CLSID && (v.FileIndex[0].clsid = m.CLSID), V(v);
  }
  function V(v) {
    var E = "Sh33tJ5";
    if (!ke.find(v, "/" + E)) {
      var m = Ge(4);
      m[0] = 55, m[1] = m[3] = 50, m[2] = 54, v.FileIndex.push({ name: E, type: 2, content: m, size: 4, L: 69, R: 69, C: 69 }), v.FullPaths.push(v.FullPaths[0] + E), D(v);
    }
  }
  function D(v, E) {
    A(v);
    for (var m = !1, k = !1, T = v.FullPaths.length - 1; T >= 0; --T) {
      var w = v.FileIndex[T];
      switch (w.type) {
        case 0:
          k ? m = !0 : (v.FileIndex.pop(), v.FullPaths.pop());
          break;
        case 1:
        case 2:
        case 5:
          k = !0, isNaN(w.R * w.L * w.C) && (m = !0), w.R > -1 && w.L > -1 && w.R == w.L && (m = !0);
          break;
        default:
          m = !0;
          break;
      }
    }
    if (!(!m && !E)) {
      var M = new Date(1987, 1, 19), Z = 0, L = Object.create ? /* @__PURE__ */ Object.create(null) : {}, B = [];
      for (T = 0; T < v.FullPaths.length; ++T)
        L[v.FullPaths[T]] = !0, v.FileIndex[T].type !== 0 && B.push([v.FullPaths[T], v.FileIndex[T]]);
      for (T = 0; T < B.length; ++T) {
        var z = a(B[T][0]);
        k = L[z], k || (B.push([z, {
          name: n(z).replace("/", ""),
          type: 1,
          clsid: fe,
          ct: M,
          mt: M,
          content: null
        }]), L[z] = !0);
      }
      for (B.sort(function(se, q) {
        return r(se[0], q[0]);
      }), v.FullPaths = [], v.FileIndex = [], T = 0; T < B.length; ++T)
        v.FullPaths[T] = B[T][0], v.FileIndex[T] = B[T][1];
      for (T = 0; T < B.length; ++T) {
        var K = v.FileIndex[T], ee = v.FullPaths[T];
        if (K.name = n(ee).replace("/", ""), K.L = K.R = K.C = -(K.color = 1), K.size = K.content ? K.content.length : 0, K.start = 0, K.clsid = K.clsid || fe, T === 0)
          K.C = B.length > 1 ? 1 : -1, K.size = 0, K.type = 5;
        else if (ee.slice(-1) == "/") {
          for (Z = T + 1; Z < B.length && a(v.FullPaths[Z]) != ee; ++Z) ;
          for (K.C = Z >= B.length ? -1 : Z, Z = T + 1; Z < B.length && a(v.FullPaths[Z]) != a(ee); ++Z) ;
          K.R = Z >= B.length ? -1 : Z, K.type = 1;
        } else
          a(v.FullPaths[T + 1] || "") == a(ee) && (K.R = T + 1), K.type = 2;
      }
    }
  }
  function G(v, E) {
    var m = E || {};
    if (m.fileType == "mad") return Ef(v, m);
    switch (D(v), m.fileType) {
      case "zip":
        return df(v, m);
    }
    var k = function(se) {
      for (var q = 0, ne = 0, pe = 0; pe < se.FileIndex.length; ++pe) {
        var De = se.FileIndex[pe];
        if (De.content) {
          var Re = De.content.length;
          Re > 0 && (Re < 4096 ? q += Re + 63 >> 6 : ne += Re + 511 >> 9);
        }
      }
      for (var rr = se.FullPaths.length + 3 >> 2, Wt = q + 7 >> 3, Zt = q + 127 >> 7, Gt = Wt + ne + rr + Zt, lt = Gt + 127 >> 7, pn = lt <= 109 ? 0 : Math.ceil((lt - 109) / 127); Gt + lt + pn + 127 >> 7 > lt; ) pn = ++lt <= 109 ? 0 : Math.ceil((lt - 109) / 127);
      var Gr = [1, pn, lt, Zt, rr, ne, q, 0];
      return se.FileIndex[0].size = q << 6, Gr[7] = (se.FileIndex[0].start = Gr[0] + Gr[1] + Gr[2] + Gr[3] + Gr[4] + Gr[5]) + (Gr[6] + 7 >> 3), Gr;
    }(v), T = Ge(k[7] << 9), w = 0, M = 0;
    {
      for (w = 0; w < 8; ++w) T.write_shift(1, te[w]);
      for (w = 0; w < 8; ++w) T.write_shift(2, 0);
      for (T.write_shift(2, 62), T.write_shift(2, 3), T.write_shift(2, 65534), T.write_shift(2, 9), T.write_shift(2, 6), w = 0; w < 3; ++w) T.write_shift(2, 0);
      for (T.write_shift(4, 0), T.write_shift(4, k[2]), T.write_shift(4, k[0] + k[1] + k[2] + k[3] - 1), T.write_shift(4, 0), T.write_shift(4, 4096), T.write_shift(4, k[3] ? k[0] + k[1] + k[2] - 1 : J), T.write_shift(4, k[3]), T.write_shift(-4, k[1] ? k[0] - 1 : J), T.write_shift(4, k[1]), w = 0; w < 109; ++w) T.write_shift(-4, w < k[2] ? k[1] + w : -1);
    }
    if (k[1])
      for (M = 0; M < k[1]; ++M) {
        for (; w < 236 + M * 127; ++w) T.write_shift(-4, w < k[2] ? k[1] + w : -1);
        T.write_shift(-4, M === k[1] - 1 ? J : M + 1);
      }
    var Z = function(se) {
      for (M += se; w < M - 1; ++w) T.write_shift(-4, w + 1);
      se && (++w, T.write_shift(-4, J));
    };
    for (M = w = 0, M += k[1]; w < M; ++w) T.write_shift(-4, ce.DIFSECT);
    for (M += k[2]; w < M; ++w) T.write_shift(-4, ce.FATSECT);
    Z(k[3]), Z(k[4]);
    for (var L = 0, B = 0, z = v.FileIndex[0]; L < v.FileIndex.length; ++L)
      z = v.FileIndex[L], z.content && (B = z.content.length, !(B < 4096) && (z.start = M, Z(B + 511 >> 9)));
    for (Z(k[6] + 7 >> 3); T.l & 511; ) T.write_shift(-4, ce.ENDOFCHAIN);
    for (M = w = 0, L = 0; L < v.FileIndex.length; ++L)
      z = v.FileIndex[L], z.content && (B = z.content.length, !(!B || B >= 4096) && (z.start = M, Z(B + 63 >> 6)));
    for (; T.l & 511; ) T.write_shift(-4, ce.ENDOFCHAIN);
    for (w = 0; w < k[4] << 2; ++w) {
      var K = v.FullPaths[w];
      if (!K || K.length === 0) {
        for (L = 0; L < 17; ++L) T.write_shift(4, 0);
        for (L = 0; L < 3; ++L) T.write_shift(4, -1);
        for (L = 0; L < 12; ++L) T.write_shift(4, 0);
        continue;
      }
      z = v.FileIndex[w], w === 0 && (z.start = z.size ? z.start - 1 : J);
      var ee = w === 0 && m.root || z.name;
      if (B = 2 * (ee.length + 1), T.write_shift(64, ee, "utf16le"), T.write_shift(2, B), T.write_shift(1, z.type), T.write_shift(1, z.color), T.write_shift(-4, z.L), T.write_shift(-4, z.R), T.write_shift(-4, z.C), z.clsid) T.write_shift(16, z.clsid, "hex");
      else for (L = 0; L < 4; ++L) T.write_shift(4, 0);
      T.write_shift(4, z.state || 0), T.write_shift(4, 0), T.write_shift(4, 0), T.write_shift(4, 0), T.write_shift(4, 0), T.write_shift(4, z.start), T.write_shift(4, z.size), T.write_shift(4, 0);
    }
    for (w = 1; w < v.FileIndex.length; ++w)
      if (z = v.FileIndex[w], z.size >= 4096)
        if (T.l = z.start + 1 << 9, _e && Buffer.isBuffer(z.content))
          z.content.copy(T, T.l, 0, z.size), T.l += z.size + 511 & -512;
        else {
          for (L = 0; L < z.size; ++L) T.write_shift(1, z.content[L]);
          for (; L & 511; ++L) T.write_shift(1, 0);
        }
    for (w = 1; w < v.FileIndex.length; ++w)
      if (z = v.FileIndex[w], z.size > 0 && z.size < 4096)
        if (_e && Buffer.isBuffer(z.content))
          z.content.copy(T, T.l, 0, z.size), T.l += z.size + 63 & -64;
        else {
          for (L = 0; L < z.size; ++L) T.write_shift(1, z.content[L]);
          for (; L & 63; ++L) T.write_shift(1, 0);
        }
    if (_e)
      T.l = T.length;
    else
      for (; T.l < T.length; ) T.write_shift(1, 0);
    return T;
  }
  function W(v, E) {
    var m = v.FullPaths.map(function(L) {
      return L.toUpperCase();
    }), k = m.map(function(L) {
      var B = L.split("/");
      return B[B.length - (L.slice(-1) == "/" ? 2 : 1)];
    }), T = !1;
    E.charCodeAt(0) === 47 ? (T = !0, E = m[0].slice(0, -1) + E) : T = E.indexOf("/") !== -1;
    var w = E.toUpperCase(), M = T === !0 ? m.indexOf(w) : k.indexOf(w);
    if (M !== -1) return v.FileIndex[M];
    var Z = !w.match(Xt);
    for (w = w.replace(dr, ""), Z && (w = w.replace(Xt, "!")), M = 0; M < m.length; ++M)
      if ((Z ? m[M].replace(Xt, "!") : m[M]).replace(dr, "") == w || (Z ? k[M].replace(Xt, "!") : k[M]).replace(dr, "") == w) return v.FileIndex[M];
    return null;
  }
  var b = 64, J = -2, oe = "d0cf11e0a1b11ae1", te = [208, 207, 17, 224, 161, 177, 26, 225], fe = "00000000000000000000000000000000", ce = {
    /* 2.1 Compund File Sector Numbers and Types */
    MAXREGSECT: -6,
    DIFSECT: -4,
    FATSECT: -3,
    ENDOFCHAIN: J,
    FREESECT: -1,
    /* 2.2 Compound File Header */
    HEADER_SIGNATURE: oe,
    HEADER_MINOR_VERSION: "3e00",
    MAXREGSID: -6,
    NOSTREAM: -1,
    HEADER_CLSID: fe,
    /* 2.6.1 Compound File Directory Entry */
    EntryTypes: ["unknown", "storage", "stream", "lockbytes", "property", "root"]
  };
  function Ce(v, E, m) {
    o();
    var k = G(v, m);
    f.writeFileSync(E, k);
  }
  function H(v) {
    for (var E = new Array(v.length), m = 0; m < v.length; ++m) E[m] = String.fromCharCode(v[m]);
    return E.join("");
  }
  function he(v, E) {
    var m = G(v, E);
    switch (E && E.type || "buffer") {
      case "file":
        return o(), f.writeFileSync(E.filename, m), m;
      case "binary":
        return typeof m == "string" ? m : H(m);
      case "base64":
        return I0(typeof m == "string" ? m : H(m));
      case "buffer":
        if (_e) return Buffer.isBuffer(m) ? m : Et(m);
      case "array":
        return typeof m == "string" ? Rr(m) : m;
    }
    return m;
  }
  var xe;
  function S(v) {
    try {
      var E = v.InflateRaw, m = new E();
      if (m._processChunk(new Uint8Array([3, 0]), m._finishFlushFlag), m.bytesRead) xe = v;
      else throw new Error("zlib does not expose bytesRead");
    } catch (k) {
      console.error("cannot use native zlib: " + (k.message || k));
    }
  }
  function U(v, E) {
    if (!xe) return A0(v, E);
    var m = xe.InflateRaw, k = new m(), T = k._processChunk(v.slice(v.l), k._finishFlushFlag);
    return v.l += k.bytesRead, T;
  }
  function N(v) {
    return xe ? xe.deflateRawSync(v) : ge(v);
  }
  var R = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], X = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258], re = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
  function ie(v) {
    var E = (v << 1 | v << 11) & 139536 | (v << 5 | v << 15) & 558144;
    return (E >> 16 | E >> 8 | E) & 255;
  }
  for (var Q = typeof Uint8Array < "u", Y = Q ? new Uint8Array(256) : [], Te = 0; Te < 256; ++Te) Y[Te] = ie(Te);
  function y(v, E) {
    var m = Y[v & 255];
    return E <= 8 ? m >>> 8 - E : (m = m << 8 | Y[v >> 8 & 255], E <= 16 ? m >>> 16 - E : (m = m << 8 | Y[v >> 16 & 255], m >>> 24 - E));
  }
  function Be(v, E) {
    var m = E & 7, k = E >>> 3;
    return (v[k] | (m <= 6 ? 0 : v[k + 1] << 8)) >>> m & 3;
  }
  function Ae(v, E) {
    var m = E & 7, k = E >>> 3;
    return (v[k] | (m <= 5 ? 0 : v[k + 1] << 8)) >>> m & 7;
  }
  function Se(v, E) {
    var m = E & 7, k = E >>> 3;
    return (v[k] | (m <= 4 ? 0 : v[k + 1] << 8)) >>> m & 15;
  }
  function me(v, E) {
    var m = E & 7, k = E >>> 3;
    return (v[k] | (m <= 3 ? 0 : v[k + 1] << 8)) >>> m & 31;
  }
  function ae(v, E) {
    var m = E & 7, k = E >>> 3;
    return (v[k] | (m <= 1 ? 0 : v[k + 1] << 8)) >>> m & 127;
  }
  function Ue(v, E, m) {
    var k = E & 7, T = E >>> 3, w = (1 << m) - 1, M = v[T] >>> k;
    return m < 8 - k || (M |= v[T + 1] << 8 - k, m < 16 - k) || (M |= v[T + 2] << 16 - k, m < 24 - k) || (M |= v[T + 3] << 24 - k), M & w;
  }
  function Tr(v, E, m) {
    var k = E & 7, T = E >>> 3;
    return k <= 5 ? v[T] |= (m & 7) << k : (v[T] |= m << k & 255, v[T + 1] = (m & 7) >> 8 - k), E + 3;
  }
  function Mr(v, E, m) {
    var k = E & 7, T = E >>> 3;
    return m = (m & 1) << k, v[T] |= m, E + 1;
  }
  function Wr(v, E, m) {
    var k = E & 7, T = E >>> 3;
    return m <<= k, v[T] |= m & 255, m >>>= 8, v[T + 1] = m, E + 8;
  }
  function Vt(v, E, m) {
    var k = E & 7, T = E >>> 3;
    return m <<= k, v[T] |= m & 255, m >>>= 8, v[T + 1] = m & 255, v[T + 2] = m >>> 8, E + 16;
  }
  function qr(v, E) {
    var m = v.length, k = 2 * m > E ? 2 * m : E + 5, T = 0;
    if (m >= E) return v;
    if (_e) {
      var w = D0(k);
      if (v.copy) v.copy(w);
      else for (; T < v.length; ++T) w[T] = v[T];
      return w;
    } else if (Q) {
      var M = new Uint8Array(k);
      if (M.set) M.set(v);
      else for (; T < m; ++T) M[T] = v[T];
      return M;
    }
    return v.length = k, v;
  }
  function mr(v) {
    for (var E = new Array(v), m = 0; m < v; ++m) E[m] = 0;
    return E;
  }
  function Zr(v, E, m) {
    var k = 1, T = 0, w = 0, M = 0, Z = 0, L = v.length, B = Q ? new Uint16Array(32) : mr(32);
    for (w = 0; w < 32; ++w) B[w] = 0;
    for (w = L; w < m; ++w) v[w] = 0;
    L = v.length;
    var z = Q ? new Uint16Array(L) : mr(L);
    for (w = 0; w < L; ++w)
      B[T = v[w]]++, k < T && (k = T), z[w] = 0;
    for (B[0] = 0, w = 1; w <= k; ++w) B[w + 16] = Z = Z + B[w - 1] << 1;
    for (w = 0; w < L; ++w)
      Z = v[w], Z != 0 && (z[w] = B[Z + 16]++);
    var K = 0;
    for (w = 0; w < L; ++w)
      if (K = v[w], K != 0)
        for (Z = y(z[w], k) >> k - K, M = (1 << k + 4 - K) - 1; M >= 0; --M)
          E[Z | M << K] = K & 15 | w << 4;
    return k;
  }
  var Qr = Q ? new Uint16Array(512) : mr(512), Ht = Q ? new Uint16Array(32) : mr(32);
  if (!Q) {
    for (var or = 0; or < 512; ++or) Qr[or] = 0;
    for (or = 0; or < 32; ++or) Ht[or] = 0;
  }
  (function() {
    for (var v = [], E = 0; E < 32; E++) v.push(5);
    Zr(v, Ht, 32);
    var m = [];
    for (E = 0; E <= 143; E++) m.push(8);
    for (; E <= 255; E++) m.push(9);
    for (; E <= 279; E++) m.push(7);
    for (; E <= 287; E++) m.push(8);
    Zr(m, Qr, 288);
  })();
  var Br = /* @__PURE__ */ function() {
    for (var E = Q ? new Uint8Array(32768) : [], m = 0, k = 0; m < re.length - 1; ++m)
      for (; k < re[m + 1]; ++k) E[k] = m;
    for (; k < 32768; ++k) E[k] = 29;
    var T = Q ? new Uint8Array(259) : [];
    for (m = 0, k = 0; m < X.length - 1; ++m)
      for (; k < X[m + 1]; ++k) T[k] = m;
    function w(Z, L) {
      for (var B = 0; B < Z.length; ) {
        var z = Math.min(65535, Z.length - B), K = B + z == Z.length;
        for (L.write_shift(1, +K), L.write_shift(2, z), L.write_shift(2, ~z & 65535); z-- > 0; ) L[L.l++] = Z[B++];
      }
      return L.l;
    }
    function M(Z, L) {
      for (var B = 0, z = 0, K = Q ? new Uint16Array(32768) : []; z < Z.length; ) {
        var ee = (
          /* data.length - boff; */
          Math.min(65535, Z.length - z)
        );
        if (ee < 10) {
          for (B = Tr(L, B, +(z + ee == Z.length)), B & 7 && (B += 8 - (B & 7)), L.l = B / 8 | 0, L.write_shift(2, ee), L.write_shift(2, ~ee & 65535); ee-- > 0; ) L[L.l++] = Z[z++];
          B = L.l * 8;
          continue;
        }
        B = Tr(L, B, +(z + ee == Z.length) + 2);
        for (var se = 0; ee-- > 0; ) {
          var q = Z[z];
          se = (se << 5 ^ q) & 32767;
          var ne = -1, pe = 0;
          if ((ne = K[se]) && (ne |= z & -32768, ne > z && (ne -= 32768), ne < z))
            for (; Z[ne + pe] == Z[z + pe] && pe < 250; ) ++pe;
          if (pe > 2) {
            q = T[pe], q <= 22 ? B = Wr(L, B, Y[q + 1] >> 1) - 1 : (Wr(L, B, 3), B += 5, Wr(L, B, Y[q - 23] >> 5), B += 3);
            var De = q < 8 ? 0 : q - 4 >> 2;
            De > 0 && (Vt(L, B, pe - X[q]), B += De), q = E[z - ne], B = Wr(L, B, Y[q] >> 3), B -= 3;
            var Re = q < 4 ? 0 : q - 2 >> 1;
            Re > 0 && (Vt(L, B, z - ne - re[q]), B += Re);
            for (var rr = 0; rr < pe; ++rr)
              K[se] = z & 32767, se = (se << 5 ^ Z[z]) & 32767, ++z;
            ee -= pe - 1;
          } else
            q <= 143 ? q = q + 48 : B = Mr(L, B, 1), B = Wr(L, B, Y[q]), K[se] = z & 32767, ++z;
        }
        B = Wr(L, B, 0) - 1;
      }
      return L.l = (B + 7) / 8 | 0, L.l;
    }
    return function(L, B) {
      return L.length < 8 ? w(L, B) : M(L, B);
    };
  }();
  function ge(v) {
    var E = Ge(50 + Math.floor(v.length * 1.1)), m = Br(v, E);
    return E.slice(0, m);
  }
  var ze = Q ? new Uint16Array(32768) : mr(32768), wr = Q ? new Uint16Array(32768) : mr(32768), Ze = Q ? new Uint16Array(128) : mr(128), ut = 1, w0 = 1;
  function lf(v, E) {
    var m = me(v, E) + 257;
    E += 5;
    var k = me(v, E) + 1;
    E += 5;
    var T = Se(v, E) + 4;
    E += 4;
    for (var w = 0, M = Q ? new Uint8Array(19) : mr(19), Z = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], L = 1, B = Q ? new Uint8Array(8) : mr(8), z = Q ? new Uint8Array(8) : mr(8), K = M.length, ee = 0; ee < T; ++ee)
      M[R[ee]] = w = Ae(v, E), L < w && (L = w), B[w]++, E += 3;
    var se = 0;
    for (B[0] = 0, ee = 1; ee <= L; ++ee) z[ee] = se = se + B[ee - 1] << 1;
    for (ee = 0; ee < K; ++ee) (se = M[ee]) != 0 && (Z[ee] = z[se]++);
    var q = 0;
    for (ee = 0; ee < K; ++ee)
      if (q = M[ee], q != 0) {
        se = Y[Z[ee]] >> 8 - q;
        for (var ne = (1 << 7 - q) - 1; ne >= 0; --ne) Ze[se | ne << q] = q & 7 | ee << 3;
      }
    var pe = [];
    for (L = 1; pe.length < m + k; )
      switch (se = Ze[ae(v, E)], E += se & 7, se >>>= 3) {
        case 16:
          for (w = 3 + Be(v, E), E += 2, se = pe[pe.length - 1]; w-- > 0; ) pe.push(se);
          break;
        case 17:
          for (w = 3 + Ae(v, E), E += 3; w-- > 0; ) pe.push(0);
          break;
        case 18:
          for (w = 11 + ae(v, E), E += 7; w-- > 0; ) pe.push(0);
          break;
        default:
          pe.push(se), L < se && (L = se);
          break;
      }
    var De = pe.slice(0, m), Re = pe.slice(m);
    for (ee = m; ee < 286; ++ee) De[ee] = 0;
    for (ee = k; ee < 30; ++ee) Re[ee] = 0;
    return ut = Zr(De, ze, 286), w0 = Zr(Re, wr, 30), E;
  }
  function hf(v, E) {
    if (v[0] == 3 && !(v[1] & 3))
      return [it(E), 2];
    for (var m = 0, k = 0, T = D0(E || 1 << 18), w = 0, M = T.length >>> 0, Z = 0, L = 0; !(k & 1); ) {
      if (k = Ae(v, m), m += 3, k >>> 1)
        k >> 1 == 1 ? (Z = 9, L = 5) : (m = lf(v, m), Z = ut, L = w0);
      else {
        m & 7 && (m += 8 - (m & 7));
        var B = v[m >>> 3] | v[(m >>> 3) + 1] << 8;
        if (m += 32, B > 0)
          for (!E && M < w + B && (T = qr(T, w + B), M = T.length); B-- > 0; )
            T[w++] = v[m >>> 3], m += 8;
        continue;
      }
      for (; ; ) {
        !E && M < w + 32767 && (T = qr(T, w + 32767), M = T.length);
        var z = Ue(v, m, Z), K = k >>> 1 == 1 ? Qr[z] : ze[z];
        if (m += K & 15, K >>>= 4, !(K >>> 8 & 255)) T[w++] = K;
        else {
          if (K == 256) break;
          K -= 257;
          var ee = K < 8 ? 0 : K - 4 >> 2;
          ee > 5 && (ee = 0);
          var se = w + X[K];
          ee > 0 && (se += Ue(v, m, ee), m += ee), z = Ue(v, m, L), K = k >>> 1 == 1 ? Ht[z] : wr[z], m += K & 15, K >>>= 4;
          var q = K < 4 ? 0 : K - 2 >> 1, ne = re[K];
          for (q > 0 && (ne += Ue(v, m, q), m += q), !E && M < se && (T = qr(T, se + 100), M = T.length); w < se; )
            T[w] = T[w - ne], ++w;
        }
      }
    }
    return E ? [T, m + 7 >>> 3] : [T.slice(0, w), m + 7 >>> 3];
  }
  function A0(v, E) {
    var m = v.slice(v.l || 0), k = hf(m, E);
    return v.l += k[1], k[0];
  }
  function F0(v, E) {
    if (v)
      typeof console < "u" && console.error(E);
    else throw new Error(E);
  }
  function S0(v, E) {
    var m = (
      /*::(*/
      v
    );
    Je(m, 0);
    var k = [], T = [], w = {
      FileIndex: k,
      FullPaths: T
    };
    A(w, { root: E.root });
    for (var M = m.length - 4; (m[M] != 80 || m[M + 1] != 75 || m[M + 2] != 5 || m[M + 3] != 6) && M >= 0; ) --M;
    m.l = M + 4, m.l += 4;
    var Z = m.read_shift(2);
    m.l += 6;
    var L = m.read_shift(4);
    for (m.l = L, M = 0; M < Z; ++M) {
      m.l += 20;
      var B = m.read_shift(4), z = m.read_shift(4), K = m.read_shift(2), ee = m.read_shift(2), se = m.read_shift(2);
      m.l += 8;
      var q = m.read_shift(4), ne = c(
        /*::(*/
        m.slice(m.l + K, m.l + K + ee)
        /*:: :any)*/
      );
      m.l += K + ee + se;
      var pe = m.l;
      m.l = q + 4, xf(m, B, z, w, ne), m.l = pe;
    }
    return w;
  }
  function xf(v, E, m, k, T) {
    v.l += 2;
    var w = v.read_shift(2), M = v.read_shift(2), Z = s(v);
    if (w & 8257) throw new Error("Unsupported ZIP encryption");
    for (var L = v.read_shift(4), B = v.read_shift(4), z = v.read_shift(4), K = v.read_shift(2), ee = v.read_shift(2), se = "", q = 0; q < K; ++q) se += String.fromCharCode(v[v.l++]);
    if (ee) {
      var ne = c(
        /*::(*/
        v.slice(v.l, v.l + ee)
        /*:: :any)*/
      );
      (ne[21589] || {}).mt && (Z = ne[21589].mt), ((T || {})[21589] || {}).mt && (Z = T[21589].mt);
    }
    v.l += ee;
    var pe = v.slice(v.l, v.l + B);
    switch (M) {
      case 8:
        pe = U(v, z);
        break;
      case 0:
        break;
      default:
        throw new Error("Unsupported ZIP Compression method " + M);
    }
    var De = !1;
    w & 8 && (L = v.read_shift(4), L == 134695760 && (L = v.read_shift(4), De = !0), B = v.read_shift(4), z = v.read_shift(4)), B != E && F0(De, "Bad compressed size: " + E + " != " + B), z != m && F0(De, "Bad uncompressed size: " + m + " != " + z), dn(k, se, pe, { unsafe: !0, mt: Z });
  }
  function df(v, E) {
    var m = E || {}, k = [], T = [], w = Ge(1), M = m.compression ? 8 : 0, Z = 0, L = 0, B = 0, z = 0, K = 0, ee = v.FullPaths[0], se = ee, q = v.FileIndex[0], ne = [], pe = 0;
    for (L = 1; L < v.FullPaths.length; ++L)
      if (se = v.FullPaths[L].slice(ee.length), q = v.FileIndex[L], !(!q.size || !q.content || se == "Sh33tJ5")) {
        var De = z, Re = Ge(se.length);
        for (B = 0; B < se.length; ++B) Re.write_shift(1, se.charCodeAt(B) & 127);
        Re = Re.slice(0, Re.l), ne[K] = fo.buf(
          /*::((*/
          q.content,
          0
        );
        var rr = q.content;
        M == 8 && (rr = N(rr)), w = Ge(30), w.write_shift(4, 67324752), w.write_shift(2, 20), w.write_shift(2, Z), w.write_shift(2, M), q.mt ? i(w, q.mt) : w.write_shift(4, 0), w.write_shift(-4, ne[K]), w.write_shift(4, rr.length), w.write_shift(
          4,
          /*::(*/
          q.content.length
        ), w.write_shift(2, Re.length), w.write_shift(2, 0), z += w.length, k.push(w), z += Re.length, k.push(Re), z += rr.length, k.push(rr), w = Ge(46), w.write_shift(4, 33639248), w.write_shift(2, 0), w.write_shift(2, 20), w.write_shift(2, Z), w.write_shift(2, M), w.write_shift(4, 0), w.write_shift(-4, ne[K]), w.write_shift(4, rr.length), w.write_shift(
          4,
          /*::(*/
          q.content.length
        ), w.write_shift(2, Re.length), w.write_shift(2, 0), w.write_shift(2, 0), w.write_shift(2, 0), w.write_shift(2, 0), w.write_shift(4, 0), w.write_shift(4, De), pe += w.l, T.push(w), pe += Re.length, T.push(Re), ++K;
      }
    return w = Ge(22), w.write_shift(4, 101010256), w.write_shift(2, 0), w.write_shift(2, 0), w.write_shift(2, K), w.write_shift(2, K), w.write_shift(4, pe), w.write_shift(4, z), w.write_shift(2, 0), rt([rt(k), rt(T), w]);
  }
  var Sa = {
    htm: "text/html",
    xml: "text/xml",
    gif: "image/gif",
    jpg: "image/jpeg",
    png: "image/png",
    mso: "application/x-mso",
    thmx: "application/vnd.ms-officetheme",
    sh33tj5: "application/octet-stream"
  };
  function pf(v, E) {
    if (v.ctype) return v.ctype;
    var m = v.name || "", k = m.match(/\.([^\.]+)$/);
    return k && Sa[k[1]] || E && (k = (m = E).match(/[\.\\]([^\.\\])+$/), k && Sa[k[1]]) ? Sa[k[1]] : "application/octet-stream";
  }
  function vf(v) {
    for (var E = I0(v), m = [], k = 0; k < E.length; k += 76) m.push(E.slice(k, k + 76));
    return m.join(`\r
`) + `\r
`;
  }
  function gf(v) {
    var E = v.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(B) {
      var z = B.charCodeAt(0).toString(16).toUpperCase();
      return "=" + (z.length == 1 ? "0" + z : z);
    });
    E = E.replace(/ $/mg, "=20").replace(/\t$/mg, "=09"), E.charAt(0) == `
` && (E = "=0D" + E.slice(1)), E = E.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, `
=0A`).replace(/([^\r\n])\n/mg, "$1=0A");
    for (var m = [], k = E.split(`\r
`), T = 0; T < k.length; ++T) {
      var w = k[T];
      if (w.length == 0) {
        m.push("");
        continue;
      }
      for (var M = 0; M < w.length; ) {
        var Z = 76, L = w.slice(M, M + Z);
        L.charAt(Z - 1) == "=" ? Z-- : L.charAt(Z - 2) == "=" ? Z -= 2 : L.charAt(Z - 3) == "=" && (Z -= 3), L = w.slice(M, M + Z), M += Z, M < w.length && (L += "="), m.push(L);
      }
    }
    return m.join(`\r
`);
  }
  function mf(v) {
    for (var E = [], m = 0; m < v.length; ++m) {
      for (var k = v[m]; m <= v.length && k.charAt(k.length - 1) == "="; ) k = k.slice(0, k.length - 1) + v[++m];
      E.push(k);
    }
    for (var T = 0; T < E.length; ++T) E[T] = E[T].replace(/[=][0-9A-Fa-f]{2}/g, function(w) {
      return String.fromCharCode(parseInt(w.slice(1), 16));
    });
    return Rr(E.join(`\r
`));
  }
  function _f(v, E, m) {
    for (var k = "", T = "", w = "", M, Z = 0; Z < 10; ++Z) {
      var L = E[Z];
      if (!L || L.match(/^\s*$/)) break;
      var B = L.match(/^(.*?):\s*([^\s].*)$/);
      if (B) switch (B[1].toLowerCase()) {
        case "content-location":
          k = B[2].trim();
          break;
        case "content-type":
          w = B[2].trim();
          break;
        case "content-transfer-encoding":
          T = B[2].trim();
          break;
      }
    }
    switch (++Z, T.toLowerCase()) {
      case "base64":
        M = Rr(Er(E.slice(Z).join("")));
        break;
      case "quoted-printable":
        M = mf(E.slice(Z));
        break;
      default:
        throw new Error("Unsupported Content-Transfer-Encoding " + T);
    }
    var z = dn(v, k.slice(m.length), M, { unsafe: !0 });
    w && (z.ctype = w);
  }
  function kf(v, E) {
    if (H(v.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
    var m = E && E.root || "", k = (_e && Buffer.isBuffer(v) ? v.toString("binary") : H(v)).split(`\r
`), T = 0, w = "";
    for (T = 0; T < k.length; ++T)
      if (w = k[T], !!/^Content-Location:/i.test(w) && (w = w.slice(w.indexOf("file")), m || (m = w.slice(0, w.lastIndexOf("/") + 1)), w.slice(0, m.length) != m))
        for (; m.length > 0 && (m = m.slice(0, m.length - 1), m = m.slice(0, m.lastIndexOf("/") + 1), w.slice(0, m.length) != m); )
          ;
    var M = (k[1] || "").match(/boundary="(.*?)"/);
    if (!M) throw new Error("MAD cannot find boundary");
    var Z = "--" + (M[1] || ""), L = [], B = [], z = {
      FileIndex: L,
      FullPaths: B
    };
    A(z);
    var K, ee = 0;
    for (T = 0; T < k.length; ++T) {
      var se = k[T];
      se !== Z && se !== Z + "--" || (ee++ && _f(z, k.slice(K, T), m), K = T);
    }
    return z;
  }
  function Ef(v, E) {
    var m = E || {}, k = m.boundary || "SheetJS";
    k = "------=" + k;
    for (var T = [
      "MIME-Version: 1.0",
      'Content-Type: multipart/related; boundary="' + k.slice(2) + '"',
      "",
      "",
      ""
    ], w = v.FullPaths[0], M = w, Z = v.FileIndex[0], L = 1; L < v.FullPaths.length; ++L)
      if (M = v.FullPaths[L].slice(w.length), Z = v.FileIndex[L], !(!Z.size || !Z.content || M == "Sh33tJ5")) {
        M = M.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(pe) {
          return "_x" + pe.charCodeAt(0).toString(16) + "_";
        }).replace(/[\u0080-\uFFFF]/g, function(pe) {
          return "_u" + pe.charCodeAt(0).toString(16) + "_";
        });
        for (var B = Z.content, z = _e && Buffer.isBuffer(B) ? B.toString("binary") : H(B), K = 0, ee = Math.min(1024, z.length), se = 0, q = 0; q <= ee; ++q) (se = z.charCodeAt(q)) >= 32 && se < 128 && ++K;
        var ne = K >= ee * 4 / 5;
        T.push(k), T.push("Content-Location: " + (m.root || "file:///C:/SheetJS/") + M), T.push("Content-Transfer-Encoding: " + (ne ? "quoted-printable" : "base64")), T.push("Content-Type: " + pf(Z, M)), T.push(""), T.push(ne ? gf(z) : vf(z));
      }
    return T.push(k + `--\r
`), T.join(`\r
`);
  }
  function Tf(v) {
    var E = {};
    return A(E, v), E;
  }
  function dn(v, E, m, k) {
    var T = k && k.unsafe;
    T || A(v);
    var w = !T && ke.find(v, E);
    if (!w) {
      var M = v.FullPaths[0];
      E.slice(0, M.length) == M ? M = E : (M.slice(-1) != "/" && (M += "/"), M = (M + E).replace("//", "/")), w = { name: n(E), type: 2 }, v.FileIndex.push(w), v.FullPaths.push(M), T || ke.utils.cfb_gc(v);
    }
    return w.content = m, w.size = m ? m.length : 0, k && (k.CLSID && (w.clsid = k.CLSID), k.mt && (w.mt = k.mt), k.ct && (w.ct = k.ct)), w;
  }
  function wf(v, E) {
    A(v);
    var m = ke.find(v, E);
    if (m) {
      for (var k = 0; k < v.FileIndex.length; ++k) if (v.FileIndex[k] == m)
        return v.FileIndex.splice(k, 1), v.FullPaths.splice(k, 1), !0;
    }
    return !1;
  }
  function Af(v, E, m) {
    A(v);
    var k = ke.find(v, E);
    if (k) {
      for (var T = 0; T < v.FileIndex.length; ++T) if (v.FileIndex[T] == k)
        return v.FileIndex[T].name = n(m), v.FullPaths[T] = m, !0;
    }
    return !1;
  }
  function Ff(v) {
    D(v, !0);
  }
  return t.find = W, t.read = O, t.parse = u, t.write = he, t.writeFile = Ce, t.utils = {
    cfb_new: Tf,
    cfb_add: dn,
    cfb_del: wf,
    cfb_mov: Af,
    cfb_gc: Ff,
    ReadShift: qt,
    CheckField: Ls,
    prep_blob: Je,
    bconcat: rt,
    use_zlib: S,
    _deflateRaw: ge,
    _inflateRaw: A0,
    consts: ce
  }, t;
}();
function oo(e) {
  if (typeof Deno < "u") return Deno.readFileSync(e);
  if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u") try {
    var t = File(e);
    t.open("r"), t.encoding = "binary";
    var r = t.read();
    return t.close(), r;
  } catch (a) {
    if (!a.message || !a.message.match(/onstruct/)) throw a;
  }
  throw new Error("Cannot access file " + e);
}
function $r(e) {
  for (var t = Object.keys(e), r = [], a = 0; a < t.length; ++a) Object.prototype.hasOwnProperty.call(e, t[a]) && r.push(t[a]);
  return r;
}
function Xn(e) {
  for (var t = [], r = $r(e), a = 0; a !== r.length; ++a) t[e[r[a]]] = r[a];
  return t;
}
var ja = /* @__PURE__ */ new Date(1899, 11, 30, 0, 0, 0);
function pr(e, t) {
  var r = /* @__PURE__ */ e.getTime(), a = /* @__PURE__ */ ja.getTime() + (/* @__PURE__ */ e.getTimezoneOffset() - /* @__PURE__ */ ja.getTimezoneOffset()) * 6e4;
  return (r - a) / (24 * 60 * 60 * 1e3);
}
var ps = /* @__PURE__ */ new Date(), uo = /* @__PURE__ */ ja.getTime() + (/* @__PURE__ */ ps.getTimezoneOffset() - /* @__PURE__ */ ja.getTimezoneOffset()) * 6e4, U0 = /* @__PURE__ */ ps.getTimezoneOffset();
function sn(e) {
  var t = /* @__PURE__ */ new Date();
  return t.setTime(e * 24 * 60 * 60 * 1e3 + uo), t.getTimezoneOffset() !== U0 && t.setTime(t.getTime() + (t.getTimezoneOffset() - U0) * 6e4), t;
}
function lo(e) {
  var t = 0, r = 0, a = !1, n = e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
  if (!n) throw new Error("|" + e + "| is not an ISO8601 Duration");
  for (var i = 1; i != n.length; ++i)
    if (n[i]) {
      switch (r = 1, i > 3 && (a = !0), n[i].slice(n[i].length - 1)) {
        case "Y":
          throw new Error("Unsupported ISO Duration Field: " + n[i].slice(n[i].length - 1));
        case "D":
          r *= 24;
        case "H":
          r *= 60;
        case "M":
          if (a) r *= 60;
          else throw new Error("Unsupported ISO Duration Field: M");
      }
      t += r * parseInt(n[i], 10);
    }
  return t;
}
var z0 = /* @__PURE__ */ new Date("2017-02-19T19:06:09.000Z"), vs = /* @__PURE__ */ isNaN(/* @__PURE__ */ z0.getFullYear()) ? /* @__PURE__ */ new Date("2/19/17") : z0, ho = /* @__PURE__ */ vs.getFullYear() == 2017;
function Ye(e, t) {
  var r = new Date(e);
  if (ho)
    return t > 0 ? r.setTime(r.getTime() + r.getTimezoneOffset() * 60 * 1e3) : t < 0 && r.setTime(r.getTime() - r.getTimezoneOffset() * 60 * 1e3), r;
  if (e instanceof Date) return e;
  if (vs.getFullYear() == 1917 && !isNaN(r.getFullYear())) {
    var a = r.getFullYear();
    return e.indexOf("" + a) > -1 || r.setFullYear(r.getFullYear() + 100), r;
  }
  var n = e.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"], i = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
  return e.indexOf("Z") > -1 && (i = new Date(i.getTime() - i.getTimezoneOffset() * 60 * 1e3)), i;
}
function gt(e, t) {
  if (_e && Buffer.isBuffer(e)) {
    if (t) {
      if (e[0] == 255 && e[1] == 254) return Yt(e.slice(2).toString("utf16le"));
      if (e[1] == 254 && e[2] == 255) return Yt(ts(e.slice(2).toString("binary")));
    }
    return e.toString("binary");
  }
  if (typeof TextDecoder < "u") try {
    if (t) {
      if (e[0] == 255 && e[1] == 254) return Yt(new TextDecoder("utf-16le").decode(e.slice(2)));
      if (e[0] == 254 && e[1] == 255) return Yt(new TextDecoder("utf-16be").decode(e.slice(2)));
    }
    var r = {
      "€": "",
      "‚": "",
      ƒ: "",
      "„": "",
      "…": "",
      "†": "",
      "‡": "",
      "ˆ": "",
      "‰": "",
      Š: "",
      "‹": "",
      Œ: "",
      Ž: "",
      "‘": "",
      "’": "",
      "“": "",
      "”": "",
      "•": "",
      "–": "",
      "—": "",
      "˜": "",
      "™": "",
      š: "",
      "›": "",
      œ: "",
      ž: "",
      Ÿ: ""
    };
    return Array.isArray(e) && (e = new Uint8Array(e)), new TextDecoder("latin1").decode(e).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(i) {
      return r[i] || i;
    });
  } catch {
  }
  for (var a = [], n = 0; n != e.length; ++n) a.push(String.fromCharCode(e[n]));
  return a.join("");
}
function qe(e) {
  if (typeof JSON < "u" && !Array.isArray(e)) return JSON.parse(JSON.stringify(e));
  if (typeof e != "object" || e == null) return e;
  if (e instanceof Date) return new Date(e.getTime());
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = qe(e[r]));
  return t;
}
function be(e, t) {
  for (var r = ""; r.length < t; ) r += e;
  return r;
}
function Lr(e) {
  var t = Number(e);
  if (!isNaN(t)) return isFinite(t) ? t : NaN;
  if (!/\d/.test(e)) return t;
  var r = 1, a = e.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
    return r *= 100, "";
  });
  return !isNaN(t = Number(a)) || (a = a.replace(/[(](.*)[)]/, function(n, i) {
    return r = -r, i;
  }), !isNaN(t = Number(a))) ? t / r : t;
}
var xo = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
function Lt(e) {
  var t = new Date(e), r = /* @__PURE__ */ new Date(NaN), a = t.getYear(), n = t.getMonth(), i = t.getDate();
  if (isNaN(i)) return r;
  var s = e.toLowerCase();
  if (s.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
    if (s = s.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, ""), s.length > 3 && xo.indexOf(s) == -1) return r;
  } else if (s.match(/[a-z]/)) return r;
  return a < 0 || a > 8099 ? r : (n > 0 || i > 1) && a != 101 ? t : e.match(/[^-0-9:,\/\\]/) ? r : t;
}
var po = /* @__PURE__ */ function() {
  var e = "abacaba".split(/(:?b)/i).length == 5;
  return function(r, a, n) {
    if (e || typeof a == "string") return r.split(a);
    for (var i = r.split(a), s = [i[0]], c = 1; c < i.length; ++c)
      s.push(n), s.push(i[c]);
    return s;
  };
}();
function gs(e) {
  return e ? e.content && e.type ? gt(e.content, !0) : e.data ? jt(e.data) : e.asNodeBuffer && _e ? jt(e.asNodeBuffer().toString("binary")) : e.asBinary ? jt(e.asBinary()) : e._data && e._data.getContent ? jt(gt(Array.prototype.slice.call(e._data.getContent(), 0))) : null : null;
}
function ms(e) {
  if (!e) return null;
  if (e.data) return C0(e.data);
  if (e.asNodeBuffer && _e) return e.asNodeBuffer();
  if (e._data && e._data.getContent) {
    var t = e._data.getContent();
    return typeof t == "string" ? C0(t) : Array.prototype.slice.call(t);
  }
  return e.content && e.type ? e.content : null;
}
function vo(e) {
  return e && e.name.slice(-4) === ".bin" ? ms(e) : gs(e);
}
function Sr(e, t) {
  for (var r = e.FullPaths || $r(e.files), a = t.toLowerCase().replace(/[\/]/g, "\\"), n = a.replace(/\\/g, "/"), i = 0; i < r.length; ++i) {
    var s = r[i].replace(/^Root Entry[\/]/, "").toLowerCase();
    if (a == s || n == s) return e.files ? e.files[r[i]] : e.FileIndex[i];
  }
  return null;
}
function Kn(e, t) {
  var r = Sr(e, t);
  if (r == null) throw new Error("Cannot find file " + t + " in zip");
  return r;
}
function He(e, t, r) {
  if (!r) return vo(Kn(e, t));
  if (!t) return null;
  try {
    return He(e, t);
  } catch {
    return null;
  }
}
function kr(e, t, r) {
  if (!r) return gs(Kn(e, t));
  if (!t) return null;
  try {
    return kr(e, t);
  } catch {
    return null;
  }
}
function go(e, t, r) {
  return ms(Kn(e, t));
}
function $0(e) {
  for (var t = e.FullPaths || $r(e.files), r = [], a = 0; a < t.length; ++a) t[a].slice(-1) != "/" && r.push(t[a].replace(/^Root Entry[\/]/, ""));
  return r.sort();
}
function mo(e, t, r) {
  if (e.FullPaths) {
    if (typeof r == "string") {
      var a;
      return _e ? a = Et(r) : a = Lf(r), ke.utils.cfb_add(e, t, a);
    }
    ke.utils.cfb_add(e, t, r);
  } else e.file(t, r);
}
function _s(e, t) {
  switch (t.type) {
    case "base64":
      return ke.read(e, { type: "base64" });
    case "binary":
      return ke.read(e, { type: "binary" });
    case "buffer":
    case "array":
      return ke.read(e, { type: "buffer" });
  }
  throw new Error("Unrecognized type " + t.type);
}
function Kt(e, t) {
  if (e.charAt(0) == "/") return e.slice(1);
  var r = t.split("/");
  t.slice(-1) != "/" && r.pop();
  for (var a = e.split("/"); a.length !== 0; ) {
    var n = a.shift();
    n === ".." ? r.pop() : n !== "." && r.push(n);
  }
  return r.join("/");
}
var ks = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r
`, _o = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g, V0 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, ko = /<[^>]*>/g, fr = /* @__PURE__ */ ks.match(V0) ? V0 : ko, Eo = /<\w*:/, To = /<(\/?)\w+:/;
function le(e, t, r) {
  for (var a = {}, n = 0, i = 0; n !== e.length && !((i = e.charCodeAt(n)) === 32 || i === 10 || i === 13); ++n) ;
  if (t || (a[0] = e.slice(0, n)), n === e.length) return a;
  var s = e.match(_o), c = 0, f = "", o = 0, u = "", l = "", h = 1;
  if (s) for (o = 0; o != s.length; ++o) {
    for (l = s[o], i = 0; i != l.length && l.charCodeAt(i) !== 61; ++i) ;
    for (u = l.slice(0, i).trim(); l.charCodeAt(i + 1) == 32; ) ++i;
    for (h = (n = l.charCodeAt(i + 1)) == 34 || n == 39 ? 1 : 0, f = l.slice(i + 1 + h, l.length - h), c = 0; c != u.length && u.charCodeAt(c) !== 58; ++c) ;
    if (c === u.length)
      u.indexOf("_") > 0 && (u = u.slice(0, u.indexOf("_"))), a[u] = f, a[u.toLowerCase()] = f;
    else {
      var d = (c === 5 && u.slice(0, 5) === "xmlns" ? "xmlns" : "") + u.slice(c + 1);
      if (a[d] && u.slice(c - 3, c) == "ext") continue;
      a[d] = f, a[d.toLowerCase()] = f;
    }
  }
  return a;
}
function Vr(e) {
  return e.replace(To, "<$1");
}
var Es = {
  "&quot;": '"',
  "&apos;": "'",
  "&gt;": ">",
  "&lt;": "<",
  "&amp;": "&"
}, wo = /* @__PURE__ */ Xn(Es), we = /* @__PURE__ */ function() {
  var e = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, t = /_x([\da-fA-F]{4})_/ig;
  return function r(a) {
    var n = a + "", i = n.indexOf("<![CDATA[");
    if (i == -1) return n.replace(e, function(c, f) {
      return Es[c] || String.fromCharCode(parseInt(f, c.indexOf("x") > -1 ? 16 : 10)) || c;
    }).replace(t, function(c, f) {
      return String.fromCharCode(parseInt(f, 16));
    });
    var s = n.indexOf("]]>");
    return r(n.slice(0, i)) + n.slice(i + 9, s) + r(n.slice(s + 3));
  };
}(), Ao = /[&<>'"]/g, Fo = /[\u0000-\u001f]/g;
function Yn(e) {
  var t = e + "";
  return t.replace(Ao, function(r) {
    return wo[r];
  }).replace(/\n/g, "<br/>").replace(Fo, function(r) {
    return "&#x" + ("000" + r.charCodeAt(0).toString(16)).slice(-4) + ";";
  });
}
var H0 = /* @__PURE__ */ function() {
  var e = /&#(\d+);/g;
  function t(r, a) {
    return String.fromCharCode(parseInt(a, 10));
  }
  return function(a) {
    return a.replace(e, t);
  };
}();
function Oe(e) {
  switch (e) {
    case 1:
    case !0:
    case "1":
    case "true":
    case "TRUE":
      return !0;
    default:
      return !1;
  }
}
function _n(e) {
  for (var t = "", r = 0, a = 0, n = 0, i = 0, s = 0, c = 0; r < e.length; ) {
    if (a = e.charCodeAt(r++), a < 128) {
      t += String.fromCharCode(a);
      continue;
    }
    if (n = e.charCodeAt(r++), a > 191 && a < 224) {
      s = (a & 31) << 6, s |= n & 63, t += String.fromCharCode(s);
      continue;
    }
    if (i = e.charCodeAt(r++), a < 240) {
      t += String.fromCharCode((a & 15) << 12 | (n & 63) << 6 | i & 63);
      continue;
    }
    s = e.charCodeAt(r++), c = ((a & 7) << 18 | (n & 63) << 12 | (i & 63) << 6 | s & 63) - 65536, t += String.fromCharCode(55296 + (c >>> 10 & 1023)), t += String.fromCharCode(56320 + (c & 1023));
  }
  return t;
}
function W0(e) {
  var t = it(2 * e.length), r, a, n = 1, i = 0, s = 0, c;
  for (a = 0; a < e.length; a += n)
    n = 1, (c = e.charCodeAt(a)) < 128 ? r = c : c < 224 ? (r = (c & 31) * 64 + (e.charCodeAt(a + 1) & 63), n = 2) : c < 240 ? (r = (c & 15) * 4096 + (e.charCodeAt(a + 1) & 63) * 64 + (e.charCodeAt(a + 2) & 63), n = 3) : (n = 4, r = (c & 7) * 262144 + (e.charCodeAt(a + 1) & 63) * 4096 + (e.charCodeAt(a + 2) & 63) * 64 + (e.charCodeAt(a + 3) & 63), r -= 65536, s = 55296 + (r >>> 10 & 1023), r = 56320 + (r & 1023)), s !== 0 && (t[i++] = s & 255, t[i++] = s >>> 8, s = 0), t[i++] = r % 256, t[i++] = r >>> 8;
  return t.slice(0, i).toString("ucs2");
}
function Z0(e) {
  return Et(e, "binary").toString("utf8");
}
var Oa = "foo bar bazâð£", ye = _e && (/* @__PURE__ */ Z0(Oa) == /* @__PURE__ */ _n(Oa) && Z0 || /* @__PURE__ */ W0(Oa) == /* @__PURE__ */ _n(Oa) && W0) || _n, Yt = _e ? function(e) {
  return Et(e, "utf8").toString("binary");
} : function(e) {
  for (var t = [], r = 0, a = 0, n = 0; r < e.length; )
    switch (a = e.charCodeAt(r++), !0) {
      case a < 128:
        t.push(String.fromCharCode(a));
        break;
      case a < 2048:
        t.push(String.fromCharCode(192 + (a >> 6))), t.push(String.fromCharCode(128 + (a & 63)));
        break;
      case (a >= 55296 && a < 57344):
        a -= 55296, n = e.charCodeAt(r++) - 56320 + (a << 10), t.push(String.fromCharCode(240 + (n >> 18 & 7))), t.push(String.fromCharCode(144 + (n >> 12 & 63))), t.push(String.fromCharCode(128 + (n >> 6 & 63))), t.push(String.fromCharCode(128 + (n & 63)));
        break;
      default:
        t.push(String.fromCharCode(224 + (a >> 12))), t.push(String.fromCharCode(128 + (a >> 6 & 63))), t.push(String.fromCharCode(128 + (a & 63)));
    }
  return t.join("");
}, ua = /* @__PURE__ */ function() {
  var e = {};
  return function(r, a) {
    var n = r + "|" + (a || "");
    return e[n] ? e[n] : e[n] = new RegExp("<(?:\\w+:)?" + r + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + r + ">", a || "");
  };
}(), Ts = /* @__PURE__ */ function() {
  var e = [
    ["nbsp", " "],
    ["middot", "·"],
    ["quot", '"'],
    ["apos", "'"],
    ["gt", ">"],
    ["lt", "<"],
    ["amp", "&"]
  ].map(function(t) {
    return [new RegExp("&" + t[0] + ";", "ig"), t[1]];
  });
  return function(r) {
    for (var a = r.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/>\s+/g, ">").replace(/\s+</g, "<").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, `
`).replace(/<[^>]*>/g, ""), n = 0; n < e.length; ++n) a = a.replace(e[n][0], e[n][1]);
    return a;
  };
}(), So = /* @__PURE__ */ function() {
  var e = {};
  return function(r) {
    return e[r] !== void 0 ? e[r] : e[r] = new RegExp("<(?:vt:)?" + r + ">([\\s\\S]*?)</(?:vt:)?" + r + ">", "g");
  };
}(), yo = /<\/?(?:vt:)?variant>/g, Co = /<(?:vt:)([^>]*)>([\s\S]*)</;
function G0(e, t) {
  var r = le(e), a = e.match(So(r.baseType)) || [], n = [];
  if (a.length != r.size) {
    if (t.WTF) throw new Error("unexpected vector length " + a.length + " != " + r.size);
    return n;
  }
  return a.forEach(function(i) {
    var s = i.replace(yo, "").match(Co);
    s && n.push({ v: ye(s[2]), t: s[1] });
  }), n;
}
var Oo = /(^\s|\s$|\n)/;
function Io(e) {
  return $r(e).map(function(t) {
    return " " + t + '="' + e[t] + '"';
  }).join("");
}
function Do(e, t, r) {
  return "<" + e + (r != null ? Io(r) : "") + (t != null ? (t.match(Oo) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e : "/") + ">";
}
function Jn(e) {
  if (_e && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/
  Buffer.isBuffer(e)) return e.toString("utf8");
  if (typeof e == "string") return e;
  if (typeof Uint8Array < "u" && e instanceof Uint8Array) return ye(Tt(Zn(e)));
  throw new Error("Bad input format: expected Buffer or string");
}
var la = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg, Ro = {
  CT: "http://schemas.openxmlformats.org/package/2006/content-types"
}, No = [
  "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
  "http://purl.oclc.org/ooxml/spreadsheetml/main",
  "http://schemas.microsoft.com/office/excel/2006/main",
  "http://schemas.microsoft.com/office/excel/2006/2"
];
function bo(e, t) {
  for (var r = 1 - 2 * (e[t + 7] >>> 7), a = ((e[t + 7] & 127) << 4) + (e[t + 6] >>> 4 & 15), n = e[t + 6] & 15, i = 5; i >= 0; --i) n = n * 256 + e[t + i];
  return a == 2047 ? n == 0 ? r * (1 / 0) : NaN : (a == 0 ? a = -1022 : (a -= 1023, n += Math.pow(2, 52)), r * Math.pow(2, a - 52) * n);
}
function Po(e, t, r) {
  var a = (t < 0 || 1 / t == -1 / 0 ? 1 : 0) << 7, n = 0, i = 0, s = a ? -t : t;
  isFinite(s) ? s == 0 ? n = i = 0 : (n = Math.floor(Math.log(s) / Math.LN2), i = s * Math.pow(2, 52 - n), n <= -1023 && (!isFinite(i) || i < Math.pow(2, 52)) ? n = -1022 : (i -= Math.pow(2, 52), n += 1023)) : (n = 2047, i = isNaN(t) ? 26985 : 0);
  for (var c = 0; c <= 5; ++c, i /= 256) e[r + c] = i & 255;
  e[r + 6] = (n & 15) << 4 | i & 15, e[r + 7] = n >> 4 | a;
}
var j0 = function(e) {
  for (var t = [], r = 10240, a = 0; a < e[0].length; ++a) if (e[0][a]) for (var n = 0, i = e[0][a].length; n < i; n += r) t.push.apply(t, e[0][a].slice(n, n + r));
  return t;
}, X0 = _e ? function(e) {
  return e[0].length > 0 && Buffer.isBuffer(e[0][0]) ? Buffer.concat(e[0].map(function(t) {
    return Buffer.isBuffer(t) ? t : Et(t);
  })) : j0(e);
} : j0, K0 = function(e, t, r) {
  for (var a = [], n = t; n < r; n += 2) a.push(String.fromCharCode(jr(e, n)));
  return a.join("").replace(dr, "");
}, qn = _e ? function(e, t, r) {
  return Buffer.isBuffer(e) ? e.toString("utf16le", t, r).replace(dr, "") : K0(e, t, r);
} : K0, Y0 = function(e, t, r) {
  for (var a = [], n = t; n < t + r; ++n) a.push(("0" + e[n].toString(16)).slice(-2));
  return a.join("");
}, ws = _e ? function(e, t, r) {
  return Buffer.isBuffer(e) ? e.toString("hex", t, t + r) : Y0(e, t, r);
} : Y0, J0 = function(e, t, r) {
  for (var a = [], n = t; n < r; n++) a.push(String.fromCharCode(Ot(e, n)));
  return a.join("");
}, _a = _e ? function(t, r, a) {
  return Buffer.isBuffer(t) ? t.toString("utf8", r, a) : J0(t, r, a);
} : J0, As = function(e, t) {
  var r = _r(e, t);
  return r > 0 ? _a(e, t + 4, t + 4 + r - 1) : "";
}, Fs = As, Ss = function(e, t) {
  var r = _r(e, t);
  return r > 0 ? _a(e, t + 4, t + 4 + r - 1) : "";
}, ys = Ss, Cs = function(e, t) {
  var r = 2 * _r(e, t);
  return r > 0 ? _a(e, t + 4, t + 4 + r - 1) : "";
}, Os = Cs, Is = function(t, r) {
  var a = _r(t, r);
  return a > 0 ? qn(t, r + 4, r + 4 + a) : "";
}, Ds = Is, Rs = function(e, t) {
  var r = _r(e, t);
  return r > 0 ? _a(e, t + 4, t + 4 + r) : "";
}, Ns = Rs, bs = function(e, t) {
  return bo(e, t);
}, Xa = bs, Ps = function(t) {
  return Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
};
_e && (Fs = function(t, r) {
  if (!Buffer.isBuffer(t)) return As(t, r);
  var a = t.readUInt32LE(r);
  return a > 0 ? t.toString("utf8", r + 4, r + 4 + a - 1) : "";
}, ys = function(t, r) {
  if (!Buffer.isBuffer(t)) return Ss(t, r);
  var a = t.readUInt32LE(r);
  return a > 0 ? t.toString("utf8", r + 4, r + 4 + a - 1) : "";
}, Os = function(t, r) {
  if (!Buffer.isBuffer(t)) return Cs(t, r);
  var a = 2 * t.readUInt32LE(r);
  return t.toString("utf16le", r + 4, r + 4 + a - 1);
}, Ds = function(t, r) {
  if (!Buffer.isBuffer(t)) return Is(t, r);
  var a = t.readUInt32LE(r);
  return t.toString("utf16le", r + 4, r + 4 + a);
}, Ns = function(t, r) {
  if (!Buffer.isBuffer(t)) return Rs(t, r);
  var a = t.readUInt32LE(r);
  return t.toString("utf8", r + 4, r + 4 + a);
}, Xa = function(t, r) {
  return Buffer.isBuffer(t) ? t.readDoubleLE(r) : bs(t, r);
}, Ps = function(t) {
  return Buffer.isBuffer(t) || Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
});
var Ot = function(e, t) {
  return e[t];
}, jr = function(e, t) {
  return e[t + 1] * 256 + e[t];
}, Lo = function(e, t) {
  var r = e[t + 1] * 256 + e[t];
  return r < 32768 ? r : (65535 - r + 1) * -1;
}, _r = function(e, t) {
  return e[t + 3] * (1 << 24) + (e[t + 2] << 16) + (e[t + 1] << 8) + e[t];
}, ht = function(e, t) {
  return e[t + 3] << 24 | e[t + 2] << 16 | e[t + 1] << 8 | e[t];
}, Mo = function(e, t) {
  return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
};
function qt(e, t) {
  var r = "", a, n, i = [], s, c, f, o;
  switch (t) {
    case "dbcs":
      if (o = this.l, _e && Buffer.isBuffer(this)) r = this.slice(this.l, this.l + 2 * e).toString("utf16le");
      else for (f = 0; f < e; ++f)
        r += String.fromCharCode(jr(this, o)), o += 2;
      e *= 2;
      break;
    case "utf8":
      r = _a(this, this.l, this.l + e);
      break;
    case "utf16le":
      e *= 2, r = qn(this, this.l, this.l + e);
      break;
    case "wstr":
      return qt.call(this, e, "dbcs");
    case "lpstr-ansi":
      r = Fs(this, this.l), e = 4 + _r(this, this.l);
      break;
    case "lpstr-cp":
      r = ys(this, this.l), e = 4 + _r(this, this.l);
      break;
    case "lpwstr":
      r = Os(this, this.l), e = 4 + 2 * _r(this, this.l);
      break;
    case "lpp4":
      e = 4 + _r(this, this.l), r = Ds(this, this.l), e & 2 && (e += 2);
      break;
    case "8lpp4":
      e = 4 + _r(this, this.l), r = Ns(this, this.l), e & 3 && (e += 4 - (e & 3));
      break;
    case "cstr":
      for (e = 0, r = ""; (s = Ot(this, this.l + e++)) !== 0; ) i.push(Ca(s));
      r = i.join("");
      break;
    case "_wstr":
      for (e = 0, r = ""; (s = jr(this, this.l + e)) !== 0; )
        i.push(Ca(s)), e += 2;
      e += 2, r = i.join("");
      break;
    case "dbcs-cont":
      for (r = "", o = this.l, f = 0; f < e; ++f) {
        if (this.lens && this.lens.indexOf(o) !== -1)
          return s = Ot(this, o), this.l = o + 1, c = qt.call(this, e - f, s ? "dbcs-cont" : "sbcs-cont"), i.join("") + c;
        i.push(Ca(jr(this, o))), o += 2;
      }
      r = i.join(""), e *= 2;
      break;
    case "cpstr":
    case "sbcs-cont":
      for (r = "", o = this.l, f = 0; f != e; ++f) {
        if (this.lens && this.lens.indexOf(o) !== -1)
          return s = Ot(this, o), this.l = o + 1, c = qt.call(this, e - f, s ? "dbcs-cont" : "sbcs-cont"), i.join("") + c;
        i.push(Ca(Ot(this, o))), o += 1;
      }
      r = i.join("");
      break;
    default:
      switch (e) {
        case 1:
          return a = Ot(this, this.l), this.l++, a;
        case 2:
          return a = (t === "i" ? Lo : jr)(this, this.l), this.l += 2, a;
        case 4:
        case -4:
          return t === "i" || !(this[this.l + 3] & 128) ? (a = (e > 0 ? ht : Mo)(this, this.l), this.l += 4, a) : (n = _r(this, this.l), this.l += 4, n);
        case 8:
        case -8:
          if (t === "f")
            return e == 8 ? n = Xa(this, this.l) : n = Xa([this[this.l + 7], this[this.l + 6], this[this.l + 5], this[this.l + 4], this[this.l + 3], this[this.l + 2], this[this.l + 1], this[this.l + 0]], 0), this.l += 8, n;
          e = 8;
        case 16:
          r = ws(this, this.l, e);
          break;
      }
  }
  return this.l += e, r;
}
var Bo = function(e, t, r) {
  e[r] = t & 255, e[r + 1] = t >>> 8 & 255, e[r + 2] = t >>> 16 & 255, e[r + 3] = t >>> 24 & 255;
}, Uo = function(e, t, r) {
  e[r] = t & 255, e[r + 1] = t >> 8 & 255, e[r + 2] = t >> 16 & 255, e[r + 3] = t >> 24 & 255;
}, zo = function(e, t, r) {
  e[r] = t & 255, e[r + 1] = t >>> 8 & 255;
};
function $o(e, t, r) {
  var a = 0, n = 0;
  if (r === "dbcs") {
    for (n = 0; n != t.length; ++n) zo(this, t.charCodeAt(n), this.l + 2 * n);
    a = 2 * t.length;
  } else if (r === "sbcs") {
    for (t = t.replace(/[^\x00-\x7F]/g, "_"), n = 0; n != t.length; ++n) this[this.l + n] = t.charCodeAt(n) & 255;
    a = t.length;
  } else if (r === "hex") {
    for (; n < e; ++n)
      this[this.l++] = parseInt(t.slice(2 * n, 2 * n + 2), 16) || 0;
    return this;
  } else if (r === "utf16le") {
    var i = Math.min(this.l + e, this.length);
    for (n = 0; n < Math.min(t.length, e); ++n) {
      var s = t.charCodeAt(n);
      this[this.l++] = s & 255, this[this.l++] = s >> 8;
    }
    for (; this.l < i; ) this[this.l++] = 0;
    return this;
  } else switch (e) {
    case 1:
      a = 1, this[this.l] = t & 255;
      break;
    case 2:
      a = 2, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255;
      break;
    case 3:
      a = 3, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255, t >>>= 8, this[this.l + 2] = t & 255;
      break;
    case 4:
      a = 4, Bo(this, t, this.l);
      break;
    case 8:
      if (a = 8, r === "f") {
        Po(this, t, this.l);
        break;
      }
    case 16:
      break;
    case -4:
      a = 4, Uo(this, t, this.l);
      break;
  }
  return this.l += a, this;
}
function Ls(e, t) {
  var r = ws(this, this.l, e.length >> 1);
  if (r !== e) throw new Error(t + "Expected " + e + " saw " + r);
  this.l += e.length >> 1;
}
function Je(e, t) {
  e.l = t, e.read_shift = /*::(*/
  qt, e.chk = Ls, e.write_shift = $o;
}
function cr(e, t) {
  e.l += t;
}
function Ge(e) {
  var t = it(e);
  return Je(t, 0), t;
}
function Jr(e, t, r) {
  if (e) {
    var a, n, i;
    Je(e, e.l || 0);
    for (var s = e.length, c = 0, f = 0; e.l < s; ) {
      c = e.read_shift(1), c & 128 && (c = (c & 127) + ((e.read_shift(1) & 127) << 7));
      var o = en[c] || en[65535];
      for (a = e.read_shift(1), i = a & 127, n = 1; n < 4 && a & 128; ++n) i += ((a = e.read_shift(1)) & 127) << 7 * n;
      f = e.l + i;
      var u = o.f && o.f(e, i, r);
      if (e.l = f, t(u, o, c)) return;
    }
  }
}
function On() {
  var e = [], t = _e ? 256 : 2048, r = function(o) {
    var u = Ge(o);
    return Je(u, 0), u;
  }, a = r(t), n = function() {
    a && (a.length > a.l && (a = a.slice(0, a.l), a.l = a.length), a.length > 0 && e.push(a), a = null);
  }, i = function(o) {
    return a && o < a.length - a.l ? a : (n(), a = r(Math.max(o + 1, t)));
  }, s = function() {
    return n(), rt(e);
  }, c = function(o) {
    n(), a = o, a.l == null && (a.l = a.length), i(t);
  };
  return { next: i, push: c, end: s, _bufs: e };
}
function Qt(e, t, r) {
  var a = qe(e);
  if (t.s ? (a.cRel && (a.c += t.s.c), a.rRel && (a.r += t.s.r)) : (a.cRel && (a.c += t.c), a.rRel && (a.r += t.r)), !r || r.biff < 12) {
    for (; a.c >= 256; ) a.c -= 256;
    for (; a.r >= 65536; ) a.r -= 65536;
  }
  return a;
}
function q0(e, t, r) {
  var a = qe(e);
  return a.s = Qt(a.s, t.s, r), a.e = Qt(a.e, t.s, r), a;
}
function ea(e, t) {
  if (e.cRel && e.c < 0)
    for (e = qe(e); e.c < 0; ) e.c += t > 8 ? 16384 : 256;
  if (e.rRel && e.r < 0)
    for (e = qe(e); e.r < 0; ) e.r += t > 8 ? 1048576 : t > 5 ? 65536 : 16384;
  var r = de(e);
  return !e.cRel && e.cRel != null && (r = Wo(r)), !e.rRel && e.rRel != null && (r = Vo(r)), r;
}
function kn(e, t) {
  return e.s.r == 0 && !e.s.rRel && e.e.r == (t.biff >= 12 ? 1048575 : t.biff >= 8 ? 65536 : 16384) && !e.e.rRel ? (e.s.cRel ? "" : "$") + je(e.s.c) + ":" + (e.e.cRel ? "" : "$") + je(e.e.c) : e.s.c == 0 && !e.s.cRel && e.e.c == (t.biff >= 12 ? 16383 : 255) && !e.e.cRel ? (e.s.rRel ? "" : "$") + Qe(e.s.r) + ":" + (e.e.rRel ? "" : "$") + Qe(e.e.r) : ea(e.s, t.biff) + ":" + ea(e.e, t.biff);
}
function Qn(e) {
  return parseInt(Ho(e), 10) - 1;
}
function Qe(e) {
  return "" + (e + 1);
}
function Vo(e) {
  return e.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function Ho(e) {
  return e.replace(/\$(\d+)$/, "$1");
}
function e0(e) {
  for (var t = Zo(e), r = 0, a = 0; a !== t.length; ++a) r = 26 * r + t.charCodeAt(a) - 64;
  return r - 1;
}
function je(e) {
  if (e < 0) throw new Error("invalid column " + e);
  var t = "";
  for (++e; e; e = Math.floor((e - 1) / 26)) t = String.fromCharCode((e - 1) % 26 + 65) + t;
  return t;
}
function Wo(e) {
  return e.replace(/^([A-Z])/, "$$$1");
}
function Zo(e) {
  return e.replace(/^\$([A-Z])/, "$1");
}
function Go(e) {
  return e.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function xr(e) {
  for (var t = 0, r = 0, a = 0; a < e.length; ++a) {
    var n = e.charCodeAt(a);
    n >= 48 && n <= 57 ? t = 10 * t + (n - 48) : n >= 65 && n <= 90 && (r = 26 * r + (n - 64));
  }
  return { c: r - 1, r: t - 1 };
}
function de(e) {
  for (var t = e.c + 1, r = ""; t; t = (t - 1) / 26 | 0) r = String.fromCharCode((t - 1) % 26 + 65) + r;
  return r + (e.r + 1);
}
function Ut(e) {
  var t = e.indexOf(":");
  return t == -1 ? { s: xr(e), e: xr(e) } : { s: xr(e.slice(0, t)), e: xr(e.slice(t + 1)) };
}
function Ee(e, t) {
  return typeof t > "u" || typeof t == "number" ? Ee(e.s, e.e) : (typeof e != "string" && (e = de(e)), typeof t != "string" && (t = de(t)), e == t ? e : e + ":" + t);
}
function Pe(e) {
  var t = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }, r = 0, a = 0, n = 0, i = e.length;
  for (r = 0; a < i && !((n = e.charCodeAt(a) - 64) < 1 || n > 26); ++a)
    r = 26 * r + n;
  for (t.s.c = --r, r = 0; a < i && !((n = e.charCodeAt(a) - 48) < 0 || n > 9); ++a)
    r = 10 * r + n;
  if (t.s.r = --r, a === i || n != 10)
    return t.e.c = t.s.c, t.e.r = t.s.r, t;
  for (++a, r = 0; a != i && !((n = e.charCodeAt(a) - 64) < 1 || n > 26); ++a)
    r = 26 * r + n;
  for (t.e.c = --r, r = 0; a != i && !((n = e.charCodeAt(a) - 48) < 0 || n > 9); ++a)
    r = 10 * r + n;
  return t.e.r = --r, t;
}
function Q0(e, t) {
  var r = e.t == "d" && t instanceof Date;
  if (e.z != null) try {
    return e.w = yr(e.z, r ? pr(t) : t);
  } catch {
  }
  try {
    return e.w = yr((e.XF || {}).numFmtId || (r ? 14 : 0), r ? pr(t) : t);
  } catch {
    return "" + t;
  }
}
function Yr(e, t, r) {
  return e == null || e.t == null || e.t == "z" ? "" : e.w !== void 0 ? e.w : (e.t == "d" && !e.z && r && r.dateNF && (e.z = r.dateNF), e.t == "e" ? Ft[e.v] || e.v : t == null ? Q0(e, e.v) : Q0(e, t));
}
function ct(e, t) {
  var r = t && t.sheet ? t.sheet : "Sheet1", a = {};
  return a[r] = e, { SheetNames: [r], Sheets: a };
}
function Ms(e, t, r) {
  var a = r || {}, n = e ? Array.isArray(e) : a.dense, i = e || (n ? [] : {}), s = 0, c = 0;
  if (i && a.origin != null) {
    if (typeof a.origin == "number") s = a.origin;
    else {
      var f = typeof a.origin == "string" ? xr(a.origin) : a.origin;
      s = f.r, c = f.c;
    }
    i["!ref"] || (i["!ref"] = "A1:A1");
  }
  var o = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
  if (i["!ref"]) {
    var u = Pe(i["!ref"]);
    o.s.c = u.s.c, o.s.r = u.s.r, o.e.c = Math.max(o.e.c, u.e.c), o.e.r = Math.max(o.e.r, u.e.r), s == -1 && (o.e.r = s = u.e.r + 1);
  }
  for (var l = 0; l != t.length; ++l)
    if (t[l]) {
      if (!Array.isArray(t[l])) throw new Error("aoa_to_sheet expects an array of arrays");
      for (var h = 0; h != t[l].length; ++h)
        if (!(typeof t[l][h] > "u")) {
          var d = { v: t[l][h] }, p = s + l, x = c + h;
          if (o.s.r > p && (o.s.r = p), o.s.c > x && (o.s.c = x), o.e.r < p && (o.e.r = p), o.e.c < x && (o.e.c = x), t[l][h] && typeof t[l][h] == "object" && !Array.isArray(t[l][h]) && !(t[l][h] instanceof Date)) d = t[l][h];
          else if (Array.isArray(d.v) && (d.f = t[l][h][1], d.v = d.v[0]), d.v === null)
            if (d.f) d.t = "n";
            else if (a.nullError)
              d.t = "e", d.v = 0;
            else if (a.sheetStubs) d.t = "z";
            else continue;
          else typeof d.v == "number" ? d.t = "n" : typeof d.v == "boolean" ? d.t = "b" : d.v instanceof Date ? (d.z = a.dateNF || ve[14], a.cellDates ? (d.t = "d", d.w = yr(d.z, pr(d.v))) : (d.t = "n", d.v = pr(d.v), d.w = yr(d.z, d.v))) : d.t = "s";
          if (n)
            i[p] || (i[p] = []), i[p][x] && i[p][x].z && (d.z = i[p][x].z), i[p][x] = d;
          else {
            var g = de({ c: x, r: p });
            i[g] && i[g].z && (d.z = i[g].z), i[g] = d;
          }
        }
    }
  return o.s.c < 1e7 && (i["!ref"] = Ee(o)), i;
}
function zt(e, t) {
  return Ms(null, e, t);
}
function jo(e) {
  return e.read_shift(4, "i");
}
function sr(e) {
  var t = e.read_shift(4);
  return t === 0 ? "" : e.read_shift(t, "dbcs");
}
function Xo(e) {
  return { ich: e.read_shift(2), ifnt: e.read_shift(2) };
}
function r0(e, t) {
  var r = e.l, a = e.read_shift(1), n = sr(e), i = [], s = { t: n, h: n };
  if (a & 1) {
    for (var c = e.read_shift(4), f = 0; f != c; ++f) i.push(Xo(e));
    s.r = i;
  } else s.r = [{ ich: 0, ifnt: 0 }];
  return e.l = r + t, s;
}
var Ko = r0;
function Cr(e) {
  var t = e.read_shift(4), r = e.read_shift(2);
  return r += e.read_shift(1) << 16, e.l++, { c: t, iStyleRef: r };
}
function wt(e) {
  var t = e.read_shift(2);
  return t += e.read_shift(1) << 16, e.l++, { c: -1, iStyleRef: t };
}
var Yo = sr;
function t0(e) {
  var t = e.read_shift(4);
  return t === 0 || t === 4294967295 ? "" : e.read_shift(t, "dbcs");
}
var Jo = sr, In = t0;
function a0(e) {
  var t = e.slice(e.l, e.l + 4), r = t[0] & 1, a = t[0] & 2;
  e.l += 4;
  var n = a === 0 ? Xa([0, 0, 0, 0, t[0] & 252, t[1], t[2], t[3]], 0) : ht(t, 0) >> 2;
  return r ? n / 100 : n;
}
function Bs(e) {
  var t = { s: {}, e: {} };
  return t.s.r = e.read_shift(4), t.e.r = e.read_shift(4), t.s.c = e.read_shift(4), t.e.c = e.read_shift(4), t;
}
var At = Bs;
function nr(e) {
  if (e.length - e.l < 8) throw "XLS Xnum Buffer underflow";
  return e.read_shift(8, "f");
}
function qo(e) {
  var t = {}, r = e.read_shift(1), a = r >>> 1, n = e.read_shift(1), i = e.read_shift(2, "i"), s = e.read_shift(1), c = e.read_shift(1), f = e.read_shift(1);
  switch (e.l++, a) {
    case 0:
      t.auto = 1;
      break;
    case 1:
      t.index = n;
      var o = pt[n];
      o && (t.rgb = xa(o));
      break;
    case 2:
      t.rgb = xa([s, c, f]);
      break;
    case 3:
      t.theme = n;
      break;
  }
  return i != 0 && (t.tint = i > 0 ? i / 32767 : i / 32768), t;
}
function Qo(e) {
  var t = e.read_shift(1);
  e.l++;
  var r = {
    fBold: t & 1,
    fItalic: t & 2,
    fUnderline: t & 4,
    fStrikeout: t & 8,
    fOutline: t & 16,
    fShadow: t & 32,
    fCondense: t & 64,
    fExtend: t & 128
  };
  return r;
}
function Us(e, t) {
  var r = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" }, a = e.read_shift(4);
  switch (a) {
    case 0:
      return "";
    case 4294967295:
    case 4294967294:
      return r[e.read_shift(4)] || "";
  }
  if (a > 400) throw new Error("Unsupported Clipboard: " + a.toString(16));
  return e.l -= 4, e.read_shift(0, t == 1 ? "lpstr" : "lpwstr");
}
function eu(e) {
  return Us(e, 1);
}
function ru(e) {
  return Us(e, 2);
}
var n0 = 2, vr = 3, Ia = 11, ei = 12, Ka = 19, Da = 64, tu = 65, au = 71, nu = 4108, iu = 4126, Ke = 80, zs = 81, su = [Ke, zs], cu = {
  /*::[*/
  1: { n: "CodePage", t: n0 },
  /*::[*/
  2: { n: "Category", t: Ke },
  /*::[*/
  3: { n: "PresentationFormat", t: Ke },
  /*::[*/
  4: { n: "ByteCount", t: vr },
  /*::[*/
  5: { n: "LineCount", t: vr },
  /*::[*/
  6: { n: "ParagraphCount", t: vr },
  /*::[*/
  7: { n: "SlideCount", t: vr },
  /*::[*/
  8: { n: "NoteCount", t: vr },
  /*::[*/
  9: { n: "HiddenCount", t: vr },
  /*::[*/
  10: { n: "MultimediaClipCount", t: vr },
  /*::[*/
  11: { n: "ScaleCrop", t: Ia },
  /*::[*/
  12: {
    n: "HeadingPairs",
    t: nu
    /* VT_VECTOR | VT_VARIANT */
  },
  /*::[*/
  13: {
    n: "TitlesOfParts",
    t: iu
    /* VT_VECTOR | VT_LPSTR */
  },
  /*::[*/
  14: { n: "Manager", t: Ke },
  /*::[*/
  15: { n: "Company", t: Ke },
  /*::[*/
  16: { n: "LinksUpToDate", t: Ia },
  /*::[*/
  17: { n: "CharacterCount", t: vr },
  /*::[*/
  19: { n: "SharedDoc", t: Ia },
  /*::[*/
  22: { n: "HyperlinksChanged", t: Ia },
  /*::[*/
  23: { n: "AppVersion", t: vr, p: "version" },
  /*::[*/
  24: { n: "DigSig", t: tu },
  /*::[*/
  26: { n: "ContentType", t: Ke },
  /*::[*/
  27: { n: "ContentStatus", t: Ke },
  /*::[*/
  28: { n: "Language", t: Ke },
  /*::[*/
  29: { n: "Version", t: Ke },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: Ka },
  /*::[*/
  2147483651: { n: "Behavior", t: Ka },
  /*::[*/
  1919054434: {}
}, fu = {
  /*::[*/
  1: { n: "CodePage", t: n0 },
  /*::[*/
  2: { n: "Title", t: Ke },
  /*::[*/
  3: { n: "Subject", t: Ke },
  /*::[*/
  4: { n: "Author", t: Ke },
  /*::[*/
  5: { n: "Keywords", t: Ke },
  /*::[*/
  6: { n: "Comments", t: Ke },
  /*::[*/
  7: { n: "Template", t: Ke },
  /*::[*/
  8: { n: "LastAuthor", t: Ke },
  /*::[*/
  9: { n: "RevNumber", t: Ke },
  /*::[*/
  10: { n: "EditTime", t: Da },
  /*::[*/
  11: { n: "LastPrinted", t: Da },
  /*::[*/
  12: { n: "CreatedDate", t: Da },
  /*::[*/
  13: { n: "ModifiedDate", t: Da },
  /*::[*/
  14: { n: "PageCount", t: vr },
  /*::[*/
  15: { n: "WordCount", t: vr },
  /*::[*/
  16: { n: "CharCount", t: vr },
  /*::[*/
  17: { n: "Thumbnail", t: au },
  /*::[*/
  18: { n: "Application", t: Ke },
  /*::[*/
  19: { n: "DocSecurity", t: vr },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: Ka },
  /*::[*/
  2147483651: { n: "Behavior", t: Ka },
  /*::[*/
  1919054434: {}
}, ri = {
  /*::[*/
  1: "US",
  // United States
  /*::[*/
  2: "CA",
  // Canada
  /*::[*/
  3: "",
  // Latin America (except Brazil)
  /*::[*/
  7: "RU",
  // Russia
  /*::[*/
  20: "EG",
  // Egypt
  /*::[*/
  30: "GR",
  // Greece
  /*::[*/
  31: "NL",
  // Netherlands
  /*::[*/
  32: "BE",
  // Belgium
  /*::[*/
  33: "FR",
  // France
  /*::[*/
  34: "ES",
  // Spain
  /*::[*/
  36: "HU",
  // Hungary
  /*::[*/
  39: "IT",
  // Italy
  /*::[*/
  41: "CH",
  // Switzerland
  /*::[*/
  43: "AT",
  // Austria
  /*::[*/
  44: "GB",
  // United Kingdom
  /*::[*/
  45: "DK",
  // Denmark
  /*::[*/
  46: "SE",
  // Sweden
  /*::[*/
  47: "NO",
  // Norway
  /*::[*/
  48: "PL",
  // Poland
  /*::[*/
  49: "DE",
  // Germany
  /*::[*/
  52: "MX",
  // Mexico
  /*::[*/
  55: "BR",
  // Brazil
  /*::[*/
  61: "AU",
  // Australia
  /*::[*/
  64: "NZ",
  // New Zealand
  /*::[*/
  66: "TH",
  // Thailand
  /*::[*/
  81: "JP",
  // Japan
  /*::[*/
  82: "KR",
  // Korea
  /*::[*/
  84: "VN",
  // Viet Nam
  /*::[*/
  86: "CN",
  // China
  /*::[*/
  90: "TR",
  // Turkey
  /*::[*/
  105: "JS",
  // Ramastan
  /*::[*/
  213: "DZ",
  // Algeria
  /*::[*/
  216: "MA",
  // Morocco
  /*::[*/
  218: "LY",
  // Libya
  /*::[*/
  351: "PT",
  // Portugal
  /*::[*/
  354: "IS",
  // Iceland
  /*::[*/
  358: "FI",
  // Finland
  /*::[*/
  420: "CZ",
  // Czech Republic
  /*::[*/
  886: "TW",
  // Taiwan
  /*::[*/
  961: "LB",
  // Lebanon
  /*::[*/
  962: "JO",
  // Jordan
  /*::[*/
  963: "SY",
  // Syria
  /*::[*/
  964: "IQ",
  // Iraq
  /*::[*/
  965: "KW",
  // Kuwait
  /*::[*/
  966: "SA",
  // Saudi Arabia
  /*::[*/
  971: "AE",
  // United Arab Emirates
  /*::[*/
  972: "IL",
  // Israel
  /*::[*/
  974: "QA",
  // Qatar
  /*::[*/
  981: "IR",
  // Iran
  /*::[*/
  65535: "US"
  // United States
}, ou = [
  null,
  "solid",
  "mediumGray",
  "darkGray",
  "lightGray",
  "darkHorizontal",
  "darkVertical",
  "darkDown",
  "darkUp",
  "darkGrid",
  "darkTrellis",
  "lightHorizontal",
  "lightVertical",
  "lightDown",
  "lightUp",
  "lightGrid",
  "lightTrellis",
  "gray125",
  "gray0625"
];
function uu(e) {
  return e.map(function(t) {
    return [t >> 16 & 255, t >> 8 & 255, t & 255];
  });
}
var lu = /* @__PURE__ */ uu([
  /* Color Constants */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  /* Overridable Defaults */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  8388608,
  32768,
  128,
  8421376,
  8388736,
  32896,
  12632256,
  8421504,
  10066431,
  10040166,
  16777164,
  13434879,
  6684774,
  16744576,
  26316,
  13421823,
  128,
  16711935,
  16776960,
  65535,
  8388736,
  8388608,
  32896,
  255,
  52479,
  13434879,
  13434828,
  16777113,
  10079487,
  16751052,
  13408767,
  16764057,
  3368703,
  3394764,
  10079232,
  16763904,
  16750848,
  16737792,
  6710937,
  9868950,
  13158,
  3381606,
  13056,
  3355392,
  10040064,
  10040166,
  3355545,
  3355443,
  /* Other entries to appease BIFF8/12 */
  16777215,
  /* 0x40 icvForeground ?? */
  0,
  /* 0x41 icvBackground ?? */
  0,
  /* 0x42 icvFrame ?? */
  0,
  /* 0x43 icv3D ?? */
  0,
  /* 0x44 icv3DText ?? */
  0,
  /* 0x45 icv3DHilite ?? */
  0,
  /* 0x46 icv3DShadow ?? */
  0,
  /* 0x47 icvHilite ?? */
  0,
  /* 0x48 icvCtlText ?? */
  0,
  /* 0x49 icvCtlScrl ?? */
  0,
  /* 0x4A icvCtlInv ?? */
  0,
  /* 0x4B icvCtlBody ?? */
  0,
  /* 0x4C icvCtlFrame ?? */
  0,
  /* 0x4D icvCtlFore ?? */
  0,
  /* 0x4E icvCtlBack ?? */
  0,
  /* 0x4F icvCtlNeutral */
  0,
  /* 0x50 icvInfoBk ?? */
  0
  /* 0x51 icvInfoText ?? */
]), pt = /* @__PURE__ */ qe(lu), Ft = {
  /*::[*/
  0: "#NULL!",
  /*::[*/
  7: "#DIV/0!",
  /*::[*/
  15: "#VALUE!",
  /*::[*/
  23: "#REF!",
  /*::[*/
  29: "#NAME?",
  /*::[*/
  36: "#NUM!",
  /*::[*/
  42: "#N/A",
  /*::[*/
  43: "#GETTING_DATA",
  /*::[*/
  255: "#WTF?"
}, $s = {
  "#NULL!": 0,
  "#DIV/0!": 7,
  "#VALUE!": 15,
  "#REF!": 23,
  "#NAME?": 29,
  "#NUM!": 36,
  "#N/A": 42,
  "#GETTING_DATA": 43,
  "#WTF?": 255
}, ti = {
  /* Workbook */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
  "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
  /* Worksheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
  "application/vnd.ms-excel.worksheet": "sheets",
  "application/vnd.ms-excel.binIndexWs": "TODO",
  /* Binary Index */
  /* Chartsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
  "application/vnd.ms-excel.chartsheet": "charts",
  /* Macrosheet */
  "application/vnd.ms-excel.macrosheet+xml": "macros",
  "application/vnd.ms-excel.macrosheet": "macros",
  "application/vnd.ms-excel.intlmacrosheet": "TODO",
  "application/vnd.ms-excel.binIndexMs": "TODO",
  /* Binary Index */
  /* Dialogsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
  "application/vnd.ms-excel.dialogsheet": "dialogs",
  /* Shared Strings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
  "application/vnd.ms-excel.sharedStrings": "strs",
  /* Styles */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
  "application/vnd.ms-excel.styles": "styles",
  /* File Properties */
  "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
  /* Custom Data Properties */
  "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
  /* Comments */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
  "application/vnd.ms-excel.comments": "comments",
  "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
  "application/vnd.ms-excel.person+xml": "people",
  /* Metadata (Stock/Geography and Dynamic Array) */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
  "application/vnd.ms-excel.sheetMetadata": "metadata",
  /* PivotTable */
  "application/vnd.ms-excel.pivotTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
  /* Chart Objects */
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
  /* Chart Colors */
  "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
  /* Chart Style */
  "application/vnd.ms-office.chartstyle+xml": "TODO",
  /* Chart Advanced */
  "application/vnd.ms-office.chartex+xml": "TODO",
  /* Calculation Chain */
  "application/vnd.ms-excel.calcChain": "calcchains",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
  /* Printer Settings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
  /* ActiveX */
  "application/vnd.ms-office.activeX": "TODO",
  "application/vnd.ms-office.activeX+xml": "TODO",
  /* Custom Toolbars */
  "application/vnd.ms-excel.attachedToolbars": "TODO",
  /* External Data Connections */
  "application/vnd.ms-excel.connections": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
  /* External Links */
  "application/vnd.ms-excel.externalLink": "links",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
  /* PivotCache */
  "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
  "application/vnd.ms-excel.pivotCacheRecords": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
  /* Query Table */
  "application/vnd.ms-excel.queryTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
  /* Shared Workbook */
  "application/vnd.ms-excel.userNames": "TODO",
  "application/vnd.ms-excel.revisionHeaders": "TODO",
  "application/vnd.ms-excel.revisionLog": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
  /* Single Cell Table */
  "application/vnd.ms-excel.tableSingleCells": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
  /* Slicer */
  "application/vnd.ms-excel.slicer": "TODO",
  "application/vnd.ms-excel.slicerCache": "TODO",
  "application/vnd.ms-excel.slicer+xml": "TODO",
  "application/vnd.ms-excel.slicerCache+xml": "TODO",
  /* Sort Map */
  "application/vnd.ms-excel.wsSortMap": "TODO",
  /* Table */
  "application/vnd.ms-excel.table": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
  /* Themes */
  "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
  /* Theme Override */
  "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
  /* Timeline */
  "application/vnd.ms-excel.Timeline+xml": "TODO",
  /* verify */
  "application/vnd.ms-excel.TimelineCache+xml": "TODO",
  /* verify */
  /* VBA */
  "application/vnd.ms-office.vbaProject": "vba",
  "application/vnd.ms-office.vbaProjectSignature": "TODO",
  /* Volatile Dependencies */
  "application/vnd.ms-office.volatileDependencies": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
  /* Control Properties */
  "application/vnd.ms-excel.controlproperties+xml": "TODO",
  /* Data Model */
  "application/vnd.openxmlformats-officedocument.model+data": "TODO",
  /* Survey */
  "application/vnd.ms-excel.Survey+xml": "TODO",
  /* Drawing */
  "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
  /* VML */
  "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
  "application/vnd.openxmlformats-package.relationships+xml": "rels",
  "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
  /* Image */
  "image/png": "TODO",
  sheet: "js"
};
function hu() {
  return {
    workbooks: [],
    sheets: [],
    charts: [],
    dialogs: [],
    macros: [],
    rels: [],
    strs: [],
    comments: [],
    threadedcomments: [],
    links: [],
    coreprops: [],
    extprops: [],
    custprops: [],
    themes: [],
    styles: [],
    calcchains: [],
    vba: [],
    drawings: [],
    metadata: [],
    people: [],
    TODO: [],
    xmlns: ""
  };
}
function xu(e) {
  var t = hu();
  if (!e || !e.match) return t;
  var r = {};
  if ((e.match(fr) || []).forEach(function(a) {
    var n = le(a);
    switch (n[0].replace(Eo, "<")) {
      case "<?xml":
        break;
      case "<Types":
        t.xmlns = n["xmlns" + (n[0].match(/<(\w+):/) || ["", ""])[1]];
        break;
      case "<Default":
        r[n.Extension] = n.ContentType;
        break;
      case "<Override":
        t[ti[n.ContentType]] !== void 0 && t[ti[n.ContentType]].push(n.PartName);
        break;
    }
  }), t.xmlns !== Ro.CT) throw new Error("Unknown Namespace: " + t.xmlns);
  return t.calcchain = t.calcchains.length > 0 ? t.calcchains[0] : "", t.sst = t.strs.length > 0 ? t.strs[0] : "", t.style = t.styles.length > 0 ? t.styles[0] : "", t.defaults = r, delete t.calcchains, t;
}
var It = {
  WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
  VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
  XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
  XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
  XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
  CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
  CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
  CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
  SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
  STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
  THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
  CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
  CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
  CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
  WS: [
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
  ],
  DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
  MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
  IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
  DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
  XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
  TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
  PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
  VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
};
function Dn(e) {
  var t = e.lastIndexOf("/");
  return e.slice(0, t + 1) + "_rels/" + e.slice(t + 1) + ".rels";
}
function ra(e, t) {
  var r = { "!id": {} };
  if (!e) return r;
  t.charAt(0) !== "/" && (t = "/" + t);
  var a = {};
  return (e.match(fr) || []).forEach(function(n) {
    var i = le(n);
    if (i[0] === "<Relationship") {
      var s = {};
      s.Type = i.Type, s.Target = i.Target, s.Id = i.Id, i.TargetMode && (s.TargetMode = i.TargetMode);
      var c = i.TargetMode === "External" ? i.Target : Kt(i.Target, t);
      r[c] = s, a[i.Id] = s;
    }
  }), r["!id"] = a, r;
}
var du = "application/vnd.oasis.opendocument.spreadsheet";
function pu(e, t) {
  for (var r = Jn(e), a, n; a = la.exec(r); ) switch (a[3]) {
    case "manifest":
      break;
    case "file-entry":
      if (n = le(a[0], !1), n.path == "/" && n.type !== du) throw new Error("This OpenDocument is not a spreadsheet");
      break;
    case "encryption-data":
    case "algorithm":
    case "start-key-generation":
    case "key-derivation":
      throw new Error("Unsupported ODS Encryption");
    default:
      if (t && t.WTF) throw a;
  }
}
var ta = [
  ["cp:category", "Category"],
  ["cp:contentStatus", "ContentStatus"],
  ["cp:keywords", "Keywords"],
  ["cp:lastModifiedBy", "LastAuthor"],
  ["cp:lastPrinted", "LastPrinted"],
  ["cp:revision", "RevNumber"],
  ["cp:version", "Version"],
  ["dc:creator", "Author"],
  ["dc:description", "Comments"],
  ["dc:identifier", "Identifier"],
  ["dc:language", "Language"],
  ["dc:subject", "Subject"],
  ["dc:title", "Title"],
  ["dcterms:created", "CreatedDate", "date"],
  ["dcterms:modified", "ModifiedDate", "date"]
], vu = /* @__PURE__ */ function() {
  for (var e = new Array(ta.length), t = 0; t < ta.length; ++t) {
    var r = ta[t], a = "(?:" + r[0].slice(0, r[0].indexOf(":")) + ":)" + r[0].slice(r[0].indexOf(":") + 1);
    e[t] = new RegExp("<" + a + "[^>]*>([\\s\\S]*?)</" + a + ">");
  }
  return e;
}();
function Vs(e) {
  var t = {};
  e = ye(e);
  for (var r = 0; r < ta.length; ++r) {
    var a = ta[r], n = e.match(vu[r]);
    n != null && n.length > 0 && (t[a[1]] = we(n[1])), a[2] === "date" && t[a[1]] && (t[a[1]] = Ye(t[a[1]]));
  }
  return t;
}
var gu = [
  ["Application", "Application", "string"],
  ["AppVersion", "AppVersion", "string"],
  ["Company", "Company", "string"],
  ["DocSecurity", "DocSecurity", "string"],
  ["Manager", "Manager", "string"],
  ["HyperlinksChanged", "HyperlinksChanged", "bool"],
  ["SharedDoc", "SharedDoc", "bool"],
  ["LinksUpToDate", "LinksUpToDate", "bool"],
  ["ScaleCrop", "ScaleCrop", "bool"],
  ["HeadingPairs", "HeadingPairs", "raw"],
  ["TitlesOfParts", "TitlesOfParts", "raw"]
];
function Hs(e, t, r, a) {
  var n = [];
  if (typeof e == "string") n = G0(e, a);
  else for (var i = 0; i < e.length; ++i) n = n.concat(e[i].map(function(u) {
    return { v: u };
  }));
  var s = typeof t == "string" ? G0(t, a).map(function(u) {
    return u.v;
  }) : t, c = 0, f = 0;
  if (s.length > 0) for (var o = 0; o !== n.length; o += 2) {
    switch (f = +n[o + 1].v, n[o].v) {
      case "Worksheets":
      case "工作表":
      case "Листы":
      case "أوراق العمل":
      case "ワークシート":
      case "גליונות עבודה":
      case "Arbeitsblätter":
      case "Çalışma Sayfaları":
      case "Feuilles de calcul":
      case "Fogli di lavoro":
      case "Folhas de cálculo":
      case "Planilhas":
      case "Regneark":
      case "Hojas de cálculo":
      case "Werkbladen":
        r.Worksheets = f, r.SheetNames = s.slice(c, c + f);
        break;
      case "Named Ranges":
      case "Rangos con nombre":
      case "名前付き一覧":
      case "Benannte Bereiche":
      case "Navngivne områder":
        r.NamedRanges = f, r.DefinedNames = s.slice(c, c + f);
        break;
      case "Charts":
      case "Diagramme":
        r.Chartsheets = f, r.ChartNames = s.slice(c, c + f);
        break;
    }
    c += f;
  }
}
function mu(e, t, r) {
  var a = {};
  return t || (t = {}), e = ye(e), gu.forEach(function(n) {
    var i = (e.match(ua(n[0])) || [])[1];
    switch (n[2]) {
      case "string":
        i && (t[n[1]] = we(i));
        break;
      case "bool":
        t[n[1]] = i === "true";
        break;
      case "raw":
        var s = e.match(new RegExp("<" + n[0] + "[^>]*>([\\s\\S]*?)</" + n[0] + ">"));
        s && s.length > 0 && (a[n[1]] = s[1]);
        break;
    }
  }), a.HeadingPairs && a.TitlesOfParts && Hs(a.HeadingPairs, a.TitlesOfParts, t, r), t;
}
var _u = /<[^>]+>[^<]*/g;
function ku(e, t) {
  var r = {}, a = "", n = e.match(_u);
  if (n) for (var i = 0; i != n.length; ++i) {
    var s = n[i], c = le(s);
    switch (c[0]) {
      case "<?xml":
        break;
      case "<Properties":
        break;
      case "<property":
        a = we(c.name);
        break;
      case "</property>":
        a = null;
        break;
      default:
        if (s.indexOf("<vt:") === 0) {
          var f = s.split(">"), o = f[0].slice(4), u = f[1];
          switch (o) {
            case "lpstr":
            case "bstr":
            case "lpwstr":
              r[a] = we(u);
              break;
            case "bool":
              r[a] = Oe(u);
              break;
            case "i1":
            case "i2":
            case "i4":
            case "i8":
            case "int":
            case "uint":
              r[a] = parseInt(u, 10);
              break;
            case "r4":
            case "r8":
            case "decimal":
              r[a] = parseFloat(u);
              break;
            case "filetime":
            case "date":
              r[a] = Ye(u);
              break;
            case "cy":
            case "error":
              r[a] = we(u);
              break;
            default:
              if (o.slice(-1) == "/") break;
              t.WTF && typeof console < "u" && console.warn("Unexpected", s, o, f);
          }
        } else if (s.slice(0, 2) !== "</") {
          if (t.WTF) throw new Error(s);
        }
    }
  }
  return r;
}
var Eu = {
  Title: "Title",
  Subject: "Subject",
  Author: "Author",
  Keywords: "Keywords",
  Comments: "Description",
  LastAuthor: "LastAuthor",
  RevNumber: "Revision",
  Application: "AppName",
  /* TotalTime: 'TotalTime', */
  LastPrinted: "LastPrinted",
  CreatedDate: "Created",
  ModifiedDate: "LastSaved",
  /* Pages */
  /* Words */
  /* Characters */
  Category: "Category",
  /* PresentationFormat */
  Manager: "Manager",
  Company: "Company",
  /* Guid */
  /* HyperlinkBase */
  /* Bytes */
  /* Lines */
  /* Paragraphs */
  /* CharactersWithSpaces */
  AppVersion: "Version",
  ContentStatus: "ContentStatus",
  /* NOTE: missing from schema */
  Identifier: "Identifier",
  /* NOTE: missing from schema */
  Language: "Language"
  /* NOTE: missing from schema */
}, En;
function Tu(e, t, r) {
  En || (En = Xn(Eu)), t = En[t] || t, e[t] = r;
}
function i0(e) {
  var t = e.read_shift(4), r = e.read_shift(4);
  return new Date((r / 1e7 * Math.pow(2, 32) + t / 1e7 - 11644473600) * 1e3).toISOString().replace(/\.000/, "");
}
function Ws(e, t, r) {
  var a = e.l, n = e.read_shift(0, "lpstr-cp");
  if (r) for (; e.l - a & 3; ) ++e.l;
  return n;
}
function Zs(e, t, r) {
  var a = e.read_shift(0, "lpwstr");
  return a;
}
function Gs(e, t, r) {
  return t === 31 ? Zs(e) : Ws(e, t, r);
}
function Rn(e, t, r) {
  return Gs(e, t, r === !1 ? 0 : 4);
}
function wu(e, t) {
  if (!t) throw new Error("VtUnalignedString must have positive length");
  return Gs(e, t, 0);
}
function Au(e) {
  for (var t = e.read_shift(4), r = [], a = 0; a != t; ++a) {
    var n = e.l;
    r[a] = e.read_shift(0, "lpwstr").replace(dr, ""), e.l - n & 2 && (e.l += 2);
  }
  return r;
}
function Fu(e) {
  for (var t = e.read_shift(4), r = [], a = 0; a != t; ++a) r[a] = e.read_shift(0, "lpstr-cp").replace(dr, "");
  return r;
}
function Su(e) {
  var t = e.l, r = Ya(e, zs);
  e[e.l] == 0 && e[e.l + 1] == 0 && e.l - t & 2 && (e.l += 2);
  var a = Ya(e, vr);
  return [r, a];
}
function yu(e) {
  for (var t = e.read_shift(4), r = [], a = 0; a < t / 2; ++a) r.push(Su(e));
  return r;
}
function ai(e, t) {
  for (var r = e.read_shift(4), a = {}, n = 0; n != r; ++n) {
    var i = e.read_shift(4), s = e.read_shift(4);
    a[i] = e.read_shift(s, t === 1200 ? "utf16le" : "utf8").replace(dr, "").replace(Xt, "!"), t === 1200 && s % 2 && (e.l += 2);
  }
  return e.l & 3 && (e.l = e.l >> 3 << 2), a;
}
function js(e) {
  var t = e.read_shift(4), r = e.slice(e.l, e.l + t);
  return e.l += t, (t & 3) > 0 && (e.l += 4 - (t & 3) & 3), r;
}
function Cu(e) {
  var t = {};
  return t.Size = e.read_shift(4), e.l += t.Size + 3 - (t.Size - 1) % 4, t;
}
function Ya(e, t, r) {
  var a = e.read_shift(2), n, i = r || {};
  if (e.l += 2, t !== ei && a !== t && su.indexOf(t) === -1 && !((t & 65534) == 4126 && (a & 65534) == 4126))
    throw new Error("Expected type " + t + " saw " + a);
  switch (t === ei ? a : t) {
    case 2:
      return n = e.read_shift(2, "i"), i.raw || (e.l += 2), n;
    case 3:
      return n = e.read_shift(4, "i"), n;
    case 11:
      return e.read_shift(4) !== 0;
    case 19:
      return n = e.read_shift(4), n;
    case 30:
      return Ws(e, a, 4).replace(dr, "");
    case 31:
      return Zs(e);
    case 64:
      return i0(e);
    case 65:
      return js(e);
    case 71:
      return Cu(e);
    case 80:
      return Rn(e, a, !i.raw).replace(dr, "");
    case 81:
      return wu(
        e,
        a
        /*, 4*/
      ).replace(dr, "");
    case 4108:
      return yu(e);
    case 4126:
    case 4127:
      return a == 4127 ? Au(e) : Fu(e);
    default:
      throw new Error("TypedPropertyValue unrecognized type " + t + " " + a);
  }
}
function ni(e, t) {
  var r = e.l, a = e.read_shift(4), n = e.read_shift(4), i = [], s = 0, c = 0, f = -1, o = {};
  for (s = 0; s != n; ++s) {
    var u = e.read_shift(4), l = e.read_shift(4);
    i[s] = [u, l + r];
  }
  i.sort(function(C, _) {
    return C[1] - _[1];
  });
  var h = {};
  for (s = 0; s != n; ++s) {
    if (e.l !== i[s][1]) {
      var d = !0;
      if (s > 0 && t) switch (t[i[s - 1][0]].t) {
        case 2:
          e.l + 2 === i[s][1] && (e.l += 2, d = !1);
          break;
        case 80:
          e.l <= i[s][1] && (e.l = i[s][1], d = !1);
          break;
        case 4108:
          e.l <= i[s][1] && (e.l = i[s][1], d = !1);
          break;
      }
      if ((!t || s == 0) && e.l <= i[s][1] && (d = !1, e.l = i[s][1]), d) throw new Error("Read Error: Expected address " + i[s][1] + " at " + e.l + " :" + s);
    }
    if (t) {
      var p = t[i[s][0]];
      if (h[p.n] = Ya(e, p.t, { raw: !0 }), p.p === "version" && (h[p.n] = String(h[p.n] >> 16) + "." + ("0000" + String(h[p.n] & 65535)).slice(-4)), p.n == "CodePage") switch (h[p.n]) {
        case 0:
          h[p.n] = 1252;
        case 874:
        case 932:
        case 936:
        case 949:
        case 950:
        case 1250:
        case 1251:
        case 1253:
        case 1254:
        case 1255:
        case 1256:
        case 1257:
        case 1258:
        case 1e4:
        case 1200:
        case 1201:
        case 1252:
        case 65e3:
        case -536:
        case 65001:
        case -535:
          Nr(c = h[p.n] >>> 0 & 65535);
          break;
        default:
          throw new Error("Unsupported CodePage: " + h[p.n]);
      }
    } else if (i[s][0] === 1) {
      if (c = h.CodePage = Ya(e, n0), Nr(c), f !== -1) {
        var x = e.l;
        e.l = i[f][1], o = ai(e, c), e.l = x;
      }
    } else if (i[s][0] === 0) {
      if (c === 0) {
        f = s, e.l = i[s + 1][1];
        continue;
      }
      o = ai(e, c);
    } else {
      var g = o[i[s][0]], F;
      switch (e[e.l]) {
        case 65:
          e.l += 4, F = js(e);
          break;
        case 30:
          e.l += 4, F = Rn(e, e[e.l - 4]).replace(/\u0000+$/, "");
          break;
        case 31:
          e.l += 4, F = Rn(e, e[e.l - 4]).replace(/\u0000+$/, "");
          break;
        case 3:
          e.l += 4, F = e.read_shift(4, "i");
          break;
        case 19:
          e.l += 4, F = e.read_shift(4);
          break;
        case 5:
          e.l += 4, F = e.read_shift(8, "f");
          break;
        case 11:
          e.l += 4, F = $e(e, 4);
          break;
        case 64:
          e.l += 4, F = Ye(i0(e));
          break;
        default:
          throw new Error("unparsed value: " + e[e.l]);
      }
      h[g] = F;
    }
  }
  return e.l = r + a, h;
}
function ii(e, t, r) {
  var a = e.content;
  if (!a) return {};
  Je(a, 0);
  var n, i, s, c, f = 0;
  a.chk("feff", "Byte Order: "), a.read_shift(2);
  var o = a.read_shift(4), u = a.read_shift(16);
  if (u !== ke.utils.consts.HEADER_CLSID && u !== r) throw new Error("Bad PropertySet CLSID " + u);
  if (n = a.read_shift(4), n !== 1 && n !== 2) throw new Error("Unrecognized #Sets: " + n);
  if (i = a.read_shift(16), c = a.read_shift(4), n === 1 && c !== a.l) throw new Error("Length mismatch: " + c + " !== " + a.l);
  n === 2 && (s = a.read_shift(16), f = a.read_shift(4));
  var l = ni(a, t), h = { SystemIdentifier: o };
  for (var d in l) h[d] = l[d];
  if (h.FMTID = i, n === 1) return h;
  if (f - a.l == 2 && (a.l += 2), a.l !== f) throw new Error("Length mismatch 2: " + a.l + " !== " + f);
  var p;
  try {
    p = ni(a, null);
  } catch {
  }
  for (d in p) h[d] = p[d];
  return h.FMTID = [i, s], h;
}
function et(e, t) {
  return e.read_shift(t), null;
}
function Ou(e, t, r) {
  for (var a = [], n = e.l + t; e.l < n; ) a.push(r(e, n - e.l));
  if (n !== e.l) throw new Error("Slurp error");
  return a;
}
function $e(e, t) {
  return e.read_shift(t) === 1;
}
function We(e) {
  return e.read_shift(2, "u");
}
function Xs(e, t) {
  return Ou(e, t, We);
}
function Iu(e) {
  var t = e.read_shift(1), r = e.read_shift(1);
  return r === 1 ? t : t === 1;
}
function ka(e, t, r) {
  var a = e.read_shift(r && r.biff >= 12 ? 2 : 1), n = "sbcs-cont";
  if (r && r.biff >= 8, !r || r.biff == 8) {
    var i = e.read_shift(1);
    i && (n = "dbcs-cont");
  } else r.biff == 12 && (n = "wstr");
  r.biff >= 2 && r.biff <= 5 && (n = "cpstr");
  var s = a ? e.read_shift(a, n) : "";
  return s;
}
function Du(e) {
  var t = e.read_shift(2), r = e.read_shift(1), a = r & 4, n = r & 8, i = 1 + (r & 1), s = 0, c, f = {};
  n && (s = e.read_shift(2)), a && (c = e.read_shift(4));
  var o = i == 2 ? "dbcs-cont" : "sbcs-cont", u = t === 0 ? "" : e.read_shift(t, o);
  return n && (e.l += 4 * s), a && (e.l += c), f.t = u, n || (f.raw = "<t>" + f.t + "</t>", f.r = f.t), f;
}
function mt(e, t, r) {
  var a;
  if (r) {
    if (r.biff >= 2 && r.biff <= 5) return e.read_shift(t, "cpstr");
    if (r.biff >= 12) return e.read_shift(t, "dbcs-cont");
  }
  var n = e.read_shift(1);
  return n === 0 ? a = e.read_shift(t, "sbcs-cont") : a = e.read_shift(t, "dbcs-cont"), a;
}
function Ea(e, t, r) {
  var a = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return a === 0 ? (e.l++, "") : mt(e, a, r);
}
function St(e, t, r) {
  if (r.biff > 5) return Ea(e, t, r);
  var a = e.read_shift(1);
  return a === 0 ? (e.l++, "") : e.read_shift(a, r.biff <= 4 || !e.lens ? "cpstr" : "sbcs-cont");
}
function Ru(e) {
  var t = e.read_shift(1);
  e.l++;
  var r = e.read_shift(2);
  return e.l += 2, [t, r];
}
function Nu(e) {
  var t = e.read_shift(4), r = e.l, a = !1;
  t > 24 && (e.l += t - 24, e.read_shift(16) === "795881f43b1d7f48af2c825dc4852763" && (a = !0), e.l = r);
  var n = e.read_shift((a ? t - 24 : t) >> 1, "utf16le").replace(dr, "");
  return a && (e.l += 24), n;
}
function bu(e) {
  for (var t = e.read_shift(2), r = ""; t-- > 0; ) r += "../";
  var a = e.read_shift(0, "lpstr-ansi");
  if (e.l += 2, e.read_shift(2) != 57005) throw new Error("Bad FileMoniker");
  var n = e.read_shift(4);
  if (n === 0) return r + a.replace(/\\/g, "/");
  var i = e.read_shift(4);
  if (e.read_shift(2) != 3) throw new Error("Bad FileMoniker");
  var s = e.read_shift(i >> 1, "utf16le").replace(dr, "");
  return r + s;
}
function Pu(e, t) {
  var r = e.read_shift(16);
  switch (r) {
    case "e0c9ea79f9bace118c8200aa004ba90b":
      return Nu(e);
    case "0303000000000000c000000000000046":
      return bu(e);
    default:
      throw new Error("Unsupported Moniker " + r);
  }
}
function Ra(e) {
  var t = e.read_shift(4), r = t > 0 ? e.read_shift(t, "utf16le").replace(dr, "") : "";
  return r;
}
function Lu(e, t) {
  var r = e.l + t, a = e.read_shift(4);
  if (a !== 2) throw new Error("Unrecognized streamVersion: " + a);
  var n = e.read_shift(2);
  e.l += 2;
  var i, s, c, f, o = "", u, l;
  n & 16 && (i = Ra(e, r - e.l)), n & 128 && (s = Ra(e, r - e.l)), (n & 257) === 257 && (c = Ra(e, r - e.l)), (n & 257) === 1 && (f = Pu(e, r - e.l)), n & 8 && (o = Ra(e, r - e.l)), n & 32 && (u = e.read_shift(16)), n & 64 && (l = i0(
    e
    /*, 8*/
  )), e.l = r;
  var h = s || c || f || "";
  h && o && (h += "#" + o), h || (h = "#" + o), n & 2 && h.charAt(0) == "/" && h.charAt(1) != "/" && (h = "file://" + h);
  var d = { Target: h };
  return u && (d.guid = u), l && (d.time = l), i && (d.Tooltip = i), d;
}
function Ks(e) {
  var t = e.read_shift(1), r = e.read_shift(1), a = e.read_shift(1), n = e.read_shift(1);
  return [t, r, a, n];
}
function Ys(e, t) {
  var r = Ks(e);
  return r[3] = 0, r;
}
function Hr(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2);
  return { r: t, c: r, ixfe: a };
}
function Mu(e) {
  var t = e.read_shift(2), r = e.read_shift(2);
  return e.l += 8, { type: t, flags: r };
}
function Bu(e, t, r) {
  return t === 0 ? "" : St(e, t, r);
}
function Uu(e, t, r) {
  var a = r.biff > 8 ? 4 : 2, n = e.read_shift(a), i = e.read_shift(a, "i"), s = e.read_shift(a, "i");
  return [n, i, s];
}
function Js(e) {
  var t = e.read_shift(2), r = a0(e);
  return [t, r];
}
function zu(e, t, r) {
  e.l += 4, t -= 4;
  var a = e.l + t, n = ka(e, t, r), i = e.read_shift(2);
  if (a -= e.l, i !== a) throw new Error("Malformed AddinUdf: padding = " + a + " != " + i);
  return e.l += i, n;
}
function cn(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2), n = e.read_shift(2);
  return { s: { c: a, r: t }, e: { c: n, r } };
}
function qs(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(1), n = e.read_shift(1);
  return { s: { c: a, r: t }, e: { c: n, r } };
}
var $u = qs;
function Qs(e) {
  e.l += 4;
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2);
  return e.l += 12, [r, t, a];
}
function Vu(e) {
  var t = {};
  return e.l += 4, e.l += 16, t.fSharedNote = e.read_shift(2), e.l += 4, t;
}
function Hu(e) {
  var t = {};
  return e.l += 4, e.cf = e.read_shift(2), t;
}
function tr(e) {
  e.l += 2, e.l += e.read_shift(2);
}
var Wu = {
  /*::[*/
  0: tr,
  /* FtEnd */
  /*::[*/
  4: tr,
  /* FtMacro */
  /*::[*/
  5: tr,
  /* FtButton */
  /*::[*/
  6: tr,
  /* FtGmo */
  /*::[*/
  7: Hu,
  /* FtCf */
  /*::[*/
  8: tr,
  /* FtPioGrbit */
  /*::[*/
  9: tr,
  /* FtPictFmla */
  /*::[*/
  10: tr,
  /* FtCbls */
  /*::[*/
  11: tr,
  /* FtRbo */
  /*::[*/
  12: tr,
  /* FtSbs */
  /*::[*/
  13: Vu,
  /* FtNts */
  /*::[*/
  14: tr,
  /* FtSbsFmla */
  /*::[*/
  15: tr,
  /* FtGboData */
  /*::[*/
  16: tr,
  /* FtEdoData */
  /*::[*/
  17: tr,
  /* FtRboData */
  /*::[*/
  18: tr,
  /* FtCblsData */
  /*::[*/
  19: tr,
  /* FtLbsData */
  /*::[*/
  20: tr,
  /* FtCblsFmla */
  /*::[*/
  21: Qs
};
function Zu(e, t) {
  for (var r = e.l + t, a = []; e.l < r; ) {
    var n = e.read_shift(2);
    e.l -= 2;
    try {
      a.push(Wu[n](e, r - e.l));
    } catch {
      return e.l = r, a;
    }
  }
  return e.l != r && (e.l = r), a;
}
function Na(e, t) {
  var r = { BIFFVer: 0, dt: 0 };
  switch (r.BIFFVer = e.read_shift(2), t -= 2, t >= 2 && (r.dt = e.read_shift(2), e.l -= 2), r.BIFFVer) {
    case 1536:
    case 1280:
    case 1024:
    case 768:
    case 512:
    case 2:
    case 7:
      break;
    default:
      if (t > 6) throw new Error("Unexpected BIFF Ver " + r.BIFFVer);
  }
  return e.read_shift(t), r;
}
function Gu(e, t) {
  return t === 0 || e.read_shift(2), 1200;
}
function ju(e, t, r) {
  if (r.enc)
    return e.l += t, "";
  var a = e.l, n = St(e, 0, r);
  return e.read_shift(t + a - e.l), n;
}
function Xu(e, t, r) {
  var a = r && r.biff == 8 || t == 2 ? e.read_shift(2) : (e.l += t, 0);
  return { fDialog: a & 16, fBelow: a & 64, fRight: a & 128 };
}
function Ku(e, t, r) {
  var a = e.read_shift(4), n = e.read_shift(1) & 3, i = e.read_shift(1);
  switch (i) {
    case 0:
      i = "Worksheet";
      break;
    case 1:
      i = "Macrosheet";
      break;
    case 2:
      i = "Chartsheet";
      break;
    case 6:
      i = "VBAModule";
      break;
  }
  var s = ka(e, 0, r);
  return s.length === 0 && (s = "Sheet1"), { pos: a, hs: n, dt: i, name: s };
}
function Yu(e, t) {
  for (var r = e.l + t, a = e.read_shift(4), n = e.read_shift(4), i = [], s = 0; s != n && e.l < r; ++s)
    i.push(Du(e));
  return i.Count = a, i.Unique = n, i;
}
function Ju(e, t) {
  var r = {};
  return r.dsst = e.read_shift(2), e.l += t - 2, r;
}
function qu(e) {
  var t = {};
  t.r = e.read_shift(2), t.c = e.read_shift(2), t.cnt = e.read_shift(2) - t.c;
  var r = e.read_shift(2);
  e.l += 4;
  var a = e.read_shift(1);
  return e.l += 3, a & 7 && (t.level = a & 7), a & 32 && (t.hidden = !0), a & 64 && (t.hpt = r / 20), t;
}
function Qu(e) {
  var t = Mu(e);
  if (t.type != 2211) throw new Error("Invalid Future Record " + t.type);
  var r = e.read_shift(4);
  return r !== 0;
}
function el(e) {
  return e.read_shift(2), e.read_shift(4);
}
function si(e, t, r) {
  var a = 0;
  r && r.biff == 2 || (a = e.read_shift(2));
  var n = e.read_shift(2);
  r && r.biff == 2 && (a = 1 - (n >> 15), n &= 32767);
  var i = { Unsynced: a & 1, DyZero: (a & 2) >> 1, ExAsc: (a & 4) >> 2, ExDsc: (a & 8) >> 3 };
  return [i, n];
}
function rl(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2), n = e.read_shift(2), i = e.read_shift(2), s = e.read_shift(2), c = e.read_shift(2), f = e.read_shift(2), o = e.read_shift(2);
  return {
    Pos: [t, r],
    Dim: [a, n],
    Flags: i,
    CurTab: s,
    FirstTab: c,
    Selected: f,
    TabRatio: o
  };
}
function tl(e, t, r) {
  if (r && r.biff >= 2 && r.biff < 5) return {};
  var a = e.read_shift(2);
  return { RTL: a & 64 };
}
function al() {
}
function nl(e, t, r) {
  var a = {
    dyHeight: e.read_shift(2),
    fl: e.read_shift(2)
  };
  switch (r && r.biff || 8) {
    case 2:
      break;
    case 3:
    case 4:
      e.l += 2;
      break;
    default:
      e.l += 10;
      break;
  }
  return a.name = ka(e, 0, r), a;
}
function il(e) {
  var t = Hr(e);
  return t.isst = e.read_shift(4), t;
}
function sl(e, t, r) {
  r.biffguess && r.biff == 2 && (r.biff = 5);
  var a = e.l + t, n = Hr(e);
  r.biff == 2 && e.l++;
  var i = Ea(e, a - e.l, r);
  return n.val = i, n;
}
function cl(e, t, r) {
  var a = e.read_shift(2), n = St(e, 0, r);
  return [a, n];
}
var fl = St;
function ci(e, t, r) {
  var a = e.l + t, n = r.biff == 8 || !r.biff ? 4 : 2, i = e.read_shift(n), s = e.read_shift(n), c = e.read_shift(2), f = e.read_shift(2);
  return e.l = a, { s: { r: i, c }, e: { r: s, c: f } };
}
function ol(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = Js(e);
  return { r: t, c: r, ixfe: a[0], rknum: a[1] };
}
function ul(e, t) {
  for (var r = e.l + t - 2, a = e.read_shift(2), n = e.read_shift(2), i = []; e.l < r; ) i.push(Js(e));
  if (e.l !== r) throw new Error("MulRK read error");
  var s = e.read_shift(2);
  if (i.length != s - n + 1) throw new Error("MulRK length mismatch");
  return { r: a, c: n, C: s, rkrec: i };
}
function ll(e, t) {
  for (var r = e.l + t - 2, a = e.read_shift(2), n = e.read_shift(2), i = []; e.l < r; ) i.push(e.read_shift(2));
  if (e.l !== r) throw new Error("MulBlank read error");
  var s = e.read_shift(2);
  if (i.length != s - n + 1) throw new Error("MulBlank length mismatch");
  return { r: a, c: n, C: s, ixfe: i };
}
function hl(e, t, r, a) {
  var n = {}, i = e.read_shift(4), s = e.read_shift(4), c = e.read_shift(4), f = e.read_shift(2);
  return n.patternType = ou[c >> 26], a.cellStyles && (n.alc = i & 7, n.fWrap = i >> 3 & 1, n.alcV = i >> 4 & 7, n.fJustLast = i >> 7 & 1, n.trot = i >> 8 & 255, n.cIndent = i >> 16 & 15, n.fShrinkToFit = i >> 20 & 1, n.iReadOrder = i >> 22 & 2, n.fAtrNum = i >> 26 & 1, n.fAtrFnt = i >> 27 & 1, n.fAtrAlc = i >> 28 & 1, n.fAtrBdr = i >> 29 & 1, n.fAtrPat = i >> 30 & 1, n.fAtrProt = i >> 31 & 1, n.dgLeft = s & 15, n.dgRight = s >> 4 & 15, n.dgTop = s >> 8 & 15, n.dgBottom = s >> 12 & 15, n.icvLeft = s >> 16 & 127, n.icvRight = s >> 23 & 127, n.grbitDiag = s >> 30 & 3, n.icvTop = c & 127, n.icvBottom = c >> 7 & 127, n.icvDiag = c >> 14 & 127, n.dgDiag = c >> 21 & 15, n.icvFore = f & 127, n.icvBack = f >> 7 & 127, n.fsxButton = f >> 14 & 1), n;
}
function xl(e, t, r) {
  var a = {};
  return a.ifnt = e.read_shift(2), a.numFmtId = e.read_shift(2), a.flags = e.read_shift(2), a.fStyle = a.flags >> 2 & 1, t -= 6, a.data = hl(e, t, a.fStyle, r), a;
}
function dl(e) {
  e.l += 4;
  var t = [e.read_shift(2), e.read_shift(2)];
  if (t[0] !== 0 && t[0]--, t[1] !== 0 && t[1]--, t[0] > 7 || t[1] > 7) throw new Error("Bad Gutters: " + t.join("|"));
  return t;
}
function fi(e, t, r) {
  var a = Hr(e);
  (r.biff == 2 || t == 9) && ++e.l;
  var n = Iu(e);
  return a.val = n, a.t = n === !0 || n === !1 ? "b" : "e", a;
}
function pl(e, t, r) {
  r.biffguess && r.biff == 2 && (r.biff = 5);
  var a = Hr(e), n = nr(e);
  return a.val = n, a;
}
var oi = Bu;
function vl(e, t, r) {
  var a = e.l + t, n = e.read_shift(2), i = e.read_shift(2);
  if (r.sbcch = i, i == 1025 || i == 14849) return [i, n];
  if (i < 1 || i > 255) throw new Error("Unexpected SupBook type: " + i);
  for (var s = mt(e, i), c = []; a > e.l; ) c.push(Ea(e));
  return [i, n, s, c];
}
function ui(e, t, r) {
  var a = e.read_shift(2), n, i = {
    fBuiltIn: a & 1,
    fWantAdvise: a >>> 1 & 1,
    fWantPict: a >>> 2 & 1,
    fOle: a >>> 3 & 1,
    fOleLink: a >>> 4 & 1,
    cf: a >>> 5 & 1023,
    fIcon: a >>> 15 & 1
  };
  return r.sbcch === 14849 && (n = zu(e, t - 2, r)), i.body = n || e.read_shift(t - 2), typeof n == "string" && (i.Name = n), i;
}
var gl = [
  "_xlnm.Consolidate_Area",
  "_xlnm.Auto_Open",
  "_xlnm.Auto_Close",
  "_xlnm.Extract",
  "_xlnm.Database",
  "_xlnm.Criteria",
  "_xlnm.Print_Area",
  "_xlnm.Print_Titles",
  "_xlnm.Recorder",
  "_xlnm.Data_Form",
  "_xlnm.Auto_Activate",
  "_xlnm.Auto_Deactivate",
  "_xlnm.Sheet_Title",
  "_xlnm._FilterDatabase"
];
function li(e, t, r) {
  var a = e.l + t, n = e.read_shift(2), i = e.read_shift(1), s = e.read_shift(1), c = e.read_shift(r && r.biff == 2 ? 1 : 2), f = 0;
  (!r || r.biff >= 5) && (r.biff != 5 && (e.l += 2), f = e.read_shift(2), r.biff == 5 && (e.l += 2), e.l += 4);
  var o = mt(e, s, r);
  n & 32 && (o = gl[o.charCodeAt(0)]);
  var u = a - e.l;
  r && r.biff == 2 && --u;
  var l = a == e.l || c === 0 || !(u > 0) ? [] : qx(e, u, r, c);
  return {
    chKey: i,
    Name: o,
    itab: f,
    rgce: l
  };
}
function ec(e, t, r) {
  if (r.biff < 8) return ml(e, t, r);
  for (var a = [], n = e.l + t, i = e.read_shift(r.biff > 8 ? 4 : 2); i-- !== 0; ) a.push(Uu(e, r.biff > 8 ? 12 : 6, r));
  if (e.l != n) throw new Error("Bad ExternSheet: " + e.l + " != " + n);
  return a;
}
function ml(e, t, r) {
  e[e.l + 1] == 3 && e[e.l]++;
  var a = ka(e, t, r);
  return a.charCodeAt(0) == 3 ? a.slice(1) : a;
}
function _l(e, t, r) {
  if (r.biff < 8) {
    e.l += t;
    return;
  }
  var a = e.read_shift(2), n = e.read_shift(2), i = mt(e, a, r), s = mt(e, n, r);
  return [i, s];
}
function kl(e, t, r) {
  var a = qs(e);
  e.l++;
  var n = e.read_shift(1);
  return t -= 8, [Qx(e, t, r), n, a];
}
function hi(e, t, r) {
  var a = $u(e);
  switch (r.biff) {
    case 2:
      e.l++, t -= 7;
      break;
    case 3:
    case 4:
      e.l += 2, t -= 8;
      break;
    default:
      e.l += 6, t -= 12;
  }
  return [a, Yx(e, t, r)];
}
function El(e) {
  var t = e.read_shift(4) !== 0, r = e.read_shift(4) !== 0, a = e.read_shift(4);
  return [t, r, a];
}
function Tl(e, t, r) {
  if (!(r.biff < 8)) {
    var a = e.read_shift(2), n = e.read_shift(2), i = e.read_shift(2), s = e.read_shift(2), c = St(e, 0, r);
    return r.biff < 8 && e.read_shift(1), [{ r: a, c: n }, c, s, i];
  }
}
function wl(e, t, r) {
  return Tl(e, t, r);
}
function Al(e, t) {
  for (var r = [], a = e.read_shift(2); a--; ) r.push(cn(e));
  return r;
}
function Fl(e, t, r) {
  if (r && r.biff < 8) return yl(e, t, r);
  var a = Qs(e), n = Zu(e, t - 22, a[1]);
  return { cmo: a, ft: n };
}
var Sl = {
  8: function(e, t) {
    var r = e.l + t;
    e.l += 10;
    var a = e.read_shift(2);
    e.l += 4, e.l += 2, e.l += 2, e.l += 2, e.l += 4;
    var n = e.read_shift(1);
    return e.l += n, e.l = r, { fmt: a };
  }
};
function yl(e, t, r) {
  e.l += 4;
  var a = e.read_shift(2), n = e.read_shift(2), i = e.read_shift(2);
  e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 6, t -= 36;
  var s = [];
  return s.push((Sl[a] || cr)(e, t, r)), { cmo: [n, a, i], ft: s };
}
function Cl(e, t, r) {
  var a = e.l, n = "";
  try {
    e.l += 4;
    var i = (r.lastobj || { cmo: [0, 0] }).cmo[1], s;
    [0, 5, 7, 11, 12, 14].indexOf(i) == -1 ? e.l += 6 : s = Ru(e, 6, r);
    var c = e.read_shift(2);
    e.read_shift(2), We(e, 2);
    var f = e.read_shift(2);
    e.l += f;
    for (var o = 1; o < e.lens.length - 1; ++o) {
      if (e.l - a != e.lens[o]) throw new Error("TxO: bad continue record");
      var u = e[e.l], l = mt(e, e.lens[o + 1] - e.lens[o] - 1);
      if (n += l, n.length >= (u ? c : 2 * c)) break;
    }
    if (n.length !== c && n.length !== c * 2)
      throw new Error("cchText: " + c + " != " + n.length);
    return e.l = a + t, { t: n };
  } catch {
    return e.l = a + t, { t: n };
  }
}
function Ol(e, t) {
  var r = cn(e);
  e.l += 16;
  var a = Lu(e, t - 24);
  return [r, a];
}
function Il(e, t) {
  e.read_shift(2);
  var r = cn(e), a = e.read_shift((t - 10) / 2, "dbcs-cont");
  return a = a.replace(dr, ""), [r, a];
}
function Dl(e) {
  var t = [0, 0], r;
  return r = e.read_shift(2), t[0] = ri[r] || r, r = e.read_shift(2), t[1] = ri[r] || r, t;
}
function Rl(e) {
  for (var t = e.read_shift(2), r = []; t-- > 0; ) r.push(Ys(e));
  return r;
}
function Nl(e) {
  for (var t = e.read_shift(2), r = []; t-- > 0; ) r.push(Ys(e));
  return r;
}
function bl(e) {
  e.l += 2;
  var t = { cxfs: 0, crc: 0 };
  return t.cxfs = e.read_shift(2), t.crc = e.read_shift(4), t;
}
function rc(e, t, r) {
  if (!r.cellStyles) return cr(e, t);
  var a = r && r.biff >= 12 ? 4 : 2, n = e.read_shift(a), i = e.read_shift(a), s = e.read_shift(a), c = e.read_shift(a), f = e.read_shift(2);
  a == 2 && (e.l += 2);
  var o = { s: n, e: i, w: s, ixfe: c, flags: f };
  return (r.biff >= 5 || !r.biff) && (o.level = f >> 8 & 7), o;
}
function Pl(e, t) {
  var r = {};
  return t < 32 || (e.l += 16, r.header = nr(e), r.footer = nr(e), e.l += 2), r;
}
function Ll(e, t, r) {
  var a = { area: !1 };
  if (r.biff != 5)
    return e.l += t, a;
  var n = e.read_shift(1);
  return e.l += 3, n & 16 && (a.area = !0), a;
}
var Ml = Hr, Bl = Xs, Ul = Ea;
function zl(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(4), n = { fmt: t, env: r, len: a, data: e.slice(e.l, e.l + a) };
  return e.l += a, n;
}
function $l(e, t, r) {
  r.biffguess && r.biff == 5 && (r.biff = 2);
  var a = Hr(e);
  ++e.l;
  var n = St(e, t - 7, r);
  return a.t = "str", a.val = n, a;
}
function Vl(e) {
  var t = Hr(e);
  ++e.l;
  var r = nr(e);
  return t.t = "n", t.val = r, t;
}
function Hl(e) {
  var t = Hr(e);
  ++e.l;
  var r = e.read_shift(2);
  return t.t = "n", t.val = r, t;
}
function Wl(e) {
  var t = e.read_shift(1);
  return t === 0 ? (e.l++, "") : e.read_shift(t, "sbcs-cont");
}
function Zl(e, t) {
  e.l += 6, e.l += 2, e.l += 1, e.l += 3, e.l += 1, e.l += t - 13;
}
function Gl(e, t, r) {
  var a = e.l + t, n = Hr(e), i = e.read_shift(2), s = mt(e, i, r);
  return e.l = a, n.t = "str", n.val = s, n;
}
var jl = [2, 3, 48, 49, 131, 139, 140, 245], xi = /* @__PURE__ */ function() {
  var e = {
    /* Code Pages Supported by Visual FoxPro */
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /* shapefile DBF extension */
    /*::[*/
    0: 20127,
    /*::[*/
    8: 865,
    /*::[*/
    9: 437,
    /*::[*/
    10: 850,
    /*::[*/
    11: 437,
    /*::[*/
    13: 437,
    /*::[*/
    14: 850,
    /*::[*/
    15: 437,
    /*::[*/
    16: 850,
    /*::[*/
    17: 437,
    /*::[*/
    18: 850,
    /*::[*/
    19: 932,
    /*::[*/
    20: 850,
    /*::[*/
    21: 437,
    /*::[*/
    22: 850,
    /*::[*/
    23: 865,
    /*::[*/
    24: 437,
    /*::[*/
    25: 437,
    /*::[*/
    26: 850,
    /*::[*/
    27: 437,
    /*::[*/
    28: 863,
    /*::[*/
    29: 850,
    /*::[*/
    31: 852,
    /*::[*/
    34: 852,
    /*::[*/
    35: 852,
    /*::[*/
    36: 860,
    /*::[*/
    37: 850,
    /*::[*/
    38: 866,
    /*::[*/
    55: 850,
    /*::[*/
    64: 852,
    /*::[*/
    77: 936,
    /*::[*/
    78: 949,
    /*::[*/
    79: 950,
    /*::[*/
    80: 874,
    /*::[*/
    87: 1252,
    /*::[*/
    88: 1252,
    /*::[*/
    89: 1252,
    /*::[*/
    108: 863,
    /*::[*/
    134: 737,
    /*::[*/
    135: 852,
    /*::[*/
    136: 857,
    /*::[*/
    204: 1257,
    /*::[*/
    255: 16969
  }, t = Xn({
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /*::[*/
    0: 20127
  });
  function r(c, f) {
    var o = [], u = it(1);
    switch (f.type) {
      case "base64":
        u = Rr(Er(c));
        break;
      case "binary":
        u = Rr(c);
        break;
      case "buffer":
      case "array":
        u = c;
        break;
    }
    Je(u, 0);
    var l = u.read_shift(1), h = !!(l & 136), d = !1, p = !1;
    switch (l) {
      case 2:
        break;
      case 3:
        break;
      case 48:
        d = !0, h = !0;
        break;
      case 49:
        d = !0, h = !0;
        break;
      case 131:
        break;
      case 139:
        break;
      case 140:
        p = !0;
        break;
      case 245:
        break;
      default:
        throw new Error("DBF Unsupported Version: " + l.toString(16));
    }
    var x = 0, g = 521;
    l == 2 && (x = u.read_shift(2)), u.l += 3, l != 2 && (x = u.read_shift(4)), x > 1048576 && (x = 1e6), l != 2 && (g = u.read_shift(2));
    var F = u.read_shift(2), C = f.codepage || 1252;
    l != 2 && (u.l += 16, u.read_shift(1), u[u.l] !== 0 && (C = e[u[u.l]]), u.l += 1, u.l += 2), p && (u.l += 36);
    for (var _ = [], I = {}, P = Math.min(u.length, l == 2 ? 521 : g - 10 - (d ? 264 : 0)), O = p ? 32 : 11; u.l < P && u[u.l] != 13; )
      switch (I = {}, I.name = fa.utils.decode(C, u.slice(u.l, u.l + O)).replace(/[\u0000\r\n].*$/g, ""), u.l += O, I.type = String.fromCharCode(u.read_shift(1)), l != 2 && !p && (I.offset = u.read_shift(4)), I.len = u.read_shift(1), l == 2 && (I.offset = u.read_shift(2)), I.dec = u.read_shift(1), I.name.length && _.push(I), l != 2 && (u.l += p ? 13 : 14), I.type) {
        case "B":
          (!d || I.len != 8) && f.WTF && console.log("Skipping " + I.name + ":" + I.type);
          break;
        case "G":
        case "P":
          f.WTF && console.log("Skipping " + I.name + ":" + I.type);
          break;
        case "+":
        case "0":
        case "@":
        case "C":
        case "D":
        case "F":
        case "I":
        case "L":
        case "M":
        case "N":
        case "O":
        case "T":
        case "Y":
          break;
        default:
          throw new Error("Unknown Field Type: " + I.type);
      }
    if (u[u.l] !== 13 && (u.l = g - 1), u.read_shift(1) !== 13) throw new Error("DBF Terminator not found " + u.l + " " + u[u.l]);
    u.l = g;
    var A = 0, V = 0;
    for (o[0] = [], V = 0; V != _.length; ++V) o[0][V] = _[V].name;
    for (; x-- > 0; ) {
      if (u[u.l] === 42) {
        u.l += F;
        continue;
      }
      for (++u.l, o[++A] = [], V = 0, V = 0; V != _.length; ++V) {
        var D = u.slice(u.l, u.l + _[V].len);
        u.l += _[V].len, Je(D, 0);
        var G = fa.utils.decode(C, D);
        switch (_[V].type) {
          case "C":
            G.trim().length && (o[A][V] = G.replace(/\s+$/, ""));
            break;
          case "D":
            G.length === 8 ? o[A][V] = new Date(+G.slice(0, 4), +G.slice(4, 6) - 1, +G.slice(6, 8)) : o[A][V] = G;
            break;
          case "F":
            o[A][V] = parseFloat(G.trim());
            break;
          case "+":
          case "I":
            o[A][V] = p ? D.read_shift(-4, "i") ^ 2147483648 : D.read_shift(4, "i");
            break;
          case "L":
            switch (G.trim().toUpperCase()) {
              case "Y":
              case "T":
                o[A][V] = !0;
                break;
              case "N":
              case "F":
                o[A][V] = !1;
                break;
              case "":
              case "?":
                break;
              default:
                throw new Error("DBF Unrecognized L:|" + G + "|");
            }
            break;
          case "M":
            if (!h) throw new Error("DBF Unexpected MEMO for type " + l.toString(16));
            o[A][V] = "##MEMO##" + (p ? parseInt(G.trim(), 10) : D.read_shift(4));
            break;
          case "N":
            G = G.replace(/\u0000/g, "").trim(), G && G != "." && (o[A][V] = +G || 0);
            break;
          case "@":
            o[A][V] = new Date(D.read_shift(-8, "f") - 621356832e5);
            break;
          case "T":
            o[A][V] = new Date((D.read_shift(4) - 2440588) * 864e5 + D.read_shift(4));
            break;
          case "Y":
            o[A][V] = D.read_shift(4, "i") / 1e4 + D.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
            break;
          case "O":
            o[A][V] = -D.read_shift(-8, "f");
            break;
          case "B":
            if (d && _[V].len == 8) {
              o[A][V] = D.read_shift(8, "f");
              break;
            }
          case "G":
          case "P":
            D.l += _[V].len;
            break;
          case "0":
            if (_[V].name === "_NullFlags") break;
          default:
            throw new Error("DBF Unsupported data type " + _[V].type);
        }
      }
    }
    if (l != 2 && u.l < u.length && u[u.l++] != 26) throw new Error("DBF EOF Marker missing " + (u.l - 1) + " of " + u.length + " " + u[u.l - 1].toString(16));
    return f && f.sheetRows && (o = o.slice(0, f.sheetRows)), f.DBF = _, o;
  }
  function a(c, f) {
    var o = f || {};
    o.dateNF || (o.dateNF = "yyyymmdd");
    var u = zt(r(c, o), o);
    return u["!cols"] = o.DBF.map(function(l) {
      return {
        wch: l.len,
        DBF: l
      };
    }), delete o.DBF, u;
  }
  function n(c, f) {
    try {
      return ct(a(c, f), f);
    } catch (o) {
      if (f && f.WTF) throw o;
    }
    return { SheetNames: [], Sheets: {} };
  }
  var i = { B: 8, C: 250, L: 1, D: 8, "?": 0, "": 0 };
  function s(c, f) {
    var o = f || {};
    if (+o.codepage >= 0 && Nr(+o.codepage), o.type == "string") throw new Error("Cannot write DBF to JS string");
    var u = On(), l = Un(c, { header: 1, raw: !0, cellDates: !0 }), h = l[0], d = l.slice(1), p = c["!cols"] || [], x = 0, g = 0, F = 0, C = 1;
    for (x = 0; x < h.length; ++x) {
      if (((p[x] || {}).DBF || {}).name) {
        h[x] = p[x].DBF.name, ++F;
        continue;
      }
      if (h[x] != null) {
        if (++F, typeof h[x] == "number" && (h[x] = h[x].toString(10)), typeof h[x] != "string") throw new Error("DBF Invalid column name " + h[x] + " |" + typeof h[x] + "|");
        if (h.indexOf(h[x]) !== x) {
          for (g = 0; g < 1024; ++g)
            if (h.indexOf(h[x] + "_" + g) == -1) {
              h[x] += "_" + g;
              break;
            }
        }
      }
    }
    var _ = Pe(c["!ref"]), I = [], P = [], O = [];
    for (x = 0; x <= _.e.c - _.s.c; ++x) {
      var A = "", V = "", D = 0, G = [];
      for (g = 0; g < d.length; ++g)
        d[g][x] != null && G.push(d[g][x]);
      if (G.length == 0 || h[x] == null) {
        I[x] = "?";
        continue;
      }
      for (g = 0; g < G.length; ++g) {
        switch (typeof G[g]) {
          case "number":
            V = "B";
            break;
          case "string":
            V = "C";
            break;
          case "boolean":
            V = "L";
            break;
          case "object":
            V = G[g] instanceof Date ? "D" : "C";
            break;
          default:
            V = "C";
        }
        D = Math.max(D, String(G[g]).length), A = A && A != V ? "C" : V;
      }
      D > 250 && (D = 250), V = ((p[x] || {}).DBF || {}).type, V == "C" && p[x].DBF.len > D && (D = p[x].DBF.len), A == "B" && V == "N" && (A = "N", O[x] = p[x].DBF.dec, D = p[x].DBF.len), P[x] = A == "C" || V == "N" ? D : i[A] || 0, C += P[x], I[x] = A;
    }
    var W = u.next(32);
    for (W.write_shift(4, 318902576), W.write_shift(4, d.length), W.write_shift(2, 296 + 32 * F), W.write_shift(2, C), x = 0; x < 4; ++x) W.write_shift(4, 0);
    for (W.write_shift(4, 0 | (+t[
      /*::String(*/
      es
      /*::)*/
    ] || 3) << 8), x = 0, g = 0; x < h.length; ++x)
      if (h[x] != null) {
        var b = u.next(32), J = (h[x].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11);
        b.write_shift(1, J, "sbcs"), b.write_shift(1, I[x] == "?" ? "C" : I[x], "sbcs"), b.write_shift(4, g), b.write_shift(1, P[x] || i[I[x]] || 0), b.write_shift(1, O[x] || 0), b.write_shift(1, 2), b.write_shift(4, 0), b.write_shift(1, 0), b.write_shift(4, 0), b.write_shift(4, 0), g += P[x] || i[I[x]] || 0;
      }
    var oe = u.next(264);
    for (oe.write_shift(4, 13), x = 0; x < 65; ++x) oe.write_shift(4, 0);
    for (x = 0; x < d.length; ++x) {
      var te = u.next(C);
      for (te.write_shift(1, 0), g = 0; g < h.length; ++g)
        if (h[g] != null)
          switch (I[g]) {
            case "L":
              te.write_shift(1, d[x][g] == null ? 63 : d[x][g] ? 84 : 70);
              break;
            case "B":
              te.write_shift(8, d[x][g] || 0, "f");
              break;
            case "N":
              var fe = "0";
              for (typeof d[x][g] == "number" && (fe = d[x][g].toFixed(O[g] || 0)), F = 0; F < P[g] - fe.length; ++F) te.write_shift(1, 32);
              te.write_shift(1, fe, "sbcs");
              break;
            case "D":
              d[x][g] ? (te.write_shift(4, ("0000" + d[x][g].getFullYear()).slice(-4), "sbcs"), te.write_shift(2, ("00" + (d[x][g].getMonth() + 1)).slice(-2), "sbcs"), te.write_shift(2, ("00" + d[x][g].getDate()).slice(-2), "sbcs")) : te.write_shift(8, "00000000", "sbcs");
              break;
            case "C":
              var ce = String(d[x][g] != null ? d[x][g] : "").slice(0, P[g]);
              for (te.write_shift(1, ce, "sbcs"), F = 0; F < P[g] - ce.length; ++F) te.write_shift(1, 32);
              break;
          }
    }
    return u.next(1).write_shift(1, 26), u.end();
  }
  return {
    to_workbook: n,
    to_sheet: a,
    from_sheet: s
  };
}(), Xl = /* @__PURE__ */ function() {
  var e = {
    AA: "À",
    BA: "Á",
    CA: "Â",
    DA: 195,
    HA: "Ä",
    JA: 197,
    AE: "È",
    BE: "É",
    CE: "Ê",
    HE: "Ë",
    AI: "Ì",
    BI: "Í",
    CI: "Î",
    HI: "Ï",
    AO: "Ò",
    BO: "Ó",
    CO: "Ô",
    DO: 213,
    HO: "Ö",
    AU: "Ù",
    BU: "Ú",
    CU: "Û",
    HU: "Ü",
    Aa: "à",
    Ba: "á",
    Ca: "â",
    Da: 227,
    Ha: "ä",
    Ja: 229,
    Ae: "è",
    Be: "é",
    Ce: "ê",
    He: "ë",
    Ai: "ì",
    Bi: "í",
    Ci: "î",
    Hi: "ï",
    Ao: "ò",
    Bo: "ó",
    Co: "ô",
    Do: 245,
    Ho: "ö",
    Au: "ù",
    Bu: "ú",
    Cu: "û",
    Hu: "ü",
    KC: "Ç",
    Kc: "ç",
    q: "æ",
    z: "œ",
    a: "Æ",
    j: "Œ",
    DN: 209,
    Dn: 241,
    Hy: 255,
    S: 169,
    c: 170,
    R: 174,
    "B ": 180,
    /*::[*/
    0: 176,
    /*::[*/
    1: 177,
    /*::[*/
    2: 178,
    /*::[*/
    3: 179,
    /*::[*/
    5: 181,
    /*::[*/
    6: 182,
    /*::[*/
    7: 183,
    Q: 185,
    k: 186,
    b: 208,
    i: 216,
    l: 222,
    s: 240,
    y: 248,
    "!": 161,
    '"': 162,
    "#": 163,
    "(": 164,
    "%": 165,
    "'": 167,
    "H ": 168,
    "+": 171,
    ";": 187,
    "<": 188,
    "=": 189,
    ">": 190,
    "?": 191,
    "{": 223
  }, t = new RegExp("\x1BN(" + $r(e).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm"), r = function(h, d) {
    var p = e[d];
    return typeof p == "number" ? O0(p) : p;
  }, a = function(h, d, p) {
    var x = d.charCodeAt(0) - 32 << 4 | p.charCodeAt(0) - 48;
    return x == 59 ? h : O0(x);
  };
  e["|"] = 254;
  function n(h, d) {
    switch (d.type) {
      case "base64":
        return i(Er(h), d);
      case "binary":
        return i(h, d);
      case "buffer":
        return i(_e && Buffer.isBuffer(h) ? h.toString("binary") : Tt(h), d);
      case "array":
        return i(gt(h), d);
    }
    throw new Error("Unrecognized type " + d.type);
  }
  function i(h, d) {
    var p = h.split(/[\n\r]+/), x = -1, g = -1, F = 0, C = 0, _ = [], I = [], P = null, O = {}, A = [], V = [], D = [], G = 0, W;
    for (+d.codepage >= 0 && Nr(+d.codepage); F !== p.length; ++F) {
      G = 0;
      var b = p[F].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, a).replace(t, r), J = b.replace(/;;/g, "\0").split(";").map(function(R) {
        return R.replace(/\u0000/g, ";");
      }), oe = J[0], te;
      if (b.length > 0) switch (oe) {
        case "ID":
          break;
        case "E":
          break;
        case "B":
          break;
        case "O":
          break;
        case "W":
          break;
        case "P":
          J[1].charAt(0) == "P" && I.push(b.slice(3).replace(/;;/g, ";"));
          break;
        case "C":
          var fe = !1, ce = !1, Ce = !1, H = !1, he = -1, xe = -1;
          for (C = 1; C < J.length; ++C) switch (J[C].charAt(0)) {
            case "A":
              break;
            case "X":
              g = parseInt(J[C].slice(1)) - 1, ce = !0;
              break;
            case "Y":
              for (x = parseInt(J[C].slice(1)) - 1, ce || (g = 0), W = _.length; W <= x; ++W) _[W] = [];
              break;
            case "K":
              te = J[C].slice(1), te.charAt(0) === '"' ? te = te.slice(1, te.length - 1) : te === "TRUE" ? te = !0 : te === "FALSE" ? te = !1 : isNaN(Lr(te)) ? isNaN(Lt(te).getDate()) || (te = Ye(te)) : (te = Lr(te), P !== null && Bt(P) && (te = sn(te))), fe = !0;
              break;
            case "E":
              H = !0;
              var S = Nt(J[C].slice(1), { r: x, c: g });
              _[x][g] = [_[x][g], S];
              break;
            case "S":
              Ce = !0, _[x][g] = [_[x][g], "S5S"];
              break;
            case "G":
              break;
            case "R":
              he = parseInt(J[C].slice(1)) - 1;
              break;
            case "C":
              xe = parseInt(J[C].slice(1)) - 1;
              break;
            default:
              if (d && d.WTF) throw new Error("SYLK bad record " + b);
          }
          if (fe && (_[x][g] && _[x][g].length == 2 ? _[x][g][0] = te : _[x][g] = te, P = null), Ce) {
            if (H) throw new Error("SYLK shared formula cannot have own formula");
            var U = he > -1 && _[he][xe];
            if (!U || !U[1]) throw new Error("SYLK shared formula cannot find base");
            _[x][g][1] = lc(U[1], { r: x - he, c: g - xe });
          }
          break;
        case "F":
          var N = 0;
          for (C = 1; C < J.length; ++C) switch (J[C].charAt(0)) {
            case "X":
              g = parseInt(J[C].slice(1)) - 1, ++N;
              break;
            case "Y":
              for (x = parseInt(J[C].slice(1)) - 1, W = _.length; W <= x; ++W) _[W] = [];
              break;
            case "M":
              G = parseInt(J[C].slice(1)) / 20;
              break;
            case "F":
              break;
            case "G":
              break;
            case "P":
              P = I[parseInt(J[C].slice(1))];
              break;
            case "S":
              break;
            case "D":
              break;
            case "N":
              break;
            case "W":
              for (D = J[C].slice(1).split(" "), W = parseInt(D[0], 10); W <= parseInt(D[1], 10); ++W)
                G = parseInt(D[2], 10), V[W - 1] = G === 0 ? { hidden: !0 } : { wch: G }, Mt(V[W - 1]);
              break;
            case "C":
              g = parseInt(J[C].slice(1)) - 1, V[g] || (V[g] = {});
              break;
            case "R":
              x = parseInt(J[C].slice(1)) - 1, A[x] || (A[x] = {}), G > 0 ? (A[x].hpt = G, A[x].hpx = da(G)) : G === 0 && (A[x].hidden = !0);
              break;
            default:
              if (d && d.WTF) throw new Error("SYLK bad record " + b);
          }
          N < 1 && (P = null);
          break;
        default:
          if (d && d.WTF) throw new Error("SYLK bad record " + b);
      }
    }
    return A.length > 0 && (O["!rows"] = A), V.length > 0 && (O["!cols"] = V), d && d.sheetRows && (_ = _.slice(0, d.sheetRows)), [_, O];
  }
  function s(h, d) {
    var p = n(h, d), x = p[0], g = p[1], F = zt(x, d);
    return $r(g).forEach(function(C) {
      F[C] = g[C];
    }), F;
  }
  function c(h, d) {
    return ct(s(h, d), d);
  }
  function f(h, d, p, x) {
    var g = "C;Y" + (p + 1) + ";X" + (x + 1) + ";K";
    switch (h.t) {
      case "n":
        g += h.v || 0, h.f && !h.F && (g += ";E" + b1(h.f, { r: p, c: x }));
        break;
      case "b":
        g += h.v ? "TRUE" : "FALSE";
        break;
      case "e":
        g += h.w || h.v;
        break;
      case "d":
        g += '"' + (h.w || h.v) + '"';
        break;
      case "s":
        g += '"' + h.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
        break;
    }
    return g;
  }
  function o(h, d) {
    d.forEach(function(p, x) {
      var g = "F;W" + (x + 1) + " " + (x + 1) + " ";
      p.hidden ? g += "0" : (typeof p.width == "number" && !p.wpx && (p.wpx = qa(p.width)), typeof p.wpx == "number" && !p.wch && (p.wch = Qa(p.wpx)), typeof p.wch == "number" && (g += Math.round(p.wch))), g.charAt(g.length - 1) != " " && h.push(g);
    });
  }
  function u(h, d) {
    d.forEach(function(p, x) {
      var g = "F;";
      p.hidden ? g += "M0;" : p.hpt ? g += "M" + 20 * p.hpt + ";" : p.hpx && (g += "M" + 20 * fc(p.hpx) + ";"), g.length > 2 && h.push(g + "R" + (x + 1));
    });
  }
  function l(h, d) {
    var p = ["ID;PWXL;N;E"], x = [], g = Pe(h["!ref"]), F, C = Array.isArray(h), _ = `\r
`;
    p.push("P;PGeneral"), p.push("F;P0;DG0G8;M255"), h["!cols"] && o(p, h["!cols"]), h["!rows"] && u(p, h["!rows"]), p.push("B;Y" + (g.e.r - g.s.r + 1) + ";X" + (g.e.c - g.s.c + 1) + ";D" + [g.s.c, g.s.r, g.e.c, g.e.r].join(" "));
    for (var I = g.s.r; I <= g.e.r; ++I)
      for (var P = g.s.c; P <= g.e.c; ++P) {
        var O = de({ r: I, c: P });
        F = C ? (h[I] || [])[P] : h[O], !(!F || F.v == null && (!F.f || F.F)) && x.push(f(F, h, I, P));
      }
    return p.join(_) + _ + x.join(_) + _ + "E" + _;
  }
  return {
    to_workbook: c,
    to_sheet: s,
    from_sheet: l
  };
}(), Kl = /* @__PURE__ */ function() {
  function e(i, s) {
    switch (s.type) {
      case "base64":
        return t(Er(i), s);
      case "binary":
        return t(i, s);
      case "buffer":
        return t(_e && Buffer.isBuffer(i) ? i.toString("binary") : Tt(i), s);
      case "array":
        return t(gt(i), s);
    }
    throw new Error("Unrecognized type " + s.type);
  }
  function t(i, s) {
    for (var c = i.split(`
`), f = -1, o = -1, u = 0, l = []; u !== c.length; ++u) {
      if (c[u].trim() === "BOT") {
        l[++f] = [], o = 0;
        continue;
      }
      if (!(f < 0)) {
        var h = c[u].trim().split(","), d = h[0], p = h[1];
        ++u;
        for (var x = c[u] || ""; (x.match(/["]/g) || []).length & 1 && u < c.length - 1; ) x += `
` + c[++u];
        switch (x = x.trim(), +d) {
          case -1:
            if (x === "BOT") {
              l[++f] = [], o = 0;
              continue;
            } else if (x !== "EOD") throw new Error("Unrecognized DIF special command " + x);
            break;
          case 0:
            x === "TRUE" ? l[f][o] = !0 : x === "FALSE" ? l[f][o] = !1 : isNaN(Lr(p)) ? isNaN(Lt(p).getDate()) ? l[f][o] = p : l[f][o] = Ye(p) : l[f][o] = Lr(p), ++o;
            break;
          case 1:
            x = x.slice(1, x.length - 1), x = x.replace(/""/g, '"'), x && x.match(/^=".*"$/) && (x = x.slice(2, -1)), l[f][o++] = x !== "" ? x : null;
            break;
        }
        if (x === "EOD") break;
      }
    }
    return s && s.sheetRows && (l = l.slice(0, s.sheetRows)), l;
  }
  function r(i, s) {
    return zt(e(i, s), s);
  }
  function a(i, s) {
    return ct(r(i, s), s);
  }
  var n = /* @__PURE__ */ function() {
    var i = function(f, o, u, l, h) {
      f.push(o), f.push(u + "," + l), f.push('"' + h.replace(/"/g, '""') + '"');
    }, s = function(f, o, u, l) {
      f.push(o + "," + u), f.push(o == 1 ? '"' + l.replace(/"/g, '""') + '"' : l);
    };
    return function(f) {
      var o = [], u = Pe(f["!ref"]), l, h = Array.isArray(f);
      i(o, "TABLE", 0, 1, "sheetjs"), i(o, "VECTORS", 0, u.e.r - u.s.r + 1, ""), i(o, "TUPLES", 0, u.e.c - u.s.c + 1, ""), i(o, "DATA", 0, 0, "");
      for (var d = u.s.r; d <= u.e.r; ++d) {
        s(o, -1, 0, "BOT");
        for (var p = u.s.c; p <= u.e.c; ++p) {
          var x = de({ r: d, c: p });
          if (l = h ? (f[d] || [])[p] : f[x], !l) {
            s(o, 1, 0, "");
            continue;
          }
          switch (l.t) {
            case "n":
              var g = l.w;
              !g && l.v != null && (g = l.v), g == null ? l.f && !l.F ? s(o, 1, 0, "=" + l.f) : s(o, 1, 0, "") : s(o, 0, g, "V");
              break;
            case "b":
              s(o, 0, l.v ? 1 : 0, l.v ? "TRUE" : "FALSE");
              break;
            case "s":
              s(o, 1, 0, isNaN(l.v) ? l.v : '="' + l.v + '"');
              break;
            case "d":
              l.w || (l.w = yr(l.z || ve[14], pr(Ye(l.v)))), s(o, 0, l.w, "V");
              break;
            default:
              s(o, 1, 0, "");
          }
        }
      }
      s(o, -1, 0, "EOD");
      var F = `\r
`, C = o.join(F);
      return C;
    };
  }();
  return {
    to_workbook: a,
    to_sheet: r,
    from_sheet: n
  };
}(), Yl = /* @__PURE__ */ function() {
  function e(l) {
    return l.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, `
`);
  }
  function t(l) {
    return l.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
  }
  function r(l, h) {
    for (var d = l.split(`
`), p = -1, x = -1, g = 0, F = []; g !== d.length; ++g) {
      var C = d[g].trim().split(":");
      if (C[0] === "cell") {
        var _ = xr(C[1]);
        if (F.length <= _.r) for (p = F.length; p <= _.r; ++p) F[p] || (F[p] = []);
        switch (p = _.r, x = _.c, C[2]) {
          case "t":
            F[p][x] = e(C[3]);
            break;
          case "v":
            F[p][x] = +C[3];
            break;
          case "vtf":
            var I = C[C.length - 1];
          case "vtc":
            switch (C[3]) {
              case "nl":
                F[p][x] = !!+C[4];
                break;
              default:
                F[p][x] = +C[4];
                break;
            }
            C[2] == "vtf" && (F[p][x] = [F[p][x], I]);
        }
      }
    }
    return h && h.sheetRows && (F = F.slice(0, h.sheetRows)), F;
  }
  function a(l, h) {
    return zt(r(l, h), h);
  }
  function n(l, h) {
    return ct(a(l, h), h);
  }
  var i = [
    "socialcalc:version:1.5",
    "MIME-Version: 1.0",
    "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
  ].join(`
`), s = [
    "--SocialCalcSpreadsheetControlSave",
    "Content-type: text/plain; charset=UTF-8"
  ].join(`
`) + `
`, c = [
    "# SocialCalc Spreadsheet Control Save",
    "part:sheet"
  ].join(`
`), f = "--SocialCalcSpreadsheetControlSave--";
  function o(l) {
    if (!l || !l["!ref"]) return "";
    for (var h = [], d = [], p, x = "", g = Ut(l["!ref"]), F = Array.isArray(l), C = g.s.r; C <= g.e.r; ++C)
      for (var _ = g.s.c; _ <= g.e.c; ++_)
        if (x = de({ r: C, c: _ }), p = F ? (l[C] || [])[_] : l[x], !(!p || p.v == null || p.t === "z")) {
          switch (d = ["cell", x, "t"], p.t) {
            case "s":
            case "str":
              d.push(t(p.v));
              break;
            case "n":
              p.f ? (d[2] = "vtf", d[3] = "n", d[4] = p.v, d[5] = t(p.f)) : (d[2] = "v", d[3] = p.v);
              break;
            case "b":
              d[2] = "vt" + (p.f ? "f" : "c"), d[3] = "nl", d[4] = p.v ? "1" : "0", d[5] = t(p.f || (p.v ? "TRUE" : "FALSE"));
              break;
            case "d":
              var I = pr(Ye(p.v));
              d[2] = "vtc", d[3] = "nd", d[4] = "" + I, d[5] = p.w || yr(p.z || ve[14], I);
              break;
            case "e":
              continue;
          }
          h.push(d.join(":"));
        }
    return h.push("sheet:c:" + (g.e.c - g.s.c + 1) + ":r:" + (g.e.r - g.s.r + 1) + ":tvf:1"), h.push("valueformat:1:text-wiki"), h.join(`
`);
  }
  function u(l) {
    return [i, s, c, s, o(l), f].join(`
`);
  }
  return {
    to_workbook: n,
    to_sheet: a,
    from_sheet: u
  };
}(), ha = /* @__PURE__ */ function() {
  function e(u, l, h, d, p) {
    p.raw ? l[h][d] = u : u === "" || (u === "TRUE" ? l[h][d] = !0 : u === "FALSE" ? l[h][d] = !1 : isNaN(Lr(u)) ? isNaN(Lt(u).getDate()) ? l[h][d] = u : l[h][d] = Ye(u) : l[h][d] = Lr(u));
  }
  function t(u, l) {
    var h = l || {}, d = [];
    if (!u || u.length === 0) return d;
    for (var p = u.split(/[\r\n]/), x = p.length - 1; x >= 0 && p[x].length === 0; ) --x;
    for (var g = 10, F = 0, C = 0; C <= x; ++C)
      F = p[C].indexOf(" "), F == -1 ? F = p[C].length : F++, g = Math.max(g, F);
    for (C = 0; C <= x; ++C) {
      d[C] = [];
      var _ = 0;
      for (e(p[C].slice(0, g).trim(), d, C, _, h), _ = 1; _ <= (p[C].length - g) / 10 + 1; ++_)
        e(p[C].slice(g + (_ - 1) * 10, g + _ * 10).trim(), d, C, _, h);
    }
    return h.sheetRows && (d = d.slice(0, h.sheetRows)), d;
  }
  var r = {
    /*::[*/
    44: ",",
    /*::[*/
    9: "	",
    /*::[*/
    59: ";",
    /*::[*/
    124: "|"
  }, a = {
    /*::[*/
    44: 3,
    /*::[*/
    9: 2,
    /*::[*/
    59: 1,
    /*::[*/
    124: 0
  };
  function n(u) {
    for (var l = {}, h = !1, d = 0, p = 0; d < u.length; ++d)
      (p = u.charCodeAt(d)) == 34 ? h = !h : !h && p in r && (l[p] = (l[p] || 0) + 1);
    p = [];
    for (d in l) Object.prototype.hasOwnProperty.call(l, d) && p.push([l[d], d]);
    if (!p.length) {
      l = a;
      for (d in l) Object.prototype.hasOwnProperty.call(l, d) && p.push([l[d], d]);
    }
    return p.sort(function(x, g) {
      return x[0] - g[0] || a[x[1]] - a[g[1]];
    }), r[p.pop()[1]] || 44;
  }
  function i(u, l) {
    var h = l || {}, d = "", p = h.dense ? [] : {}, x = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    u.slice(0, 4) == "sep=" ? u.charCodeAt(5) == 13 && u.charCodeAt(6) == 10 ? (d = u.charAt(4), u = u.slice(7)) : u.charCodeAt(5) == 13 || u.charCodeAt(5) == 10 ? (d = u.charAt(4), u = u.slice(6)) : d = n(u.slice(0, 1024)) : h && h.FS ? d = h.FS : d = n(u.slice(0, 1024));
    var g = 0, F = 0, C = 0, _ = 0, I = 0, P = d.charCodeAt(0), O = !1, A = 0, V = u.charCodeAt(0);
    u = u.replace(/\r\n/mg, `
`);
    var D = h.dateNF != null ? so(h.dateNF) : null;
    function G() {
      var W = u.slice(_, I), b = {};
      if (W.charAt(0) == '"' && W.charAt(W.length - 1) == '"' && (W = W.slice(1, -1).replace(/""/g, '"')), W.length === 0) b.t = "z";
      else if (h.raw)
        b.t = "s", b.v = W;
      else if (W.trim().length === 0)
        b.t = "s", b.v = W;
      else if (W.charCodeAt(0) == 61)
        W.charCodeAt(1) == 34 && W.charCodeAt(W.length - 1) == 34 ? (b.t = "s", b.v = W.slice(2, -1).replace(/""/g, '"')) : L1(W) ? (b.t = "n", b.f = W.slice(1)) : (b.t = "s", b.v = W);
      else if (W == "TRUE")
        b.t = "b", b.v = !0;
      else if (W == "FALSE")
        b.t = "b", b.v = !1;
      else if (!isNaN(C = Lr(W)))
        b.t = "n", h.cellText !== !1 && (b.w = W), b.v = C;
      else if (!isNaN(Lt(W).getDate()) || D && W.match(D)) {
        b.z = h.dateNF || ve[14];
        var J = 0;
        D && W.match(D) && (W = co(W, h.dateNF, W.match(D) || []), J = 1), h.cellDates ? (b.t = "d", b.v = Ye(W, J)) : (b.t = "n", b.v = pr(Ye(W, J))), h.cellText !== !1 && (b.w = yr(b.z, b.v instanceof Date ? pr(b.v) : b.v)), h.cellNF || delete b.z;
      } else
        b.t = "s", b.v = W;
      if (b.t == "z" || (h.dense ? (p[g] || (p[g] = []), p[g][F] = b) : p[de({ c: F, r: g })] = b), _ = I + 1, V = u.charCodeAt(_), x.e.c < F && (x.e.c = F), x.e.r < g && (x.e.r = g), A == P) ++F;
      else if (F = 0, ++g, h.sheetRows && h.sheetRows <= g) return !0;
    }
    e: for (; I < u.length; ++I) switch (A = u.charCodeAt(I)) {
      case 34:
        V === 34 && (O = !O);
        break;
      case P:
      case 10:
      case 13:
        if (!O && G()) break e;
        break;
    }
    return I - _ > 0 && G(), p["!ref"] = Ee(x), p;
  }
  function s(u, l) {
    return !(l && l.PRN) || l.FS || u.slice(0, 4) == "sep=" || u.indexOf("	") >= 0 || u.indexOf(",") >= 0 || u.indexOf(";") >= 0 ? i(u, l) : zt(t(u, l), l);
  }
  function c(u, l) {
    var h = "", d = l.type == "string" ? [0, 0, 0, 0] : x0(u, l);
    switch (l.type) {
      case "base64":
        h = Er(u);
        break;
      case "binary":
        h = u;
        break;
      case "buffer":
        l.codepage == 65001 ? h = u.toString("utf8") : l.codepage && typeof fa < "u" || (h = _e && Buffer.isBuffer(u) ? u.toString("binary") : Tt(u));
        break;
      case "array":
        h = gt(u);
        break;
      case "string":
        h = u;
        break;
      default:
        throw new Error("Unrecognized type " + l.type);
    }
    return d[0] == 239 && d[1] == 187 && d[2] == 191 ? h = ye(h.slice(3)) : l.type != "string" && l.type != "buffer" && l.codepage == 65001 ? h = ye(h) : l.type == "binary" && typeof fa < "u", h.slice(0, 19) == "socialcalc:version:" ? Yl.to_sheet(l.type == "string" ? h : ye(h), l) : s(h, l);
  }
  function f(u, l) {
    return ct(c(u, l), l);
  }
  function o(u) {
    for (var l = [], h = Pe(u["!ref"]), d, p = Array.isArray(u), x = h.s.r; x <= h.e.r; ++x) {
      for (var g = [], F = h.s.c; F <= h.e.c; ++F) {
        var C = de({ r: x, c: F });
        if (d = p ? (u[x] || [])[F] : u[C], !d || d.v == null) {
          g.push("          ");
          continue;
        }
        for (var _ = (d.w || (Yr(d), d.w) || "").slice(0, 10); _.length < 10; ) _ += " ";
        g.push(_ + (F === 0 ? " " : ""));
      }
      l.push(g.join(""));
    }
    return l.join(`
`);
  }
  return {
    to_workbook: f,
    to_sheet: c,
    from_sheet: o
  };
}();
function Jl(e, t) {
  var r = t || {}, a = !!r.WTF;
  r.WTF = !0;
  try {
    var n = Xl.to_workbook(e, r);
    return r.WTF = a, n;
  } catch (i) {
    if (r.WTF = a, !i.message.match(/SYLK bad record ID/) && a) throw i;
    return ha.to_workbook(e, t);
  }
}
var aa = /* @__PURE__ */ function() {
  function e(S, U, N) {
    if (S) {
      Je(S, S.l || 0);
      for (var R = N.Enum || he; S.l < S.length; ) {
        var X = S.read_shift(2), re = R[X] || R[65535], ie = S.read_shift(2), Q = S.l + ie, Y = re.f && re.f(S, ie, N);
        if (S.l = Q, U(Y, re, X)) return;
      }
    }
  }
  function t(S, U) {
    switch (U.type) {
      case "base64":
        return r(Rr(Er(S)), U);
      case "binary":
        return r(Rr(S), U);
      case "buffer":
      case "array":
        return r(S, U);
    }
    throw "Unsupported type " + U.type;
  }
  function r(S, U) {
    if (!S) return S;
    var N = U || {}, R = N.dense ? [] : {}, X = "Sheet1", re = "", ie = 0, Q = {}, Y = [], Te = [], y = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, Be = N.sheetRows || 0;
    if (S[2] == 0 && (S[3] == 8 || S[3] == 9) && S.length >= 16 && S[14] == 5 && S[15] === 108)
      throw new Error("Unsupported Works 3 for Mac file");
    if (S[2] == 2)
      N.Enum = he, e(S, function(ae, Ue, Tr) {
        switch (Tr) {
          case 0:
            N.vers = ae, ae >= 4096 && (N.qpro = !0);
            break;
          case 6:
            y = ae;
            break;
          case 204:
            ae && (re = ae);
            break;
          case 222:
            re = ae;
            break;
          case 15:
          case 51:
            N.qpro || (ae[1].v = ae[1].v.slice(1));
          case 13:
          case 14:
          case 16:
            Tr == 14 && (ae[2] & 112) == 112 && (ae[2] & 15) > 1 && (ae[2] & 15) < 15 && (ae[1].z = N.dateNF || ve[14], N.cellDates && (ae[1].t = "d", ae[1].v = sn(ae[1].v))), N.qpro && ae[3] > ie && (R["!ref"] = Ee(y), Q[X] = R, Y.push(X), R = N.dense ? [] : {}, y = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, ie = ae[3], X = re || "Sheet" + (ie + 1), re = "");
            var Mr = N.dense ? (R[ae[0].r] || [])[ae[0].c] : R[de(ae[0])];
            if (Mr) {
              Mr.t = ae[1].t, Mr.v = ae[1].v, ae[1].z != null && (Mr.z = ae[1].z), ae[1].f != null && (Mr.f = ae[1].f);
              break;
            }
            N.dense ? (R[ae[0].r] || (R[ae[0].r] = []), R[ae[0].r][ae[0].c] = ae[1]) : R[de(ae[0])] = ae[1];
            break;
        }
      }, N);
    else if (S[2] == 26 || S[2] == 14)
      N.Enum = xe, S[2] == 14 && (N.qpro = !0, S.l = 0), e(S, function(ae, Ue, Tr) {
        switch (Tr) {
          case 204:
            X = ae;
            break;
          case 22:
            ae[1].v = ae[1].v.slice(1);
          case 23:
          case 24:
          case 25:
          case 37:
          case 39:
          case 40:
            if (ae[3] > ie && (R["!ref"] = Ee(y), Q[X] = R, Y.push(X), R = N.dense ? [] : {}, y = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, ie = ae[3], X = "Sheet" + (ie + 1)), Be > 0 && ae[0].r >= Be) break;
            N.dense ? (R[ae[0].r] || (R[ae[0].r] = []), R[ae[0].r][ae[0].c] = ae[1]) : R[de(ae[0])] = ae[1], y.e.c < ae[0].c && (y.e.c = ae[0].c), y.e.r < ae[0].r && (y.e.r = ae[0].r);
            break;
          case 27:
            ae[14e3] && (Te[ae[14e3][0]] = ae[14e3][1]);
            break;
          case 1537:
            Te[ae[0]] = ae[1], ae[0] == ie && (X = ae[1]);
            break;
        }
      }, N);
    else throw new Error("Unrecognized LOTUS BOF " + S[2]);
    if (R["!ref"] = Ee(y), Q[re || X] = R, Y.push(re || X), !Te.length) return { SheetNames: Y, Sheets: Q };
    for (var Ae = {}, Se = [], me = 0; me < Te.length; ++me) Q[Y[me]] ? (Se.push(Te[me] || Y[me]), Ae[Te[me]] = Q[Te[me]] || Q[Y[me]]) : (Se.push(Te[me]), Ae[Te[me]] = { "!ref": "A1" });
    return { SheetNames: Se, Sheets: Ae };
  }
  function a(S, U) {
    var N = U || {};
    if (+N.codepage >= 0 && Nr(+N.codepage), N.type == "string") throw new Error("Cannot write WK1 to JS string");
    var R = On(), X = Pe(S["!ref"]), re = Array.isArray(S), ie = [];
    Dr(R, 0, i(1030)), Dr(R, 6, f(X));
    for (var Q = Math.min(X.e.r, 8191), Y = X.s.r; Y <= Q; ++Y)
      for (var Te = Qe(Y), y = X.s.c; y <= X.e.c; ++y) {
        Y === X.s.r && (ie[y] = je(y));
        var Be = ie[y] + Te, Ae = re ? (S[Y] || [])[y] : S[Be];
        if (!(!Ae || Ae.t == "z"))
          if (Ae.t == "n")
            (Ae.v | 0) == Ae.v && Ae.v >= -32768 && Ae.v <= 32767 ? Dr(R, 13, d(Y, y, Ae.v)) : Dr(R, 14, x(Y, y, Ae.v));
          else {
            var Se = Yr(Ae);
            Dr(R, 15, l(Y, y, Se.slice(0, 239)));
          }
      }
    return Dr(R, 1), R.end();
  }
  function n(S, U) {
    var N = U || {};
    if (+N.codepage >= 0 && Nr(+N.codepage), N.type == "string") throw new Error("Cannot write WK3 to JS string");
    var R = On();
    Dr(R, 0, s(S));
    for (var X = 0, re = 0; X < S.SheetNames.length; ++X) (S.Sheets[S.SheetNames[X]] || {})["!ref"] && Dr(R, 27, H(S.SheetNames[X], re++));
    var ie = 0;
    for (X = 0; X < S.SheetNames.length; ++X) {
      var Q = S.Sheets[S.SheetNames[X]];
      if (!(!Q || !Q["!ref"])) {
        for (var Y = Pe(Q["!ref"]), Te = Array.isArray(Q), y = [], Be = Math.min(Y.e.r, 8191), Ae = Y.s.r; Ae <= Be; ++Ae)
          for (var Se = Qe(Ae), me = Y.s.c; me <= Y.e.c; ++me) {
            Ae === Y.s.r && (y[me] = je(me));
            var ae = y[me] + Se, Ue = Te ? (Q[Ae] || [])[me] : Q[ae];
            if (!(!Ue || Ue.t == "z"))
              if (Ue.t == "n")
                Dr(R, 23, G(Ae, me, ie, Ue.v));
              else {
                var Tr = Yr(Ue);
                Dr(R, 22, A(Ae, me, ie, Tr.slice(0, 239)));
              }
          }
        ++ie;
      }
    }
    return Dr(R, 1), R.end();
  }
  function i(S) {
    var U = Ge(2);
    return U.write_shift(2, S), U;
  }
  function s(S) {
    var U = Ge(26);
    U.write_shift(2, 4096), U.write_shift(2, 4), U.write_shift(4, 0);
    for (var N = 0, R = 0, X = 0, re = 0; re < S.SheetNames.length; ++re) {
      var ie = S.SheetNames[re], Q = S.Sheets[ie];
      if (!(!Q || !Q["!ref"])) {
        ++X;
        var Y = Ut(Q["!ref"]);
        N < Y.e.r && (N = Y.e.r), R < Y.e.c && (R = Y.e.c);
      }
    }
    return N > 8191 && (N = 8191), U.write_shift(2, N), U.write_shift(1, X), U.write_shift(1, R), U.write_shift(2, 0), U.write_shift(2, 0), U.write_shift(1, 1), U.write_shift(1, 2), U.write_shift(4, 0), U.write_shift(4, 0), U;
  }
  function c(S, U, N) {
    var R = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    return U == 8 && N.qpro ? (R.s.c = S.read_shift(1), S.l++, R.s.r = S.read_shift(2), R.e.c = S.read_shift(1), S.l++, R.e.r = S.read_shift(2), R) : (R.s.c = S.read_shift(2), R.s.r = S.read_shift(2), U == 12 && N.qpro && (S.l += 2), R.e.c = S.read_shift(2), R.e.r = S.read_shift(2), U == 12 && N.qpro && (S.l += 2), R.s.c == 65535 && (R.s.c = R.e.c = R.s.r = R.e.r = 0), R);
  }
  function f(S) {
    var U = Ge(8);
    return U.write_shift(2, S.s.c), U.write_shift(2, S.s.r), U.write_shift(2, S.e.c), U.write_shift(2, S.e.r), U;
  }
  function o(S, U, N) {
    var R = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0, 0];
    return N.qpro && N.vers != 20768 ? (R[0].c = S.read_shift(1), R[3] = S.read_shift(1), R[0].r = S.read_shift(2), S.l += 2) : (R[2] = S.read_shift(1), R[0].c = S.read_shift(2), R[0].r = S.read_shift(2)), R;
  }
  function u(S, U, N) {
    var R = S.l + U, X = o(S, U, N);
    if (X[1].t = "s", N.vers == 20768) {
      S.l++;
      var re = S.read_shift(1);
      return X[1].v = S.read_shift(re, "utf8"), X;
    }
    return N.qpro && S.l++, X[1].v = S.read_shift(R - S.l, "cstr"), X;
  }
  function l(S, U, N) {
    var R = Ge(7 + N.length);
    R.write_shift(1, 255), R.write_shift(2, U), R.write_shift(2, S), R.write_shift(1, 39);
    for (var X = 0; X < R.length; ++X) {
      var re = N.charCodeAt(X);
      R.write_shift(1, re >= 128 ? 95 : re);
    }
    return R.write_shift(1, 0), R;
  }
  function h(S, U, N) {
    var R = o(S, U, N);
    return R[1].v = S.read_shift(2, "i"), R;
  }
  function d(S, U, N) {
    var R = Ge(7);
    return R.write_shift(1, 255), R.write_shift(2, U), R.write_shift(2, S), R.write_shift(2, N, "i"), R;
  }
  function p(S, U, N) {
    var R = o(S, U, N);
    return R[1].v = S.read_shift(8, "f"), R;
  }
  function x(S, U, N) {
    var R = Ge(13);
    return R.write_shift(1, 255), R.write_shift(2, U), R.write_shift(2, S), R.write_shift(8, N, "f"), R;
  }
  function g(S, U, N) {
    var R = S.l + U, X = o(S, U, N);
    if (X[1].v = S.read_shift(8, "f"), N.qpro) S.l = R;
    else {
      var re = S.read_shift(2);
      I(S.slice(S.l, S.l + re), X), S.l += re;
    }
    return X;
  }
  function F(S, U, N) {
    var R = U & 32768;
    return U &= -32769, U = (R ? S : 0) + (U >= 8192 ? U - 16384 : U), (R ? "" : "$") + (N ? je(U) : Qe(U));
  }
  var C = {
    51: ["FALSE", 0],
    52: ["TRUE", 0],
    70: ["LEN", 1],
    80: ["SUM", 69],
    81: ["AVERAGEA", 69],
    82: ["COUNTA", 69],
    83: ["MINA", 69],
    84: ["MAXA", 69],
    111: ["T", 1]
  }, _ = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "",
    "+",
    "-",
    "*",
    "/",
    "^",
    "=",
    "<>",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "<=",
    ">=",
    "<",
    ">",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "&",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
    // eslint-disable-line no-mixed-spaces-and-tabs
  ];
  function I(S, U) {
    Je(S, 0);
    for (var N = [], R = 0, X = "", re = "", ie = "", Q = ""; S.l < S.length; ) {
      var Y = S[S.l++];
      switch (Y) {
        case 0:
          N.push(S.read_shift(8, "f"));
          break;
        case 1:
          re = F(U[0].c, S.read_shift(2), !0), X = F(U[0].r, S.read_shift(2), !1), N.push(re + X);
          break;
        case 2:
          {
            var Te = F(U[0].c, S.read_shift(2), !0), y = F(U[0].r, S.read_shift(2), !1);
            re = F(U[0].c, S.read_shift(2), !0), X = F(U[0].r, S.read_shift(2), !1), N.push(Te + y + ":" + re + X);
          }
          break;
        case 3:
          if (S.l < S.length) {
            console.error("WK1 premature formula end");
            return;
          }
          break;
        case 4:
          N.push("(" + N.pop() + ")");
          break;
        case 5:
          N.push(S.read_shift(2));
          break;
        case 6:
          {
            for (var Be = ""; Y = S[S.l++]; ) Be += String.fromCharCode(Y);
            N.push('"' + Be.replace(/"/g, '""') + '"');
          }
          break;
        case 8:
          N.push("-" + N.pop());
          break;
        case 23:
          N.push("+" + N.pop());
          break;
        case 22:
          N.push("NOT(" + N.pop() + ")");
          break;
        case 20:
        case 21:
          Q = N.pop(), ie = N.pop(), N.push(["AND", "OR"][Y - 20] + "(" + ie + "," + Q + ")");
          break;
        default:
          if (Y < 32 && _[Y])
            Q = N.pop(), ie = N.pop(), N.push(ie + _[Y] + Q);
          else if (C[Y]) {
            if (R = C[Y][1], R == 69 && (R = S[S.l++]), R > N.length) {
              console.error("WK1 bad formula parse 0x" + Y.toString(16) + ":|" + N.join("|") + "|");
              return;
            }
            var Ae = N.slice(-R);
            N.length -= R, N.push(C[Y][0] + "(" + Ae.join(",") + ")");
          } else return Y <= 7 ? console.error("WK1 invalid opcode " + Y.toString(16)) : Y <= 24 ? console.error("WK1 unsupported op " + Y.toString(16)) : Y <= 30 ? console.error("WK1 invalid opcode " + Y.toString(16)) : Y <= 115 ? console.error("WK1 unsupported function opcode " + Y.toString(16)) : console.error("WK1 unrecognized opcode " + Y.toString(16));
      }
    }
    N.length == 1 ? U[1].f = "" + N[0] : console.error("WK1 bad formula parse |" + N.join("|") + "|");
  }
  function P(S) {
    var U = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
    return U[0].r = S.read_shift(2), U[3] = S[S.l++], U[0].c = S[S.l++], U;
  }
  function O(S, U) {
    var N = P(S);
    return N[1].t = "s", N[1].v = S.read_shift(U - 4, "cstr"), N;
  }
  function A(S, U, N, R) {
    var X = Ge(6 + R.length);
    X.write_shift(2, S), X.write_shift(1, N), X.write_shift(1, U), X.write_shift(1, 39);
    for (var re = 0; re < R.length; ++re) {
      var ie = R.charCodeAt(re);
      X.write_shift(1, ie >= 128 ? 95 : ie);
    }
    return X.write_shift(1, 0), X;
  }
  function V(S, U) {
    var N = P(S);
    N[1].v = S.read_shift(2);
    var R = N[1].v >> 1;
    if (N[1].v & 1)
      switch (R & 7) {
        case 0:
          R = (R >> 3) * 5e3;
          break;
        case 1:
          R = (R >> 3) * 500;
          break;
        case 2:
          R = (R >> 3) / 20;
          break;
        case 3:
          R = (R >> 3) / 200;
          break;
        case 4:
          R = (R >> 3) / 2e3;
          break;
        case 5:
          R = (R >> 3) / 2e4;
          break;
        case 6:
          R = (R >> 3) / 16;
          break;
        case 7:
          R = (R >> 3) / 64;
          break;
      }
    return N[1].v = R, N;
  }
  function D(S, U) {
    var N = P(S), R = S.read_shift(4), X = S.read_shift(4), re = S.read_shift(2);
    if (re == 65535)
      return R === 0 && X === 3221225472 ? (N[1].t = "e", N[1].v = 15) : R === 0 && X === 3489660928 ? (N[1].t = "e", N[1].v = 42) : N[1].v = 0, N;
    var ie = re & 32768;
    return re = (re & 32767) - 16446, N[1].v = (1 - ie * 2) * (X * Math.pow(2, re + 32) + R * Math.pow(2, re)), N;
  }
  function G(S, U, N, R) {
    var X = Ge(14);
    if (X.write_shift(2, S), X.write_shift(1, N), X.write_shift(1, U), R == 0)
      return X.write_shift(4, 0), X.write_shift(4, 0), X.write_shift(2, 65535), X;
    var re = 0, ie = 0, Q = 0, Y = 0;
    return R < 0 && (re = 1, R = -R), ie = Math.log2(R) | 0, R /= Math.pow(2, ie - 31), Y = R >>> 0, Y & 2147483648 || (R /= 2, ++ie, Y = R >>> 0), R -= Y, Y |= 2147483648, Y >>>= 0, R *= Math.pow(2, 32), Q = R >>> 0, X.write_shift(4, Q), X.write_shift(4, Y), ie += 16383 + (re ? 32768 : 0), X.write_shift(2, ie), X;
  }
  function W(S, U) {
    var N = D(S);
    return S.l += U - 14, N;
  }
  function b(S, U) {
    var N = P(S), R = S.read_shift(4);
    return N[1].v = R >> 6, N;
  }
  function J(S, U) {
    var N = P(S), R = S.read_shift(8, "f");
    return N[1].v = R, N;
  }
  function oe(S, U) {
    var N = J(S);
    return S.l += U - 10, N;
  }
  function te(S, U) {
    return S[S.l + U - 1] == 0 ? S.read_shift(U, "cstr") : "";
  }
  function fe(S, U) {
    var N = S[S.l++];
    N > U - 1 && (N = U - 1);
    for (var R = ""; R.length < N; ) R += String.fromCharCode(S[S.l++]);
    return R;
  }
  function ce(S, U, N) {
    if (!(!N.qpro || U < 21)) {
      var R = S.read_shift(1);
      S.l += 17, S.l += 1, S.l += 2;
      var X = S.read_shift(U - 21, "cstr");
      return [R, X];
    }
  }
  function Ce(S, U) {
    for (var N = {}, R = S.l + U; S.l < R; ) {
      var X = S.read_shift(2);
      if (X == 14e3) {
        for (N[X] = [0, ""], N[X][0] = S.read_shift(2); S[S.l]; )
          N[X][1] += String.fromCharCode(S[S.l]), S.l++;
        S.l++;
      }
    }
    return N;
  }
  function H(S, U) {
    var N = Ge(5 + S.length);
    N.write_shift(2, 14e3), N.write_shift(2, U);
    for (var R = 0; R < S.length; ++R) {
      var X = S.charCodeAt(R);
      N[N.l++] = X > 127 ? 95 : X;
    }
    return N[N.l++] = 0, N;
  }
  var he = {
    /*::[*/
    0: { n: "BOF", f: We },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "CALCMODE" },
    /*::[*/
    3: { n: "CALCORDER" },
    /*::[*/
    4: { n: "SPLIT" },
    /*::[*/
    5: { n: "SYNC" },
    /*::[*/
    6: { n: "RANGE", f: c },
    /*::[*/
    7: { n: "WINDOW1" },
    /*::[*/
    8: { n: "COLW1" },
    /*::[*/
    9: { n: "WINTWO" },
    /*::[*/
    10: { n: "COLW2" },
    /*::[*/
    11: { n: "NAME" },
    /*::[*/
    12: { n: "BLANK" },
    /*::[*/
    13: { n: "INTEGER", f: h },
    /*::[*/
    14: { n: "NUMBER", f: p },
    /*::[*/
    15: { n: "LABEL", f: u },
    /*::[*/
    16: { n: "FORMULA", f: g },
    /*::[*/
    24: { n: "TABLE" },
    /*::[*/
    25: { n: "ORANGE" },
    /*::[*/
    26: { n: "PRANGE" },
    /*::[*/
    27: { n: "SRANGE" },
    /*::[*/
    28: { n: "FRANGE" },
    /*::[*/
    29: { n: "KRANGE1" },
    /*::[*/
    32: { n: "HRANGE" },
    /*::[*/
    35: { n: "KRANGE2" },
    /*::[*/
    36: { n: "PROTEC" },
    /*::[*/
    37: { n: "FOOTER" },
    /*::[*/
    38: { n: "HEADER" },
    /*::[*/
    39: { n: "SETUP" },
    /*::[*/
    40: { n: "MARGINS" },
    /*::[*/
    41: { n: "LABELFMT" },
    /*::[*/
    42: { n: "TITLES" },
    /*::[*/
    43: { n: "SHEETJS" },
    /*::[*/
    45: { n: "GRAPH" },
    /*::[*/
    46: { n: "NGRAPH" },
    /*::[*/
    47: { n: "CALCCOUNT" },
    /*::[*/
    48: { n: "UNFORMATTED" },
    /*::[*/
    49: { n: "CURSORW12" },
    /*::[*/
    50: { n: "WINDOW" },
    /*::[*/
    51: { n: "STRING", f: u },
    /*::[*/
    55: { n: "PASSWORD" },
    /*::[*/
    56: { n: "LOCKED" },
    /*::[*/
    60: { n: "QUERY" },
    /*::[*/
    61: { n: "QUERYNAME" },
    /*::[*/
    62: { n: "PRINT" },
    /*::[*/
    63: { n: "PRINTNAME" },
    /*::[*/
    64: { n: "GRAPH2" },
    /*::[*/
    65: { n: "GRAPHNAME" },
    /*::[*/
    66: { n: "ZOOM" },
    /*::[*/
    67: { n: "SYMSPLIT" },
    /*::[*/
    68: { n: "NSROWS" },
    /*::[*/
    69: { n: "NSCOLS" },
    /*::[*/
    70: { n: "RULER" },
    /*::[*/
    71: { n: "NNAME" },
    /*::[*/
    72: { n: "ACOMM" },
    /*::[*/
    73: { n: "AMACRO" },
    /*::[*/
    74: { n: "PARSE" },
    /*::[*/
    102: { n: "PRANGES??" },
    /*::[*/
    103: { n: "RRANGES??" },
    /*::[*/
    104: { n: "FNAME??" },
    /*::[*/
    105: { n: "MRANGES??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: te },
    /*::[*/
    222: { n: "SHEETNAMELP", f: fe },
    /*::[*/
    65535: { n: "" }
  }, xe = {
    /*::[*/
    0: { n: "BOF" },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "PASSWORD" },
    /*::[*/
    3: { n: "CALCSET" },
    /*::[*/
    4: { n: "WINDOWSET" },
    /*::[*/
    5: { n: "SHEETCELLPTR" },
    /*::[*/
    6: { n: "SHEETLAYOUT" },
    /*::[*/
    7: { n: "COLUMNWIDTH" },
    /*::[*/
    8: { n: "HIDDENCOLUMN" },
    /*::[*/
    9: { n: "USERRANGE" },
    /*::[*/
    10: { n: "SYSTEMRANGE" },
    /*::[*/
    11: { n: "ZEROFORCE" },
    /*::[*/
    12: { n: "SORTKEYDIR" },
    /*::[*/
    13: { n: "FILESEAL" },
    /*::[*/
    14: { n: "DATAFILLNUMS" },
    /*::[*/
    15: { n: "PRINTMAIN" },
    /*::[*/
    16: { n: "PRINTSTRING" },
    /*::[*/
    17: { n: "GRAPHMAIN" },
    /*::[*/
    18: { n: "GRAPHSTRING" },
    /*::[*/
    19: { n: "??" },
    /*::[*/
    20: { n: "ERRCELL" },
    /*::[*/
    21: { n: "NACELL" },
    /*::[*/
    22: { n: "LABEL16", f: O },
    /*::[*/
    23: { n: "NUMBER17", f: D },
    /*::[*/
    24: { n: "NUMBER18", f: V },
    /*::[*/
    25: { n: "FORMULA19", f: W },
    /*::[*/
    26: { n: "FORMULA1A" },
    /*::[*/
    27: { n: "XFORMAT", f: Ce },
    /*::[*/
    28: { n: "DTLABELMISC" },
    /*::[*/
    29: { n: "DTLABELCELL" },
    /*::[*/
    30: { n: "GRAPHWINDOW" },
    /*::[*/
    31: { n: "CPA" },
    /*::[*/
    32: { n: "LPLAUTO" },
    /*::[*/
    33: { n: "QUERY" },
    /*::[*/
    34: { n: "HIDDENSHEET" },
    /*::[*/
    35: { n: "??" },
    /*::[*/
    37: { n: "NUMBER25", f: b },
    /*::[*/
    38: { n: "??" },
    /*::[*/
    39: { n: "NUMBER27", f: J },
    /*::[*/
    40: { n: "FORMULA28", f: oe },
    /*::[*/
    142: { n: "??" },
    /*::[*/
    147: { n: "??" },
    /*::[*/
    150: { n: "??" },
    /*::[*/
    151: { n: "??" },
    /*::[*/
    152: { n: "??" },
    /*::[*/
    153: { n: "??" },
    /*::[*/
    154: { n: "??" },
    /*::[*/
    155: { n: "??" },
    /*::[*/
    156: { n: "??" },
    /*::[*/
    163: { n: "??" },
    /*::[*/
    174: { n: "??" },
    /*::[*/
    175: { n: "??" },
    /*::[*/
    176: { n: "??" },
    /*::[*/
    177: { n: "??" },
    /*::[*/
    184: { n: "??" },
    /*::[*/
    185: { n: "??" },
    /*::[*/
    186: { n: "??" },
    /*::[*/
    187: { n: "??" },
    /*::[*/
    188: { n: "??" },
    /*::[*/
    195: { n: "??" },
    /*::[*/
    201: { n: "??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: te },
    /*::[*/
    205: { n: "??" },
    /*::[*/
    206: { n: "??" },
    /*::[*/
    207: { n: "??" },
    /*::[*/
    208: { n: "??" },
    /*::[*/
    256: { n: "??" },
    /*::[*/
    259: { n: "??" },
    /*::[*/
    260: { n: "??" },
    /*::[*/
    261: { n: "??" },
    /*::[*/
    262: { n: "??" },
    /*::[*/
    263: { n: "??" },
    /*::[*/
    265: { n: "??" },
    /*::[*/
    266: { n: "??" },
    /*::[*/
    267: { n: "??" },
    /*::[*/
    268: { n: "??" },
    /*::[*/
    270: { n: "??" },
    /*::[*/
    271: { n: "??" },
    /*::[*/
    384: { n: "??" },
    /*::[*/
    389: { n: "??" },
    /*::[*/
    390: { n: "??" },
    /*::[*/
    393: { n: "??" },
    /*::[*/
    396: { n: "??" },
    /*::[*/
    512: { n: "??" },
    /*::[*/
    514: { n: "??" },
    /*::[*/
    513: { n: "??" },
    /*::[*/
    516: { n: "??" },
    /*::[*/
    517: { n: "??" },
    /*::[*/
    640: { n: "??" },
    /*::[*/
    641: { n: "??" },
    /*::[*/
    642: { n: "??" },
    /*::[*/
    643: { n: "??" },
    /*::[*/
    644: { n: "??" },
    /*::[*/
    645: { n: "??" },
    /*::[*/
    646: { n: "??" },
    /*::[*/
    647: { n: "??" },
    /*::[*/
    648: { n: "??" },
    /*::[*/
    658: { n: "??" },
    /*::[*/
    659: { n: "??" },
    /*::[*/
    660: { n: "??" },
    /*::[*/
    661: { n: "??" },
    /*::[*/
    662: { n: "??" },
    /*::[*/
    665: { n: "??" },
    /*::[*/
    666: { n: "??" },
    /*::[*/
    768: { n: "??" },
    /*::[*/
    772: { n: "??" },
    /*::[*/
    1537: { n: "SHEETINFOQP", f: ce },
    /*::[*/
    1600: { n: "??" },
    /*::[*/
    1602: { n: "??" },
    /*::[*/
    1793: { n: "??" },
    /*::[*/
    1794: { n: "??" },
    /*::[*/
    1795: { n: "??" },
    /*::[*/
    1796: { n: "??" },
    /*::[*/
    1920: { n: "??" },
    /*::[*/
    2048: { n: "??" },
    /*::[*/
    2049: { n: "??" },
    /*::[*/
    2052: { n: "??" },
    /*::[*/
    2688: { n: "??" },
    /*::[*/
    10998: { n: "??" },
    /*::[*/
    12849: { n: "??" },
    /*::[*/
    28233: { n: "??" },
    /*::[*/
    28484: { n: "??" },
    /*::[*/
    65535: { n: "" }
  };
  return {
    sheet_to_wk1: a,
    book_to_wk3: n,
    to_workbook: t
  };
}();
function ql(e) {
  var t = {}, r = e.match(fr), a = 0, n = !1;
  if (r) for (; a != r.length; ++a) {
    var i = le(r[a]);
    switch (i[0].replace(/\w*:/g, "")) {
      case "<condense":
        break;
      case "<extend":
        break;
      case "<shadow":
        if (!i.val) break;
      case "<shadow>":
      case "<shadow/>":
        t.shadow = 1;
        break;
      case "</shadow>":
        break;
      case "<charset":
        if (i.val == "1") break;
        t.cp = Hn[parseInt(i.val, 10)];
        break;
      case "<outline":
        if (!i.val) break;
      case "<outline>":
      case "<outline/>":
        t.outline = 1;
        break;
      case "</outline>":
        break;
      case "<rFont":
        t.name = i.val;
        break;
      case "<sz":
        t.sz = i.val;
        break;
      case "<strike":
        if (!i.val) break;
      case "<strike>":
      case "<strike/>":
        t.strike = 1;
        break;
      case "</strike>":
        break;
      case "<u":
        if (!i.val) break;
        switch (i.val) {
          case "double":
            t.uval = "double";
            break;
          case "singleAccounting":
            t.uval = "single-accounting";
            break;
          case "doubleAccounting":
            t.uval = "double-accounting";
            break;
        }
      case "<u>":
      case "<u/>":
        t.u = 1;
        break;
      case "</u>":
        break;
      case "<b":
        if (i.val == "0") break;
      case "<b>":
      case "<b/>":
        t.b = 1;
        break;
      case "</b>":
        break;
      case "<i":
        if (i.val == "0") break;
      case "<i>":
      case "<i/>":
        t.i = 1;
        break;
      case "</i>":
        break;
      case "<color":
        i.rgb && (t.color = i.rgb.slice(2, 8));
        break;
      case "<color>":
      case "<color/>":
      case "</color>":
        break;
      case "<family":
        t.family = i.val;
        break;
      case "<family>":
      case "<family/>":
      case "</family>":
        break;
      case "<vertAlign":
        t.valign = i.val;
        break;
      case "<vertAlign>":
      case "<vertAlign/>":
      case "</vertAlign>":
        break;
      case "<scheme":
        break;
      case "<scheme>":
      case "<scheme/>":
      case "</scheme>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        n = !0;
        break;
      case "</ext>":
        n = !1;
        break;
      default:
        if (i[0].charCodeAt(1) !== 47 && !n) throw new Error("Unrecognized rich format " + i[0]);
    }
  }
  return t;
}
var Ql = /* @__PURE__ */ function() {
  var e = ua("t"), t = ua("rPr");
  function r(i) {
    var s = i.match(e);
    if (!s) return { t: "s", v: "" };
    var c = { t: "s", v: we(s[1]) }, f = i.match(t);
    return f && (c.s = ql(f[1])), c;
  }
  var a = /<(?:\w+:)?r>/g, n = /<\/(?:\w+:)?r>/;
  return function(s) {
    return s.replace(a, "").split(n).map(r).filter(function(c) {
      return c.v;
    });
  };
}(), eh = /* @__PURE__ */ function() {
  var t = /(\r\n|\n)/g;
  function r(n, i, s) {
    var c = [];
    n.u && c.push("text-decoration: underline;"), n.uval && c.push("text-underline-style:" + n.uval + ";"), n.sz && c.push("font-size:" + n.sz + "pt;"), n.outline && c.push("text-effect: outline;"), n.shadow && c.push("text-shadow: auto;"), i.push('<span style="' + c.join("") + '">'), n.b && (i.push("<b>"), s.push("</b>")), n.i && (i.push("<i>"), s.push("</i>")), n.strike && (i.push("<s>"), s.push("</s>"));
    var f = n.valign || "";
    return f == "superscript" || f == "super" ? f = "sup" : f == "subscript" && (f = "sub"), f != "" && (i.push("<" + f + ">"), s.push("</" + f + ">")), s.push("</span>"), n;
  }
  function a(n) {
    var i = [[], n.v, []];
    return n.v ? (n.s && r(n.s, i[0], i[2]), i[0].join("") + i[1].replace(t, "<br/>") + i[2].join("")) : "";
  }
  return function(i) {
    return i.map(a).join("");
  };
}(), rh = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, th = /<(?:\w+:)?r>/, ah = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function s0(e, t) {
  var r = t ? t.cellHTML : !0, a = {};
  return e ? (e.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (a.t = we(ye(e.slice(e.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || "")), a.r = ye(e), r && (a.h = Yn(a.t))) : (
    /*y = */
    e.match(th) && (a.r = ye(e), a.t = we(ye((e.replace(ah, "").match(rh) || []).join("").replace(fr, ""))), r && (a.h = eh(Ql(a.r))))
  ), a) : { t: "" };
}
var nh = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/, ih = /<(?:\w+:)?(?:si|sstItem)>/g, sh = /<\/(?:\w+:)?(?:si|sstItem)>/;
function ch(e, t) {
  var r = [], a = "";
  if (!e) return r;
  var n = e.match(nh);
  if (n) {
    a = n[2].replace(ih, "").split(sh);
    for (var i = 0; i != a.length; ++i) {
      var s = s0(a[i].trim(), t);
      s != null && (r[r.length] = s);
    }
    n = le(n[1]), r.Count = n.count, r.Unique = n.uniqueCount;
  }
  return r;
}
function fh(e) {
  return [e.read_shift(4), e.read_shift(4)];
}
function oh(e, t) {
  var r = [], a = !1;
  return Jr(e, function(i, s, c) {
    switch (c) {
      case 159:
        r.Count = i[0], r.Unique = i[1];
        break;
      case 19:
        r.push(i);
        break;
      case 160:
        return !0;
      case 35:
        a = !0;
        break;
      case 36:
        a = !1;
        break;
      default:
        if (s.T, !a || t.WTF) throw new Error("Unexpected record 0x" + c.toString(16));
    }
  }), r;
}
function tc(e) {
  for (var t = [], r = e.split(""), a = 0; a < r.length; ++a) t[a] = r[a].charCodeAt(0);
  return t;
}
function Kr(e, t) {
  var r = {};
  return r.Major = e.read_shift(2), r.Minor = e.read_shift(2), t >= 4 && (e.l += t - 4), r;
}
function uh(e) {
  var t = {};
  return t.id = e.read_shift(0, "lpp4"), t.R = Kr(e, 4), t.U = Kr(e, 4), t.W = Kr(e, 4), t;
}
function lh(e) {
  for (var t = e.read_shift(4), r = e.l + t - 4, a = {}, n = e.read_shift(4), i = []; n-- > 0; ) i.push({ t: e.read_shift(4), v: e.read_shift(0, "lpp4") });
  if (a.name = e.read_shift(0, "lpp4"), a.comps = i, e.l != r) throw new Error("Bad DataSpaceMapEntry: " + e.l + " != " + r);
  return a;
}
function hh(e) {
  var t = [];
  e.l += 4;
  for (var r = e.read_shift(4); r-- > 0; ) t.push(lh(e));
  return t;
}
function xh(e) {
  var t = [];
  e.l += 4;
  for (var r = e.read_shift(4); r-- > 0; ) t.push(e.read_shift(0, "lpp4"));
  return t;
}
function dh(e) {
  var t = {};
  return e.read_shift(4), e.l += 4, t.id = e.read_shift(0, "lpp4"), t.name = e.read_shift(0, "lpp4"), t.R = Kr(e, 4), t.U = Kr(e, 4), t.W = Kr(e, 4), t;
}
function ph(e) {
  var t = dh(e);
  if (t.ename = e.read_shift(0, "8lpp4"), t.blksz = e.read_shift(4), t.cmode = e.read_shift(4), e.read_shift(4) != 4) throw new Error("Bad !Primary record");
  return t;
}
function ac(e, t) {
  var r = e.l + t, a = {};
  a.Flags = e.read_shift(4) & 63, e.l += 4, a.AlgID = e.read_shift(4);
  var n = !1;
  switch (a.AlgID) {
    case 26126:
    case 26127:
    case 26128:
      n = a.Flags == 36;
      break;
    case 26625:
      n = a.Flags == 4;
      break;
    case 0:
      n = a.Flags == 16 || a.Flags == 4 || a.Flags == 36;
      break;
    default:
      throw "Unrecognized encryption algorithm: " + a.AlgID;
  }
  if (!n) throw new Error("Encryption Flags/AlgID mismatch");
  return a.AlgIDHash = e.read_shift(4), a.KeySize = e.read_shift(4), a.ProviderType = e.read_shift(4), e.l += 8, a.CSPName = e.read_shift(r - e.l >> 1, "utf16le"), e.l = r, a;
}
function nc(e, t) {
  var r = {}, a = e.l + t;
  return e.l += 4, r.Salt = e.slice(e.l, e.l + 16), e.l += 16, r.Verifier = e.slice(e.l, e.l + 16), e.l += 16, e.read_shift(4), r.VerifierHash = e.slice(e.l, a), e.l = a, r;
}
function vh(e) {
  var t = Kr(e);
  switch (t.Minor) {
    case 2:
      return [t.Minor, gh(e)];
    case 3:
      return [t.Minor, mh()];
    case 4:
      return [t.Minor, _h(e)];
  }
  throw new Error("ECMA-376 Encrypted file unrecognized Version: " + t.Minor);
}
function gh(e) {
  var t = e.read_shift(4);
  if ((t & 63) != 36) throw new Error("EncryptionInfo mismatch");
  var r = e.read_shift(4), a = ac(e, r), n = nc(e, e.length - e.l);
  return { t: "Std", h: a, v: n };
}
function mh() {
  throw new Error("File is password-protected: ECMA-376 Extensible");
}
function _h(e) {
  var t = ["saltSize", "blockSize", "keyBits", "hashSize", "cipherAlgorithm", "cipherChaining", "hashAlgorithm", "saltValue"];
  e.l += 4;
  var r = e.read_shift(e.length - e.l, "utf8"), a = {};
  return r.replace(fr, function(i) {
    var s = le(i);
    switch (Vr(s[0])) {
      case "<?xml":
        break;
      case "<encryption":
      case "</encryption>":
        break;
      case "<keyData":
        t.forEach(function(c) {
          a[c] = s[c];
        });
        break;
      case "<dataIntegrity":
        a.encryptedHmacKey = s.encryptedHmacKey, a.encryptedHmacValue = s.encryptedHmacValue;
        break;
      case "<keyEncryptors>":
      case "<keyEncryptors":
        a.encs = [];
        break;
      case "</keyEncryptors>":
        break;
      case "<keyEncryptor":
        a.uri = s.uri;
        break;
      case "</keyEncryptor>":
        break;
      case "<encryptedKey":
        a.encs.push(s);
        break;
      default:
        throw s[0];
    }
  }), a;
}
function kh(e, t) {
  var r = {}, a = r.EncryptionVersionInfo = Kr(e, 4);
  if (t -= 4, a.Minor != 2) throw new Error("unrecognized minor version code: " + a.Minor);
  if (a.Major > 4 || a.Major < 2) throw new Error("unrecognized major version code: " + a.Major);
  r.Flags = e.read_shift(4), t -= 4;
  var n = e.read_shift(4);
  return t -= 4, r.EncryptionHeader = ac(e, n), t -= n, r.EncryptionVerifier = nc(e, t), r;
}
function Eh(e) {
  var t = {}, r = t.EncryptionVersionInfo = Kr(e, 4);
  if (r.Major != 1 || r.Minor != 1) throw "unrecognized version code " + r.Major + " : " + r.Minor;
  return t.Salt = e.read_shift(16), t.EncryptedVerifier = e.read_shift(16), t.EncryptedVerifierHash = e.read_shift(16), t;
}
function Th(e) {
  var t = 0, r, a = tc(e), n = a.length + 1, i, s, c, f, o;
  for (r = it(n), r[0] = a.length, i = 1; i != n; ++i) r[i] = a[i - 1];
  for (i = n - 1; i >= 0; --i)
    s = r[i], c = t & 16384 ? 1 : 0, f = t << 1 & 32767, o = c | f, t = o ^ s;
  return t ^ 52811;
}
var ic = /* @__PURE__ */ function() {
  var e = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0], t = [57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287, 34041, 10252, 43370, 20163], r = [44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933, 60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248, 885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614, 21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210, 60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898, 15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812, 17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557, 1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128, 28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883, 1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628], a = function(s) {
    return (s / 2 | s * 128) & 255;
  }, n = function(s, c) {
    return a(s ^ c);
  }, i = function(s) {
    for (var c = t[s.length - 1], f = 104, o = s.length - 1; o >= 0; --o)
      for (var u = s[o], l = 0; l != 7; ++l)
        u & 64 && (c ^= r[f]), u *= 2, --f;
    return c;
  };
  return function(s) {
    for (var c = tc(s), f = i(c), o = c.length, u = it(16), l = 0; l != 16; ++l) u[l] = 0;
    var h, d, p;
    for ((o & 1) === 1 && (h = f >> 8, u[o] = n(e[0], h), --o, h = f & 255, d = c[c.length - 1], u[o] = n(d, h)); o > 0; )
      --o, h = f >> 8, u[o] = n(c[o], h), --o, h = f & 255, u[o] = n(c[o], h);
    for (o = 15, p = 15 - c.length; p > 0; )
      h = f >> 8, u[o] = n(e[p], h), --o, --p, h = f & 255, u[o] = n(c[o], h), --o, --p;
    return u;
  };
}(), wh = function(e, t, r, a, n) {
  n || (n = t), a || (a = ic(e));
  var i, s;
  for (i = 0; i != t.length; ++i)
    s = t[i], s ^= a[r], s = (s >> 5 | s << 3) & 255, n[i] = s, ++r;
  return [n, r, a];
}, Ah = function(e) {
  var t = 0, r = ic(e);
  return function(a) {
    var n = wh("", a, t, r);
    return t = n[1], n[0];
  };
};
function Fh(e, t, r, a) {
  var n = { key: We(e), verificationBytes: We(e) };
  return r.password && (n.verifier = Th(r.password)), a.valid = n.verificationBytes === n.verifier, a.valid && (a.insitu = Ah(r.password)), n;
}
function Sh(e, t, r) {
  var a = r || {};
  return a.Info = e.read_shift(2), e.l -= 2, a.Info === 1 ? a.Data = Eh(e) : a.Data = kh(e, t), a;
}
function yh(e, t, r) {
  var a = { Type: r.biff >= 8 ? e.read_shift(2) : 0 };
  return a.Type ? Sh(e, t - 2, a) : Fh(e, r.biff >= 8 ? t : t - 2, r, a), a;
}
var Ch = /* @__PURE__ */ function() {
  function e(n, i) {
    switch (i.type) {
      case "base64":
        return t(Er(n), i);
      case "binary":
        return t(n, i);
      case "buffer":
        return t(_e && Buffer.isBuffer(n) ? n.toString("binary") : Tt(n), i);
      case "array":
        return t(gt(n), i);
    }
    throw new Error("Unrecognized type " + i.type);
  }
  function t(n, i) {
    var s = i || {}, c = s.dense ? [] : {}, f = n.match(/\\trowd.*?\\row\b/g);
    if (!f.length) throw new Error("RTF missing table");
    var o = { s: { c: 0, r: 0 }, e: { c: 0, r: f.length - 1 } };
    return f.forEach(function(u, l) {
      Array.isArray(c) && (c[l] = []);
      for (var h = /\\\w+\b/g, d = 0, p, x = -1; p = h.exec(u); ) {
        switch (p[0]) {
          case "\\cell":
            var g = u.slice(d, h.lastIndex - p[0].length);
            if (g[0] == " " && (g = g.slice(1)), ++x, g.length) {
              var F = { v: g, t: "s" };
              Array.isArray(c) ? c[l][x] = F : c[de({ r: l, c: x })] = F;
            }
            break;
        }
        d = h.lastIndex;
      }
      x > o.e.c && (o.e.c = x);
    }), c["!ref"] = Ee(o), c;
  }
  function r(n, i) {
    return ct(e(n, i), i);
  }
  function a(n) {
    for (var i = ["{\\rtf1\\ansi"], s = Pe(n["!ref"]), c, f = Array.isArray(n), o = s.s.r; o <= s.e.r; ++o) {
      i.push("\\trowd\\trautofit1");
      for (var u = s.s.c; u <= s.e.c; ++u) i.push("\\cellx" + (u + 1));
      for (i.push("\\pard\\intbl"), u = s.s.c; u <= s.e.c; ++u) {
        var l = de({ r: o, c: u });
        c = f ? (n[o] || [])[u] : n[l], !(!c || c.v == null && (!c.f || c.F)) && (i.push(" " + (c.w || (Yr(c), c.w))), i.push("\\cell"));
      }
      i.push("\\pard\\intbl\\row");
    }
    return i.join("") + "}";
  }
  return {
    to_workbook: r,
    to_sheet: e,
    from_sheet: a
  };
}();
function Oh(e) {
  var t = e.slice(e[0] === "#" ? 1 : 0).slice(0, 6);
  return [parseInt(t.slice(0, 2), 16), parseInt(t.slice(2, 4), 16), parseInt(t.slice(4, 6), 16)];
}
function xa(e) {
  for (var t = 0, r = 1; t != 3; ++t) r = r * 256 + (e[t] > 255 ? 255 : e[t] < 0 ? 0 : e[t]);
  return r.toString(16).toUpperCase().slice(1);
}
function Ih(e) {
  var t = e[0] / 255, r = e[1] / 255, a = e[2] / 255, n = Math.max(t, r, a), i = Math.min(t, r, a), s = n - i;
  if (s === 0) return [0, 0, t];
  var c = 0, f = 0, o = n + i;
  switch (f = s / (o > 1 ? 2 - o : o), n) {
    case t:
      c = ((r - a) / s + 6) % 6;
      break;
    case r:
      c = (a - t) / s + 2;
      break;
    case a:
      c = (t - r) / s + 4;
      break;
  }
  return [c / 6, f, o / 2];
}
function Dh(e) {
  var t = e[0], r = e[1], a = e[2], n = r * 2 * (a < 0.5 ? a : 1 - a), i = a - n / 2, s = [i, i, i], c = 6 * t, f;
  if (r !== 0) switch (c | 0) {
    case 0:
    case 6:
      f = n * c, s[0] += n, s[1] += f;
      break;
    case 1:
      f = n * (2 - c), s[0] += f, s[1] += n;
      break;
    case 2:
      f = n * (c - 2), s[1] += n, s[2] += f;
      break;
    case 3:
      f = n * (4 - c), s[1] += f, s[2] += n;
      break;
    case 4:
      f = n * (c - 4), s[2] += n, s[0] += f;
      break;
    case 5:
      f = n * (6 - c), s[2] += f, s[0] += n;
      break;
  }
  for (var o = 0; o != 3; ++o) s[o] = Math.round(s[o] * 255);
  return s;
}
function Ja(e, t) {
  if (t === 0) return e;
  var r = Ih(Oh(e));
  return t < 0 ? r[2] = r[2] * (1 + t) : r[2] = 1 - (1 - r[2]) * (1 - t), xa(Dh(r));
}
var sc = 6, Rh = 15, Nh = 1, hr = sc;
function qa(e) {
  return Math.floor((e + Math.round(128 / hr) / 256) * hr);
}
function Qa(e) {
  return Math.floor((e - 5) / hr * 100 + 0.5) / 100;
}
function Nn(e) {
  return Math.round((e * hr + 5) / hr * 256) / 256;
}
function Tn(e) {
  return Nn(Qa(qa(e)));
}
function c0(e) {
  var t = Math.abs(e - Tn(e)), r = hr;
  if (t > 5e-3) for (hr = Nh; hr < Rh; ++hr) Math.abs(e - Tn(e)) <= t && (t = Math.abs(e - Tn(e)), r = hr);
  hr = r;
}
function Mt(e) {
  e.width ? (e.wpx = qa(e.width), e.wch = Qa(e.wpx), e.MDW = hr) : e.wpx ? (e.wch = Qa(e.wpx), e.width = Nn(e.wch), e.MDW = hr) : typeof e.wch == "number" && (e.width = Nn(e.wch), e.wpx = qa(e.width), e.MDW = hr), e.customWidth && delete e.customWidth;
}
var bh = 96, cc = bh;
function fc(e) {
  return e * 96 / cc;
}
function da(e) {
  return e * cc / 96;
}
var Ph = {
  None: "none",
  Solid: "solid",
  Gray50: "mediumGray",
  Gray75: "darkGray",
  Gray25: "lightGray",
  HorzStripe: "darkHorizontal",
  VertStripe: "darkVertical",
  ReverseDiagStripe: "darkDown",
  DiagStripe: "darkUp",
  DiagCross: "darkGrid",
  ThickDiagCross: "darkTrellis",
  ThinHorzStripe: "lightHorizontal",
  ThinVertStripe: "lightVertical",
  ThinReverseDiagStripe: "lightDown",
  ThinHorzCross: "lightGrid"
};
function Lh(e, t, r, a) {
  t.Borders = [];
  var n = {}, i = !1;
  (e[0].match(fr) || []).forEach(function(s) {
    var c = le(s);
    switch (Vr(c[0])) {
      case "<borders":
      case "<borders>":
      case "</borders>":
        break;
      case "<border":
      case "<border>":
      case "<border/>":
        n = /*::(*/
        {}, c.diagonalUp && (n.diagonalUp = Oe(c.diagonalUp)), c.diagonalDown && (n.diagonalDown = Oe(c.diagonalDown)), t.Borders.push(n);
        break;
      case "</border>":
        break;
      case "<left/>":
        break;
      case "<left":
      case "<left>":
        break;
      case "</left>":
        break;
      case "<right/>":
        break;
      case "<right":
      case "<right>":
        break;
      case "</right>":
        break;
      case "<top/>":
        break;
      case "<top":
      case "<top>":
        break;
      case "</top>":
        break;
      case "<bottom/>":
        break;
      case "<bottom":
      case "<bottom>":
        break;
      case "</bottom>":
        break;
      case "<diagonal":
      case "<diagonal>":
      case "<diagonal/>":
        break;
      case "</diagonal>":
        break;
      case "<horizontal":
      case "<horizontal>":
      case "<horizontal/>":
        break;
      case "</horizontal>":
        break;
      case "<vertical":
      case "<vertical>":
      case "<vertical/>":
        break;
      case "</vertical>":
        break;
      case "<start":
      case "<start>":
      case "<start/>":
        break;
      case "</start>":
        break;
      case "<end":
      case "<end>":
      case "<end/>":
        break;
      case "</end>":
        break;
      case "<color":
      case "<color>":
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        i = !0;
        break;
      case "</ext>":
        i = !1;
        break;
      default:
        if (a && a.WTF && !i)
          throw new Error("unrecognized " + c[0] + " in borders");
    }
  });
}
function Mh(e, t, r, a) {
  t.Fills = [];
  var n = {}, i = !1;
  (e[0].match(fr) || []).forEach(function(s) {
    var c = le(s);
    switch (Vr(c[0])) {
      case "<fills":
      case "<fills>":
      case "</fills>":
        break;
      case "<fill>":
      case "<fill":
      case "<fill/>":
        n = {}, t.Fills.push(n);
        break;
      case "</fill>":
        break;
      case "<gradientFill>":
        break;
      case "<gradientFill":
      case "</gradientFill>":
        t.Fills.push(n), n = {};
        break;
      case "<patternFill":
      case "<patternFill>":
        c.patternType && (n.patternType = c.patternType);
        break;
      case "<patternFill/>":
      case "</patternFill>":
        break;
      case "<bgColor":
        n.bgColor || (n.bgColor = {}), c.indexed && (n.bgColor.indexed = parseInt(c.indexed, 10)), c.theme && (n.bgColor.theme = parseInt(c.theme, 10)), c.tint && (n.bgColor.tint = parseFloat(c.tint)), c.rgb && (n.bgColor.rgb = c.rgb.slice(-6));
        break;
      case "<bgColor/>":
      case "</bgColor>":
        break;
      case "<fgColor":
        n.fgColor || (n.fgColor = {}), c.theme && (n.fgColor.theme = parseInt(c.theme, 10)), c.tint && (n.fgColor.tint = parseFloat(c.tint)), c.rgb != null && (n.fgColor.rgb = c.rgb.slice(-6));
        break;
      case "<fgColor/>":
      case "</fgColor>":
        break;
      case "<stop":
      case "<stop/>":
        break;
      case "</stop>":
        break;
      case "<color":
      case "<color/>":
        break;
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        i = !0;
        break;
      case "</ext>":
        i = !1;
        break;
      default:
        if (a && a.WTF && !i)
          throw new Error("unrecognized " + c[0] + " in fills");
    }
  });
}
function Bh(e, t, r, a) {
  t.Fonts = [];
  var n = {}, i = !1;
  (e[0].match(fr) || []).forEach(function(s) {
    var c = le(s);
    switch (Vr(c[0])) {
      case "<fonts":
      case "<fonts>":
      case "</fonts>":
        break;
      case "<font":
      case "<font>":
        break;
      case "</font>":
      case "<font/>":
        t.Fonts.push(n), n = {};
        break;
      case "<name":
        c.val && (n.name = ye(c.val));
        break;
      case "<name/>":
      case "</name>":
        break;
      case "<b":
        n.bold = c.val ? Oe(c.val) : 1;
        break;
      case "<b/>":
        n.bold = 1;
        break;
      case "<i":
        n.italic = c.val ? Oe(c.val) : 1;
        break;
      case "<i/>":
        n.italic = 1;
        break;
      case "<u":
        switch (c.val) {
          case "none":
            n.underline = 0;
            break;
          case "single":
            n.underline = 1;
            break;
          case "double":
            n.underline = 2;
            break;
          case "singleAccounting":
            n.underline = 33;
            break;
          case "doubleAccounting":
            n.underline = 34;
            break;
        }
        break;
      case "<u/>":
        n.underline = 1;
        break;
      case "<strike":
        n.strike = c.val ? Oe(c.val) : 1;
        break;
      case "<strike/>":
        n.strike = 1;
        break;
      case "<outline":
        n.outline = c.val ? Oe(c.val) : 1;
        break;
      case "<outline/>":
        n.outline = 1;
        break;
      case "<shadow":
        n.shadow = c.val ? Oe(c.val) : 1;
        break;
      case "<shadow/>":
        n.shadow = 1;
        break;
      case "<condense":
        n.condense = c.val ? Oe(c.val) : 1;
        break;
      case "<condense/>":
        n.condense = 1;
        break;
      case "<extend":
        n.extend = c.val ? Oe(c.val) : 1;
        break;
      case "<extend/>":
        n.extend = 1;
        break;
      case "<sz":
        c.val && (n.sz = +c.val);
        break;
      case "<sz/>":
      case "</sz>":
        break;
      case "<vertAlign":
        c.val && (n.vertAlign = c.val);
        break;
      case "<vertAlign/>":
      case "</vertAlign>":
        break;
      case "<family":
        c.val && (n.family = parseInt(c.val, 10));
        break;
      case "<family/>":
      case "</family>":
        break;
      case "<scheme":
        c.val && (n.scheme = c.val);
        break;
      case "<scheme/>":
      case "</scheme>":
        break;
      case "<charset":
        if (c.val == "1") break;
        c.codepage = Hn[parseInt(c.val, 10)];
        break;
      case "<color":
        if (n.color || (n.color = {}), c.auto && (n.color.auto = Oe(c.auto)), c.rgb) n.color.rgb = c.rgb.slice(-6);
        else if (c.indexed) {
          n.color.index = parseInt(c.indexed, 10);
          var f = pt[n.color.index];
          n.color.index == 81 && (f = pt[1]), f || (f = pt[1]), n.color.rgb = f[0].toString(16) + f[1].toString(16) + f[2].toString(16);
        } else c.theme && (n.color.theme = parseInt(c.theme, 10), c.tint && (n.color.tint = parseFloat(c.tint)), c.theme && r.themeElements && r.themeElements.clrScheme && (n.color.rgb = Ja(r.themeElements.clrScheme[n.color.theme].rgb, n.color.tint || 0)));
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<AlternateContent":
        i = !0;
        break;
      case "</AlternateContent>":
        i = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        i = !0;
        break;
      case "</ext>":
        i = !1;
        break;
      default:
        if (a && a.WTF && !i)
          throw new Error("unrecognized " + c[0] + " in fonts");
    }
  });
}
function Uh(e, t, r) {
  t.NumberFmt = [];
  for (var a = $r(ve), n = 0; n < a.length; ++n) t.NumberFmt[a[n]] = ve[a[n]];
  var i = e[0].match(fr);
  if (i)
    for (n = 0; n < i.length; ++n) {
      var s = le(i[n]);
      switch (Vr(s[0])) {
        case "<numFmts":
        case "</numFmts>":
        case "<numFmts/>":
        case "<numFmts>":
          break;
        case "<numFmt":
          {
            var c = we(ye(s.formatCode)), f = parseInt(s.numFmtId, 10);
            if (t.NumberFmt[f] = c, f > 0) {
              if (f > 392) {
                for (f = 392; f > 60 && t.NumberFmt[f] != null; --f) ;
                t.NumberFmt[f] = c;
              }
              dt(c, f);
            }
          }
          break;
        case "</numFmt>":
          break;
        default:
          if (r.WTF) throw new Error("unrecognized " + s[0] + " in numFmts");
      }
    }
}
var ba = ["numFmtId", "fillId", "fontId", "borderId", "xfId"], Pa = ["applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix"];
function zh(e, t, r) {
  t.CellXf = [];
  var a, n = !1;
  (e[0].match(fr) || []).forEach(function(i) {
    var s = le(i), c = 0;
    switch (Vr(s[0])) {
      case "<cellXfs":
      case "<cellXfs>":
      case "<cellXfs/>":
      case "</cellXfs>":
        break;
      case "<xf":
      case "<xf/>":
        for (a = s, delete a[0], c = 0; c < ba.length; ++c) a[ba[c]] && (a[ba[c]] = parseInt(a[ba[c]], 10));
        for (c = 0; c < Pa.length; ++c) a[Pa[c]] && (a[Pa[c]] = Oe(a[Pa[c]]));
        if (t.NumberFmt && a.numFmtId > 392) {
          for (c = 392; c > 60; --c) if (t.NumberFmt[a.numFmtId] == t.NumberFmt[c]) {
            a.numFmtId = c;
            break;
          }
        }
        t.CellXf.push(a);
        break;
      case "</xf>":
        break;
      case "<alignment":
      case "<alignment/>":
        var f = {};
        s.vertical && (f.vertical = s.vertical), s.horizontal && (f.horizontal = s.horizontal), s.textRotation != null && (f.textRotation = s.textRotation), s.indent && (f.indent = s.indent), s.wrapText && (f.wrapText = Oe(s.wrapText)), a.alignment = f;
        break;
      case "</alignment>":
        break;
      case "<protection":
        break;
      case "</protection>":
      case "<protection/>":
        break;
      case "<AlternateContent":
        n = !0;
        break;
      case "</AlternateContent>":
        n = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        n = !0;
        break;
      case "</ext>":
        n = !1;
        break;
      default:
        if (r && r.WTF && !n)
          throw new Error("unrecognized " + s[0] + " in cellXfs");
    }
  });
}
var $h = /* @__PURE__ */ function() {
  var t = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/, r = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/, a = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/, n = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/, i = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
  return function(c, f, o) {
    var u = {};
    if (!c) return u;
    c = c.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    var l;
    return (l = c.match(t)) && Uh(l, u, o), (l = c.match(n)) && Bh(l, u, f, o), (l = c.match(a)) && Mh(l, u, f, o), (l = c.match(i)) && Lh(l, u, f, o), (l = c.match(r)) && zh(l, u, o), u;
  };
}();
function Vh(e, t) {
  var r = e.read_shift(2), a = sr(e);
  return [r, a];
}
function Hh(e, t, r) {
  var a = {};
  a.sz = e.read_shift(2) / 20;
  var n = Qo(e);
  n.fItalic && (a.italic = 1), n.fCondense && (a.condense = 1), n.fExtend && (a.extend = 1), n.fShadow && (a.shadow = 1), n.fOutline && (a.outline = 1), n.fStrikeout && (a.strike = 1);
  var i = e.read_shift(2);
  switch (i === 700 && (a.bold = 1), e.read_shift(2)) {
    case 1:
      a.vertAlign = "superscript";
      break;
    case 2:
      a.vertAlign = "subscript";
      break;
  }
  var s = e.read_shift(1);
  s != 0 && (a.underline = s);
  var c = e.read_shift(1);
  c > 0 && (a.family = c);
  var f = e.read_shift(1);
  switch (f > 0 && (a.charset = f), e.l++, a.color = qo(e), e.read_shift(1)) {
    case 1:
      a.scheme = "major";
      break;
    case 2:
      a.scheme = "minor";
      break;
  }
  return a.name = sr(e), a;
}
var Wh = cr;
function Zh(e, t) {
  var r = e.l + t, a = e.read_shift(2), n = e.read_shift(2);
  return e.l = r, { ixfe: a, numFmtId: n };
}
var Gh = cr;
function jh(e, t, r) {
  var a = {};
  a.NumberFmt = [];
  for (var n in ve) a.NumberFmt[n] = ve[n];
  a.CellXf = [], a.Fonts = [];
  var i = [], s = !1;
  return Jr(e, function(f, o, u) {
    switch (u) {
      case 44:
        a.NumberFmt[f[0]] = f[1], dt(f[1], f[0]);
        break;
      case 43:
        a.Fonts.push(f), f.color.theme != null && t && t.themeElements && t.themeElements.clrScheme && (f.color.rgb = Ja(t.themeElements.clrScheme[f.color.theme].rgb, f.color.tint || 0));
        break;
      case 1025:
        break;
      case 45:
        break;
      case 46:
        break;
      case 47:
        i[i.length - 1] == 617 && a.CellXf.push(f);
        break;
      case 48:
      case 507:
      case 572:
      case 475:
        break;
      case 1171:
      case 2102:
      case 1130:
      case 512:
      case 2095:
      case 3072:
        break;
      case 35:
        s = !0;
        break;
      case 36:
        s = !1;
        break;
      case 37:
        i.push(u), s = !0;
        break;
      case 38:
        i.pop(), s = !1;
        break;
      default:
        if (o.T > 0) i.push(u);
        else if (o.T < 0) i.pop();
        else if (!s || r.WTF && i[i.length - 1] != 37) throw new Error("Unexpected record 0x" + u.toString(16));
    }
  }), a;
}
var Xh = [
  "</a:lt1>",
  "</a:dk1>",
  "</a:lt2>",
  "</a:dk2>",
  "</a:accent1>",
  "</a:accent2>",
  "</a:accent3>",
  "</a:accent4>",
  "</a:accent5>",
  "</a:accent6>",
  "</a:hlink>",
  "</a:folHlink>"
];
function Kh(e, t, r) {
  t.themeElements.clrScheme = [];
  var a = {};
  (e[0].match(fr) || []).forEach(function(n) {
    var i = le(n);
    switch (i[0]) {
      case "<a:clrScheme":
      case "</a:clrScheme>":
        break;
      case "<a:srgbClr":
        a.rgb = i.val;
        break;
      case "<a:sysClr":
        a.rgb = i.lastClr;
        break;
      case "<a:dk1>":
      case "</a:dk1>":
      case "<a:lt1>":
      case "</a:lt1>":
      case "<a:dk2>":
      case "</a:dk2>":
      case "<a:lt2>":
      case "</a:lt2>":
      case "<a:accent1>":
      case "</a:accent1>":
      case "<a:accent2>":
      case "</a:accent2>":
      case "<a:accent3>":
      case "</a:accent3>":
      case "<a:accent4>":
      case "</a:accent4>":
      case "<a:accent5>":
      case "</a:accent5>":
      case "<a:accent6>":
      case "</a:accent6>":
      case "<a:hlink>":
      case "</a:hlink>":
      case "<a:folHlink>":
      case "</a:folHlink>":
        i[0].charAt(1) === "/" ? (t.themeElements.clrScheme[Xh.indexOf(i[0])] = a, a = {}) : a.name = i[0].slice(3, i[0].length - 1);
        break;
      default:
        if (r && r.WTF) throw new Error("Unrecognized " + i[0] + " in clrScheme");
    }
  });
}
function Yh() {
}
function Jh() {
}
var qh = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/, Qh = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/, e1 = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
function r1(e, t, r) {
  t.themeElements = {};
  var a;
  [
    /* clrScheme CT_ColorScheme */
    ["clrScheme", qh, Kh],
    /* fontScheme CT_FontScheme */
    ["fontScheme", Qh, Yh],
    /* fmtScheme CT_StyleMatrix */
    ["fmtScheme", e1, Jh]
  ].forEach(function(n) {
    if (!(a = e.match(n[1]))) throw new Error(n[0] + " not found in themeElements");
    n[2](a, t, r);
  });
}
var t1 = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
function oc(e, t) {
  (!e || e.length === 0) && (e = a1());
  var r, a = {};
  if (!(r = e.match(t1))) throw new Error("themeElements not found in theme");
  return r1(r[0], a, t), a.raw = e, a;
}
function a1(e, t) {
  var r = [ks];
  return r[r.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', r[r.length] = "<a:themeElements>", r[r.length] = '<a:clrScheme name="Office">', r[r.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', r[r.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', r[r.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', r[r.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', r[r.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', r[r.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', r[r.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', r[r.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', r[r.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', r[r.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', r[r.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', r[r.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', r[r.length] = "</a:clrScheme>", r[r.length] = '<a:fontScheme name="Office">', r[r.length] = "<a:majorFont>", r[r.length] = '<a:latin typeface="Cambria"/>', r[r.length] = '<a:ea typeface=""/>', r[r.length] = '<a:cs typeface=""/>', r[r.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', r[r.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', r[r.length] = '<a:font script="Hans" typeface="宋体"/>', r[r.length] = '<a:font script="Hant" typeface="新細明體"/>', r[r.length] = '<a:font script="Arab" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Thai" typeface="Tahoma"/>', r[r.length] = '<a:font script="Ethi" typeface="Nyala"/>', r[r.length] = '<a:font script="Beng" typeface="Vrinda"/>', r[r.length] = '<a:font script="Gujr" typeface="Shruti"/>', r[r.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', r[r.length] = '<a:font script="Knda" typeface="Tunga"/>', r[r.length] = '<a:font script="Guru" typeface="Raavi"/>', r[r.length] = '<a:font script="Cans" typeface="Euphemia"/>', r[r.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', r[r.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', r[r.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', r[r.length] = '<a:font script="Thaa" typeface="MV Boli"/>', r[r.length] = '<a:font script="Deva" typeface="Mangal"/>', r[r.length] = '<a:font script="Telu" typeface="Gautami"/>', r[r.length] = '<a:font script="Taml" typeface="Latha"/>', r[r.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', r[r.length] = '<a:font script="Orya" typeface="Kalinga"/>', r[r.length] = '<a:font script="Mlym" typeface="Kartika"/>', r[r.length] = '<a:font script="Laoo" typeface="DokChampa"/>', r[r.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', r[r.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', r[r.length] = '<a:font script="Viet" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', r[r.length] = '<a:font script="Geor" typeface="Sylfaen"/>', r[r.length] = "</a:majorFont>", r[r.length] = "<a:minorFont>", r[r.length] = '<a:latin typeface="Calibri"/>', r[r.length] = '<a:ea typeface=""/>', r[r.length] = '<a:cs typeface=""/>', r[r.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', r[r.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', r[r.length] = '<a:font script="Hans" typeface="宋体"/>', r[r.length] = '<a:font script="Hant" typeface="新細明體"/>', r[r.length] = '<a:font script="Arab" typeface="Arial"/>', r[r.length] = '<a:font script="Hebr" typeface="Arial"/>', r[r.length] = '<a:font script="Thai" typeface="Tahoma"/>', r[r.length] = '<a:font script="Ethi" typeface="Nyala"/>', r[r.length] = '<a:font script="Beng" typeface="Vrinda"/>', r[r.length] = '<a:font script="Gujr" typeface="Shruti"/>', r[r.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', r[r.length] = '<a:font script="Knda" typeface="Tunga"/>', r[r.length] = '<a:font script="Guru" typeface="Raavi"/>', r[r.length] = '<a:font script="Cans" typeface="Euphemia"/>', r[r.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', r[r.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', r[r.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', r[r.length] = '<a:font script="Thaa" typeface="MV Boli"/>', r[r.length] = '<a:font script="Deva" typeface="Mangal"/>', r[r.length] = '<a:font script="Telu" typeface="Gautami"/>', r[r.length] = '<a:font script="Taml" typeface="Latha"/>', r[r.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', r[r.length] = '<a:font script="Orya" typeface="Kalinga"/>', r[r.length] = '<a:font script="Mlym" typeface="Kartika"/>', r[r.length] = '<a:font script="Laoo" typeface="DokChampa"/>', r[r.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', r[r.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', r[r.length] = '<a:font script="Viet" typeface="Arial"/>', r[r.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', r[r.length] = '<a:font script="Geor" typeface="Sylfaen"/>', r[r.length] = "</a:minorFont>", r[r.length] = "</a:fontScheme>", r[r.length] = '<a:fmtScheme name="Office">', r[r.length] = "<a:fillStyleLst>", r[r.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:lin ang="16200000" scaled="1"/>', r[r.length] = "</a:gradFill>", r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:lin ang="16200000" scaled="0"/>', r[r.length] = "</a:gradFill>", r[r.length] = "</a:fillStyleLst>", r[r.length] = "<a:lnStyleLst>", r[r.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = "</a:lnStyleLst>", r[r.length] = "<a:effectStyleLst>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = "</a:effectStyle>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = "</a:effectStyle>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', r[r.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', r[r.length] = "</a:effectStyle>", r[r.length] = "</a:effectStyleLst>", r[r.length] = "<a:bgFillStyleLst>", r[r.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', r[r.length] = "</a:gradFill>", r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', r[r.length] = "</a:gradFill>", r[r.length] = "</a:bgFillStyleLst>", r[r.length] = "</a:fmtScheme>", r[r.length] = "</a:themeElements>", r[r.length] = "<a:objectDefaults>", r[r.length] = "<a:spDef>", r[r.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', r[r.length] = "</a:spDef>", r[r.length] = "<a:lnDef>", r[r.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', r[r.length] = "</a:lnDef>", r[r.length] = "</a:objectDefaults>", r[r.length] = "<a:extraClrSchemeLst/>", r[r.length] = "</a:theme>", r.join("");
}
function n1(e, t, r) {
  var a = e.l + t, n = e.read_shift(4);
  if (n !== 124226) {
    if (!r.cellStyles) {
      e.l = a;
      return;
    }
    var i = e.slice(e.l);
    e.l = a;
    var s;
    try {
      s = _s(i, { type: "array" });
    } catch {
      return;
    }
    var c = kr(s, "theme/theme/theme1.xml", !0);
    if (c)
      return oc(c, r);
  }
}
function i1(e) {
  return e.read_shift(4);
}
function s1(e) {
  var t = {};
  switch (t.xclrType = e.read_shift(2), t.nTintShade = e.read_shift(2), t.xclrType) {
    case 0:
      e.l += 4;
      break;
    case 1:
      t.xclrValue = c1(e, 4);
      break;
    case 2:
      t.xclrValue = Ks(e);
      break;
    case 3:
      t.xclrValue = i1(e);
      break;
    case 4:
      e.l += 4;
      break;
  }
  return e.l += 8, t;
}
function c1(e, t) {
  return cr(e, t);
}
function f1(e, t) {
  return cr(e, t);
}
function o1(e) {
  var t = e.read_shift(2), r = e.read_shift(2) - 4, a = [t];
  switch (t) {
    case 4:
    case 5:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 13:
      a[1] = s1(e);
      break;
    case 6:
      a[1] = f1(e, r);
      break;
    case 14:
    case 15:
      a[1] = e.read_shift(r === 1 ? 1 : 2);
      break;
    default:
      throw new Error("Unrecognized ExtProp type: " + t + " " + r);
  }
  return a;
}
function u1(e, t) {
  var r = e.l + t;
  e.l += 2;
  var a = e.read_shift(2);
  e.l += 2;
  for (var n = e.read_shift(2), i = []; n-- > 0; ) i.push(o1(e, r - e.l));
  return { ixfe: a, ext: i };
}
function l1(e, t) {
  t.forEach(function(r) {
    switch (r[0]) {
    }
  });
}
function h1(e, t) {
  return {
    flags: e.read_shift(4),
    version: e.read_shift(4),
    name: sr(e)
  };
}
function x1(e) {
  for (var t = [], r = e.read_shift(4); r-- > 0; )
    t.push([e.read_shift(4), e.read_shift(4)]);
  return t;
}
function d1(e) {
  return e.l += 4, e.read_shift(4) != 0;
}
function p1(e, t, r) {
  var a = { Types: [], Cell: [], Value: [] }, n = r || {}, i = [], s = !1, c = 2;
  return Jr(e, function(f, o, u) {
    switch (u) {
      case 335:
        a.Types.push({ name: f.name });
        break;
      case 51:
        f.forEach(function(l) {
          c == 1 ? a.Cell.push({ type: a.Types[l[0] - 1].name, index: l[1] }) : c == 0 && a.Value.push({ type: a.Types[l[0] - 1].name, index: l[1] });
        });
        break;
      case 337:
        c = f ? 1 : 0;
        break;
      case 338:
        c = 2;
        break;
      case 35:
        i.push(u), s = !0;
        break;
      case 36:
        i.pop(), s = !1;
        break;
      default:
        if (!o.T) {
          if (!s || n.WTF && i[i.length - 1] != 35)
            throw new Error("Unexpected record 0x" + u.toString(16));
        }
    }
  }), a;
}
function v1(e, t, r) {
  var a = { Types: [], Cell: [], Value: [] };
  if (!e)
    return a;
  var n = !1, i = 2, s;
  return e.replace(fr, function(c) {
    var f = le(c);
    switch (Vr(f[0])) {
      case "<?xml":
        break;
      case "<metadata":
      case "</metadata>":
        break;
      case "<metadataTypes":
      case "</metadataTypes>":
        break;
      case "<metadataType":
        a.Types.push({ name: f.name });
        break;
      case "</metadataType>":
        break;
      case "<futureMetadata":
        for (var o = 0; o < a.Types.length; ++o)
          a.Types[o].name == f.name && (s = a.Types[o]);
        break;
      case "</futureMetadata>":
        break;
      case "<bk>":
        break;
      case "</bk>":
        break;
      case "<rc":
        i == 1 ? a.Cell.push({ type: a.Types[f.t - 1].name, index: +f.v }) : i == 0 && a.Value.push({ type: a.Types[f.t - 1].name, index: +f.v });
        break;
      case "</rc>":
        break;
      case "<cellMetadata":
        i = 1;
        break;
      case "</cellMetadata>":
        i = 2;
        break;
      case "<valueMetadata":
        i = 0;
        break;
      case "</valueMetadata>":
        i = 2;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        n = !0;
        break;
      case "</ext>":
        n = !1;
        break;
      case "<rvb":
        if (!s)
          break;
        s.offsets || (s.offsets = []), s.offsets.push(+f.i);
        break;
      default:
        if (!n && r.WTF)
          throw new Error("unrecognized " + f[0] + " in metadata");
    }
    return c;
  }), a;
}
function g1(e) {
  var t = [];
  if (!e) return t;
  var r = 1;
  return (e.match(fr) || []).forEach(function(a) {
    var n = le(a);
    switch (n[0]) {
      case "<?xml":
        break;
      case "<calcChain":
      case "<calcChain>":
      case "</calcChain>":
        break;
      case "<c":
        delete n[0], n.i ? r = n.i : n.i = r, t.push(n);
        break;
    }
  }), t;
}
function m1(e) {
  var t = {};
  t.i = e.read_shift(4);
  var r = {};
  r.r = e.read_shift(4), r.c = e.read_shift(4), t.r = de(r);
  var a = e.read_shift(1);
  return a & 2 && (t.l = "1"), a & 8 && (t.a = "1"), t;
}
function _1(e, t, r) {
  var a = [];
  return Jr(e, function(i, s, c) {
    switch (c) {
      case 63:
        a.push(i);
        break;
      default:
        if (!s.T) throw new Error("Unexpected record 0x" + c.toString(16));
    }
  }), a;
}
function k1(e, t, r, a) {
  if (!e) return e;
  var n = a || {}, i = !1;
  Jr(e, function(c, f, o) {
    switch (o) {
      case 359:
      case 363:
      case 364:
      case 366:
      case 367:
      case 368:
      case 369:
      case 370:
      case 371:
      case 472:
      case 577:
      case 578:
      case 579:
      case 580:
      case 581:
      case 582:
      case 583:
      case 584:
      case 585:
      case 586:
      case 587:
        break;
      case 35:
        i = !0;
        break;
      case 36:
        i = !1;
        break;
      default:
        if (!f.T) {
          if (!i || n.WTF) throw new Error("Unexpected record 0x" + o.toString(16));
        }
    }
  }, n);
}
function E1(e, t) {
  if (!e) return "??";
  var r = (e.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1];
  return t["!id"][r].Target;
}
function di(e, t, r, a) {
  var n = Array.isArray(e), i;
  t.forEach(function(s) {
    var c = xr(s.ref);
    if (n ? (e[c.r] || (e[c.r] = []), i = e[c.r][c.c]) : i = e[s.ref], !i) {
      i = { t: "z" }, n ? e[c.r][c.c] = i : e[s.ref] = i;
      var f = Pe(e["!ref"] || "BDWGO1000001:A1");
      f.s.r > c.r && (f.s.r = c.r), f.e.r < c.r && (f.e.r = c.r), f.s.c > c.c && (f.s.c = c.c), f.e.c < c.c && (f.e.c = c.c);
      var o = Ee(f);
      o !== e["!ref"] && (e["!ref"] = o);
    }
    i.c || (i.c = []);
    var u = { a: s.author, t: s.t, r: s.r, T: r };
    s.h && (u.h = s.h);
    for (var l = i.c.length - 1; l >= 0; --l) {
      if (!r && i.c[l].T) return;
      r && !i.c[l].T && i.c.splice(l, 1);
    }
    if (r && a) {
      for (l = 0; l < a.length; ++l)
        if (u.a == a[l].id) {
          u.a = a[l].name || u.a;
          break;
        }
    }
    i.c.push(u);
  });
}
function T1(e, t) {
  if (e.match(/<(?:\w+:)?comments *\/>/)) return [];
  var r = [], a = [], n = e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
  n && n[1] && n[1].split(/<\/\w*:?author>/).forEach(function(s) {
    if (!(s === "" || s.trim() === "")) {
      var c = s.match(/<(?:\w+:)?author[^>]*>(.*)/);
      c && r.push(c[1]);
    }
  });
  var i = e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
  return i && i[1] && i[1].split(/<\/\w*:?comment>/).forEach(function(s) {
    if (!(s === "" || s.trim() === "")) {
      var c = s.match(/<(?:\w+:)?comment[^>]*>/);
      if (c) {
        var f = le(c[0]), o = { author: f.authorId && r[f.authorId] || "sheetjsghost", ref: f.ref, guid: f.guid }, u = xr(f.ref);
        if (!(t.sheetRows && t.sheetRows <= u.r)) {
          var l = s.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/), h = !!l && !!l[1] && s0(l[1]) || { r: "", t: "", h: "" };
          o.r = h.r, h.r == "<t></t>" && (h.t = h.h = ""), o.t = (h.t || "").replace(/\r\n/g, `
`).replace(/\r/g, `
`), t.cellHTML && (o.h = h.h), a.push(o);
        }
      }
    }
  }), a;
}
function w1(e, t) {
  var r = [], a = !1, n = {}, i = 0;
  return e.replace(fr, function(c, f) {
    var o = le(c);
    switch (Vr(o[0])) {
      case "<?xml":
        break;
      case "<ThreadedComments":
        break;
      case "</ThreadedComments>":
        break;
      case "<threadedComment":
        n = { author: o.personId, guid: o.id, ref: o.ref, T: 1 };
        break;
      case "</threadedComment>":
        n.t != null && r.push(n);
        break;
      case "<text>":
      case "<text":
        i = f + c.length;
        break;
      case "</text>":
        n.t = e.slice(i, f).replace(/\r\n/g, `
`).replace(/\r/g, `
`);
        break;
      case "<mentions":
      case "<mentions>":
        a = !0;
        break;
      case "</mentions>":
        a = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (!a && t.WTF) throw new Error("unrecognized " + o[0] + " in threaded comments");
    }
    return c;
  }), r;
}
function A1(e, t) {
  var r = [], a = !1;
  return e.replace(fr, function(i) {
    var s = le(i);
    switch (Vr(s[0])) {
      case "<?xml":
        break;
      case "<personList":
        break;
      case "</personList>":
        break;
      case "<person":
        r.push({ name: s.displayname, id: s.id });
        break;
      case "</person>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (!a && t.WTF) throw new Error("unrecognized " + s[0] + " in threaded comments");
    }
    return i;
  }), r;
}
function F1(e) {
  var t = {};
  t.iauthor = e.read_shift(4);
  var r = At(e);
  return t.rfx = r.s, t.ref = de(r.s), e.l += 16, t;
}
var S1 = sr;
function y1(e, t) {
  var r = [], a = [], n = {}, i = !1;
  return Jr(e, function(c, f, o) {
    switch (o) {
      case 632:
        a.push(c);
        break;
      case 635:
        n = c;
        break;
      case 637:
        n.t = c.t, n.h = c.h, n.r = c.r;
        break;
      case 636:
        if (n.author = a[n.iauthor], delete n.iauthor, t.sheetRows && n.rfx && t.sheetRows <= n.rfx.r) break;
        n.t || (n.t = ""), delete n.rfx, r.push(n);
        break;
      case 3072:
        break;
      case 35:
        i = !0;
        break;
      case 36:
        i = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!f.T) {
          if (!i || t.WTF) throw new Error("Unexpected record 0x" + o.toString(16));
        }
    }
  }), r;
}
var C1 = "application/vnd.ms-office.vbaProject";
function O1(e) {
  var t = ke.utils.cfb_new({ root: "R" });
  return e.FullPaths.forEach(function(r, a) {
    if (!(r.slice(-1) === "/" || !r.match(/_VBA_PROJECT_CUR/))) {
      var n = r.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
      ke.utils.cfb_add(t, n, e.FileIndex[a].content);
    }
  }), ke.write(t);
}
function I1() {
  return { "!type": "dialog" };
}
function D1() {
  return { "!type": "dialog" };
}
function R1() {
  return { "!type": "macro" };
}
function N1() {
  return { "!type": "macro" };
}
var Nt = /* @__PURE__ */ function() {
  var e = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g, t = { r: 0, c: 0 };
  function r(a, n, i, s) {
    var c = !1, f = !1;
    i.length == 0 ? f = !0 : i.charAt(0) == "[" && (f = !0, i = i.slice(1, -1)), s.length == 0 ? c = !0 : s.charAt(0) == "[" && (c = !0, s = s.slice(1, -1));
    var o = i.length > 0 ? parseInt(i, 10) | 0 : 0, u = s.length > 0 ? parseInt(s, 10) | 0 : 0;
    return c ? u += t.c : --u, f ? o += t.r : --o, n + (c ? "" : "$") + je(u) + (f ? "" : "$") + Qe(o);
  }
  return function(n, i) {
    return t = i, n.replace(e, r);
  };
}(), uc = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g, b1 = /* @__PURE__ */ function() {
  return function(t, r) {
    return t.replace(uc, function(a, n, i, s, c, f) {
      var o = e0(s) - (i ? 0 : r.c), u = Qn(f) - (c ? 0 : r.r), l = u == 0 ? "" : c ? u + 1 : "[" + u + "]", h = o == 0 ? "" : i ? o + 1 : "[" + o + "]";
      return n + "R" + l + "C" + h;
    });
  };
}();
function lc(e, t) {
  return e.replace(uc, function(r, a, n, i, s, c) {
    return a + (n == "$" ? n + i : je(e0(i) + t.c)) + (s == "$" ? s + c : Qe(Qn(c) + t.r));
  });
}
function P1(e, t, r) {
  var a = Ut(t), n = a.s, i = xr(r), s = { r: i.r - n.r, c: i.c - n.c };
  return lc(e, s);
}
function L1(e) {
  return e.length != 1;
}
function pi(e) {
  return e.replace(/_xlfn\./g, "");
}
function Ve(e) {
  e.l += 1;
}
function st(e, t) {
  var r = e.read_shift(2);
  return [r & 16383, r >> 14 & 1, r >> 15 & 1];
}
function hc(e, t, r) {
  var a = 2;
  if (r) {
    if (r.biff >= 2 && r.biff <= 5) return xc(e);
    r.biff == 12 && (a = 4);
  }
  var n = e.read_shift(a), i = e.read_shift(a), s = st(e), c = st(e);
  return { s: { r: n, c: s[0], cRel: s[1], rRel: s[2] }, e: { r: i, c: c[0], cRel: c[1], rRel: c[2] } };
}
function xc(e) {
  var t = st(e), r = st(e), a = e.read_shift(1), n = e.read_shift(1);
  return { s: { r: t[0], c: a, cRel: t[1], rRel: t[2] }, e: { r: r[0], c: n, cRel: r[1], rRel: r[2] } };
}
function M1(e, t, r) {
  if (r.biff < 8) return xc(e);
  var a = e.read_shift(r.biff == 12 ? 4 : 2), n = e.read_shift(r.biff == 12 ? 4 : 2), i = st(e), s = st(e);
  return { s: { r: a, c: i[0], cRel: i[1], rRel: i[2] }, e: { r: n, c: s[0], cRel: s[1], rRel: s[2] } };
}
function dc(e, t, r) {
  if (r && r.biff >= 2 && r.biff <= 5) return B1(e);
  var a = e.read_shift(r && r.biff == 12 ? 4 : 2), n = st(e);
  return { r: a, c: n[0], cRel: n[1], rRel: n[2] };
}
function B1(e) {
  var t = st(e), r = e.read_shift(1);
  return { r: t[0], c: r, cRel: t[1], rRel: t[2] };
}
function U1(e) {
  var t = e.read_shift(2), r = e.read_shift(2);
  return { r: t, c: r & 255, fQuoted: !!(r & 16384), cRel: r >> 15, rRel: r >> 15 };
}
function z1(e, t, r) {
  var a = r && r.biff ? r.biff : 8;
  if (a >= 2 && a <= 5) return $1(e);
  var n = e.read_shift(a >= 12 ? 4 : 2), i = e.read_shift(2), s = (i & 16384) >> 14, c = (i & 32768) >> 15;
  if (i &= 16383, c == 1) for (; n > 524287; ) n -= 1048576;
  if (s == 1) for (; i > 8191; ) i = i - 16384;
  return { r: n, c: i, cRel: s, rRel: c };
}
function $1(e) {
  var t = e.read_shift(2), r = e.read_shift(1), a = (t & 32768) >> 15, n = (t & 16384) >> 14;
  return t &= 16383, a == 1 && t >= 8192 && (t = t - 16384), n == 1 && r >= 128 && (r = r - 256), { r: t, c: r, cRel: n, rRel: a };
}
function V1(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = hc(e, r.biff >= 2 && r.biff <= 5 ? 6 : 8, r);
  return [a, n];
}
function H1(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = e.read_shift(2, "i"), i = 8;
  if (r) switch (r.biff) {
    case 5:
      e.l += 12, i = 6;
      break;
    case 12:
      i = 12;
      break;
  }
  var s = hc(e, i, r);
  return [a, n, s];
}
function W1(e, t, r) {
  var a = (e[e.l++] & 96) >> 5;
  return e.l += r && r.biff > 8 ? 12 : r.biff < 8 ? 6 : 8, [a];
}
function Z1(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = e.read_shift(2), i = 8;
  if (r) switch (r.biff) {
    case 5:
      e.l += 12, i = 6;
      break;
    case 12:
      i = 12;
      break;
  }
  return e.l += i, [a, n];
}
function G1(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = M1(e, t - 1, r);
  return [a, n];
}
function j1(e, t, r) {
  var a = (e[e.l++] & 96) >> 5;
  return e.l += r.biff == 2 ? 6 : r.biff == 12 ? 14 : 7, [a];
}
function vi(e) {
  var t = e[e.l + 1] & 1, r = 1;
  return e.l += 4, [t, r];
}
function X1(e, t, r) {
  e.l += 2;
  for (var a = e.read_shift(r && r.biff == 2 ? 1 : 2), n = [], i = 0; i <= a; ++i) n.push(e.read_shift(r && r.biff == 2 ? 1 : 2));
  return n;
}
function K1(e, t, r) {
  var a = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [a, e.read_shift(r && r.biff == 2 ? 1 : 2)];
}
function Y1(e, t, r) {
  var a = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [a, e.read_shift(r && r.biff == 2 ? 1 : 2)];
}
function J1(e) {
  var t = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [t, e.read_shift(2)];
}
function q1(e, t, r) {
  var a = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += r && r.biff == 2 ? 3 : 4, [a];
}
function pc(e) {
  var t = e.read_shift(1), r = e.read_shift(1);
  return [t, r];
}
function Q1(e) {
  return e.read_shift(2), pc(e);
}
function ex(e) {
  return e.read_shift(2), pc(e);
}
function rx(e, t, r) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = dc(e, 0, r);
  return [a, n];
}
function tx(e, t, r) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = z1(e, 0, r);
  return [a, n];
}
function ax(e, t, r) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = e.read_shift(2);
  r && r.biff == 5 && (e.l += 12);
  var i = dc(e, 0, r);
  return [a, n, i];
}
function nx(e, t, r) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = e.read_shift(r && r.biff <= 3 ? 1 : 2);
  return [id[n], mc[n], a];
}
function ix(e, t, r) {
  var a = e[e.l++], n = e.read_shift(1), i = r && r.biff <= 3 ? [a == 88 ? -1 : 0, e.read_shift(1)] : sx(e);
  return [n, (i[0] === 0 ? mc : nd)[i[1]]];
}
function sx(e) {
  return [e[e.l + 1] >> 7, e.read_shift(2) & 32767];
}
function cx(e, t, r) {
  e.l += r && r.biff == 2 ? 3 : 4;
}
function fx(e, t, r) {
  if (e.l++, r && r.biff == 12) return [e.read_shift(4, "i"), 0];
  var a = e.read_shift(2), n = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return [a, n];
}
function ox(e) {
  return e.l++, Ft[e.read_shift(1)];
}
function ux(e) {
  return e.l++, e.read_shift(2);
}
function lx(e) {
  return e.l++, e.read_shift(1) !== 0;
}
function hx(e) {
  return e.l++, nr(e);
}
function xx(e, t, r) {
  return e.l++, ka(e, t - 1, r);
}
function dx(e, t) {
  var r = [e.read_shift(1)];
  if (t == 12) switch (r[0]) {
    case 2:
      r[0] = 4;
      break;
    case 4:
      r[0] = 16;
      break;
    case 0:
      r[0] = 1;
      break;
    case 1:
      r[0] = 2;
      break;
  }
  switch (r[0]) {
    case 4:
      r[1] = $e(e, 1) ? "TRUE" : "FALSE", t != 12 && (e.l += 7);
      break;
    case 37:
    case 16:
      r[1] = Ft[e[e.l]], e.l += t == 12 ? 4 : 8;
      break;
    case 0:
      e.l += 8;
      break;
    case 1:
      r[1] = nr(e);
      break;
    case 2:
      r[1] = St(e, 0, { biff: t > 0 && t < 8 ? 2 : t });
      break;
    default:
      throw new Error("Bad SerAr: " + r[0]);
  }
  return r;
}
function px(e, t, r) {
  for (var a = e.read_shift(r.biff == 12 ? 4 : 2), n = [], i = 0; i != a; ++i) n.push((r.biff == 12 ? At : cn)(e));
  return n;
}
function vx(e, t, r) {
  var a = 0, n = 0;
  r.biff == 12 ? (a = e.read_shift(4), n = e.read_shift(4)) : (n = 1 + e.read_shift(1), a = 1 + e.read_shift(2)), r.biff >= 2 && r.biff < 8 && (--a, --n == 0 && (n = 256));
  for (var i = 0, s = []; i != a && (s[i] = []); ++i)
    for (var c = 0; c != n; ++c) s[i][c] = dx(e, r.biff);
  return s;
}
function gx(e, t, r) {
  var a = e.read_shift(1) >>> 5 & 3, n = !r || r.biff >= 8 ? 4 : 2, i = e.read_shift(n);
  switch (r.biff) {
    case 2:
      e.l += 5;
      break;
    case 3:
    case 4:
      e.l += 8;
      break;
    case 5:
      e.l += 12;
      break;
  }
  return [a, 0, i];
}
function mx(e, t, r) {
  if (r.biff == 5) return _x(e);
  var a = e.read_shift(1) >>> 5 & 3, n = e.read_shift(2), i = e.read_shift(4);
  return [a, n, i];
}
function _x(e) {
  var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2, "i");
  e.l += 8;
  var a = e.read_shift(2);
  return e.l += 12, [t, r, a];
}
function kx(e, t, r) {
  var a = e.read_shift(1) >>> 5 & 3;
  e.l += r && r.biff == 2 ? 3 : 4;
  var n = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return [a, n];
}
function Ex(e, t, r) {
  var a = e.read_shift(1) >>> 5 & 3, n = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return [a, n];
}
function Tx(e, t, r) {
  var a = e.read_shift(1) >>> 5 & 3;
  return e.l += 4, r.biff < 8 && e.l--, r.biff == 12 && (e.l += 2), [a];
}
function wx(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = e.read_shift(2), i = 4;
  if (r) switch (r.biff) {
    case 5:
      i = 15;
      break;
    case 12:
      i = 6;
      break;
  }
  return e.l += i, [a, n];
}
var Ax = cr, Fx = cr, Sx = cr;
function Ta(e, t, r) {
  return e.l += 2, [U1(e)];
}
function f0(e) {
  return e.l += 6, [];
}
var yx = Ta, Cx = f0, Ox = f0, Ix = Ta;
function vc(e) {
  return e.l += 2, [We(e), e.read_shift(2) & 1];
}
var Dx = Ta, Rx = vc, Nx = f0, bx = Ta, Px = Ta, Lx = [
  "Data",
  "All",
  "Headers",
  "??",
  "?Data2",
  "??",
  "?DataHeaders",
  "??",
  "Totals",
  "??",
  "??",
  "??",
  "?DataTotals",
  "??",
  "??",
  "??",
  "?Current"
];
function Mx(e) {
  e.l += 2;
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(4), n = e.read_shift(2), i = e.read_shift(2), s = Lx[r >> 2 & 31];
  return { ixti: t, coltype: r & 3, rt: s, idx: a, c: n, C: i };
}
function Bx(e) {
  return e.l += 2, [e.read_shift(4)];
}
function Ux(e, t, r) {
  return e.l += 5, e.l += 2, e.l += r.biff == 2 ? 1 : 4, ["PTGSHEET"];
}
function zx(e, t, r) {
  return e.l += r.biff == 2 ? 4 : 5, ["PTGENDSHEET"];
}
function $x(e) {
  var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2);
  return [t, r];
}
function Vx(e) {
  var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2);
  return [t, r];
}
function Hx(e) {
  return e.l += 4, [0, 0];
}
var gi = {
  /*::[*/
  1: { n: "PtgExp", f: fx },
  /*::[*/
  2: { n: "PtgTbl", f: Sx },
  /*::[*/
  3: { n: "PtgAdd", f: Ve },
  /*::[*/
  4: { n: "PtgSub", f: Ve },
  /*::[*/
  5: { n: "PtgMul", f: Ve },
  /*::[*/
  6: { n: "PtgDiv", f: Ve },
  /*::[*/
  7: { n: "PtgPower", f: Ve },
  /*::[*/
  8: { n: "PtgConcat", f: Ve },
  /*::[*/
  9: { n: "PtgLt", f: Ve },
  /*::[*/
  10: { n: "PtgLe", f: Ve },
  /*::[*/
  11: { n: "PtgEq", f: Ve },
  /*::[*/
  12: { n: "PtgGe", f: Ve },
  /*::[*/
  13: { n: "PtgGt", f: Ve },
  /*::[*/
  14: { n: "PtgNe", f: Ve },
  /*::[*/
  15: { n: "PtgIsect", f: Ve },
  /*::[*/
  16: { n: "PtgUnion", f: Ve },
  /*::[*/
  17: { n: "PtgRange", f: Ve },
  /*::[*/
  18: { n: "PtgUplus", f: Ve },
  /*::[*/
  19: { n: "PtgUminus", f: Ve },
  /*::[*/
  20: { n: "PtgPercent", f: Ve },
  /*::[*/
  21: { n: "PtgParen", f: Ve },
  /*::[*/
  22: { n: "PtgMissArg", f: Ve },
  /*::[*/
  23: { n: "PtgStr", f: xx },
  /*::[*/
  26: { n: "PtgSheet", f: Ux },
  /*::[*/
  27: { n: "PtgEndSheet", f: zx },
  /*::[*/
  28: { n: "PtgErr", f: ox },
  /*::[*/
  29: { n: "PtgBool", f: lx },
  /*::[*/
  30: { n: "PtgInt", f: ux },
  /*::[*/
  31: { n: "PtgNum", f: hx },
  /*::[*/
  32: { n: "PtgArray", f: j1 },
  /*::[*/
  33: { n: "PtgFunc", f: nx },
  /*::[*/
  34: { n: "PtgFuncVar", f: ix },
  /*::[*/
  35: { n: "PtgName", f: gx },
  /*::[*/
  36: { n: "PtgRef", f: rx },
  /*::[*/
  37: { n: "PtgArea", f: V1 },
  /*::[*/
  38: { n: "PtgMemArea", f: kx },
  /*::[*/
  39: { n: "PtgMemErr", f: Ax },
  /*::[*/
  40: { n: "PtgMemNoMem", f: Fx },
  /*::[*/
  41: { n: "PtgMemFunc", f: Ex },
  /*::[*/
  42: { n: "PtgRefErr", f: Tx },
  /*::[*/
  43: { n: "PtgAreaErr", f: W1 },
  /*::[*/
  44: { n: "PtgRefN", f: tx },
  /*::[*/
  45: { n: "PtgAreaN", f: G1 },
  /*::[*/
  46: { n: "PtgMemAreaN", f: $x },
  /*::[*/
  47: { n: "PtgMemNoMemN", f: Vx },
  /*::[*/
  57: { n: "PtgNameX", f: mx },
  /*::[*/
  58: { n: "PtgRef3d", f: ax },
  /*::[*/
  59: { n: "PtgArea3d", f: H1 },
  /*::[*/
  60: { n: "PtgRefErr3d", f: wx },
  /*::[*/
  61: { n: "PtgAreaErr3d", f: Z1 },
  /*::[*/
  255: {}
}, Wx = {
  /*::[*/
  64: 32,
  /*::[*/
  96: 32,
  /*::[*/
  65: 33,
  /*::[*/
  97: 33,
  /*::[*/
  66: 34,
  /*::[*/
  98: 34,
  /*::[*/
  67: 35,
  /*::[*/
  99: 35,
  /*::[*/
  68: 36,
  /*::[*/
  100: 36,
  /*::[*/
  69: 37,
  /*::[*/
  101: 37,
  /*::[*/
  70: 38,
  /*::[*/
  102: 38,
  /*::[*/
  71: 39,
  /*::[*/
  103: 39,
  /*::[*/
  72: 40,
  /*::[*/
  104: 40,
  /*::[*/
  73: 41,
  /*::[*/
  105: 41,
  /*::[*/
  74: 42,
  /*::[*/
  106: 42,
  /*::[*/
  75: 43,
  /*::[*/
  107: 43,
  /*::[*/
  76: 44,
  /*::[*/
  108: 44,
  /*::[*/
  77: 45,
  /*::[*/
  109: 45,
  /*::[*/
  78: 46,
  /*::[*/
  110: 46,
  /*::[*/
  79: 47,
  /*::[*/
  111: 47,
  /*::[*/
  88: 34,
  /*::[*/
  120: 34,
  /*::[*/
  89: 57,
  /*::[*/
  121: 57,
  /*::[*/
  90: 58,
  /*::[*/
  122: 58,
  /*::[*/
  91: 59,
  /*::[*/
  123: 59,
  /*::[*/
  92: 60,
  /*::[*/
  124: 60,
  /*::[*/
  93: 61,
  /*::[*/
  125: 61
}, Zx = {
  /*::[*/
  1: { n: "PtgElfLel", f: vc },
  /*::[*/
  2: { n: "PtgElfRw", f: bx },
  /*::[*/
  3: { n: "PtgElfCol", f: yx },
  /*::[*/
  6: { n: "PtgElfRwV", f: Px },
  /*::[*/
  7: { n: "PtgElfColV", f: Ix },
  /*::[*/
  10: { n: "PtgElfRadical", f: Dx },
  /*::[*/
  11: { n: "PtgElfRadicalS", f: Nx },
  /*::[*/
  13: { n: "PtgElfColS", f: Cx },
  /*::[*/
  15: { n: "PtgElfColSV", f: Ox },
  /*::[*/
  16: { n: "PtgElfRadicalLel", f: Rx },
  /*::[*/
  25: { n: "PtgList", f: Mx },
  /*::[*/
  29: { n: "PtgSxName", f: Bx },
  /*::[*/
  255: {}
}, Gx = {
  /*::[*/
  0: { n: "PtgAttrNoop", f: Hx },
  /*::[*/
  1: { n: "PtgAttrSemi", f: q1 },
  /*::[*/
  2: { n: "PtgAttrIf", f: Y1 },
  /*::[*/
  4: { n: "PtgAttrChoose", f: X1 },
  /*::[*/
  8: { n: "PtgAttrGoto", f: K1 },
  /*::[*/
  16: { n: "PtgAttrSum", f: cx },
  /*::[*/
  32: { n: "PtgAttrBaxcel", f: vi },
  /*::[*/
  33: { n: "PtgAttrBaxcel", f: vi },
  /*::[*/
  64: { n: "PtgAttrSpace", f: Q1 },
  /*::[*/
  65: { n: "PtgAttrSpaceSemi", f: ex },
  /*::[*/
  128: { n: "PtgAttrIfError", f: J1 },
  /*::[*/
  255: {}
};
function wa(e, t, r, a) {
  if (a.biff < 8) return cr(e, t);
  for (var n = e.l + t, i = [], s = 0; s !== r.length; ++s)
    switch (r[s][0]) {
      case "PtgArray":
        r[s][1] = vx(e, 0, a), i.push(r[s][1]);
        break;
      case "PtgMemArea":
        r[s][2] = px(e, r[s][1], a), i.push(r[s][2]);
        break;
      case "PtgExp":
        a && a.biff == 12 && (r[s][1][1] = e.read_shift(4), i.push(r[s][1]));
        break;
      case "PtgList":
      case "PtgElfRadicalS":
      case "PtgElfColS":
      case "PtgElfColSV":
        throw "Unsupported " + r[s][0];
    }
  return t = n - e.l, t !== 0 && i.push(cr(e, t)), i;
}
function Aa(e, t, r) {
  for (var a = e.l + t, n, i, s = []; a != e.l; )
    t = a - e.l, i = e[e.l], n = gi[i] || gi[Wx[i]], (i === 24 || i === 25) && (n = (i === 24 ? Zx : Gx)[e[e.l + 1]]), !n || !n.f ? cr(e, t) : s.push([n.n, n.f(e, t, r)]);
  return s;
}
function jx(e) {
  for (var t = [], r = 0; r < e.length; ++r) {
    for (var a = e[r], n = [], i = 0; i < a.length; ++i) {
      var s = a[i];
      if (s) switch (s[0]) {
        case 2:
          n.push('"' + s[1].replace(/"/g, '""') + '"');
          break;
        default:
          n.push(s[1]);
      }
      else n.push("");
    }
    t.push(n.join(","));
  }
  return t.join(";");
}
var Xx = {
  PtgAdd: "+",
  PtgConcat: "&",
  PtgDiv: "/",
  PtgEq: "=",
  PtgGe: ">=",
  PtgGt: ">",
  PtgLe: "<=",
  PtgLt: "<",
  PtgMul: "*",
  PtgNe: "<>",
  PtgPower: "^",
  PtgSub: "-"
};
function Kx(e, t) {
  if (!e && !(t && t.biff <= 5 && t.biff >= 2)) throw new Error("empty sheet name");
  return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(e) ? "'" + e + "'" : e;
}
function gc(e, t, r) {
  if (!e) return "SH33TJSERR0";
  if (r.biff > 8 && (!e.XTI || !e.XTI[t])) return e.SheetNames[t];
  if (!e.XTI) return "SH33TJSERR6";
  var a = e.XTI[t];
  if (r.biff < 8)
    return t > 1e4 && (t -= 65536), t < 0 && (t = -t), t == 0 ? "" : e.XTI[t - 1];
  if (!a) return "SH33TJSERR1";
  var n = "";
  if (r.biff > 8) switch (e[a[0]][0]) {
    case 357:
      return n = a[1] == -1 ? "#REF" : e.SheetNames[a[1]], a[1] == a[2] ? n : n + ":" + e.SheetNames[a[2]];
    case 358:
      return r.SID != null ? e.SheetNames[r.SID] : "SH33TJSSAME" + e[a[0]][0];
    case 355:
    default:
      return "SH33TJSSRC" + e[a[0]][0];
  }
  switch (e[a[0]][0][0]) {
    case 1025:
      return n = a[1] == -1 ? "#REF" : e.SheetNames[a[1]] || "SH33TJSERR3", a[1] == a[2] ? n : n + ":" + e.SheetNames[a[2]];
    case 14849:
      return e[a[0]].slice(1).map(function(i) {
        return i.Name;
      }).join(";;");
    default:
      return e[a[0]][0][3] ? (n = a[1] == -1 ? "#REF" : e[a[0]][0][3][a[1]] || "SH33TJSERR4", a[1] == a[2] ? n : n + ":" + e[a[0]][0][3][a[2]]) : "SH33TJSERR2";
  }
}
function mi(e, t, r) {
  var a = gc(e, t, r);
  return a == "#REF" ? a : Kx(a, r);
}
function ar(e, t, r, a, n) {
  var i = n && n.biff || 8, s = (
    /*range != null ? range :*/
    { s: { c: 0, r: 0 } }
  ), c = [], f, o, u, l = 0, h = 0, d, p = "";
  if (!e[0] || !e[0][0]) return "";
  for (var x = -1, g = "", F = 0, C = e[0].length; F < C; ++F) {
    var _ = e[0][F];
    switch (_[0]) {
      case "PtgUminus":
        c.push("-" + c.pop());
        break;
      case "PtgUplus":
        c.push("+" + c.pop());
        break;
      case "PtgPercent":
        c.push(c.pop() + "%");
        break;
      case "PtgAdd":
      case "PtgConcat":
      case "PtgDiv":
      case "PtgEq":
      case "PtgGe":
      case "PtgGt":
      case "PtgLe":
      case "PtgLt":
      case "PtgMul":
      case "PtgNe":
      case "PtgPower":
      case "PtgSub":
        if (f = c.pop(), o = c.pop(), x >= 0) {
          switch (e[0][x][1][0]) {
            case 0:
              g = be(" ", e[0][x][1][1]);
              break;
            case 1:
              g = be("\r", e[0][x][1][1]);
              break;
            default:
              if (g = "", n.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][x][1][0]);
          }
          o = o + g, x = -1;
        }
        c.push(o + Xx[_[0]] + f);
        break;
      case "PtgIsect":
        f = c.pop(), o = c.pop(), c.push(o + " " + f);
        break;
      case "PtgUnion":
        f = c.pop(), o = c.pop(), c.push(o + "," + f);
        break;
      case "PtgRange":
        f = c.pop(), o = c.pop(), c.push(o + ":" + f);
        break;
      case "PtgAttrChoose":
        break;
      case "PtgAttrGoto":
        break;
      case "PtgAttrIf":
        break;
      case "PtgAttrIfError":
        break;
      case "PtgRef":
        u = Qt(_[1][1], s, n), c.push(ea(u, i));
        break;
      case "PtgRefN":
        u = r ? Qt(_[1][1], r, n) : _[1][1], c.push(ea(u, i));
        break;
      case "PtgRef3d":
        l = /*::Number(*/
        _[1][1], u = Qt(_[1][2], s, n), p = mi(a, l, n), c.push(p + "!" + ea(u, i));
        break;
      case "PtgFunc":
      case "PtgFuncVar":
        var I = _[1][0], P = _[1][1];
        I || (I = 0), I &= 127;
        var O = I == 0 ? [] : c.slice(-I);
        c.length -= I, P === "User" && (P = O.shift()), c.push(P + "(" + O.join(",") + ")");
        break;
      case "PtgBool":
        c.push(_[1] ? "TRUE" : "FALSE");
        break;
      case "PtgInt":
        c.push(
          /*::String(*/
          _[1]
          /*::)*/
        );
        break;
      case "PtgNum":
        c.push(String(_[1]));
        break;
      case "PtgStr":
        c.push('"' + _[1].replace(/"/g, '""') + '"');
        break;
      case "PtgErr":
        c.push(
          /*::String(*/
          _[1]
          /*::)*/
        );
        break;
      case "PtgAreaN":
        d = q0(_[1][1], r ? { s: r } : s, n), c.push(kn(d, n));
        break;
      case "PtgArea":
        d = q0(_[1][1], s, n), c.push(kn(d, n));
        break;
      case "PtgArea3d":
        l = /*::Number(*/
        _[1][1], d = _[1][2], p = mi(a, l, n), c.push(p + "!" + kn(d, n));
        break;
      case "PtgAttrSum":
        c.push("SUM(" + c.pop() + ")");
        break;
      case "PtgAttrBaxcel":
      case "PtgAttrSemi":
        break;
      case "PtgName":
        h = _[1][2];
        var A = (a.names || [])[h - 1] || (a[0] || [])[h], V = A ? A.Name : "SH33TJSNAME" + String(h);
        V && V.slice(0, 6) == "_xlfn." && !n.xlfn && (V = V.slice(6)), c.push(V);
        break;
      case "PtgNameX":
        var D = _[1][1];
        h = _[1][2];
        var G;
        if (n.biff <= 5)
          D < 0 && (D = -D), a[D] && (G = a[D][h]);
        else {
          var W = "";
          if (((a[D] || [])[0] || [])[0] == 14849 || (((a[D] || [])[0] || [])[0] == 1025 ? a[D][h] && a[D][h].itab > 0 && (W = a.SheetNames[a[D][h].itab - 1] + "!") : W = a.SheetNames[h - 1] + "!"), a[D] && a[D][h]) W += a[D][h].Name;
          else if (a[0] && a[0][h]) W += a[0][h].Name;
          else {
            var b = (gc(a, D, n) || "").split(";;");
            b[h - 1] ? W = b[h - 1] : W += "SH33TJSERRX";
          }
          c.push(W);
          break;
        }
        G || (G = { Name: "SH33TJSERRY" }), c.push(G.Name);
        break;
      case "PtgParen":
        var J = "(", oe = ")";
        if (x >= 0) {
          switch (g = "", e[0][x][1][0]) {
            case 2:
              J = be(" ", e[0][x][1][1]) + J;
              break;
            case 3:
              J = be("\r", e[0][x][1][1]) + J;
              break;
            case 4:
              oe = be(" ", e[0][x][1][1]) + oe;
              break;
            case 5:
              oe = be("\r", e[0][x][1][1]) + oe;
              break;
            default:
              if (n.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][x][1][0]);
          }
          x = -1;
        }
        c.push(J + c.pop() + oe);
        break;
      case "PtgRefErr":
        c.push("#REF!");
        break;
      case "PtgRefErr3d":
        c.push("#REF!");
        break;
      case "PtgExp":
        u = { c: _[1][1], r: _[1][0] };
        var te = { c: r.c, r: r.r };
        if (a.sharedf[de(u)]) {
          var fe = a.sharedf[de(u)];
          c.push(ar(fe, s, te, a, n));
        } else {
          var ce = !1;
          for (f = 0; f != a.arrayf.length; ++f)
            if (o = a.arrayf[f], !(u.c < o[0].s.c || u.c > o[0].e.c) && !(u.r < o[0].s.r || u.r > o[0].e.r)) {
              c.push(ar(o[1], s, te, a, n)), ce = !0;
              break;
            }
          ce || c.push(
            /*::String(*/
            _[1]
            /*::)*/
          );
        }
        break;
      case "PtgArray":
        c.push("{" + jx(
          /*::(*/
          _[1]
          /*:: :any)*/
        ) + "}");
        break;
      case "PtgMemArea":
        break;
      case "PtgAttrSpace":
      case "PtgAttrSpaceSemi":
        x = F;
        break;
      case "PtgTbl":
        break;
      case "PtgMemErr":
        break;
      case "PtgMissArg":
        c.push("");
        break;
      case "PtgAreaErr":
        c.push("#REF!");
        break;
      case "PtgAreaErr3d":
        c.push("#REF!");
        break;
      case "PtgList":
        c.push("Table" + _[1].idx + "[#" + _[1].rt + "]");
        break;
      case "PtgMemAreaN":
      case "PtgMemNoMemN":
      case "PtgAttrNoop":
      case "PtgSheet":
      case "PtgEndSheet":
        break;
      case "PtgMemFunc":
        break;
      case "PtgMemNoMem":
        break;
      case "PtgElfCol":
      case "PtgElfColS":
      case "PtgElfColSV":
      case "PtgElfColV":
      case "PtgElfLel":
      case "PtgElfRadical":
      case "PtgElfRadicalLel":
      case "PtgElfRadicalS":
      case "PtgElfRw":
      case "PtgElfRwV":
        throw new Error("Unsupported ELFs");
      case "PtgSxName":
        throw new Error("Unrecognized Formula Token: " + String(_));
      default:
        throw new Error("Unrecognized Formula Token: " + String(_));
    }
    var Ce = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
    if (n.biff != 3 && x >= 0 && Ce.indexOf(e[0][F][0]) == -1) {
      _ = e[0][x];
      var H = !0;
      switch (_[1][0]) {
        case 4:
          H = !1;
        case 0:
          g = be(" ", _[1][1]);
          break;
        case 5:
          H = !1;
        case 1:
          g = be("\r", _[1][1]);
          break;
        default:
          if (g = "", n.WTF) throw new Error("Unexpected PtgAttrSpaceType " + _[1][0]);
      }
      c.push((H ? g : "") + c.pop() + (H ? "" : g)), x = -1;
    }
  }
  if (c.length > 1 && n.WTF) throw new Error("bad formula stack");
  return c[0];
}
function Yx(e, t, r) {
  var a = e.l + t, n = r.biff == 2 ? 1 : 2, i, s = e.read_shift(n);
  if (s == 65535) return [[], cr(e, t - 2)];
  var c = Aa(e, s, r);
  return t !== s + n && (i = wa(e, t - s - n, c, r)), e.l = a, [c, i];
}
function Jx(e, t, r) {
  var a = e.l + t, n = r.biff == 2 ? 1 : 2, i, s = e.read_shift(n);
  if (s == 65535) return [[], cr(e, t - 2)];
  var c = Aa(e, s, r);
  return t !== s + n && (i = wa(e, t - s - n, c, r)), e.l = a, [c, i];
}
function qx(e, t, r, a) {
  var n = e.l + t, i = Aa(e, a, r), s;
  return n !== e.l && (s = wa(e, n - e.l, i, r)), [i, s];
}
function Qx(e, t, r) {
  var a = e.l + t, n, i = e.read_shift(2), s = Aa(e, i, r);
  return i == 65535 ? [[], cr(e, t - 2)] : (t !== i + 2 && (n = wa(e, a - i - 2, s, r)), [s, n]);
}
function ed(e) {
  var t;
  if (jr(e, e.l + 6) !== 65535) return [nr(e), "n"];
  switch (e[e.l]) {
    case 0:
      return e.l += 8, ["String", "s"];
    case 1:
      return t = e[e.l + 2] === 1, e.l += 8, [t, "b"];
    case 2:
      return t = e[e.l + 2], e.l += 8, [t, "e"];
    case 3:
      return e.l += 8, ["", "s"];
  }
  return [];
}
function wn(e, t, r) {
  var a = e.l + t, n = Hr(e);
  r.biff == 2 && ++e.l;
  var i = ed(e), s = e.read_shift(1);
  r.biff != 2 && (e.read_shift(1), r.biff >= 5 && e.read_shift(4));
  var c = Jx(e, a - e.l, r);
  return { cell: n, val: i[0], formula: c, shared: s >> 3 & 1, tt: i[1] };
}
function fn(e, t, r) {
  var a = e.read_shift(4), n = Aa(e, a, r), i = e.read_shift(4), s = i > 0 ? wa(e, i, n, r) : null;
  return [n, s];
}
var rd = fn, on = fn, td = fn, ad = fn, nd = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
}, mc = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
}, id = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
function _i(e) {
  return e.slice(0, 3) == "of:" && (e = e.slice(3)), e.charCodeAt(0) == 61 && (e = e.slice(1), e.charCodeAt(0) == 61 && (e = e.slice(1))), e = e.replace(/COM\.MICROSOFT\./g, ""), e = e.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function(t, r) {
    return r.replace(/\./g, "");
  }), e = e.replace(/\[.(#[A-Z]*[?!])\]/g, "$1"), e.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function An(e) {
  var t = e.split(":"), r = t[0].split(".")[0];
  return [r, t[0].split(".")[1] + (t.length > 1 ? ":" + (t[1].split(".")[1] || t[1].split(".")[0]) : "")];
}
var na = {}, bt = {};
function ia(e, t) {
  if (e) {
    var r = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
    t == "xlml" && (r = [1, 1, 1, 1, 0.5, 0.5]), e.left == null && (e.left = r[0]), e.right == null && (e.right = r[1]), e.top == null && (e.top = r[2]), e.bottom == null && (e.bottom = r[3]), e.header == null && (e.header = r[4]), e.footer == null && (e.footer = r[5]);
  }
}
function _c(e, t, r, a, n, i) {
  try {
    a.cellNF && (e.z = ve[t]);
  } catch (c) {
    if (a.WTF) throw c;
  }
  if (!(e.t === "z" && !a.cellStyles)) {
    if (e.t === "d" && typeof e.v == "string" && (e.v = Ye(e.v)), (!a || a.cellText !== !1) && e.t !== "z") try {
      if (ve[t] == null && dt(io[t] || "General", t), e.t === "e") e.w = e.w || Ft[e.v];
      else if (t === 0)
        if (e.t === "n")
          (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = oa(e.v);
        else if (e.t === "d") {
          var s = pr(e.v);
          (s | 0) === s ? e.w = s.toString(10) : e.w = oa(s);
        } else {
          if (e.v === void 0) return "";
          e.w = vt(e.v, bt);
        }
      else e.t === "d" ? e.w = yr(t, pr(e.v), bt) : e.w = yr(t, e.v, bt);
    } catch (c) {
      if (a.WTF) throw c;
    }
    if (a.cellStyles && r != null)
      try {
        e.s = i.Fills[r], e.s.fgColor && e.s.fgColor.theme && !e.s.fgColor.rgb && (e.s.fgColor.rgb = Ja(n.themeElements.clrScheme[e.s.fgColor.theme].rgb, e.s.fgColor.tint || 0), a.WTF && (e.s.fgColor.raw_rgb = n.themeElements.clrScheme[e.s.fgColor.theme].rgb)), e.s.bgColor && e.s.bgColor.theme && (e.s.bgColor.rgb = Ja(n.themeElements.clrScheme[e.s.bgColor.theme].rgb, e.s.bgColor.tint || 0), a.WTF && (e.s.bgColor.raw_rgb = n.themeElements.clrScheme[e.s.bgColor.theme].rgb));
      } catch (c) {
        if (a.WTF && i.Fills) throw c;
      }
  }
}
function sd(e, t) {
  var r = Pe(t);
  r.s.r <= r.e.r && r.s.c <= r.e.c && r.s.r >= 0 && r.s.c >= 0 && (e["!ref"] = Ee(r));
}
var cd = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g, fd = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/, od = /<(?:\w:)?hyperlink [^>]*>/mg, ud = /"(\w*:\w*)"/, ld = /<(?:\w:)?col\b[^>]*[\/]?>/g, hd = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g, xd = /<(?:\w:)?pageMargins[^>]*\/>/g, kc = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/, dd = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/, pd = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
function vd(e, t, r, a, n, i, s) {
  if (!e) return e;
  a || (a = { "!id": {} });
  var c = t.dense ? [] : {}, f = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, o = "", u = "", l = e.match(fd);
  l ? (o = e.slice(0, l.index), u = e.slice(l.index + l[0].length)) : o = u = e;
  var h = o.match(kc);
  h ? o0(h[0], c, n, r) : (h = o.match(dd)) && gd(h[0], h[1] || "", c, n, r);
  var d = (o.match(/<(?:\w*:)?dimension/) || { index: -1 }).index;
  if (d > 0) {
    var p = o.slice(d, d + 50).match(ud);
    p && sd(c, p[1]);
  }
  var x = o.match(pd);
  x && x[1] && wd(x[1], n);
  var g = [];
  if (t.cellStyles) {
    var F = o.match(ld);
    F && kd(g, F);
  }
  l && Ad(l[1], c, t, f, i, s);
  var C = u.match(hd);
  C && (c["!autofilter"] = Ed(C[0]));
  var _ = [], I = u.match(cd);
  if (I) for (d = 0; d != I.length; ++d)
    _[d] = Pe(I[d].slice(I[d].indexOf('"') + 1));
  var P = u.match(od);
  P && md(c, P, a);
  var O = u.match(xd);
  if (O && (c["!margins"] = _d(le(O[0]))), !c["!ref"] && f.e.c >= f.s.c && f.e.r >= f.s.r && (c["!ref"] = Ee(f)), t.sheetRows > 0 && c["!ref"]) {
    var A = Pe(c["!ref"]);
    t.sheetRows <= +A.e.r && (A.e.r = t.sheetRows - 1, A.e.r > f.e.r && (A.e.r = f.e.r), A.e.r < A.s.r && (A.s.r = A.e.r), A.e.c > f.e.c && (A.e.c = f.e.c), A.e.c < A.s.c && (A.s.c = A.e.c), c["!fullref"] = c["!ref"], c["!ref"] = Ee(A));
  }
  return g.length > 0 && (c["!cols"] = g), _.length > 0 && (c["!merges"] = _), c;
}
function o0(e, t, r, a) {
  var n = le(e);
  r.Sheets[a] || (r.Sheets[a] = {}), n.codeName && (r.Sheets[a].CodeName = we(ye(n.codeName)));
}
function gd(e, t, r, a, n) {
  o0(e.slice(0, e.indexOf(">")), r, a, n);
}
function md(e, t, r) {
  for (var a = Array.isArray(e), n = 0; n != t.length; ++n) {
    var i = le(ye(t[n]), !0);
    if (!i.ref) return;
    var s = ((r || {})["!id"] || [])[i.id];
    s ? (i.Target = s.Target, i.location && (i.Target += "#" + we(i.location))) : (i.Target = "#" + we(i.location), s = { Target: i.Target, TargetMode: "Internal" }), i.Rel = s, i.tooltip && (i.Tooltip = i.tooltip, delete i.tooltip);
    for (var c = Pe(i.ref), f = c.s.r; f <= c.e.r; ++f) for (var o = c.s.c; o <= c.e.c; ++o) {
      var u = de({ c: o, r: f });
      a ? (e[f] || (e[f] = []), e[f][o] || (e[f][o] = { t: "z", v: void 0 }), e[f][o].l = i) : (e[u] || (e[u] = { t: "z", v: void 0 }), e[u].l = i);
    }
  }
}
function _d(e) {
  var t = {};
  return ["left", "right", "top", "bottom", "header", "footer"].forEach(function(r) {
    e[r] && (t[r] = parseFloat(e[r]));
  }), t;
}
function kd(e, t) {
  for (var r = !1, a = 0; a != t.length; ++a) {
    var n = le(t[a], !0);
    n.hidden && (n.hidden = Oe(n.hidden));
    var i = parseInt(n.min, 10) - 1, s = parseInt(n.max, 10) - 1;
    for (n.outlineLevel && (n.level = +n.outlineLevel || 0), delete n.min, delete n.max, n.width = +n.width, !r && n.width && (r = !0, c0(n.width)), Mt(n); i <= s; ) e[i++] = qe(n);
  }
}
function Ed(e) {
  var t = { ref: (e.match(/ref="([^"]*)"/) || [])[1] };
  return t;
}
var Td = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function wd(e, t) {
  t.Views || (t.Views = [{}]), (e.match(Td) || []).forEach(function(r, a) {
    var n = le(r);
    t.Views[a] || (t.Views[a] = {}), +n.zoomScale && (t.Views[a].zoom = +n.zoomScale), Oe(n.rightToLeft) && (t.Views[a].RTL = !0);
  });
}
var Ad = /* @__PURE__ */ function() {
  var e = /<(?:\w+:)?c[ \/>]/, t = /<\/(?:\w+:)?row>/, r = /r=["']([^"']*)["']/, a = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/, n = /ref=["']([^"']*)["']/, i = ua("v"), s = ua("f");
  return function(f, o, u, l, h, d) {
    for (var p = 0, x = "", g = [], F = [], C = 0, _ = 0, I = 0, P = "", O, A, V = 0, D = 0, G, W, b = 0, J = 0, oe = Array.isArray(d.CellXf), te, fe = [], ce = [], Ce = Array.isArray(o), H = [], he = {}, xe = !1, S = !!u.sheetStubs, U = f.split(t), N = 0, R = U.length; N != R; ++N) {
      x = U[N].trim();
      var X = x.length;
      if (X !== 0) {
        var re = 0;
        e: for (p = 0; p < X; ++p) switch (
          /*x.charCodeAt(ri)*/
          x[p]
        ) {
          case ">":
            if (
              /*x.charCodeAt(ri-1) != 47*/
              x[p - 1] != "/"
            ) {
              ++p;
              break e;
            }
            if (u && u.cellStyles) {
              if (A = le(x.slice(re, p), !0), V = A.r != null ? parseInt(A.r, 10) : V + 1, D = -1, u.sheetRows && u.sheetRows < V) continue;
              he = {}, xe = !1, A.ht && (xe = !0, he.hpt = parseFloat(A.ht), he.hpx = da(he.hpt)), A.hidden == "1" && (xe = !0, he.hidden = !0), A.outlineLevel != null && (xe = !0, he.level = +A.outlineLevel), xe && (H[V - 1] = he);
            }
            break;
          case "<":
            re = p;
            break;
        }
        if (re >= p) break;
        if (A = le(x.slice(re, p), !0), V = A.r != null ? parseInt(A.r, 10) : V + 1, D = -1, !(u.sheetRows && u.sheetRows < V)) {
          l.s.r > V - 1 && (l.s.r = V - 1), l.e.r < V - 1 && (l.e.r = V - 1), u && u.cellStyles && (he = {}, xe = !1, A.ht && (xe = !0, he.hpt = parseFloat(A.ht), he.hpx = da(he.hpt)), A.hidden == "1" && (xe = !0, he.hidden = !0), A.outlineLevel != null && (xe = !0, he.level = +A.outlineLevel), xe && (H[V - 1] = he)), g = x.slice(p).split(e);
          for (var ie = 0; ie != g.length && g[ie].trim().charAt(0) == "<"; ++ie) ;
          for (g = g.slice(ie), p = 0; p != g.length; ++p)
            if (x = g[p].trim(), x.length !== 0) {
              if (F = x.match(r), C = p, _ = 0, I = 0, x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x, F != null && F.length === 2) {
                for (C = 0, P = F[1], _ = 0; _ != P.length && !((I = P.charCodeAt(_) - 64) < 1 || I > 26); ++_)
                  C = 26 * C + I;
                --C, D = C;
              } else ++D;
              for (_ = 0; _ != x.length && x.charCodeAt(_) !== 62; ++_) ;
              if (++_, A = le(x.slice(0, _), !0), A.r || (A.r = de({ r: V - 1, c: D })), P = x.slice(_), O = { t: "" }, (F = P.match(i)) != null && /*::cref != null && */
              F[1] !== "" && (O.v = we(F[1])), u.cellFormula) {
                if ((F = P.match(s)) != null && /*::cref != null && */
                F[1] !== "") {
                  if (O.f = we(ye(F[1])).replace(/\r\n/g, `
`), u.xlfn || (O.f = pi(O.f)), /*::cref != null && cref[0] != null && */
                  F[0].indexOf('t="array"') > -1)
                    O.F = (P.match(n) || [])[1], O.F.indexOf(":") > -1 && fe.push([Pe(O.F), O.F]);
                  else if (
                    /*::cref != null && cref[0] != null && */
                    F[0].indexOf('t="shared"') > -1
                  ) {
                    W = le(F[0]);
                    var Q = we(ye(F[1]));
                    u.xlfn || (Q = pi(Q)), ce[parseInt(W.si, 10)] = [W, Q, A.r];
                  }
                } else (F = P.match(/<f[^>]*\/>/)) && (W = le(F[0]), ce[W.si] && (O.f = P1(ce[W.si][1], ce[W.si][2], A.r)));
                var Y = xr(A.r);
                for (_ = 0; _ < fe.length; ++_)
                  Y.r >= fe[_][0].s.r && Y.r <= fe[_][0].e.r && Y.c >= fe[_][0].s.c && Y.c <= fe[_][0].e.c && (O.F = fe[_][1]);
              }
              if (A.t == null && O.v === void 0)
                if (O.f || O.F)
                  O.v = 0, O.t = "n";
                else if (S) O.t = "z";
                else continue;
              else O.t = A.t || "n";
              switch (l.s.c > D && (l.s.c = D), l.e.c < D && (l.e.c = D), O.t) {
                case "n":
                  if (O.v == "" || O.v == null) {
                    if (!S) continue;
                    O.t = "z";
                  } else O.v = parseFloat(O.v);
                  break;
                case "s":
                  if (typeof O.v > "u") {
                    if (!S) continue;
                    O.t = "z";
                  } else
                    G = na[parseInt(O.v, 10)], O.v = G.t, O.r = G.r, u.cellHTML && (O.h = G.h);
                  break;
                case "str":
                  O.t = "s", O.v = O.v != null ? ye(O.v) : "", u.cellHTML && (O.h = Yn(O.v));
                  break;
                case "inlineStr":
                  F = P.match(a), O.t = "s", F != null && (G = s0(F[1])) ? (O.v = G.t, u.cellHTML && (O.h = G.h)) : O.v = "";
                  break;
                case "b":
                  O.v = Oe(O.v);
                  break;
                case "d":
                  u.cellDates ? O.v = Ye(O.v, 1) : (O.v = pr(Ye(O.v, 1)), O.t = "n");
                  break;
                case "e":
                  (!u || u.cellText !== !1) && (O.w = O.v), O.v = $s[O.v];
                  break;
              }
              if (b = J = 0, te = null, oe && A.s !== void 0 && (te = d.CellXf[A.s], te != null && (te.numFmtId != null && (b = te.numFmtId), u.cellStyles && te.fillId != null && (J = te.fillId))), _c(O, b, J, u, h, d), u.cellDates && oe && O.t == "n" && Bt(ve[b]) && (O.t = "d", O.v = sn(O.v)), A.cm && u.xlmeta) {
                var Te = (u.xlmeta.Cell || [])[+A.cm - 1];
                Te && Te.type == "XLDAPR" && (O.D = !0);
              }
              if (Ce) {
                var y = xr(A.r);
                o[y.r] || (o[y.r] = []), o[y.r][y.c] = O;
              } else o[A.r] = O;
            }
        }
      }
    }
    H.length > 0 && (o["!rows"] = H);
  };
}();
function Fd(e, t) {
  var r = {}, a = e.l + t;
  r.r = e.read_shift(4), e.l += 4;
  var n = e.read_shift(2);
  e.l += 1;
  var i = e.read_shift(1);
  return e.l = a, i & 7 && (r.level = i & 7), i & 16 && (r.hidden = !0), i & 32 && (r.hpt = n / 20), r;
}
var Sd = At;
function yd() {
}
function Cd(e, t) {
  var r = {}, a = e[e.l];
  return ++e.l, r.above = !(a & 64), r.left = !(a & 128), e.l += 18, r.name = Yo(e), r;
}
function Od(e) {
  var t = Cr(e);
  return [t];
}
function Id(e) {
  var t = wt(e);
  return [t];
}
function Dd(e) {
  var t = Cr(e), r = e.read_shift(1);
  return [t, r, "b"];
}
function Rd(e) {
  var t = wt(e), r = e.read_shift(1);
  return [t, r, "b"];
}
function Nd(e) {
  var t = Cr(e), r = e.read_shift(1);
  return [t, r, "e"];
}
function bd(e) {
  var t = wt(e), r = e.read_shift(1);
  return [t, r, "e"];
}
function Pd(e) {
  var t = Cr(e), r = e.read_shift(4);
  return [t, r, "s"];
}
function Ld(e) {
  var t = wt(e), r = e.read_shift(4);
  return [t, r, "s"];
}
function Md(e) {
  var t = Cr(e), r = nr(e);
  return [t, r, "n"];
}
function Ec(e) {
  var t = wt(e), r = nr(e);
  return [t, r, "n"];
}
function Bd(e) {
  var t = Cr(e), r = a0(e);
  return [t, r, "n"];
}
function Ud(e) {
  var t = wt(e), r = a0(e);
  return [t, r, "n"];
}
function zd(e) {
  var t = Cr(e), r = r0(e);
  return [t, r, "is"];
}
function $d(e) {
  var t = Cr(e), r = sr(e);
  return [t, r, "str"];
}
function Vd(e) {
  var t = wt(e), r = sr(e);
  return [t, r, "str"];
}
function Hd(e, t, r) {
  var a = e.l + t, n = Cr(e);
  n.r = r["!row"];
  var i = e.read_shift(1), s = [n, i, "b"];
  if (r.cellFormula) {
    e.l += 2;
    var c = on(e, a - e.l, r);
    s[3] = ar(c, null, n, r.supbooks, r);
  } else e.l = a;
  return s;
}
function Wd(e, t, r) {
  var a = e.l + t, n = Cr(e);
  n.r = r["!row"];
  var i = e.read_shift(1), s = [n, i, "e"];
  if (r.cellFormula) {
    e.l += 2;
    var c = on(e, a - e.l, r);
    s[3] = ar(c, null, n, r.supbooks, r);
  } else e.l = a;
  return s;
}
function Zd(e, t, r) {
  var a = e.l + t, n = Cr(e);
  n.r = r["!row"];
  var i = nr(e), s = [n, i, "n"];
  if (r.cellFormula) {
    e.l += 2;
    var c = on(e, a - e.l, r);
    s[3] = ar(c, null, n, r.supbooks, r);
  } else e.l = a;
  return s;
}
function Gd(e, t, r) {
  var a = e.l + t, n = Cr(e);
  n.r = r["!row"];
  var i = sr(e), s = [n, i, "str"];
  if (r.cellFormula) {
    e.l += 2;
    var c = on(e, a - e.l, r);
    s[3] = ar(c, null, n, r.supbooks, r);
  } else e.l = a;
  return s;
}
var jd = At;
function Xd(e, t) {
  var r = e.l + t, a = At(e), n = t0(e), i = sr(e), s = sr(e), c = sr(e);
  e.l = r;
  var f = { rfx: a, relId: n, loc: i, display: c };
  return s && (f.Tooltip = s), f;
}
function Kd() {
}
function Yd(e, t, r) {
  var a = e.l + t, n = Bs(e), i = e.read_shift(1), s = [n];
  if (s[2] = i, r.cellFormula) {
    var c = rd(e, a - e.l, r);
    s[1] = c;
  } else e.l = a;
  return s;
}
function Jd(e, t, r) {
  var a = e.l + t, n = At(e), i = [n];
  if (r.cellFormula) {
    var s = ad(e, a - e.l, r);
    i[1] = s, e.l = a;
  } else e.l = a;
  return i;
}
var qd = ["left", "right", "top", "bottom", "header", "footer"];
function Qd(e) {
  var t = {};
  return qd.forEach(function(r) {
    t[r] = nr(e);
  }), t;
}
function ep(e) {
  var t = e.read_shift(2);
  return e.l += 28, { RTL: t & 32 };
}
function rp() {
}
function tp() {
}
function ap(e, t, r, a, n, i, s) {
  if (!e) return e;
  var c = t || {};
  a || (a = { "!id": {} });
  var f = c.dense ? [] : {}, o, u = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, l = !1, h = !1, d, p, x, g, F, C, _, I, P, O = [];
  c.biff = 12, c["!row"] = 0;
  var A = 0, V = !1, D = [], G = {}, W = c.supbooks || /*::(*/
  n.supbooks || [[]];
  if (W.sharedf = G, W.arrayf = D, W.SheetNames = n.SheetNames || n.Sheets.map(function(Ce) {
    return Ce.name;
  }), !c.supbooks && (c.supbooks = W, n.Names))
    for (var b = 0; b < n.Names.length; ++b) W[0][b + 1] = n.Names[b];
  var J = [], oe = [], te = !1;
  en[16] = { n: "BrtShortReal", f: Ec };
  var fe;
  if (Jr(e, function(H, he, xe) {
    if (!h)
      switch (xe) {
        case 148:
          o = H;
          break;
        case 0:
          d = H, c.sheetRows && c.sheetRows <= d.r && (h = !0), I = Qe(g = d.r), c["!row"] = d.r, (H.hidden || H.hpt || H.level != null) && (H.hpt && (H.hpx = da(H.hpt)), oe[H.r] = H);
          break;
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 62:
          switch (p = { t: H[2] }, H[2]) {
            case "n":
              p.v = H[1];
              break;
            case "s":
              _ = na[H[1]], p.v = _.t, p.r = _.r;
              break;
            case "b":
              p.v = !!H[1];
              break;
            case "e":
              p.v = H[1], c.cellText !== !1 && (p.w = Ft[p.v]);
              break;
            case "str":
              p.t = "s", p.v = H[1];
              break;
            case "is":
              p.t = "s", p.v = H[1].t;
              break;
          }
          if ((x = s.CellXf[H[0].iStyleRef]) && _c(p, x.numFmtId, null, c, i, s), F = H[0].c == -1 ? F + 1 : H[0].c, c.dense ? (f[g] || (f[g] = []), f[g][F] = p) : f[je(F) + I] = p, c.cellFormula) {
            for (V = !1, A = 0; A < D.length; ++A) {
              var S = D[A];
              d.r >= S[0].s.r && d.r <= S[0].e.r && F >= S[0].s.c && F <= S[0].e.c && (p.F = Ee(S[0]), V = !0);
            }
            !V && H.length > 3 && (p.f = H[3]);
          }
          if (u.s.r > d.r && (u.s.r = d.r), u.s.c > F && (u.s.c = F), u.e.r < d.r && (u.e.r = d.r), u.e.c < F && (u.e.c = F), c.cellDates && x && p.t == "n" && Bt(ve[x.numFmtId])) {
            var U = xt(p.v);
            U && (p.t = "d", p.v = new Date(U.y, U.m - 1, U.d, U.H, U.M, U.S, U.u));
          }
          fe && (fe.type == "XLDAPR" && (p.D = !0), fe = void 0);
          break;
        case 1:
        case 12:
          if (!c.sheetStubs || l) break;
          p = { t: "z", v: void 0 }, F = H[0].c == -1 ? F + 1 : H[0].c, c.dense ? (f[g] || (f[g] = []), f[g][F] = p) : f[je(F) + I] = p, u.s.r > d.r && (u.s.r = d.r), u.s.c > F && (u.s.c = F), u.e.r < d.r && (u.e.r = d.r), u.e.c < F && (u.e.c = F), fe && (fe.type == "XLDAPR" && (p.D = !0), fe = void 0);
          break;
        case 176:
          O.push(H);
          break;
        case 49:
          fe = ((c.xlmeta || {}).Cell || [])[H - 1];
          break;
        case 494:
          var N = a["!id"][H.relId];
          for (N ? (H.Target = N.Target, H.loc && (H.Target += "#" + H.loc), H.Rel = N) : H.relId == "" && (H.Target = "#" + H.loc), g = H.rfx.s.r; g <= H.rfx.e.r; ++g) for (F = H.rfx.s.c; F <= H.rfx.e.c; ++F)
            c.dense ? (f[g] || (f[g] = []), f[g][F] || (f[g][F] = { t: "z", v: void 0 }), f[g][F].l = H) : (C = de({ c: F, r: g }), f[C] || (f[C] = { t: "z", v: void 0 }), f[C].l = H);
          break;
        case 426:
          if (!c.cellFormula) break;
          D.push(H), P = c.dense ? f[g][F] : f[je(F) + I], P.f = ar(H[1], u, { r: d.r, c: F }, W, c), P.F = Ee(H[0]);
          break;
        case 427:
          if (!c.cellFormula) break;
          G[de(H[0].s)] = H[1], P = c.dense ? f[g][F] : f[je(F) + I], P.f = ar(H[1], u, { r: d.r, c: F }, W, c);
          break;
        case 60:
          if (!c.cellStyles) break;
          for (; H.e >= H.s; )
            J[H.e--] = { width: H.w / 256, hidden: !!(H.flags & 1), level: H.level }, te || (te = !0, c0(H.w / 256)), Mt(J[H.e + 1]);
          break;
        case 161:
          f["!autofilter"] = { ref: Ee(H) };
          break;
        case 476:
          f["!margins"] = H;
          break;
        case 147:
          n.Sheets[r] || (n.Sheets[r] = {}), H.name && (n.Sheets[r].CodeName = H.name), (H.above || H.left) && (f["!outline"] = { above: H.above, left: H.left });
          break;
        case 137:
          n.Views || (n.Views = [{}]), n.Views[0] || (n.Views[0] = {}), H.RTL && (n.Views[0].RTL = !0);
          break;
        case 485:
          break;
        case 64:
        case 1053:
          break;
        case 151:
          break;
        case 152:
        case 175:
        case 644:
        case 625:
        case 562:
        case 396:
        case 1112:
        case 1146:
        case 471:
        case 1050:
        case 649:
        case 1105:
        case 589:
        case 607:
        case 564:
        case 1055:
        case 168:
        case 174:
        case 1180:
        case 499:
        case 507:
        case 550:
        case 171:
        case 167:
        case 1177:
        case 169:
        case 1181:
        case 551:
        case 552:
        case 661:
        case 639:
        case 478:
        case 537:
        case 477:
        case 536:
        case 1103:
        case 680:
        case 1104:
        case 1024:
        case 663:
        case 535:
        case 678:
        case 504:
        case 1043:
        case 428:
        case 170:
        case 3072:
        case 50:
        case 2070:
        case 1045:
          break;
        case 35:
          l = !0;
          break;
        case 36:
          l = !1;
          break;
        case 37:
          l = !0;
          break;
        case 38:
          l = !1;
          break;
        default:
          if (!he.T) {
            if (!l || c.WTF) throw new Error("Unexpected record 0x" + xe.toString(16));
          }
      }
  }, c), delete c.supbooks, delete c["!row"], !f["!ref"] && (u.s.r < 2e6 || o && (o.e.r > 0 || o.e.c > 0 || o.s.r > 0 || o.s.c > 0)) && (f["!ref"] = Ee(o || u)), c.sheetRows && f["!ref"]) {
    var ce = Pe(f["!ref"]);
    c.sheetRows <= +ce.e.r && (ce.e.r = c.sheetRows - 1, ce.e.r > u.e.r && (ce.e.r = u.e.r), ce.e.r < ce.s.r && (ce.s.r = ce.e.r), ce.e.c > u.e.c && (ce.e.c = u.e.c), ce.e.c < ce.s.c && (ce.s.c = ce.e.c), f["!fullref"] = f["!ref"], f["!ref"] = Ee(ce));
  }
  return O.length > 0 && (f["!merges"] = O), J.length > 0 && (f["!cols"] = J), oe.length > 0 && (f["!rows"] = oe), f;
}
function np(e) {
  var t = [], r = e.match(/^<c:numCache>/), a;
  (e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(i) {
    var s = i.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
    s && (t[+s[1]] = r ? +s[2] : s[2]);
  });
  var n = we((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["", "General"])[1]);
  return (e.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(i) {
    a = i.replace(/<.*?>/g, "");
  }), [t, n, a];
}
function ip(e, t, r, a, n, i) {
  var s = i || { "!type": "chart" };
  if (!e) return i;
  var c = 0, f = 0, o = "A", u = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
  return (e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(l) {
    var h = np(l);
    u.s.r = u.s.c = 0, u.e.c = c, o = je(c), h[0].forEach(function(d, p) {
      s[o + Qe(p)] = { t: "n", v: d, z: h[1] }, f = p;
    }), u.e.r < f && (u.e.r = f), ++c;
  }), c > 0 && (s["!ref"] = Ee(u)), s;
}
function sp(e, t, r, a, n) {
  if (!e) return e;
  a || (a = { "!id": {} });
  var i = { "!type": "chart", "!drawel": null, "!rel": "" }, s, c = e.match(kc);
  return c && o0(c[0], i, n, r), (s = e.match(/drawing r:id="(.*?)"/)) && (i["!rel"] = s[1]), a["!id"][i["!rel"]] && (i["!drawel"] = a["!id"][i["!rel"]]), i;
}
function cp(e, t) {
  e.l += 10;
  var r = sr(e);
  return { name: r };
}
function fp(e, t, r, a, n) {
  if (!e) return e;
  a || (a = { "!id": {} });
  var i = { "!type": "chart", "!drawel": null, "!rel": "" }, s = !1;
  return Jr(e, function(f, o, u) {
    switch (u) {
      case 550:
        i["!rel"] = f;
        break;
      case 651:
        n.Sheets[r] || (n.Sheets[r] = {}), f.name && (n.Sheets[r].CodeName = f.name);
        break;
      case 562:
      case 652:
      case 669:
      case 679:
      case 551:
      case 552:
      case 476:
      case 3072:
        break;
      case 35:
        s = !0;
        break;
      case 36:
        s = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!(o.T > 0)) {
          if (!(o.T < 0)) {
            if (!s || t.WTF) throw new Error("Unexpected record 0x" + u.toString(16));
          }
        }
    }
  }, t), a["!id"][i["!rel"]] && (i["!drawel"] = a["!id"][i["!rel"]]), i;
}
var Tc = [
  ["allowRefreshQuery", !1, "bool"],
  ["autoCompressPictures", !0, "bool"],
  ["backupFile", !1, "bool"],
  ["checkCompatibility", !1, "bool"],
  ["CodeName", ""],
  ["date1904", !1, "bool"],
  ["defaultThemeVersion", 0, "int"],
  ["filterPrivacy", !1, "bool"],
  ["hidePivotFieldList", !1, "bool"],
  ["promptedSolutions", !1, "bool"],
  ["publishItems", !1, "bool"],
  ["refreshAllConnections", !1, "bool"],
  ["saveExternalLinkValues", !0, "bool"],
  ["showBorderUnselectedTables", !0, "bool"],
  ["showInkAnnotation", !0, "bool"],
  ["showObjects", "all"],
  ["showPivotChartFilter", !1, "bool"],
  ["updateLinks", "userSet"]
], op = [
  ["activeTab", 0, "int"],
  ["autoFilterDateGrouping", !0, "bool"],
  ["firstSheet", 0, "int"],
  ["minimized", !1, "bool"],
  ["showHorizontalScroll", !0, "bool"],
  ["showSheetTabs", !0, "bool"],
  ["showVerticalScroll", !0, "bool"],
  ["tabRatio", 600, "int"],
  ["visibility", "visible"]
  //window{Height,Width}, {x,y}Window
], up = [
  //['state', 'visible']
], lp = [
  ["calcCompleted", "true"],
  ["calcMode", "auto"],
  ["calcOnSave", "true"],
  ["concurrentCalc", "true"],
  ["fullCalcOnLoad", "false"],
  ["fullPrecision", "true"],
  ["iterate", "false"],
  ["iterateCount", "100"],
  ["iterateDelta", "0.001"],
  ["refMode", "A1"]
];
function ki(e, t) {
  for (var r = 0; r != e.length; ++r)
    for (var a = e[r], n = 0; n != t.length; ++n) {
      var i = t[n];
      if (a[i[0]] == null) a[i[0]] = i[1];
      else switch (i[2]) {
        case "bool":
          typeof a[i[0]] == "string" && (a[i[0]] = Oe(a[i[0]]));
          break;
        case "int":
          typeof a[i[0]] == "string" && (a[i[0]] = parseInt(a[i[0]], 10));
          break;
      }
    }
}
function Ei(e, t) {
  for (var r = 0; r != t.length; ++r) {
    var a = t[r];
    if (e[a[0]] == null) e[a[0]] = a[1];
    else switch (a[2]) {
      case "bool":
        typeof e[a[0]] == "string" && (e[a[0]] = Oe(e[a[0]]));
        break;
      case "int":
        typeof e[a[0]] == "string" && (e[a[0]] = parseInt(e[a[0]], 10));
        break;
    }
  }
}
function wc(e) {
  Ei(e.WBProps, Tc), Ei(e.CalcPr, lp), ki(e.WBView, op), ki(e.Sheets, up), bt.date1904 = Oe(e.WBProps.date1904);
}
var hp = /* @__PURE__ */ "][*?/\\".split("");
function xp(e, t) {
  if (e.length > 31)
    throw new Error("Sheet names cannot exceed 31 chars");
  var r = !0;
  return hp.forEach(function(a) {
    if (e.indexOf(a) != -1)
      throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
  }), r;
}
var dp = /<\w+:workbook/;
function pp(e, t) {
  if (!e) throw new Error("Could not find file");
  var r = (
    /*::(*/
    { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, Names: [], xmlns: "" }
  ), a = !1, n = "xmlns", i = {}, s = 0;
  if (e.replace(fr, function(f, o) {
    var u = le(f);
    switch (Vr(u[0])) {
      case "<?xml":
        break;
      case "<workbook":
        f.match(dp) && (n = "xmlns" + f.match(/<(\w+):/)[1]), r.xmlns = u[n];
        break;
      case "</workbook>":
        break;
      case "<fileVersion":
        delete u[0], r.AppVersion = u;
        break;
      case "<fileVersion/>":
      case "</fileVersion>":
        break;
      case "<fileSharing":
        break;
      case "<fileSharing/>":
        break;
      case "<workbookPr":
      case "<workbookPr/>":
        Tc.forEach(function(l) {
          if (u[l[0]] != null)
            switch (l[2]) {
              case "bool":
                r.WBProps[l[0]] = Oe(u[l[0]]);
                break;
              case "int":
                r.WBProps[l[0]] = parseInt(u[l[0]], 10);
                break;
              default:
                r.WBProps[l[0]] = u[l[0]];
            }
        }), u.codeName && (r.WBProps.CodeName = ye(u.codeName));
        break;
      case "</workbookPr>":
        break;
      case "<workbookProtection":
        break;
      case "<workbookProtection/>":
        break;
      case "<bookViews":
      case "<bookViews>":
      case "</bookViews>":
        break;
      case "<workbookView":
      case "<workbookView/>":
        delete u[0], r.WBView.push(u);
        break;
      case "</workbookView>":
        break;
      case "<sheets":
      case "<sheets>":
      case "</sheets>":
        break;
      case "<sheet":
        switch (u.state) {
          case "hidden":
            u.Hidden = 1;
            break;
          case "veryHidden":
            u.Hidden = 2;
            break;
          default:
            u.Hidden = 0;
        }
        delete u.state, u.name = we(ye(u.name)), delete u[0], r.Sheets.push(u);
        break;
      case "</sheet>":
        break;
      case "<functionGroups":
      case "<functionGroups/>":
        break;
      case "<functionGroup":
        break;
      case "<externalReferences":
      case "</externalReferences>":
      case "<externalReferences>":
        break;
      case "<externalReference":
        break;
      case "<definedNames/>":
        break;
      case "<definedNames>":
      case "<definedNames":
        a = !0;
        break;
      case "</definedNames>":
        a = !1;
        break;
      case "<definedName":
        i = {}, i.Name = ye(u.name), u.comment && (i.Comment = u.comment), u.localSheetId && (i.Sheet = +u.localSheetId), Oe(u.hidden || "0") && (i.Hidden = !0), s = o + f.length;
        break;
      case "</definedName>":
        i.Ref = we(ye(e.slice(s, o))), r.Names.push(i);
        break;
      case "<definedName/>":
        break;
      case "<calcPr":
        delete u[0], r.CalcPr = u;
        break;
      case "<calcPr/>":
        delete u[0], r.CalcPr = u;
        break;
      case "</calcPr>":
        break;
      case "<oleSize":
        break;
      case "<customWorkbookViews>":
      case "</customWorkbookViews>":
      case "<customWorkbookViews":
        break;
      case "<customWorkbookView":
      case "</customWorkbookView>":
        break;
      case "<pivotCaches>":
      case "</pivotCaches>":
      case "<pivotCaches":
        break;
      case "<pivotCache":
        break;
      case "<smartTagPr":
      case "<smartTagPr/>":
        break;
      case "<smartTagTypes":
      case "<smartTagTypes>":
      case "</smartTagTypes>":
        break;
      case "<smartTagType":
        break;
      case "<webPublishing":
      case "<webPublishing/>":
        break;
      case "<fileRecoveryPr":
      case "<fileRecoveryPr/>":
        break;
      case "<webPublishObjects>":
      case "<webPublishObjects":
      case "</webPublishObjects>":
        break;
      case "<webPublishObject":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      case "<ArchID":
        break;
      case "<AlternateContent":
      case "<AlternateContent>":
        a = !0;
        break;
      case "</AlternateContent>":
        a = !1;
        break;
      case "<revisionPtr":
        break;
      default:
        if (!a && t.WTF) throw new Error("unrecognized " + u[0] + " in workbook");
    }
    return f;
  }), No.indexOf(r.xmlns) === -1) throw new Error("Unknown Namespace: " + r.xmlns);
  return wc(r), r;
}
function vp(e, t) {
  var r = {};
  return r.Hidden = e.read_shift(4), r.iTabID = e.read_shift(4), r.strRelID = In(e), r.name = sr(e), r;
}
function gp(e, t) {
  var r = {}, a = e.read_shift(4);
  r.defaultThemeVersion = e.read_shift(4);
  var n = t > 8 ? sr(e) : "";
  return n.length > 0 && (r.CodeName = n), r.autoCompressPictures = !!(a & 65536), r.backupFile = !!(a & 64), r.checkCompatibility = !!(a & 4096), r.date1904 = !!(a & 1), r.filterPrivacy = !!(a & 8), r.hidePivotFieldList = !!(a & 1024), r.promptedSolutions = !!(a & 16), r.publishItems = !!(a & 2048), r.refreshAllConnections = !!(a & 262144), r.saveExternalLinkValues = !!(a & 128), r.showBorderUnselectedTables = !!(a & 4), r.showInkAnnotation = !!(a & 32), r.showObjects = ["all", "placeholders", "none"][a >> 13 & 3], r.showPivotChartFilter = !!(a & 32768), r.updateLinks = ["userSet", "never", "always"][a >> 8 & 3], r;
}
function mp(e, t) {
  var r = {};
  return e.read_shift(4), r.ArchID = e.read_shift(4), e.l += t - 8, r;
}
function _p(e, t, r) {
  var a = e.l + t;
  e.l += 4, e.l += 1;
  var n = e.read_shift(4), i = Jo(e), s = td(e, 0, r), c = t0(e);
  e.l = a;
  var f = { Name: i, Ptg: s };
  return n < 268435455 && (f.Sheet = n), c && (f.Comment = c), f;
}
function kp(e, t) {
  var r = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, xmlns: "" }, a = [], n = !1;
  t || (t = {}), t.biff = 12;
  var i = [], s = [[]];
  return s.SheetNames = [], s.XTI = [], en[16] = { n: "BrtFRTArchID$", f: mp }, Jr(e, function(f, o, u) {
    switch (u) {
      case 156:
        s.SheetNames.push(f.name), r.Sheets.push(f);
        break;
      case 153:
        r.WBProps = f;
        break;
      case 39:
        f.Sheet != null && (t.SID = f.Sheet), f.Ref = ar(f.Ptg, null, null, s, t), delete t.SID, delete f.Ptg, i.push(f);
        break;
      case 1036:
        break;
      case 357:
      case 358:
      case 355:
      case 667:
        s[0].length ? s.push([u, f]) : s[0] = [u, f], s[s.length - 1].XTI = [];
        break;
      case 362:
        s.length === 0 && (s[0] = [], s[0].XTI = []), s[s.length - 1].XTI = s[s.length - 1].XTI.concat(f), s.XTI = s.XTI.concat(f);
        break;
      case 361:
        break;
      case 2071:
      case 158:
      case 143:
      case 664:
      case 353:
        break;
      case 3072:
      case 3073:
      case 534:
      case 677:
      case 157:
      case 610:
      case 2050:
      case 155:
      case 548:
      case 676:
      case 128:
      case 665:
      case 2128:
      case 2125:
      case 549:
      case 2053:
      case 596:
      case 2076:
      case 2075:
      case 2082:
      case 397:
      case 154:
      case 1117:
      case 553:
      case 2091:
        break;
      case 35:
        a.push(u), n = !0;
        break;
      case 36:
        a.pop(), n = !1;
        break;
      case 37:
        a.push(u), n = !0;
        break;
      case 38:
        a.pop(), n = !1;
        break;
      case 16:
        break;
      default:
        if (!o.T) {
          if (!n || t.WTF && a[a.length - 1] != 37 && a[a.length - 1] != 35) throw new Error("Unexpected record 0x" + u.toString(16));
        }
    }
  }, t), wc(r), r.Names = i, r.supbooks = s, r;
}
function Ep(e, t, r) {
  return t.slice(-4) === ".bin" ? kp(e, r) : pp(e, r);
}
function Tp(e, t, r, a, n, i, s, c) {
  return t.slice(-4) === ".bin" ? ap(e, a, r, n, i, s, c) : vd(e, a, r, n, i, s, c);
}
function wp(e, t, r, a, n, i, s, c) {
  return t.slice(-4) === ".bin" ? fp(e, a, r, n, i) : sp(e, a, r, n, i);
}
function Ap(e, t, r, a, n, i, s, c) {
  return t.slice(-4) === ".bin" ? R1() : N1();
}
function Fp(e, t, r, a, n, i, s, c) {
  return t.slice(-4) === ".bin" ? I1() : D1();
}
function Sp(e, t, r, a) {
  return t.slice(-4) === ".bin" ? jh(e, r, a) : $h(e, r, a);
}
function yp(e, t, r) {
  return oc(e, r);
}
function Cp(e, t, r) {
  return t.slice(-4) === ".bin" ? oh(e, r) : ch(e, r);
}
function Op(e, t, r) {
  return t.slice(-4) === ".bin" ? y1(e, r) : T1(e, r);
}
function Ip(e, t, r) {
  return t.slice(-4) === ".bin" ? _1(e) : g1(e);
}
function Dp(e, t, r, a) {
  return r.slice(-4) === ".bin" ? k1(e, t, r, a) : void 0;
}
function Rp(e, t, r) {
  return t.slice(-4) === ".bin" ? p1(e, t, r) : v1(e, t, r);
}
var Ac = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g, Fc = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function Ir(e, t) {
  var r = e.split(/\s+/), a = [];
  if (a[0] = r[0], r.length === 1) return a;
  var n = e.match(Ac), i, s, c, f;
  if (n) for (f = 0; f != n.length; ++f)
    i = n[f].match(Fc), (s = i[1].indexOf(":")) === -1 ? a[i[1]] = i[2].slice(1, i[2].length - 1) : (i[1].slice(0, 6) === "xmlns:" ? c = "xmlns" + i[1].slice(6) : c = i[1].slice(s + 1), a[c] = i[2].slice(1, i[2].length - 1));
  return a;
}
function Np(e) {
  var t = e.split(/\s+/), r = {};
  if (t.length === 1) return r;
  var a = e.match(Ac), n, i, s, c;
  if (a) for (c = 0; c != a.length; ++c)
    n = a[c].match(Fc), (i = n[1].indexOf(":")) === -1 ? r[n[1]] = n[2].slice(1, n[2].length - 1) : (n[1].slice(0, 6) === "xmlns:" ? s = "xmlns" + n[1].slice(6) : s = n[1].slice(i + 1), r[s] = n[2].slice(1, n[2].length - 1));
  return r;
}
var sa;
function bp(e, t) {
  var r = sa[e] || we(e);
  return r === "General" ? vt(t) : yr(r, t);
}
function Pp(e, t, r, a) {
  var n = a;
  switch ((r[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
    case "boolean":
      n = Oe(a);
      break;
    case "i2":
    case "int":
      n = parseInt(a, 10);
      break;
    case "r4":
    case "float":
      n = parseFloat(a);
      break;
    case "date":
    case "dateTime.tz":
      n = Ye(a);
      break;
    case "i8":
    case "string":
    case "fixed":
    case "uuid":
    case "bin.base64":
      break;
    default:
      throw new Error("bad custprop:" + r[0]);
  }
  e[we(t)] = n;
}
function Lp(e, t, r) {
  if (e.t !== "z") {
    if (!r || r.cellText !== !1) try {
      e.t === "e" ? e.w = e.w || Ft[e.v] : t === "General" ? e.t === "n" ? (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = oa(e.v) : e.w = vt(e.v) : e.w = bp(t || "General", e.v);
    } catch (i) {
      if (r.WTF) throw i;
    }
    try {
      var a = sa[t] || t || "General";
      if (r.cellNF && (e.z = a), r.cellDates && e.t == "n" && Bt(a)) {
        var n = xt(e.v);
        n && (e.t = "d", e.v = new Date(n.y, n.m - 1, n.d, n.H, n.M, n.S, n.u));
      }
    } catch (i) {
      if (r.WTF) throw i;
    }
  }
}
function Mp(e, t, r) {
  if (r.cellStyles && t.Interior) {
    var a = t.Interior;
    a.Pattern && (a.patternType = Ph[a.Pattern] || a.Pattern);
  }
  e[t.ID] = t;
}
function Bp(e, t, r, a, n, i, s, c, f, o) {
  var u = "General", l = a.StyleID, h = {};
  o = o || {};
  var d = [], p = 0;
  for (l === void 0 && c && (l = c.StyleID), l === void 0 && s && (l = s.StyleID); i[l] !== void 0 && (i[l].nf && (u = i[l].nf), i[l].Interior && d.push(i[l].Interior), !!i[l].Parent); )
    l = i[l].Parent;
  switch (r.Type) {
    case "Boolean":
      a.t = "b", a.v = Oe(e);
      break;
    case "String":
      a.t = "s", a.r = H0(we(e)), a.v = e.indexOf("<") > -1 ? we(t || e).replace(/<.*?>/g, "") : a.r;
      break;
    case "DateTime":
      e.slice(-1) != "Z" && (e += "Z"), a.v = (Ye(e) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1e3), a.v !== a.v ? a.v = we(e) : a.v < 60 && (a.v = a.v - 1), (!u || u == "General") && (u = "yyyy-mm-dd");
    case "Number":
      a.v === void 0 && (a.v = +e), a.t || (a.t = "n");
      break;
    case "Error":
      a.t = "e", a.v = $s[e], o.cellText !== !1 && (a.w = e);
      break;
    default:
      e == "" && t == "" ? a.t = "z" : (a.t = "s", a.v = H0(t || e));
      break;
  }
  if (Lp(a, u, o), o.cellFormula !== !1)
    if (a.Formula) {
      var x = we(a.Formula);
      x.charCodeAt(0) == 61 && (x = x.slice(1)), a.f = Nt(x, n), delete a.Formula, a.ArrayRange == "RC" ? a.F = Nt("RC:RC", n) : a.ArrayRange && (a.F = Nt(a.ArrayRange, n), f.push([Pe(a.F), a.F]));
    } else
      for (p = 0; p < f.length; ++p)
        n.r >= f[p][0].s.r && n.r <= f[p][0].e.r && n.c >= f[p][0].s.c && n.c <= f[p][0].e.c && (a.F = f[p][1]);
  o.cellStyles && (d.forEach(function(g) {
    !h.patternType && g.patternType && (h.patternType = g.patternType);
  }), a.s = h), a.StyleID !== void 0 && (a.ixfe = a.StyleID);
}
function Up(e) {
  e.t = e.v || "", e.t = e.t.replace(/\r\n/g, `
`).replace(/\r/g, `
`), e.v = e.w = e.ixfe = void 0;
}
function Fn(e, t) {
  var r = t || {};
  xs();
  var a = jt(Jn(e));
  (r.type == "binary" || r.type == "array" || r.type == "base64") && (a = ye(a));
  var n = a.slice(0, 1024).toLowerCase(), i = !1;
  if (n = n.replace(/".*?"/g, ""), (n.indexOf(">") & 1023) > Math.min(n.indexOf(",") & 1023, n.indexOf(";") & 1023)) {
    var s = qe(r);
    return s.type = "string", ha.to_workbook(a, s);
  }
  if (n.indexOf("<?xml") == -1 && ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(Ue) {
    n.indexOf("<" + Ue) >= 0 && (i = !0);
  }), i) return Xp(a, r);
  sa = {
    "General Number": "General",
    "General Date": ve[22],
    "Long Date": "dddd, mmmm dd, yyyy",
    "Medium Date": ve[15],
    "Short Date": ve[14],
    "Long Time": ve[19],
    "Medium Time": ve[18],
    "Short Time": ve[20],
    Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    Fixed: ve[2],
    Standard: ve[4],
    Percent: ve[10],
    Scientific: ve[11],
    "Yes/No": '"Yes";"Yes";"No";@',
    "True/False": '"True";"True";"False";@',
    "On/Off": '"Yes";"Yes";"No";@'
  };
  var c, f = [], o, u = {}, l = [], h = r.dense ? [] : {}, d = "", p = {}, x = {}, g = Ir('<Data ss:Type="String">'), F = 0, C = 0, _ = 0, I = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, P = {}, O = {}, A = "", V = 0, D = [], G = {}, W = {}, b = 0, J = [], oe = [], te = {}, fe = [], ce, Ce = !1, H = [], he = [], xe = {}, S = 0, U = 0, N = { Sheets: [], WBProps: { date1904: !1 } }, R = {};
  la.lastIndex = 0, a = a.replace(/<!--([\s\S]*?)-->/mg, "");
  for (var X = ""; c = la.exec(a); ) switch (c[3] = (X = c[3]).toLowerCase()) {
    case "data":
      if (X == "data") {
        if (c[1] === "/") {
          if ((o = f.pop())[0] !== c[3]) throw new Error("Bad state: " + o.join("|"));
        } else c[0].charAt(c[0].length - 2) !== "/" && f.push([c[3], !0]);
        break;
      }
      if (f[f.length - 1][1]) break;
      c[1] === "/" ? Bp(a.slice(F, c.index), A, g, f[f.length - 1][0] == /*"Comment"*/
      "comment" ? te : p, { c: C, r: _ }, P, fe[C], x, H, r) : (A = "", g = Ir(c[0]), F = c.index + c[0].length);
      break;
    case "cell":
      if (c[1] === "/")
        if (oe.length > 0 && (p.c = oe), (!r.sheetRows || r.sheetRows > _) && p.v !== void 0 && (r.dense ? (h[_] || (h[_] = []), h[_][C] = p) : h[je(C) + Qe(_)] = p), p.HRef && (p.l = { Target: we(p.HRef) }, p.HRefScreenTip && (p.l.Tooltip = p.HRefScreenTip), delete p.HRef, delete p.HRefScreenTip), (p.MergeAcross || p.MergeDown) && (S = C + (parseInt(p.MergeAcross, 10) | 0), U = _ + (parseInt(p.MergeDown, 10) | 0), D.push({ s: { c: C, r: _ }, e: { c: S, r: U } })), !r.sheetStubs)
          p.MergeAcross ? C = S + 1 : ++C;
        else if (p.MergeAcross || p.MergeDown) {
          for (var re = C; re <= S; ++re)
            for (var ie = _; ie <= U; ++ie)
              (re > C || ie > _) && (r.dense ? (h[ie] || (h[ie] = []), h[ie][re] = { t: "z" }) : h[je(re) + Qe(ie)] = { t: "z" });
          C = S + 1;
        } else ++C;
      else
        p = Np(c[0]), p.Index && (C = +p.Index - 1), C < I.s.c && (I.s.c = C), C > I.e.c && (I.e.c = C), c[0].slice(-2) === "/>" && ++C, oe = [];
      break;
    case "row":
      c[1] === "/" || c[0].slice(-2) === "/>" ? (_ < I.s.r && (I.s.r = _), _ > I.e.r && (I.e.r = _), c[0].slice(-2) === "/>" && (x = Ir(c[0]), x.Index && (_ = +x.Index - 1)), C = 0, ++_) : (x = Ir(c[0]), x.Index && (_ = +x.Index - 1), xe = {}, (x.AutoFitHeight == "0" || x.Height) && (xe.hpx = parseInt(x.Height, 10), xe.hpt = fc(xe.hpx), he[_] = xe), x.Hidden == "1" && (xe.hidden = !0, he[_] = xe));
      break;
    case "worksheet":
      if (c[1] === "/") {
        if ((o = f.pop())[0] !== c[3]) throw new Error("Bad state: " + o.join("|"));
        l.push(d), I.s.r <= I.e.r && I.s.c <= I.e.c && (h["!ref"] = Ee(I), r.sheetRows && r.sheetRows <= I.e.r && (h["!fullref"] = h["!ref"], I.e.r = r.sheetRows - 1, h["!ref"] = Ee(I))), D.length && (h["!merges"] = D), fe.length > 0 && (h["!cols"] = fe), he.length > 0 && (h["!rows"] = he), u[d] = h;
      } else
        I = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, _ = C = 0, f.push([c[3], !1]), o = Ir(c[0]), d = we(o.Name), h = r.dense ? [] : {}, D = [], H = [], he = [], R = { name: d, Hidden: 0 }, N.Sheets.push(R);
      break;
    case "table":
      if (c[1] === "/") {
        if ((o = f.pop())[0] !== c[3]) throw new Error("Bad state: " + o.join("|"));
      } else {
        if (c[0].slice(-2) == "/>") break;
        f.push([c[3], !1]), fe = [], Ce = !1;
      }
      break;
    case "style":
      c[1] === "/" ? Mp(P, O, r) : O = Ir(c[0]);
      break;
    case "numberformat":
      O.nf = we(Ir(c[0]).Format || "General"), sa[O.nf] && (O.nf = sa[O.nf]);
      for (var Q = 0; Q != 392 && ve[Q] != O.nf; ++Q) ;
      if (Q == 392) {
        for (Q = 57; Q != 392; ++Q) if (ve[Q] == null) {
          dt(O.nf, Q);
          break;
        }
      }
      break;
    case "column":
      if (f[f.length - 1][0] !== /*'Table'*/
      "table") break;
      if (ce = Ir(c[0]), ce.Hidden && (ce.hidden = !0, delete ce.Hidden), ce.Width && (ce.wpx = parseInt(ce.Width, 10)), !Ce && ce.wpx > 10) {
        Ce = !0, hr = sc;
        for (var Y = 0; Y < fe.length; ++Y) fe[Y] && Mt(fe[Y]);
      }
      Ce && Mt(ce), fe[ce.Index - 1 || fe.length] = ce;
      for (var Te = 0; Te < +ce.Span; ++Te) fe[fe.length] = qe(ce);
      break;
    case "namedrange":
      if (c[1] === "/") break;
      N.Names || (N.Names = []);
      var y = le(c[0]), Be = {
        Name: y.Name,
        Ref: Nt(y.RefersTo.slice(1), { r: 0, c: 0 })
      };
      N.Sheets.length > 0 && (Be.Sheet = N.Sheets.length - 1), N.Names.push(Be);
      break;
    case "namedcell":
      break;
    case "b":
      break;
    case "i":
      break;
    case "u":
      break;
    case "s":
      break;
    case "em":
      break;
    case "h2":
      break;
    case "h3":
      break;
    case "sub":
      break;
    case "sup":
      break;
    case "span":
      break;
    case "alignment":
      break;
    case "borders":
      break;
    case "border":
      break;
    case "font":
      if (c[0].slice(-2) === "/>") break;
      c[1] === "/" ? A += a.slice(V, c.index) : V = c.index + c[0].length;
      break;
    case "interior":
      if (!r.cellStyles) break;
      O.Interior = Ir(c[0]);
      break;
    case "protection":
      break;
    case "author":
    case "title":
    case "description":
    case "created":
    case "keywords":
    case "subject":
    case "category":
    case "company":
    case "lastauthor":
    case "lastsaved":
    case "lastprinted":
    case "version":
    case "revision":
    case "totaltime":
    case "hyperlinkbase":
    case "manager":
    case "contentstatus":
    case "identifier":
    case "language":
    case "appname":
      if (c[0].slice(-2) === "/>") break;
      c[1] === "/" ? Tu(G, X, a.slice(b, c.index)) : b = c.index + c[0].length;
      break;
    case "paragraphs":
      break;
    case "styles":
    case "workbook":
      if (c[1] === "/") {
        if ((o = f.pop())[0] !== c[3]) throw new Error("Bad state: " + o.join("|"));
      } else f.push([c[3], !1]);
      break;
    case "comment":
      if (c[1] === "/") {
        if ((o = f.pop())[0] !== c[3]) throw new Error("Bad state: " + o.join("|"));
        Up(te), oe.push(te);
      } else
        f.push([c[3], !1]), o = Ir(c[0]), te = { a: o.Author };
      break;
    case "autofilter":
      if (c[1] === "/") {
        if ((o = f.pop())[0] !== c[3]) throw new Error("Bad state: " + o.join("|"));
      } else if (c[0].charAt(c[0].length - 2) !== "/") {
        var Ae = Ir(c[0]);
        h["!autofilter"] = { ref: Nt(Ae.Range).replace(/\$/g, "") }, f.push([c[3], !0]);
      }
      break;
    case "name":
      break;
    case "datavalidation":
      if (c[1] === "/") {
        if ((o = f.pop())[0] !== c[3]) throw new Error("Bad state: " + o.join("|"));
      } else
        c[0].charAt(c[0].length - 2) !== "/" && f.push([c[3], !0]);
      break;
    case "pixelsperinch":
      break;
    case "componentoptions":
    case "documentproperties":
    case "customdocumentproperties":
    case "officedocumentsettings":
    case "pivottable":
    case "pivotcache":
    case "names":
    case "mapinfo":
    case "pagebreaks":
    case "querytable":
    case "sorting":
    case "schema":
    case "conditionalformatting":
    case "smarttagtype":
    case "smarttags":
    case "excelworkbook":
    case "workbookoptions":
    case "worksheetoptions":
      if (c[1] === "/") {
        if ((o = f.pop())[0] !== c[3]) throw new Error("Bad state: " + o.join("|"));
      } else c[0].charAt(c[0].length - 2) !== "/" && f.push([c[3], !0]);
      break;
    case "null":
      break;
    default:
      if (f.length == 0 && c[3] == "document" || f.length == 0 && c[3] == "uof") return yi(a, r);
      var Se = !0;
      switch (f[f.length - 1][0]) {
        case "officedocumentsettings":
          switch (c[3]) {
            case "allowpng":
              break;
            case "removepersonalinformation":
              break;
            case "downloadcomponents":
              break;
            case "locationofcomponents":
              break;
            case "colors":
              break;
            case "color":
              break;
            case "index":
              break;
            case "rgb":
              break;
            case "targetscreensize":
              break;
            case "readonlyrecommended":
              break;
            default:
              Se = !1;
          }
          break;
        case "componentoptions":
          switch (c[3]) {
            case "toolbar":
              break;
            case "hideofficelogo":
              break;
            case "spreadsheetautofit":
              break;
            case "label":
              break;
            case "caption":
              break;
            case "maxheight":
              break;
            case "maxwidth":
              break;
            case "nextsheetnumber":
              break;
            default:
              Se = !1;
          }
          break;
        case "excelworkbook":
          switch (c[3]) {
            case "date1904":
              N.WBProps.date1904 = !0;
              break;
            case "windowheight":
              break;
            case "windowwidth":
              break;
            case "windowtopx":
              break;
            case "windowtopy":
              break;
            case "tabratio":
              break;
            case "protectstructure":
              break;
            case "protectwindow":
              break;
            case "protectwindows":
              break;
            case "activesheet":
              break;
            case "displayinknotes":
              break;
            case "firstvisiblesheet":
              break;
            case "supbook":
              break;
            case "sheetname":
              break;
            case "sheetindex":
              break;
            case "sheetindexfirst":
              break;
            case "sheetindexlast":
              break;
            case "dll":
              break;
            case "acceptlabelsinformulas":
              break;
            case "donotsavelinkvalues":
              break;
            case "iteration":
              break;
            case "maxiterations":
              break;
            case "maxchange":
              break;
            case "path":
              break;
            case "xct":
              break;
            case "count":
              break;
            case "selectedsheets":
              break;
            case "calculation":
              break;
            case "uncalced":
              break;
            case "startupprompt":
              break;
            case "crn":
              break;
            case "externname":
              break;
            case "formula":
              break;
            case "colfirst":
              break;
            case "collast":
              break;
            case "wantadvise":
              break;
            case "boolean":
              break;
            case "error":
              break;
            case "text":
              break;
            case "ole":
              break;
            case "noautorecover":
              break;
            case "publishobjects":
              break;
            case "donotcalculatebeforesave":
              break;
            case "number":
              break;
            case "refmoder1c1":
              break;
            case "embedsavesmarttags":
              break;
            default:
              Se = !1;
          }
          break;
        case "workbookoptions":
          switch (c[3]) {
            case "owcversion":
              break;
            case "height":
              break;
            case "width":
              break;
            default:
              Se = !1;
          }
          break;
        case "worksheetoptions":
          switch (c[3]) {
            case "visible":
              if (c[0].slice(-2) !== "/>") if (c[1] === "/") switch (a.slice(b, c.index)) {
                case "SheetHidden":
                  R.Hidden = 1;
                  break;
                case "SheetVeryHidden":
                  R.Hidden = 2;
                  break;
              }
              else b = c.index + c[0].length;
              break;
            case "header":
              h["!margins"] || ia(h["!margins"] = {}, "xlml"), isNaN(+le(c[0]).Margin) || (h["!margins"].header = +le(c[0]).Margin);
              break;
            case "footer":
              h["!margins"] || ia(h["!margins"] = {}, "xlml"), isNaN(+le(c[0]).Margin) || (h["!margins"].footer = +le(c[0]).Margin);
              break;
            case "pagemargins":
              var me = le(c[0]);
              h["!margins"] || ia(h["!margins"] = {}, "xlml"), isNaN(+me.Top) || (h["!margins"].top = +me.Top), isNaN(+me.Left) || (h["!margins"].left = +me.Left), isNaN(+me.Right) || (h["!margins"].right = +me.Right), isNaN(+me.Bottom) || (h["!margins"].bottom = +me.Bottom);
              break;
            case "displayrighttoleft":
              N.Views || (N.Views = []), N.Views[0] || (N.Views[0] = {}), N.Views[0].RTL = !0;
              break;
            case "freezepanes":
              break;
            case "frozennosplit":
              break;
            case "splithorizontal":
            case "splitvertical":
              break;
            case "donotdisplaygridlines":
              break;
            case "activerow":
              break;
            case "activecol":
              break;
            case "toprowbottompane":
              break;
            case "leftcolumnrightpane":
              break;
            case "unsynced":
              break;
            case "print":
              break;
            case "printerrors":
              break;
            case "panes":
              break;
            case "scale":
              break;
            case "pane":
              break;
            case "number":
              break;
            case "layout":
              break;
            case "pagesetup":
              break;
            case "selected":
              break;
            case "protectobjects":
              break;
            case "enableselection":
              break;
            case "protectscenarios":
              break;
            case "validprinterinfo":
              break;
            case "horizontalresolution":
              break;
            case "verticalresolution":
              break;
            case "numberofcopies":
              break;
            case "activepane":
              break;
            case "toprowvisible":
              break;
            case "leftcolumnvisible":
              break;
            case "fittopage":
              break;
            case "rangeselection":
              break;
            case "papersizeindex":
              break;
            case "pagelayoutzoom":
              break;
            case "pagebreakzoom":
              break;
            case "filteron":
              break;
            case "fitwidth":
              break;
            case "fitheight":
              break;
            case "commentslayout":
              break;
            case "zoom":
              break;
            case "lefttoright":
              break;
            case "gridlines":
              break;
            case "allowsort":
              break;
            case "allowfilter":
              break;
            case "allowinsertrows":
              break;
            case "allowdeleterows":
              break;
            case "allowinsertcols":
              break;
            case "allowdeletecols":
              break;
            case "allowinserthyperlinks":
              break;
            case "allowformatcells":
              break;
            case "allowsizecols":
              break;
            case "allowsizerows":
              break;
            case "nosummaryrowsbelowdetail":
              h["!outline"] || (h["!outline"] = {}), h["!outline"].above = !0;
              break;
            case "tabcolorindex":
              break;
            case "donotdisplayheadings":
              break;
            case "showpagelayoutzoom":
              break;
            case "nosummarycolumnsrightdetail":
              h["!outline"] || (h["!outline"] = {}), h["!outline"].left = !0;
              break;
            case "blackandwhite":
              break;
            case "donotdisplayzeros":
              break;
            case "displaypagebreak":
              break;
            case "rowcolheadings":
              break;
            case "donotdisplayoutline":
              break;
            case "noorientation":
              break;
            case "allowusepivottables":
              break;
            case "zeroheight":
              break;
            case "viewablerange":
              break;
            case "selection":
              break;
            case "protectcontents":
              break;
            default:
              Se = !1;
          }
          break;
        case "pivottable":
        case "pivotcache":
          switch (c[3]) {
            case "immediateitemsondrop":
              break;
            case "showpagemultipleitemlabel":
              break;
            case "compactrowindent":
              break;
            case "location":
              break;
            case "pivotfield":
              break;
            case "orientation":
              break;
            case "layoutform":
              break;
            case "layoutsubtotallocation":
              break;
            case "layoutcompactrow":
              break;
            case "position":
              break;
            case "pivotitem":
              break;
            case "datatype":
              break;
            case "datafield":
              break;
            case "sourcename":
              break;
            case "parentfield":
              break;
            case "ptlineitems":
              break;
            case "ptlineitem":
              break;
            case "countofsameitems":
              break;
            case "item":
              break;
            case "itemtype":
              break;
            case "ptsource":
              break;
            case "cacheindex":
              break;
            case "consolidationreference":
              break;
            case "filename":
              break;
            case "reference":
              break;
            case "nocolumngrand":
              break;
            case "norowgrand":
              break;
            case "blanklineafteritems":
              break;
            case "hidden":
              break;
            case "subtotal":
              break;
            case "basefield":
              break;
            case "mapchilditems":
              break;
            case "function":
              break;
            case "refreshonfileopen":
              break;
            case "printsettitles":
              break;
            case "mergelabels":
              break;
            case "defaultversion":
              break;
            case "refreshname":
              break;
            case "refreshdate":
              break;
            case "refreshdatecopy":
              break;
            case "versionlastrefresh":
              break;
            case "versionlastupdate":
              break;
            case "versionupdateablemin":
              break;
            case "versionrefreshablemin":
              break;
            case "calculation":
              break;
            default:
              Se = !1;
          }
          break;
        case "pagebreaks":
          switch (c[3]) {
            case "colbreaks":
              break;
            case "colbreak":
              break;
            case "rowbreaks":
              break;
            case "rowbreak":
              break;
            case "colstart":
              break;
            case "colend":
              break;
            case "rowend":
              break;
            default:
              Se = !1;
          }
          break;
        case "autofilter":
          switch (c[3]) {
            case "autofiltercolumn":
              break;
            case "autofiltercondition":
              break;
            case "autofilterand":
              break;
            case "autofilteror":
              break;
            default:
              Se = !1;
          }
          break;
        case "querytable":
          switch (c[3]) {
            case "id":
              break;
            case "autoformatfont":
              break;
            case "autoformatpattern":
              break;
            case "querysource":
              break;
            case "querytype":
              break;
            case "enableredirections":
              break;
            case "refreshedinxl9":
              break;
            case "urlstring":
              break;
            case "htmltables":
              break;
            case "connection":
              break;
            case "commandtext":
              break;
            case "refreshinfo":
              break;
            case "notitles":
              break;
            case "nextid":
              break;
            case "columninfo":
              break;
            case "overwritecells":
              break;
            case "donotpromptforfile":
              break;
            case "textwizardsettings":
              break;
            case "source":
              break;
            case "number":
              break;
            case "decimal":
              break;
            case "thousandseparator":
              break;
            case "trailingminusnumbers":
              break;
            case "formatsettings":
              break;
            case "fieldtype":
              break;
            case "delimiters":
              break;
            case "tab":
              break;
            case "comma":
              break;
            case "autoformatname":
              break;
            case "versionlastedit":
              break;
            case "versionlastrefresh":
              break;
            default:
              Se = !1;
          }
          break;
        case "datavalidation":
          switch (c[3]) {
            case "range":
              break;
            case "type":
              break;
            case "min":
              break;
            case "max":
              break;
            case "sort":
              break;
            case "descending":
              break;
            case "order":
              break;
            case "casesensitive":
              break;
            case "value":
              break;
            case "errorstyle":
              break;
            case "errormessage":
              break;
            case "errortitle":
              break;
            case "inputmessage":
              break;
            case "inputtitle":
              break;
            case "combohide":
              break;
            case "inputhide":
              break;
            case "condition":
              break;
            case "qualifier":
              break;
            case "useblank":
              break;
            case "value1":
              break;
            case "value2":
              break;
            case "format":
              break;
            case "cellrangelist":
              break;
            default:
              Se = !1;
          }
          break;
        case "sorting":
        case "conditionalformatting":
          switch (c[3]) {
            case "range":
              break;
            case "type":
              break;
            case "min":
              break;
            case "max":
              break;
            case "sort":
              break;
            case "descending":
              break;
            case "order":
              break;
            case "casesensitive":
              break;
            case "value":
              break;
            case "errorstyle":
              break;
            case "errormessage":
              break;
            case "errortitle":
              break;
            case "cellrangelist":
              break;
            case "inputmessage":
              break;
            case "inputtitle":
              break;
            case "combohide":
              break;
            case "inputhide":
              break;
            case "condition":
              break;
            case "qualifier":
              break;
            case "useblank":
              break;
            case "value1":
              break;
            case "value2":
              break;
            case "format":
              break;
            default:
              Se = !1;
          }
          break;
        case "mapinfo":
        case "schema":
        case "data":
          switch (c[3]) {
            case "map":
              break;
            case "entry":
              break;
            case "range":
              break;
            case "xpath":
              break;
            case "field":
              break;
            case "xsdtype":
              break;
            case "filteron":
              break;
            case "aggregate":
              break;
            case "elementtype":
              break;
            case "attributetype":
              break;
            case "schema":
            case "element":
            case "complextype":
            case "datatype":
            case "all":
            case "attribute":
            case "extends":
              break;
            case "row":
              break;
            default:
              Se = !1;
          }
          break;
        case "smarttags":
          break;
        default:
          Se = !1;
          break;
      }
      if (Se || c[3].match(/!\[CDATA/)) break;
      if (!f[f.length - 1][1]) throw "Unrecognized tag: " + c[3] + "|" + f.join("|");
      if (f[f.length - 1][0] === /*'CustomDocumentProperties'*/
      "customdocumentproperties") {
        if (c[0].slice(-2) === "/>") break;
        c[1] === "/" ? Pp(W, X, J, a.slice(b, c.index)) : (J = c, b = c.index + c[0].length);
        break;
      }
      if (r.WTF) throw "Unrecognized tag: " + c[3] + "|" + f.join("|");
  }
  var ae = {};
  return !r.bookSheets && !r.bookProps && (ae.Sheets = u), ae.SheetNames = l, ae.Workbook = N, ae.SSF = qe(ve), ae.Props = G, ae.Custprops = W, ae;
}
function bn(e, t) {
  switch (h0(t = t || {}), t.type || "base64") {
    case "base64":
      return Fn(Er(e), t);
    case "binary":
    case "buffer":
    case "file":
      return Fn(e, t);
    case "array":
      return Fn(Tt(e), t);
  }
}
function zp(e) {
  var t = {}, r = e.content;
  if (r.l = 28, t.AnsiUserType = r.read_shift(0, "lpstr-ansi"), t.AnsiClipboardFormat = eu(r), r.length - r.l <= 4) return t;
  var a = r.read_shift(4);
  if (a == 0 || a > 40 || (r.l -= 4, t.Reserved1 = r.read_shift(0, "lpstr-ansi"), r.length - r.l <= 4) || (a = r.read_shift(4), a !== 1907505652) || (t.UnicodeClipboardFormat = ru(r), a = r.read_shift(4), a == 0 || a > 40)) return t;
  r.l -= 4, t.Reserved2 = r.read_shift(0, "lpwstr");
}
var $p = [60, 1084, 2066, 2165, 2175];
function Vp(e, t, r, a, n) {
  var i = a, s = [], c = r.slice(r.l, r.l + i);
  if (n && n.enc && n.enc.insitu && c.length > 0) switch (e) {
    case 9:
    case 521:
    case 1033:
    case 2057:
    case 47:
    case 405:
    case 225:
    case 406:
    case 312:
    case 404:
    case 10:
      break;
    case 133:
      break;
    default:
      n.enc.insitu(c);
  }
  s.push(c), r.l += i;
  for (var f = jr(r, r.l), o = Pn[f], u = 0; o != null && $p.indexOf(f) > -1; )
    i = jr(r, r.l + 2), u = r.l + 4, f == 2066 ? u += 4 : (f == 2165 || f == 2175) && (u += 12), c = r.slice(u, r.l + 4 + i), s.push(c), r.l += 4 + i, o = Pn[f = jr(r, r.l)];
  var l = rt(s);
  Je(l, 0);
  var h = 0;
  l.lens = [];
  for (var d = 0; d < s.length; ++d)
    l.lens.push(h), h += s[d].length;
  if (l.length < a) throw "XLS Record 0x" + e.toString(16) + " Truncated: " + l.length + " < " + a;
  return t.f(l, l.length, n);
}
function Ur(e, t, r) {
  if (e.t !== "z" && e.XF) {
    var a = 0;
    try {
      a = e.z || e.XF.numFmtId || 0, t.cellNF && (e.z = ve[a]);
    } catch (i) {
      if (t.WTF) throw i;
    }
    if (!t || t.cellText !== !1) try {
      e.t === "e" ? e.w = e.w || Ft[e.v] : a === 0 || a == "General" ? e.t === "n" ? (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = oa(e.v) : e.w = vt(e.v) : e.w = yr(a, e.v, { date1904: !!r, dateNF: t && t.dateNF });
    } catch (i) {
      if (t.WTF) throw i;
    }
    if (t.cellDates && a && e.t == "n" && Bt(ve[a] || String(a))) {
      var n = xt(e.v);
      n && (e.t = "d", e.v = new Date(n.y, n.m - 1, n.d, n.H, n.M, n.S, n.u));
    }
  }
}
function La(e, t, r) {
  return { v: e, ixfe: t, t: r };
}
function Hp(e, t) {
  var r = { opts: {} }, a = {}, n = t.dense ? [] : {}, i = {}, s = {}, c = null, f = [], o = "", u = {}, l, h = "", d, p, x, g, F = {}, C = [], _, I, P = [], O = [], A = { Sheets: [], WBProps: { date1904: !1 }, Views: [{}] }, V = {}, D = function(ge) {
    return ge < 8 ? pt[ge] : ge < 64 && O[ge - 8] || pt[ge];
  }, G = function(ge, ze, wr) {
    var Ze = ze.XF.data;
    if (!(!Ze || !Ze.patternType || !wr || !wr.cellStyles)) {
      ze.s = {}, ze.s.patternType = Ze.patternType;
      var ut;
      (ut = xa(D(Ze.icvFore))) && (ze.s.fgColor = { rgb: ut }), (ut = xa(D(Ze.icvBack))) && (ze.s.bgColor = { rgb: ut });
    }
  }, W = function(ge, ze, wr) {
    if (!(xe > 1) && !(wr.sheetRows && ge.r >= wr.sheetRows)) {
      if (wr.cellStyles && ze.XF && ze.XF.data && G(ge, ze, wr), delete ze.ixfe, delete ze.XF, l = ge, h = de(ge), (!s || !s.s || !s.e) && (s = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }), ge.r < s.s.r && (s.s.r = ge.r), ge.c < s.s.c && (s.s.c = ge.c), ge.r + 1 > s.e.r && (s.e.r = ge.r + 1), ge.c + 1 > s.e.c && (s.e.c = ge.c + 1), wr.cellFormula && ze.f) {
        for (var Ze = 0; Ze < C.length; ++Ze)
          if (!(C[Ze][0].s.c > ge.c || C[Ze][0].s.r > ge.r) && !(C[Ze][0].e.c < ge.c || C[Ze][0].e.r < ge.r)) {
            ze.F = Ee(C[Ze][0]), (C[Ze][0].s.c != ge.c || C[Ze][0].s.r != ge.r) && delete ze.f, ze.f && (ze.f = "" + ar(C[Ze][1], s, ge, H, b));
            break;
          }
      }
      wr.dense ? (n[ge.r] || (n[ge.r] = []), n[ge.r][ge.c] = ze) : n[h] = ze;
    }
  }, b = {
    enc: !1,
    // encrypted
    sbcch: 0,
    // cch in the preceding SupBook
    snames: [],
    // sheetnames
    sharedf: F,
    // shared formulae by address
    arrayf: C,
    // array formulae array
    rrtabid: [],
    // RRTabId
    lastuser: "",
    // Last User from WriteAccess
    biff: 8,
    // BIFF version
    codepage: 0,
    // CP from CodePage record
    winlocked: 0,
    // fLockWn from WinProtect
    cellStyles: !!t && !!t.cellStyles,
    WTF: !!t && !!t.wtf
  };
  t.password && (b.password = t.password);
  var J, oe = [], te = [], fe = [], ce = [], Ce = !1, H = [];
  H.SheetNames = b.snames, H.sharedf = b.sharedf, H.arrayf = b.arrayf, H.names = [], H.XTI = [];
  var he = 0, xe = 0, S = 0, U = [], N = [], R;
  b.codepage = 1200, Nr(1200);
  for (var X = !1; e.l < e.length - 1; ) {
    var re = e.l, ie = e.read_shift(2);
    if (ie === 0 && he === 10) break;
    var Q = e.l === e.length ? 0 : e.read_shift(2), Y = Pn[ie];
    if (Y && Y.f) {
      if (t.bookSheets && he === 133 && ie !== 133)
        break;
      if (he = ie, Y.r === 2 || Y.r == 12) {
        var Te = e.read_shift(2);
        if (Q -= 2, !b.enc && Te !== ie && ((Te & 255) << 8 | Te >> 8) !== ie) throw new Error("rt mismatch: " + Te + "!=" + ie);
        Y.r == 12 && (e.l += 10, Q -= 10);
      }
      var y = {};
      if (ie === 10 ? y = /*::(*/
      Y.f(e, Q, b) : y = /*::(*/
      Vp(ie, Y, e, Q, b), xe == 0 && [9, 521, 1033, 2057].indexOf(he) === -1) continue;
      switch (ie) {
        case 34:
          r.opts.Date1904 = A.WBProps.date1904 = y;
          break;
        case 134:
          r.opts.WriteProtect = !0;
          break;
        case 47:
          if (b.enc || (e.l = 0), b.enc = y, !t.password) throw new Error("File is password-protected");
          if (y.valid == null) throw new Error("Encryption scheme unsupported");
          if (!y.valid) throw new Error("Password is incorrect");
          break;
        case 92:
          b.lastuser = y;
          break;
        case 66:
          var Be = Number(y);
          switch (Be) {
            case 21010:
              Be = 1200;
              break;
            case 32768:
              Be = 1e4;
              break;
            case 32769:
              Be = 1252;
              break;
          }
          Nr(b.codepage = Be), X = !0;
          break;
        case 317:
          b.rrtabid = y;
          break;
        case 25:
          b.winlocked = y;
          break;
        case 439:
          r.opts.RefreshAll = y;
          break;
        case 12:
          r.opts.CalcCount = y;
          break;
        case 16:
          r.opts.CalcDelta = y;
          break;
        case 17:
          r.opts.CalcIter = y;
          break;
        case 13:
          r.opts.CalcMode = y;
          break;
        case 14:
          r.opts.CalcPrecision = y;
          break;
        case 95:
          r.opts.CalcSaveRecalc = y;
          break;
        case 15:
          b.CalcRefMode = y;
          break;
        case 2211:
          r.opts.FullCalc = y;
          break;
        case 129:
          y.fDialog && (n["!type"] = "dialog"), y.fBelow || ((n["!outline"] || (n["!outline"] = {})).above = !0), y.fRight || ((n["!outline"] || (n["!outline"] = {})).left = !0);
          break;
        case 224:
          P.push(y);
          break;
        case 430:
          H.push([y]), H[H.length - 1].XTI = [];
          break;
        case 35:
        case 547:
          H[H.length - 1].push(y);
          break;
        case 24:
        case 536:
          R = {
            Name: y.Name,
            Ref: ar(y.rgce, s, null, H, b)
          }, y.itab > 0 && (R.Sheet = y.itab - 1), H.names.push(R), H[0] || (H[0] = [], H[0].XTI = []), H[H.length - 1].push(y), y.Name == "_xlnm._FilterDatabase" && y.itab > 0 && y.rgce && y.rgce[0] && y.rgce[0][0] && y.rgce[0][0][0] == "PtgArea3d" && (N[y.itab - 1] = { ref: Ee(y.rgce[0][0][1][2]) });
          break;
        case 22:
          b.ExternCount = y;
          break;
        case 23:
          H.length == 0 && (H[0] = [], H[0].XTI = []), H[H.length - 1].XTI = H[H.length - 1].XTI.concat(y), H.XTI = H.XTI.concat(y);
          break;
        case 2196:
          if (b.biff < 8) break;
          R != null && (R.Comment = y[1]);
          break;
        case 18:
          n["!protect"] = y;
          break;
        case 19:
          y !== 0 && b.WTF && console.error("Password verifier: " + y);
          break;
        case 133:
          i[y.pos] = y, b.snames.push(y.name);
          break;
        case 10:
          {
            if (--xe) break;
            if (s.e) {
              if (s.e.r > 0 && s.e.c > 0) {
                if (s.e.r--, s.e.c--, n["!ref"] = Ee(s), t.sheetRows && t.sheetRows <= s.e.r) {
                  var Ae = s.e.r;
                  s.e.r = t.sheetRows - 1, n["!fullref"] = n["!ref"], n["!ref"] = Ee(s), s.e.r = Ae;
                }
                s.e.r++, s.e.c++;
              }
              oe.length > 0 && (n["!merges"] = oe), te.length > 0 && (n["!objects"] = te), fe.length > 0 && (n["!cols"] = fe), ce.length > 0 && (n["!rows"] = ce), A.Sheets.push(V);
            }
            o === "" ? u = n : a[o] = n, n = t.dense ? [] : {};
          }
          break;
        case 9:
        case 521:
        case 1033:
        case 2057:
          {
            if (b.biff === 8 && (b.biff = {
              /*::[*/
              9: 2,
              /*::[*/
              521: 3,
              /*::[*/
              1033: 4
            }[ie] || {
              /*::[*/
              512: 2,
              /*::[*/
              768: 3,
              /*::[*/
              1024: 4,
              /*::[*/
              1280: 5,
              /*::[*/
              1536: 8,
              /*::[*/
              2: 2,
              /*::[*/
              7: 2
            }[y.BIFFVer] || 8), b.biffguess = y.BIFFVer == 0, y.BIFFVer == 0 && y.dt == 4096 && (b.biff = 5, X = !0, Nr(b.codepage = 28591)), b.biff == 8 && y.BIFFVer == 0 && y.dt == 16 && (b.biff = 2), xe++) break;
            if (n = t.dense ? [] : {}, b.biff < 8 && !X && (X = !0, Nr(b.codepage = t.codepage || 1252)), b.biff < 5 || y.BIFFVer == 0 && y.dt == 4096) {
              o === "" && (o = "Sheet1"), s = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
              var Se = { pos: e.l - Q, name: o };
              i[Se.pos] = Se, b.snames.push(o);
            } else o = (i[re] || { name: "" }).name;
            y.dt == 32 && (n["!type"] = "chart"), y.dt == 64 && (n["!type"] = "macro"), oe = [], te = [], b.arrayf = C = [], fe = [], ce = [], Ce = !1, V = { Hidden: (i[re] || { hs: 0 }).hs, name: o };
          }
          break;
        case 515:
        case 3:
        case 2:
          n["!type"] == "chart" && (t.dense ? (n[y.r] || [])[y.c] : n[de({ c: y.c, r: y.r })]) && ++y.c, _ = { ixfe: y.ixfe, XF: P[y.ixfe] || {}, v: y.val, t: "n" }, S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W({ c: y.c, r: y.r }, _, t);
          break;
        case 5:
        case 517:
          _ = { ixfe: y.ixfe, XF: P[y.ixfe], v: y.val, t: y.t }, S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W({ c: y.c, r: y.r }, _, t);
          break;
        case 638:
          _ = { ixfe: y.ixfe, XF: P[y.ixfe], v: y.rknum, t: "n" }, S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W({ c: y.c, r: y.r }, _, t);
          break;
        case 189:
          for (var me = y.c; me <= y.C; ++me) {
            var ae = y.rkrec[me - y.c][0];
            _ = { ixfe: ae, XF: P[ae], v: y.rkrec[me - y.c][1], t: "n" }, S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W({ c: me, r: y.r }, _, t);
          }
          break;
        case 6:
        case 518:
        case 1030:
          {
            if (y.val == "String") {
              c = y;
              break;
            }
            if (_ = La(y.val, y.cell.ixfe, y.tt), _.XF = P[_.ixfe], t.cellFormula) {
              var Ue = y.formula;
              if (Ue && Ue[0] && Ue[0][0] && Ue[0][0][0] == "PtgExp") {
                var Tr = Ue[0][0][1][0], Mr = Ue[0][0][1][1], Wr = de({ r: Tr, c: Mr });
                F[Wr] ? _.f = "" + ar(y.formula, s, y.cell, H, b) : _.F = ((t.dense ? (n[Tr] || [])[Mr] : n[Wr]) || {}).F;
              } else _.f = "" + ar(y.formula, s, y.cell, H, b);
            }
            S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W(y.cell, _, t), c = y;
          }
          break;
        case 7:
        case 519:
          if (c)
            c.val = y, _ = La(y, c.cell.ixfe, "s"), _.XF = P[_.ixfe], t.cellFormula && (_.f = "" + ar(c.formula, s, c.cell, H, b)), S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W(c.cell, _, t), c = null;
          else throw new Error("String record expects Formula");
          break;
        case 33:
        case 545:
          {
            C.push(y);
            var Vt = de(y[0].s);
            if (d = t.dense ? (n[y[0].s.r] || [])[y[0].s.c] : n[Vt], t.cellFormula && d) {
              if (!c || !Vt || !d) break;
              d.f = "" + ar(y[1], s, y[0], H, b), d.F = Ee(y[0]);
            }
          }
          break;
        case 1212:
          {
            if (!t.cellFormula) break;
            if (h) {
              if (!c) break;
              F[de(c.cell)] = y[0], d = t.dense ? (n[c.cell.r] || [])[c.cell.c] : n[de(c.cell)], (d || {}).f = "" + ar(y[0], s, l, H, b);
            }
          }
          break;
        case 253:
          _ = La(f[y.isst].t, y.ixfe, "s"), f[y.isst].h && (_.h = f[y.isst].h), _.XF = P[_.ixfe], S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W({ c: y.c, r: y.r }, _, t);
          break;
        case 513:
          t.sheetStubs && (_ = { ixfe: y.ixfe, XF: P[y.ixfe], t: "z" }, S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W({ c: y.c, r: y.r }, _, t));
          break;
        case 190:
          if (t.sheetStubs)
            for (var qr = y.c; qr <= y.C; ++qr) {
              var mr = y.ixfe[qr - y.c];
              _ = { ixfe: mr, XF: P[mr], t: "z" }, S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W({ c: qr, r: y.r }, _, t);
            }
          break;
        case 214:
        case 516:
        case 4:
          _ = La(y.val, y.ixfe, "s"), _.XF = P[_.ixfe], S > 0 && (_.z = U[_.ixfe >> 8 & 63]), Ur(_, t, r.opts.Date1904), W({ c: y.c, r: y.r }, _, t);
          break;
        case 0:
        case 512:
          xe === 1 && (s = y);
          break;
        case 252:
          f = y;
          break;
        case 1054:
          if (b.biff == 4) {
            U[S++] = y[1];
            for (var Zr = 0; Zr < S + 163 && ve[Zr] != y[1]; ++Zr) ;
            Zr >= 163 && dt(y[1], S + 163);
          } else dt(y[1], y[0]);
          break;
        case 30:
          {
            U[S++] = y;
            for (var Qr = 0; Qr < S + 163 && ve[Qr] != y; ++Qr) ;
            Qr >= 163 && dt(y, S + 163);
          }
          break;
        case 229:
          oe = oe.concat(y);
          break;
        case 93:
          te[y.cmo[0]] = b.lastobj = y;
          break;
        case 438:
          b.lastobj.TxO = y;
          break;
        case 127:
          b.lastobj.ImData = y;
          break;
        case 440:
          for (g = y[0].s.r; g <= y[0].e.r; ++g)
            for (x = y[0].s.c; x <= y[0].e.c; ++x)
              d = t.dense ? (n[g] || [])[x] : n[de({ c: x, r: g })], d && (d.l = y[1]);
          break;
        case 2048:
          for (g = y[0].s.r; g <= y[0].e.r; ++g)
            for (x = y[0].s.c; x <= y[0].e.c; ++x)
              d = t.dense ? (n[g] || [])[x] : n[de({ c: x, r: g })], d && d.l && (d.l.Tooltip = y[1]);
          break;
        case 28:
          {
            if (b.biff <= 5 && b.biff >= 2) break;
            d = t.dense ? (n[y[0].r] || [])[y[0].c] : n[de(y[0])];
            var Ht = te[y[2]];
            d || (t.dense ? (n[y[0].r] || (n[y[0].r] = []), d = n[y[0].r][y[0].c] = { t: "z" }) : d = n[de(y[0])] = { t: "z" }, s.e.r = Math.max(s.e.r, y[0].r), s.s.r = Math.min(s.s.r, y[0].r), s.e.c = Math.max(s.e.c, y[0].c), s.s.c = Math.min(s.s.c, y[0].c)), d.c || (d.c = []), p = { a: y[1], t: Ht.TxO.t }, d.c.push(p);
          }
          break;
        case 2173:
          l1(P[y.ixfe], y.ext);
          break;
        case 125:
          {
            if (!b.cellStyles) break;
            for (; y.e >= y.s; )
              fe[y.e--] = { width: y.w / 256, level: y.level || 0, hidden: !!(y.flags & 1) }, Ce || (Ce = !0, c0(y.w / 256)), Mt(fe[y.e + 1]);
          }
          break;
        case 520:
          {
            var or = {};
            y.level != null && (ce[y.r] = or, or.level = y.level), y.hidden && (ce[y.r] = or, or.hidden = !0), y.hpt && (ce[y.r] = or, or.hpt = y.hpt, or.hpx = da(y.hpt));
          }
          break;
        case 38:
        case 39:
        case 40:
        case 41:
          n["!margins"] || ia(n["!margins"] = {}), n["!margins"][{ 38: "left", 39: "right", 40: "top", 41: "bottom" }[ie]] = y;
          break;
        case 161:
          n["!margins"] || ia(n["!margins"] = {}), n["!margins"].header = y.header, n["!margins"].footer = y.footer;
          break;
        case 574:
          y.RTL && (A.Views[0].RTL = !0);
          break;
        case 146:
          O = y;
          break;
        case 2198:
          J = y;
          break;
        case 140:
          I = y;
          break;
        case 442:
          o ? V.CodeName = y || V.name : A.WBProps.CodeName = y || "ThisWorkbook";
          break;
      }
    } else
      Y || console.error("Missing Info for XLS Record 0x" + ie.toString(16)), e.l += Q;
  }
  return r.SheetNames = $r(i).sort(function(Br, ge) {
    return Number(Br) - Number(ge);
  }).map(function(Br) {
    return i[Br].name;
  }), t.bookSheets || (r.Sheets = a), !r.SheetNames.length && u["!ref"] ? (r.SheetNames.push("Sheet1"), r.Sheets && (r.Sheets.Sheet1 = u)) : r.Preamble = u, r.Sheets && N.forEach(function(Br, ge) {
    r.Sheets[r.SheetNames[ge]]["!autofilter"] = Br;
  }), r.Strings = f, r.SSF = qe(ve), b.enc && (r.Encryption = b.enc), J && (r.Themes = J), r.Metadata = {}, I !== void 0 && (r.Metadata.Country = I), H.names.length > 0 && (A.Names = H.names), r.Workbook = A, r;
}
var Ti = {
  SI: "e0859ff2f94f6810ab9108002b27b3d9",
  DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
  UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function Wp(e, t, r) {
  var a = ke.find(e, "/!DocumentSummaryInformation");
  if (a && a.size > 0) try {
    var n = ii(a, cu, Ti.DSI);
    for (var i in n) t[i] = n[i];
  } catch (o) {
    if (r.WTF) throw o;
  }
  var s = ke.find(e, "/!SummaryInformation");
  if (s && s.size > 0) try {
    var c = ii(s, fu, Ti.SI);
    for (var f in c) t[f] == null && (t[f] = c[f]);
  } catch (o) {
    if (r.WTF) throw o;
  }
  t.HeadingPairs && t.TitlesOfParts && (Hs(t.HeadingPairs, t.TitlesOfParts, t, r), delete t.HeadingPairs, delete t.TitlesOfParts);
}
function Sc(e, t) {
  t || (t = {}), h0(t), rs(), t.codepage && Wn(t.codepage);
  var r, a;
  if (e.FullPaths) {
    if (ke.find(e, "/encryption")) throw new Error("File is password-protected");
    r = ke.find(e, "!CompObj"), a = ke.find(e, "/Workbook") || ke.find(e, "/Book");
  } else {
    switch (t.type) {
      case "base64":
        e = Rr(Er(e));
        break;
      case "binary":
        e = Rr(e);
        break;
      case "buffer":
        break;
      case "array":
        Array.isArray(e) || (e = Array.prototype.slice.call(e));
        break;
    }
    Je(e, 0), a = { content: e };
  }
  var n, i;
  if (r && zp(r), t.bookProps && !t.bookSheets) n = {};
  else {
    var s = _e ? "buffer" : "array";
    if (a && a.content) n = Hp(a.content, t);
    else if ((i = ke.find(e, "PerfectOffice_MAIN")) && i.content) n = aa.to_workbook(i.content, (t.type = s, t));
    else if ((i = ke.find(e, "NativeContent_MAIN")) && i.content) n = aa.to_workbook(i.content, (t.type = s, t));
    else throw (i = ke.find(e, "MN0")) && i.content ? new Error("Unsupported Works 4 for Mac file") : new Error("Cannot find Workbook stream");
    t.bookVBA && e.FullPaths && ke.find(e, "/_VBA_PROJECT_CUR/VBA/dir") && (n.vbaraw = O1(e));
  }
  var c = {};
  return e.FullPaths && Wp(
    /*::((*/
    e,
    c,
    t
  ), n.Props = n.Custprops = c, t.bookFiles && (n.cfb = e), n;
}
var en = {
  /*::[*/
  0: {
    /* n:"BrtRowHdr", */
    f: Fd
  },
  /*::[*/
  1: {
    /* n:"BrtCellBlank", */
    f: Od
  },
  /*::[*/
  2: {
    /* n:"BrtCellRk", */
    f: Bd
  },
  /*::[*/
  3: {
    /* n:"BrtCellError", */
    f: Nd
  },
  /*::[*/
  4: {
    /* n:"BrtCellBool", */
    f: Dd
  },
  /*::[*/
  5: {
    /* n:"BrtCellReal", */
    f: Md
  },
  /*::[*/
  6: {
    /* n:"BrtCellSt", */
    f: $d
  },
  /*::[*/
  7: {
    /* n:"BrtCellIsst", */
    f: Pd
  },
  /*::[*/
  8: {
    /* n:"BrtFmlaString", */
    f: Gd
  },
  /*::[*/
  9: {
    /* n:"BrtFmlaNum", */
    f: Zd
  },
  /*::[*/
  10: {
    /* n:"BrtFmlaBool", */
    f: Hd
  },
  /*::[*/
  11: {
    /* n:"BrtFmlaError", */
    f: Wd
  },
  /*::[*/
  12: {
    /* n:"BrtShortBlank", */
    f: Id
  },
  /*::[*/
  13: {
    /* n:"BrtShortRk", */
    f: Ud
  },
  /*::[*/
  14: {
    /* n:"BrtShortError", */
    f: bd
  },
  /*::[*/
  15: {
    /* n:"BrtShortBool", */
    f: Rd
  },
  /*::[*/
  16: {
    /* n:"BrtShortReal", */
    f: Ec
  },
  /*::[*/
  17: {
    /* n:"BrtShortSt", */
    f: Vd
  },
  /*::[*/
  18: {
    /* n:"BrtShortIsst", */
    f: Ld
  },
  /*::[*/
  19: {
    /* n:"BrtSSTItem", */
    f: r0
  },
  /*::[*/
  20: {
    /* n:"BrtPCDIMissing" */
  },
  /*::[*/
  21: {
    /* n:"BrtPCDINumber" */
  },
  /*::[*/
  22: {
    /* n:"BrtPCDIBoolean" */
  },
  /*::[*/
  23: {
    /* n:"BrtPCDIError" */
  },
  /*::[*/
  24: {
    /* n:"BrtPCDIString" */
  },
  /*::[*/
  25: {
    /* n:"BrtPCDIDatetime" */
  },
  /*::[*/
  26: {
    /* n:"BrtPCDIIndex" */
  },
  /*::[*/
  27: {
    /* n:"BrtPCDIAMissing" */
  },
  /*::[*/
  28: {
    /* n:"BrtPCDIANumber" */
  },
  /*::[*/
  29: {
    /* n:"BrtPCDIABoolean" */
  },
  /*::[*/
  30: {
    /* n:"BrtPCDIAError" */
  },
  /*::[*/
  31: {
    /* n:"BrtPCDIAString" */
  },
  /*::[*/
  32: {
    /* n:"BrtPCDIADatetime" */
  },
  /*::[*/
  33: {
    /* n:"BrtPCRRecord" */
  },
  /*::[*/
  34: {
    /* n:"BrtPCRRecordDt" */
  },
  /*::[*/
  35: {
    /* n:"BrtFRTBegin", */
    T: 1
  },
  /*::[*/
  36: {
    /* n:"BrtFRTEnd", */
    T: -1
  },
  /*::[*/
  37: {
    /* n:"BrtACBegin", */
    T: 1
  },
  /*::[*/
  38: {
    /* n:"BrtACEnd", */
    T: -1
  },
  /*::[*/
  39: {
    /* n:"BrtName", */
    f: _p
  },
  /*::[*/
  40: {
    /* n:"BrtIndexRowBlock" */
  },
  /*::[*/
  42: {
    /* n:"BrtIndexBlock" */
  },
  /*::[*/
  43: {
    /* n:"BrtFont", */
    f: Hh
  },
  /*::[*/
  44: {
    /* n:"BrtFmt", */
    f: Vh
  },
  /*::[*/
  45: {
    /* n:"BrtFill", */
    f: Wh
  },
  /*::[*/
  46: {
    /* n:"BrtBorder", */
    f: Gh
  },
  /*::[*/
  47: {
    /* n:"BrtXF", */
    f: Zh
  },
  /*::[*/
  48: {
    /* n:"BrtStyle" */
  },
  /*::[*/
  49: {
    /* n:"BrtCellMeta", */
    f: jo
  },
  /*::[*/
  50: {
    /* n:"BrtValueMeta" */
  },
  /*::[*/
  51: {
    /* n:"BrtMdb" */
    f: x1
  },
  /*::[*/
  52: {
    /* n:"BrtBeginFmd", */
    T: 1
  },
  /*::[*/
  53: {
    /* n:"BrtEndFmd", */
    T: -1
  },
  /*::[*/
  54: {
    /* n:"BrtBeginMdx", */
    T: 1
  },
  /*::[*/
  55: {
    /* n:"BrtEndMdx", */
    T: -1
  },
  /*::[*/
  56: {
    /* n:"BrtBeginMdxTuple", */
    T: 1
  },
  /*::[*/
  57: {
    /* n:"BrtEndMdxTuple", */
    T: -1
  },
  /*::[*/
  58: {
    /* n:"BrtMdxMbrIstr" */
  },
  /*::[*/
  59: {
    /* n:"BrtStr" */
  },
  /*::[*/
  60: {
    /* n:"BrtColInfo", */
    f: rc
  },
  /*::[*/
  62: {
    /* n:"BrtCellRString", */
    f: zd
  },
  /*::[*/
  63: {
    /* n:"BrtCalcChainItem$", */
    f: m1
  },
  /*::[*/
  64: {
    /* n:"BrtDVal", */
    f: rp
  },
  /*::[*/
  65: {
    /* n:"BrtSxvcellNum" */
  },
  /*::[*/
  66: {
    /* n:"BrtSxvcellStr" */
  },
  /*::[*/
  67: {
    /* n:"BrtSxvcellBool" */
  },
  /*::[*/
  68: {
    /* n:"BrtSxvcellErr" */
  },
  /*::[*/
  69: {
    /* n:"BrtSxvcellDate" */
  },
  /*::[*/
  70: {
    /* n:"BrtSxvcellNil" */
  },
  /*::[*/
  128: {
    /* n:"BrtFileVersion" */
  },
  /*::[*/
  129: {
    /* n:"BrtBeginSheet", */
    T: 1
  },
  /*::[*/
  130: {
    /* n:"BrtEndSheet", */
    T: -1
  },
  /*::[*/
  131: {
    /* n:"BrtBeginBook", */
    T: 1,
    f: cr,
    p: 0
  },
  /*::[*/
  132: {
    /* n:"BrtEndBook", */
    T: -1
  },
  /*::[*/
  133: {
    /* n:"BrtBeginWsViews", */
    T: 1
  },
  /*::[*/
  134: {
    /* n:"BrtEndWsViews", */
    T: -1
  },
  /*::[*/
  135: {
    /* n:"BrtBeginBookViews", */
    T: 1
  },
  /*::[*/
  136: {
    /* n:"BrtEndBookViews", */
    T: -1
  },
  /*::[*/
  137: {
    /* n:"BrtBeginWsView", */
    T: 1,
    f: ep
  },
  /*::[*/
  138: {
    /* n:"BrtEndWsView", */
    T: -1
  },
  /*::[*/
  139: {
    /* n:"BrtBeginCsViews", */
    T: 1
  },
  /*::[*/
  140: {
    /* n:"BrtEndCsViews", */
    T: -1
  },
  /*::[*/
  141: {
    /* n:"BrtBeginCsView", */
    T: 1
  },
  /*::[*/
  142: {
    /* n:"BrtEndCsView", */
    T: -1
  },
  /*::[*/
  143: {
    /* n:"BrtBeginBundleShs", */
    T: 1
  },
  /*::[*/
  144: {
    /* n:"BrtEndBundleShs", */
    T: -1
  },
  /*::[*/
  145: {
    /* n:"BrtBeginSheetData", */
    T: 1
  },
  /*::[*/
  146: {
    /* n:"BrtEndSheetData", */
    T: -1
  },
  /*::[*/
  147: {
    /* n:"BrtWsProp", */
    f: Cd
  },
  /*::[*/
  148: {
    /* n:"BrtWsDim", */
    f: Sd,
    p: 16
  },
  /*::[*/
  151: {
    /* n:"BrtPane", */
    f: Kd
  },
  /*::[*/
  152: {
    /* n:"BrtSel" */
  },
  /*::[*/
  153: {
    /* n:"BrtWbProp", */
    f: gp
  },
  /*::[*/
  154: {
    /* n:"BrtWbFactoid" */
  },
  /*::[*/
  155: {
    /* n:"BrtFileRecover" */
  },
  /*::[*/
  156: {
    /* n:"BrtBundleSh", */
    f: vp
  },
  /*::[*/
  157: {
    /* n:"BrtCalcProp" */
  },
  /*::[*/
  158: {
    /* n:"BrtBookView" */
  },
  /*::[*/
  159: {
    /* n:"BrtBeginSst", */
    T: 1,
    f: fh
  },
  /*::[*/
  160: {
    /* n:"BrtEndSst", */
    T: -1
  },
  /*::[*/
  161: {
    /* n:"BrtBeginAFilter", */
    T: 1,
    f: At
  },
  /*::[*/
  162: {
    /* n:"BrtEndAFilter", */
    T: -1
  },
  /*::[*/
  163: {
    /* n:"BrtBeginFilterColumn", */
    T: 1
  },
  /*::[*/
  164: {
    /* n:"BrtEndFilterColumn", */
    T: -1
  },
  /*::[*/
  165: {
    /* n:"BrtBeginFilters", */
    T: 1
  },
  /*::[*/
  166: {
    /* n:"BrtEndFilters", */
    T: -1
  },
  /*::[*/
  167: {
    /* n:"BrtFilter" */
  },
  /*::[*/
  168: {
    /* n:"BrtColorFilter" */
  },
  /*::[*/
  169: {
    /* n:"BrtIconFilter" */
  },
  /*::[*/
  170: {
    /* n:"BrtTop10Filter" */
  },
  /*::[*/
  171: {
    /* n:"BrtDynamicFilter" */
  },
  /*::[*/
  172: {
    /* n:"BrtBeginCustomFilters", */
    T: 1
  },
  /*::[*/
  173: {
    /* n:"BrtEndCustomFilters", */
    T: -1
  },
  /*::[*/
  174: {
    /* n:"BrtCustomFilter" */
  },
  /*::[*/
  175: {
    /* n:"BrtAFilterDateGroupItem" */
  },
  /*::[*/
  176: {
    /* n:"BrtMergeCell", */
    f: jd
  },
  /*::[*/
  177: {
    /* n:"BrtBeginMergeCells", */
    T: 1
  },
  /*::[*/
  178: {
    /* n:"BrtEndMergeCells", */
    T: -1
  },
  /*::[*/
  179: {
    /* n:"BrtBeginPivotCacheDef", */
    T: 1
  },
  /*::[*/
  180: {
    /* n:"BrtEndPivotCacheDef", */
    T: -1
  },
  /*::[*/
  181: {
    /* n:"BrtBeginPCDFields", */
    T: 1
  },
  /*::[*/
  182: {
    /* n:"BrtEndPCDFields", */
    T: -1
  },
  /*::[*/
  183: {
    /* n:"BrtBeginPCDField", */
    T: 1
  },
  /*::[*/
  184: {
    /* n:"BrtEndPCDField", */
    T: -1
  },
  /*::[*/
  185: {
    /* n:"BrtBeginPCDSource", */
    T: 1
  },
  /*::[*/
  186: {
    /* n:"BrtEndPCDSource", */
    T: -1
  },
  /*::[*/
  187: {
    /* n:"BrtBeginPCDSRange", */
    T: 1
  },
  /*::[*/
  188: {
    /* n:"BrtEndPCDSRange", */
    T: -1
  },
  /*::[*/
  189: {
    /* n:"BrtBeginPCDFAtbl", */
    T: 1
  },
  /*::[*/
  190: {
    /* n:"BrtEndPCDFAtbl", */
    T: -1
  },
  /*::[*/
  191: {
    /* n:"BrtBeginPCDIRun", */
    T: 1
  },
  /*::[*/
  192: {
    /* n:"BrtEndPCDIRun", */
    T: -1
  },
  /*::[*/
  193: {
    /* n:"BrtBeginPivotCacheRecords", */
    T: 1
  },
  /*::[*/
  194: {
    /* n:"BrtEndPivotCacheRecords", */
    T: -1
  },
  /*::[*/
  195: {
    /* n:"BrtBeginPCDHierarchies", */
    T: 1
  },
  /*::[*/
  196: {
    /* n:"BrtEndPCDHierarchies", */
    T: -1
  },
  /*::[*/
  197: {
    /* n:"BrtBeginPCDHierarchy", */
    T: 1
  },
  /*::[*/
  198: {
    /* n:"BrtEndPCDHierarchy", */
    T: -1
  },
  /*::[*/
  199: {
    /* n:"BrtBeginPCDHFieldsUsage", */
    T: 1
  },
  /*::[*/
  200: {
    /* n:"BrtEndPCDHFieldsUsage", */
    T: -1
  },
  /*::[*/
  201: {
    /* n:"BrtBeginExtConnection", */
    T: 1
  },
  /*::[*/
  202: {
    /* n:"BrtEndExtConnection", */
    T: -1
  },
  /*::[*/
  203: {
    /* n:"BrtBeginECDbProps", */
    T: 1
  },
  /*::[*/
  204: {
    /* n:"BrtEndECDbProps", */
    T: -1
  },
  /*::[*/
  205: {
    /* n:"BrtBeginECOlapProps", */
    T: 1
  },
  /*::[*/
  206: {
    /* n:"BrtEndECOlapProps", */
    T: -1
  },
  /*::[*/
  207: {
    /* n:"BrtBeginPCDSConsol", */
    T: 1
  },
  /*::[*/
  208: {
    /* n:"BrtEndPCDSConsol", */
    T: -1
  },
  /*::[*/
  209: {
    /* n:"BrtBeginPCDSCPages", */
    T: 1
  },
  /*::[*/
  210: {
    /* n:"BrtEndPCDSCPages", */
    T: -1
  },
  /*::[*/
  211: {
    /* n:"BrtBeginPCDSCPage", */
    T: 1
  },
  /*::[*/
  212: {
    /* n:"BrtEndPCDSCPage", */
    T: -1
  },
  /*::[*/
  213: {
    /* n:"BrtBeginPCDSCPItem", */
    T: 1
  },
  /*::[*/
  214: {
    /* n:"BrtEndPCDSCPItem", */
    T: -1
  },
  /*::[*/
  215: {
    /* n:"BrtBeginPCDSCSets", */
    T: 1
  },
  /*::[*/
  216: {
    /* n:"BrtEndPCDSCSets", */
    T: -1
  },
  /*::[*/
  217: {
    /* n:"BrtBeginPCDSCSet", */
    T: 1
  },
  /*::[*/
  218: {
    /* n:"BrtEndPCDSCSet", */
    T: -1
  },
  /*::[*/
  219: {
    /* n:"BrtBeginPCDFGroup", */
    T: 1
  },
  /*::[*/
  220: {
    /* n:"BrtEndPCDFGroup", */
    T: -1
  },
  /*::[*/
  221: {
    /* n:"BrtBeginPCDFGItems", */
    T: 1
  },
  /*::[*/
  222: {
    /* n:"BrtEndPCDFGItems", */
    T: -1
  },
  /*::[*/
  223: {
    /* n:"BrtBeginPCDFGRange", */
    T: 1
  },
  /*::[*/
  224: {
    /* n:"BrtEndPCDFGRange", */
    T: -1
  },
  /*::[*/
  225: {
    /* n:"BrtBeginPCDFGDiscrete", */
    T: 1
  },
  /*::[*/
  226: {
    /* n:"BrtEndPCDFGDiscrete", */
    T: -1
  },
  /*::[*/
  227: {
    /* n:"BrtBeginPCDSDTupleCache", */
    T: 1
  },
  /*::[*/
  228: {
    /* n:"BrtEndPCDSDTupleCache", */
    T: -1
  },
  /*::[*/
  229: {
    /* n:"BrtBeginPCDSDTCEntries", */
    T: 1
  },
  /*::[*/
  230: {
    /* n:"BrtEndPCDSDTCEntries", */
    T: -1
  },
  /*::[*/
  231: {
    /* n:"BrtBeginPCDSDTCEMembers", */
    T: 1
  },
  /*::[*/
  232: {
    /* n:"BrtEndPCDSDTCEMembers", */
    T: -1
  },
  /*::[*/
  233: {
    /* n:"BrtBeginPCDSDTCEMember", */
    T: 1
  },
  /*::[*/
  234: {
    /* n:"BrtEndPCDSDTCEMember", */
    T: -1
  },
  /*::[*/
  235: {
    /* n:"BrtBeginPCDSDTCQueries", */
    T: 1
  },
  /*::[*/
  236: {
    /* n:"BrtEndPCDSDTCQueries", */
    T: -1
  },
  /*::[*/
  237: {
    /* n:"BrtBeginPCDSDTCQuery", */
    T: 1
  },
  /*::[*/
  238: {
    /* n:"BrtEndPCDSDTCQuery", */
    T: -1
  },
  /*::[*/
  239: {
    /* n:"BrtBeginPCDSDTCSets", */
    T: 1
  },
  /*::[*/
  240: {
    /* n:"BrtEndPCDSDTCSets", */
    T: -1
  },
  /*::[*/
  241: {
    /* n:"BrtBeginPCDSDTCSet", */
    T: 1
  },
  /*::[*/
  242: {
    /* n:"BrtEndPCDSDTCSet", */
    T: -1
  },
  /*::[*/
  243: {
    /* n:"BrtBeginPCDCalcItems", */
    T: 1
  },
  /*::[*/
  244: {
    /* n:"BrtEndPCDCalcItems", */
    T: -1
  },
  /*::[*/
  245: {
    /* n:"BrtBeginPCDCalcItem", */
    T: 1
  },
  /*::[*/
  246: {
    /* n:"BrtEndPCDCalcItem", */
    T: -1
  },
  /*::[*/
  247: {
    /* n:"BrtBeginPRule", */
    T: 1
  },
  /*::[*/
  248: {
    /* n:"BrtEndPRule", */
    T: -1
  },
  /*::[*/
  249: {
    /* n:"BrtBeginPRFilters", */
    T: 1
  },
  /*::[*/
  250: {
    /* n:"BrtEndPRFilters", */
    T: -1
  },
  /*::[*/
  251: {
    /* n:"BrtBeginPRFilter", */
    T: 1
  },
  /*::[*/
  252: {
    /* n:"BrtEndPRFilter", */
    T: -1
  },
  /*::[*/
  253: {
    /* n:"BrtBeginPNames", */
    T: 1
  },
  /*::[*/
  254: {
    /* n:"BrtEndPNames", */
    T: -1
  },
  /*::[*/
  255: {
    /* n:"BrtBeginPName", */
    T: 1
  },
  /*::[*/
  256: {
    /* n:"BrtEndPName", */
    T: -1
  },
  /*::[*/
  257: {
    /* n:"BrtBeginPNPairs", */
    T: 1
  },
  /*::[*/
  258: {
    /* n:"BrtEndPNPairs", */
    T: -1
  },
  /*::[*/
  259: {
    /* n:"BrtBeginPNPair", */
    T: 1
  },
  /*::[*/
  260: {
    /* n:"BrtEndPNPair", */
    T: -1
  },
  /*::[*/
  261: {
    /* n:"BrtBeginECWebProps", */
    T: 1
  },
  /*::[*/
  262: {
    /* n:"BrtEndECWebProps", */
    T: -1
  },
  /*::[*/
  263: {
    /* n:"BrtBeginEcWpTables", */
    T: 1
  },
  /*::[*/
  264: {
    /* n:"BrtEndECWPTables", */
    T: -1
  },
  /*::[*/
  265: {
    /* n:"BrtBeginECParams", */
    T: 1
  },
  /*::[*/
  266: {
    /* n:"BrtEndECParams", */
    T: -1
  },
  /*::[*/
  267: {
    /* n:"BrtBeginECParam", */
    T: 1
  },
  /*::[*/
  268: {
    /* n:"BrtEndECParam", */
    T: -1
  },
  /*::[*/
  269: {
    /* n:"BrtBeginPCDKPIs", */
    T: 1
  },
  /*::[*/
  270: {
    /* n:"BrtEndPCDKPIs", */
    T: -1
  },
  /*::[*/
  271: {
    /* n:"BrtBeginPCDKPI", */
    T: 1
  },
  /*::[*/
  272: {
    /* n:"BrtEndPCDKPI", */
    T: -1
  },
  /*::[*/
  273: {
    /* n:"BrtBeginDims", */
    T: 1
  },
  /*::[*/
  274: {
    /* n:"BrtEndDims", */
    T: -1
  },
  /*::[*/
  275: {
    /* n:"BrtBeginDim", */
    T: 1
  },
  /*::[*/
  276: {
    /* n:"BrtEndDim", */
    T: -1
  },
  /*::[*/
  277: {
    /* n:"BrtIndexPartEnd" */
  },
  /*::[*/
  278: {
    /* n:"BrtBeginStyleSheet", */
    T: 1
  },
  /*::[*/
  279: {
    /* n:"BrtEndStyleSheet", */
    T: -1
  },
  /*::[*/
  280: {
    /* n:"BrtBeginSXView", */
    T: 1
  },
  /*::[*/
  281: {
    /* n:"BrtEndSXVI", */
    T: -1
  },
  /*::[*/
  282: {
    /* n:"BrtBeginSXVI", */
    T: 1
  },
  /*::[*/
  283: {
    /* n:"BrtBeginSXVIs", */
    T: 1
  },
  /*::[*/
  284: {
    /* n:"BrtEndSXVIs", */
    T: -1
  },
  /*::[*/
  285: {
    /* n:"BrtBeginSXVD", */
    T: 1
  },
  /*::[*/
  286: {
    /* n:"BrtEndSXVD", */
    T: -1
  },
  /*::[*/
  287: {
    /* n:"BrtBeginSXVDs", */
    T: 1
  },
  /*::[*/
  288: {
    /* n:"BrtEndSXVDs", */
    T: -1
  },
  /*::[*/
  289: {
    /* n:"BrtBeginSXPI", */
    T: 1
  },
  /*::[*/
  290: {
    /* n:"BrtEndSXPI", */
    T: -1
  },
  /*::[*/
  291: {
    /* n:"BrtBeginSXPIs", */
    T: 1
  },
  /*::[*/
  292: {
    /* n:"BrtEndSXPIs", */
    T: -1
  },
  /*::[*/
  293: {
    /* n:"BrtBeginSXDI", */
    T: 1
  },
  /*::[*/
  294: {
    /* n:"BrtEndSXDI", */
    T: -1
  },
  /*::[*/
  295: {
    /* n:"BrtBeginSXDIs", */
    T: 1
  },
  /*::[*/
  296: {
    /* n:"BrtEndSXDIs", */
    T: -1
  },
  /*::[*/
  297: {
    /* n:"BrtBeginSXLI", */
    T: 1
  },
  /*::[*/
  298: {
    /* n:"BrtEndSXLI", */
    T: -1
  },
  /*::[*/
  299: {
    /* n:"BrtBeginSXLIRws", */
    T: 1
  },
  /*::[*/
  300: {
    /* n:"BrtEndSXLIRws", */
    T: -1
  },
  /*::[*/
  301: {
    /* n:"BrtBeginSXLICols", */
    T: 1
  },
  /*::[*/
  302: {
    /* n:"BrtEndSXLICols", */
    T: -1
  },
  /*::[*/
  303: {
    /* n:"BrtBeginSXFormat", */
    T: 1
  },
  /*::[*/
  304: {
    /* n:"BrtEndSXFormat", */
    T: -1
  },
  /*::[*/
  305: {
    /* n:"BrtBeginSXFormats", */
    T: 1
  },
  /*::[*/
  306: {
    /* n:"BrtEndSxFormats", */
    T: -1
  },
  /*::[*/
  307: {
    /* n:"BrtBeginSxSelect", */
    T: 1
  },
  /*::[*/
  308: {
    /* n:"BrtEndSxSelect", */
    T: -1
  },
  /*::[*/
  309: {
    /* n:"BrtBeginISXVDRws", */
    T: 1
  },
  /*::[*/
  310: {
    /* n:"BrtEndISXVDRws", */
    T: -1
  },
  /*::[*/
  311: {
    /* n:"BrtBeginISXVDCols", */
    T: 1
  },
  /*::[*/
  312: {
    /* n:"BrtEndISXVDCols", */
    T: -1
  },
  /*::[*/
  313: {
    /* n:"BrtEndSXLocation", */
    T: -1
  },
  /*::[*/
  314: {
    /* n:"BrtBeginSXLocation", */
    T: 1
  },
  /*::[*/
  315: {
    /* n:"BrtEndSXView", */
    T: -1
  },
  /*::[*/
  316: {
    /* n:"BrtBeginSXTHs", */
    T: 1
  },
  /*::[*/
  317: {
    /* n:"BrtEndSXTHs", */
    T: -1
  },
  /*::[*/
  318: {
    /* n:"BrtBeginSXTH", */
    T: 1
  },
  /*::[*/
  319: {
    /* n:"BrtEndSXTH", */
    T: -1
  },
  /*::[*/
  320: {
    /* n:"BrtBeginISXTHRws", */
    T: 1
  },
  /*::[*/
  321: {
    /* n:"BrtEndISXTHRws", */
    T: -1
  },
  /*::[*/
  322: {
    /* n:"BrtBeginISXTHCols", */
    T: 1
  },
  /*::[*/
  323: {
    /* n:"BrtEndISXTHCols", */
    T: -1
  },
  /*::[*/
  324: {
    /* n:"BrtBeginSXTDMPS", */
    T: 1
  },
  /*::[*/
  325: {
    /* n:"BrtEndSXTDMPs", */
    T: -1
  },
  /*::[*/
  326: {
    /* n:"BrtBeginSXTDMP", */
    T: 1
  },
  /*::[*/
  327: {
    /* n:"BrtEndSXTDMP", */
    T: -1
  },
  /*::[*/
  328: {
    /* n:"BrtBeginSXTHItems", */
    T: 1
  },
  /*::[*/
  329: {
    /* n:"BrtEndSXTHItems", */
    T: -1
  },
  /*::[*/
  330: {
    /* n:"BrtBeginSXTHItem", */
    T: 1
  },
  /*::[*/
  331: {
    /* n:"BrtEndSXTHItem", */
    T: -1
  },
  /*::[*/
  332: {
    /* n:"BrtBeginMetadata", */
    T: 1
  },
  /*::[*/
  333: {
    /* n:"BrtEndMetadata", */
    T: -1
  },
  /*::[*/
  334: {
    /* n:"BrtBeginEsmdtinfo", */
    T: 1
  },
  /*::[*/
  335: {
    /* n:"BrtMdtinfo", */
    f: h1
  },
  /*::[*/
  336: {
    /* n:"BrtEndEsmdtinfo", */
    T: -1
  },
  /*::[*/
  337: {
    /* n:"BrtBeginEsmdb", */
    f: d1,
    T: 1
  },
  /*::[*/
  338: {
    /* n:"BrtEndEsmdb", */
    T: -1
  },
  /*::[*/
  339: {
    /* n:"BrtBeginEsfmd", */
    T: 1
  },
  /*::[*/
  340: {
    /* n:"BrtEndEsfmd", */
    T: -1
  },
  /*::[*/
  341: {
    /* n:"BrtBeginSingleCells", */
    T: 1
  },
  /*::[*/
  342: {
    /* n:"BrtEndSingleCells", */
    T: -1
  },
  /*::[*/
  343: {
    /* n:"BrtBeginList", */
    T: 1
  },
  /*::[*/
  344: {
    /* n:"BrtEndList", */
    T: -1
  },
  /*::[*/
  345: {
    /* n:"BrtBeginListCols", */
    T: 1
  },
  /*::[*/
  346: {
    /* n:"BrtEndListCols", */
    T: -1
  },
  /*::[*/
  347: {
    /* n:"BrtBeginListCol", */
    T: 1
  },
  /*::[*/
  348: {
    /* n:"BrtEndListCol", */
    T: -1
  },
  /*::[*/
  349: {
    /* n:"BrtBeginListXmlCPr", */
    T: 1
  },
  /*::[*/
  350: {
    /* n:"BrtEndListXmlCPr", */
    T: -1
  },
  /*::[*/
  351: {
    /* n:"BrtListCCFmla" */
  },
  /*::[*/
  352: {
    /* n:"BrtListTrFmla" */
  },
  /*::[*/
  353: {
    /* n:"BrtBeginExternals", */
    T: 1
  },
  /*::[*/
  354: {
    /* n:"BrtEndExternals", */
    T: -1
  },
  /*::[*/
  355: {
    /* n:"BrtSupBookSrc", */
    f: In
  },
  /*::[*/
  357: {
    /* n:"BrtSupSelf" */
  },
  /*::[*/
  358: {
    /* n:"BrtSupSame" */
  },
  /*::[*/
  359: {
    /* n:"BrtSupTabs" */
  },
  /*::[*/
  360: {
    /* n:"BrtBeginSupBook", */
    T: 1
  },
  /*::[*/
  361: {
    /* n:"BrtPlaceholderName" */
  },
  /*::[*/
  362: {
    /* n:"BrtExternSheet", */
    f: ec
  },
  /*::[*/
  363: {
    /* n:"BrtExternTableStart" */
  },
  /*::[*/
  364: {
    /* n:"BrtExternTableEnd" */
  },
  /*::[*/
  366: {
    /* n:"BrtExternRowHdr" */
  },
  /*::[*/
  367: {
    /* n:"BrtExternCellBlank" */
  },
  /*::[*/
  368: {
    /* n:"BrtExternCellReal" */
  },
  /*::[*/
  369: {
    /* n:"BrtExternCellBool" */
  },
  /*::[*/
  370: {
    /* n:"BrtExternCellError" */
  },
  /*::[*/
  371: {
    /* n:"BrtExternCellString" */
  },
  /*::[*/
  372: {
    /* n:"BrtBeginEsmdx", */
    T: 1
  },
  /*::[*/
  373: {
    /* n:"BrtEndEsmdx", */
    T: -1
  },
  /*::[*/
  374: {
    /* n:"BrtBeginMdxSet", */
    T: 1
  },
  /*::[*/
  375: {
    /* n:"BrtEndMdxSet", */
    T: -1
  },
  /*::[*/
  376: {
    /* n:"BrtBeginMdxMbrProp", */
    T: 1
  },
  /*::[*/
  377: {
    /* n:"BrtEndMdxMbrProp", */
    T: -1
  },
  /*::[*/
  378: {
    /* n:"BrtBeginMdxKPI", */
    T: 1
  },
  /*::[*/
  379: {
    /* n:"BrtEndMdxKPI", */
    T: -1
  },
  /*::[*/
  380: {
    /* n:"BrtBeginEsstr", */
    T: 1
  },
  /*::[*/
  381: {
    /* n:"BrtEndEsstr", */
    T: -1
  },
  /*::[*/
  382: {
    /* n:"BrtBeginPRFItem", */
    T: 1
  },
  /*::[*/
  383: {
    /* n:"BrtEndPRFItem", */
    T: -1
  },
  /*::[*/
  384: {
    /* n:"BrtBeginPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  385: {
    /* n:"BrtEndPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  386: {
    /* n:"BrtBeginPivotCacheID", */
    T: 1
  },
  /*::[*/
  387: {
    /* n:"BrtEndPivotCacheID", */
    T: -1
  },
  /*::[*/
  388: {
    /* n:"BrtBeginISXVIs", */
    T: 1
  },
  /*::[*/
  389: {
    /* n:"BrtEndISXVIs", */
    T: -1
  },
  /*::[*/
  390: {
    /* n:"BrtBeginColInfos", */
    T: 1
  },
  /*::[*/
  391: {
    /* n:"BrtEndColInfos", */
    T: -1
  },
  /*::[*/
  392: {
    /* n:"BrtBeginRwBrk", */
    T: 1
  },
  /*::[*/
  393: {
    /* n:"BrtEndRwBrk", */
    T: -1
  },
  /*::[*/
  394: {
    /* n:"BrtBeginColBrk", */
    T: 1
  },
  /*::[*/
  395: {
    /* n:"BrtEndColBrk", */
    T: -1
  },
  /*::[*/
  396: {
    /* n:"BrtBrk" */
  },
  /*::[*/
  397: {
    /* n:"BrtUserBookView" */
  },
  /*::[*/
  398: {
    /* n:"BrtInfo" */
  },
  /*::[*/
  399: {
    /* n:"BrtCUsr" */
  },
  /*::[*/
  400: {
    /* n:"BrtUsr" */
  },
  /*::[*/
  401: {
    /* n:"BrtBeginUsers", */
    T: 1
  },
  /*::[*/
  403: {
    /* n:"BrtEOF" */
  },
  /*::[*/
  404: {
    /* n:"BrtUCR" */
  },
  /*::[*/
  405: {
    /* n:"BrtRRInsDel" */
  },
  /*::[*/
  406: {
    /* n:"BrtRREndInsDel" */
  },
  /*::[*/
  407: {
    /* n:"BrtRRMove" */
  },
  /*::[*/
  408: {
    /* n:"BrtRREndMove" */
  },
  /*::[*/
  409: {
    /* n:"BrtRRChgCell" */
  },
  /*::[*/
  410: {
    /* n:"BrtRREndChgCell" */
  },
  /*::[*/
  411: {
    /* n:"BrtRRHeader" */
  },
  /*::[*/
  412: {
    /* n:"BrtRRUserView" */
  },
  /*::[*/
  413: {
    /* n:"BrtRRRenSheet" */
  },
  /*::[*/
  414: {
    /* n:"BrtRRInsertSh" */
  },
  /*::[*/
  415: {
    /* n:"BrtRRDefName" */
  },
  /*::[*/
  416: {
    /* n:"BrtRRNote" */
  },
  /*::[*/
  417: {
    /* n:"BrtRRConflict" */
  },
  /*::[*/
  418: {
    /* n:"BrtRRTQSIF" */
  },
  /*::[*/
  419: {
    /* n:"BrtRRFormat" */
  },
  /*::[*/
  420: {
    /* n:"BrtRREndFormat" */
  },
  /*::[*/
  421: {
    /* n:"BrtRRAutoFmt" */
  },
  /*::[*/
  422: {
    /* n:"BrtBeginUserShViews", */
    T: 1
  },
  /*::[*/
  423: {
    /* n:"BrtBeginUserShView", */
    T: 1
  },
  /*::[*/
  424: {
    /* n:"BrtEndUserShView", */
    T: -1
  },
  /*::[*/
  425: {
    /* n:"BrtEndUserShViews", */
    T: -1
  },
  /*::[*/
  426: {
    /* n:"BrtArrFmla", */
    f: Yd
  },
  /*::[*/
  427: {
    /* n:"BrtShrFmla", */
    f: Jd
  },
  /*::[*/
  428: {
    /* n:"BrtTable" */
  },
  /*::[*/
  429: {
    /* n:"BrtBeginExtConnections", */
    T: 1
  },
  /*::[*/
  430: {
    /* n:"BrtEndExtConnections", */
    T: -1
  },
  /*::[*/
  431: {
    /* n:"BrtBeginPCDCalcMems", */
    T: 1
  },
  /*::[*/
  432: {
    /* n:"BrtEndPCDCalcMems", */
    T: -1
  },
  /*::[*/
  433: {
    /* n:"BrtBeginPCDCalcMem", */
    T: 1
  },
  /*::[*/
  434: {
    /* n:"BrtEndPCDCalcMem", */
    T: -1
  },
  /*::[*/
  435: {
    /* n:"BrtBeginPCDHGLevels", */
    T: 1
  },
  /*::[*/
  436: {
    /* n:"BrtEndPCDHGLevels", */
    T: -1
  },
  /*::[*/
  437: {
    /* n:"BrtBeginPCDHGLevel", */
    T: 1
  },
  /*::[*/
  438: {
    /* n:"BrtEndPCDHGLevel", */
    T: -1
  },
  /*::[*/
  439: {
    /* n:"BrtBeginPCDHGLGroups", */
    T: 1
  },
  /*::[*/
  440: {
    /* n:"BrtEndPCDHGLGroups", */
    T: -1
  },
  /*::[*/
  441: {
    /* n:"BrtBeginPCDHGLGroup", */
    T: 1
  },
  /*::[*/
  442: {
    /* n:"BrtEndPCDHGLGroup", */
    T: -1
  },
  /*::[*/
  443: {
    /* n:"BrtBeginPCDHGLGMembers", */
    T: 1
  },
  /*::[*/
  444: {
    /* n:"BrtEndPCDHGLGMembers", */
    T: -1
  },
  /*::[*/
  445: {
    /* n:"BrtBeginPCDHGLGMember", */
    T: 1
  },
  /*::[*/
  446: {
    /* n:"BrtEndPCDHGLGMember", */
    T: -1
  },
  /*::[*/
  447: {
    /* n:"BrtBeginQSI", */
    T: 1
  },
  /*::[*/
  448: {
    /* n:"BrtEndQSI", */
    T: -1
  },
  /*::[*/
  449: {
    /* n:"BrtBeginQSIR", */
    T: 1
  },
  /*::[*/
  450: {
    /* n:"BrtEndQSIR", */
    T: -1
  },
  /*::[*/
  451: {
    /* n:"BrtBeginDeletedNames", */
    T: 1
  },
  /*::[*/
  452: {
    /* n:"BrtEndDeletedNames", */
    T: -1
  },
  /*::[*/
  453: {
    /* n:"BrtBeginDeletedName", */
    T: 1
  },
  /*::[*/
  454: {
    /* n:"BrtEndDeletedName", */
    T: -1
  },
  /*::[*/
  455: {
    /* n:"BrtBeginQSIFs", */
    T: 1
  },
  /*::[*/
  456: {
    /* n:"BrtEndQSIFs", */
    T: -1
  },
  /*::[*/
  457: {
    /* n:"BrtBeginQSIF", */
    T: 1
  },
  /*::[*/
  458: {
    /* n:"BrtEndQSIF", */
    T: -1
  },
  /*::[*/
  459: {
    /* n:"BrtBeginAutoSortScope", */
    T: 1
  },
  /*::[*/
  460: {
    /* n:"BrtEndAutoSortScope", */
    T: -1
  },
  /*::[*/
  461: {
    /* n:"BrtBeginConditionalFormatting", */
    T: 1
  },
  /*::[*/
  462: {
    /* n:"BrtEndConditionalFormatting", */
    T: -1
  },
  /*::[*/
  463: {
    /* n:"BrtBeginCFRule", */
    T: 1
  },
  /*::[*/
  464: {
    /* n:"BrtEndCFRule", */
    T: -1
  },
  /*::[*/
  465: {
    /* n:"BrtBeginIconSet", */
    T: 1
  },
  /*::[*/
  466: {
    /* n:"BrtEndIconSet", */
    T: -1
  },
  /*::[*/
  467: {
    /* n:"BrtBeginDatabar", */
    T: 1
  },
  /*::[*/
  468: {
    /* n:"BrtEndDatabar", */
    T: -1
  },
  /*::[*/
  469: {
    /* n:"BrtBeginColorScale", */
    T: 1
  },
  /*::[*/
  470: {
    /* n:"BrtEndColorScale", */
    T: -1
  },
  /*::[*/
  471: {
    /* n:"BrtCFVO" */
  },
  /*::[*/
  472: {
    /* n:"BrtExternValueMeta" */
  },
  /*::[*/
  473: {
    /* n:"BrtBeginColorPalette", */
    T: 1
  },
  /*::[*/
  474: {
    /* n:"BrtEndColorPalette", */
    T: -1
  },
  /*::[*/
  475: {
    /* n:"BrtIndexedColor" */
  },
  /*::[*/
  476: {
    /* n:"BrtMargins", */
    f: Qd
  },
  /*::[*/
  477: {
    /* n:"BrtPrintOptions" */
  },
  /*::[*/
  478: {
    /* n:"BrtPageSetup" */
  },
  /*::[*/
  479: {
    /* n:"BrtBeginHeaderFooter", */
    T: 1
  },
  /*::[*/
  480: {
    /* n:"BrtEndHeaderFooter", */
    T: -1
  },
  /*::[*/
  481: {
    /* n:"BrtBeginSXCrtFormat", */
    T: 1
  },
  /*::[*/
  482: {
    /* n:"BrtEndSXCrtFormat", */
    T: -1
  },
  /*::[*/
  483: {
    /* n:"BrtBeginSXCrtFormats", */
    T: 1
  },
  /*::[*/
  484: {
    /* n:"BrtEndSXCrtFormats", */
    T: -1
  },
  /*::[*/
  485: {
    /* n:"BrtWsFmtInfo", */
    f: yd
  },
  /*::[*/
  486: {
    /* n:"BrtBeginMgs", */
    T: 1
  },
  /*::[*/
  487: {
    /* n:"BrtEndMGs", */
    T: -1
  },
  /*::[*/
  488: {
    /* n:"BrtBeginMGMaps", */
    T: 1
  },
  /*::[*/
  489: {
    /* n:"BrtEndMGMaps", */
    T: -1
  },
  /*::[*/
  490: {
    /* n:"BrtBeginMG", */
    T: 1
  },
  /*::[*/
  491: {
    /* n:"BrtEndMG", */
    T: -1
  },
  /*::[*/
  492: {
    /* n:"BrtBeginMap", */
    T: 1
  },
  /*::[*/
  493: {
    /* n:"BrtEndMap", */
    T: -1
  },
  /*::[*/
  494: {
    /* n:"BrtHLink", */
    f: Xd
  },
  /*::[*/
  495: {
    /* n:"BrtBeginDCon", */
    T: 1
  },
  /*::[*/
  496: {
    /* n:"BrtEndDCon", */
    T: -1
  },
  /*::[*/
  497: {
    /* n:"BrtBeginDRefs", */
    T: 1
  },
  /*::[*/
  498: {
    /* n:"BrtEndDRefs", */
    T: -1
  },
  /*::[*/
  499: {
    /* n:"BrtDRef" */
  },
  /*::[*/
  500: {
    /* n:"BrtBeginScenMan", */
    T: 1
  },
  /*::[*/
  501: {
    /* n:"BrtEndScenMan", */
    T: -1
  },
  /*::[*/
  502: {
    /* n:"BrtBeginSct", */
    T: 1
  },
  /*::[*/
  503: {
    /* n:"BrtEndSct", */
    T: -1
  },
  /*::[*/
  504: {
    /* n:"BrtSlc" */
  },
  /*::[*/
  505: {
    /* n:"BrtBeginDXFs", */
    T: 1
  },
  /*::[*/
  506: {
    /* n:"BrtEndDXFs", */
    T: -1
  },
  /*::[*/
  507: {
    /* n:"BrtDXF" */
  },
  /*::[*/
  508: {
    /* n:"BrtBeginTableStyles", */
    T: 1
  },
  /*::[*/
  509: {
    /* n:"BrtEndTableStyles", */
    T: -1
  },
  /*::[*/
  510: {
    /* n:"BrtBeginTableStyle", */
    T: 1
  },
  /*::[*/
  511: {
    /* n:"BrtEndTableStyle", */
    T: -1
  },
  /*::[*/
  512: {
    /* n:"BrtTableStyleElement" */
  },
  /*::[*/
  513: {
    /* n:"BrtTableStyleClient" */
  },
  /*::[*/
  514: {
    /* n:"BrtBeginVolDeps", */
    T: 1
  },
  /*::[*/
  515: {
    /* n:"BrtEndVolDeps", */
    T: -1
  },
  /*::[*/
  516: {
    /* n:"BrtBeginVolType", */
    T: 1
  },
  /*::[*/
  517: {
    /* n:"BrtEndVolType", */
    T: -1
  },
  /*::[*/
  518: {
    /* n:"BrtBeginVolMain", */
    T: 1
  },
  /*::[*/
  519: {
    /* n:"BrtEndVolMain", */
    T: -1
  },
  /*::[*/
  520: {
    /* n:"BrtBeginVolTopic", */
    T: 1
  },
  /*::[*/
  521: {
    /* n:"BrtEndVolTopic", */
    T: -1
  },
  /*::[*/
  522: {
    /* n:"BrtVolSubtopic" */
  },
  /*::[*/
  523: {
    /* n:"BrtVolRef" */
  },
  /*::[*/
  524: {
    /* n:"BrtVolNum" */
  },
  /*::[*/
  525: {
    /* n:"BrtVolErr" */
  },
  /*::[*/
  526: {
    /* n:"BrtVolStr" */
  },
  /*::[*/
  527: {
    /* n:"BrtVolBool" */
  },
  /*::[*/
  528: {
    /* n:"BrtBeginCalcChain$", */
    T: 1
  },
  /*::[*/
  529: {
    /* n:"BrtEndCalcChain$", */
    T: -1
  },
  /*::[*/
  530: {
    /* n:"BrtBeginSortState", */
    T: 1
  },
  /*::[*/
  531: {
    /* n:"BrtEndSortState", */
    T: -1
  },
  /*::[*/
  532: {
    /* n:"BrtBeginSortCond", */
    T: 1
  },
  /*::[*/
  533: {
    /* n:"BrtEndSortCond", */
    T: -1
  },
  /*::[*/
  534: {
    /* n:"BrtBookProtection" */
  },
  /*::[*/
  535: {
    /* n:"BrtSheetProtection" */
  },
  /*::[*/
  536: {
    /* n:"BrtRangeProtection" */
  },
  /*::[*/
  537: {
    /* n:"BrtPhoneticInfo" */
  },
  /*::[*/
  538: {
    /* n:"BrtBeginECTxtWiz", */
    T: 1
  },
  /*::[*/
  539: {
    /* n:"BrtEndECTxtWiz", */
    T: -1
  },
  /*::[*/
  540: {
    /* n:"BrtBeginECTWFldInfoLst", */
    T: 1
  },
  /*::[*/
  541: {
    /* n:"BrtEndECTWFldInfoLst", */
    T: -1
  },
  /*::[*/
  542: {
    /* n:"BrtBeginECTwFldInfo", */
    T: 1
  },
  /*::[*/
  548: {
    /* n:"BrtFileSharing" */
  },
  /*::[*/
  549: {
    /* n:"BrtOleSize" */
  },
  /*::[*/
  550: {
    /* n:"BrtDrawing", */
    f: In
  },
  /*::[*/
  551: {
    /* n:"BrtLegacyDrawing" */
  },
  /*::[*/
  552: {
    /* n:"BrtLegacyDrawingHF" */
  },
  /*::[*/
  553: {
    /* n:"BrtWebOpt" */
  },
  /*::[*/
  554: {
    /* n:"BrtBeginWebPubItems", */
    T: 1
  },
  /*::[*/
  555: {
    /* n:"BrtEndWebPubItems", */
    T: -1
  },
  /*::[*/
  556: {
    /* n:"BrtBeginWebPubItem", */
    T: 1
  },
  /*::[*/
  557: {
    /* n:"BrtEndWebPubItem", */
    T: -1
  },
  /*::[*/
  558: {
    /* n:"BrtBeginSXCondFmt", */
    T: 1
  },
  /*::[*/
  559: {
    /* n:"BrtEndSXCondFmt", */
    T: -1
  },
  /*::[*/
  560: {
    /* n:"BrtBeginSXCondFmts", */
    T: 1
  },
  /*::[*/
  561: {
    /* n:"BrtEndSXCondFmts", */
    T: -1
  },
  /*::[*/
  562: {
    /* n:"BrtBkHim" */
  },
  /*::[*/
  564: {
    /* n:"BrtColor" */
  },
  /*::[*/
  565: {
    /* n:"BrtBeginIndexedColors", */
    T: 1
  },
  /*::[*/
  566: {
    /* n:"BrtEndIndexedColors", */
    T: -1
  },
  /*::[*/
  569: {
    /* n:"BrtBeginMRUColors", */
    T: 1
  },
  /*::[*/
  570: {
    /* n:"BrtEndMRUColors", */
    T: -1
  },
  /*::[*/
  572: {
    /* n:"BrtMRUColor" */
  },
  /*::[*/
  573: {
    /* n:"BrtBeginDVals", */
    T: 1
  },
  /*::[*/
  574: {
    /* n:"BrtEndDVals", */
    T: -1
  },
  /*::[*/
  577: {
    /* n:"BrtSupNameStart" */
  },
  /*::[*/
  578: {
    /* n:"BrtSupNameValueStart" */
  },
  /*::[*/
  579: {
    /* n:"BrtSupNameValueEnd" */
  },
  /*::[*/
  580: {
    /* n:"BrtSupNameNum" */
  },
  /*::[*/
  581: {
    /* n:"BrtSupNameErr" */
  },
  /*::[*/
  582: {
    /* n:"BrtSupNameSt" */
  },
  /*::[*/
  583: {
    /* n:"BrtSupNameNil" */
  },
  /*::[*/
  584: {
    /* n:"BrtSupNameBool" */
  },
  /*::[*/
  585: {
    /* n:"BrtSupNameFmla" */
  },
  /*::[*/
  586: {
    /* n:"BrtSupNameBits" */
  },
  /*::[*/
  587: {
    /* n:"BrtSupNameEnd" */
  },
  /*::[*/
  588: {
    /* n:"BrtEndSupBook", */
    T: -1
  },
  /*::[*/
  589: {
    /* n:"BrtCellSmartTagProperty" */
  },
  /*::[*/
  590: {
    /* n:"BrtBeginCellSmartTag", */
    T: 1
  },
  /*::[*/
  591: {
    /* n:"BrtEndCellSmartTag", */
    T: -1
  },
  /*::[*/
  592: {
    /* n:"BrtBeginCellSmartTags", */
    T: 1
  },
  /*::[*/
  593: {
    /* n:"BrtEndCellSmartTags", */
    T: -1
  },
  /*::[*/
  594: {
    /* n:"BrtBeginSmartTags", */
    T: 1
  },
  /*::[*/
  595: {
    /* n:"BrtEndSmartTags", */
    T: -1
  },
  /*::[*/
  596: {
    /* n:"BrtSmartTagType" */
  },
  /*::[*/
  597: {
    /* n:"BrtBeginSmartTagTypes", */
    T: 1
  },
  /*::[*/
  598: {
    /* n:"BrtEndSmartTagTypes", */
    T: -1
  },
  /*::[*/
  599: {
    /* n:"BrtBeginSXFilters", */
    T: 1
  },
  /*::[*/
  600: {
    /* n:"BrtEndSXFilters", */
    T: -1
  },
  /*::[*/
  601: {
    /* n:"BrtBeginSXFILTER", */
    T: 1
  },
  /*::[*/
  602: {
    /* n:"BrtEndSXFilter", */
    T: -1
  },
  /*::[*/
  603: {
    /* n:"BrtBeginFills", */
    T: 1
  },
  /*::[*/
  604: {
    /* n:"BrtEndFills", */
    T: -1
  },
  /*::[*/
  605: {
    /* n:"BrtBeginCellWatches", */
    T: 1
  },
  /*::[*/
  606: {
    /* n:"BrtEndCellWatches", */
    T: -1
  },
  /*::[*/
  607: {
    /* n:"BrtCellWatch" */
  },
  /*::[*/
  608: {
    /* n:"BrtBeginCRErrs", */
    T: 1
  },
  /*::[*/
  609: {
    /* n:"BrtEndCRErrs", */
    T: -1
  },
  /*::[*/
  610: {
    /* n:"BrtCrashRecErr" */
  },
  /*::[*/
  611: {
    /* n:"BrtBeginFonts", */
    T: 1
  },
  /*::[*/
  612: {
    /* n:"BrtEndFonts", */
    T: -1
  },
  /*::[*/
  613: {
    /* n:"BrtBeginBorders", */
    T: 1
  },
  /*::[*/
  614: {
    /* n:"BrtEndBorders", */
    T: -1
  },
  /*::[*/
  615: {
    /* n:"BrtBeginFmts", */
    T: 1
  },
  /*::[*/
  616: {
    /* n:"BrtEndFmts", */
    T: -1
  },
  /*::[*/
  617: {
    /* n:"BrtBeginCellXFs", */
    T: 1
  },
  /*::[*/
  618: {
    /* n:"BrtEndCellXFs", */
    T: -1
  },
  /*::[*/
  619: {
    /* n:"BrtBeginStyles", */
    T: 1
  },
  /*::[*/
  620: {
    /* n:"BrtEndStyles", */
    T: -1
  },
  /*::[*/
  625: {
    /* n:"BrtBigName" */
  },
  /*::[*/
  626: {
    /* n:"BrtBeginCellStyleXFs", */
    T: 1
  },
  /*::[*/
  627: {
    /* n:"BrtEndCellStyleXFs", */
    T: -1
  },
  /*::[*/
  628: {
    /* n:"BrtBeginComments", */
    T: 1
  },
  /*::[*/
  629: {
    /* n:"BrtEndComments", */
    T: -1
  },
  /*::[*/
  630: {
    /* n:"BrtBeginCommentAuthors", */
    T: 1
  },
  /*::[*/
  631: {
    /* n:"BrtEndCommentAuthors", */
    T: -1
  },
  /*::[*/
  632: {
    /* n:"BrtCommentAuthor", */
    f: S1
  },
  /*::[*/
  633: {
    /* n:"BrtBeginCommentList", */
    T: 1
  },
  /*::[*/
  634: {
    /* n:"BrtEndCommentList", */
    T: -1
  },
  /*::[*/
  635: {
    /* n:"BrtBeginComment", */
    T: 1,
    f: F1
  },
  /*::[*/
  636: {
    /* n:"BrtEndComment", */
    T: -1
  },
  /*::[*/
  637: {
    /* n:"BrtCommentText", */
    f: Ko
  },
  /*::[*/
  638: {
    /* n:"BrtBeginOleObjects", */
    T: 1
  },
  /*::[*/
  639: {
    /* n:"BrtOleObject" */
  },
  /*::[*/
  640: {
    /* n:"BrtEndOleObjects", */
    T: -1
  },
  /*::[*/
  641: {
    /* n:"BrtBeginSxrules", */
    T: 1
  },
  /*::[*/
  642: {
    /* n:"BrtEndSxRules", */
    T: -1
  },
  /*::[*/
  643: {
    /* n:"BrtBeginActiveXControls", */
    T: 1
  },
  /*::[*/
  644: {
    /* n:"BrtActiveX" */
  },
  /*::[*/
  645: {
    /* n:"BrtEndActiveXControls", */
    T: -1
  },
  /*::[*/
  646: {
    /* n:"BrtBeginPCDSDTCEMembersSortBy", */
    T: 1
  },
  /*::[*/
  648: {
    /* n:"BrtBeginCellIgnoreECs", */
    T: 1
  },
  /*::[*/
  649: {
    /* n:"BrtCellIgnoreEC" */
  },
  /*::[*/
  650: {
    /* n:"BrtEndCellIgnoreECs", */
    T: -1
  },
  /*::[*/
  651: {
    /* n:"BrtCsProp", */
    f: cp
  },
  /*::[*/
  652: {
    /* n:"BrtCsPageSetup" */
  },
  /*::[*/
  653: {
    /* n:"BrtBeginUserCsViews", */
    T: 1
  },
  /*::[*/
  654: {
    /* n:"BrtEndUserCsViews", */
    T: -1
  },
  /*::[*/
  655: {
    /* n:"BrtBeginUserCsView", */
    T: 1
  },
  /*::[*/
  656: {
    /* n:"BrtEndUserCsView", */
    T: -1
  },
  /*::[*/
  657: {
    /* n:"BrtBeginPcdSFCIEntries", */
    T: 1
  },
  /*::[*/
  658: {
    /* n:"BrtEndPCDSFCIEntries", */
    T: -1
  },
  /*::[*/
  659: {
    /* n:"BrtPCDSFCIEntry" */
  },
  /*::[*/
  660: {
    /* n:"BrtBeginListParts", */
    T: 1
  },
  /*::[*/
  661: {
    /* n:"BrtListPart" */
  },
  /*::[*/
  662: {
    /* n:"BrtEndListParts", */
    T: -1
  },
  /*::[*/
  663: {
    /* n:"BrtSheetCalcProp" */
  },
  /*::[*/
  664: {
    /* n:"BrtBeginFnGroup", */
    T: 1
  },
  /*::[*/
  665: {
    /* n:"BrtFnGroup" */
  },
  /*::[*/
  666: {
    /* n:"BrtEndFnGroup", */
    T: -1
  },
  /*::[*/
  667: {
    /* n:"BrtSupAddin" */
  },
  /*::[*/
  668: {
    /* n:"BrtSXTDMPOrder" */
  },
  /*::[*/
  669: {
    /* n:"BrtCsProtection" */
  },
  /*::[*/
  671: {
    /* n:"BrtBeginWsSortMap", */
    T: 1
  },
  /*::[*/
  672: {
    /* n:"BrtEndWsSortMap", */
    T: -1
  },
  /*::[*/
  673: {
    /* n:"BrtBeginRRSort", */
    T: 1
  },
  /*::[*/
  674: {
    /* n:"BrtEndRRSort", */
    T: -1
  },
  /*::[*/
  675: {
    /* n:"BrtRRSortItem" */
  },
  /*::[*/
  676: {
    /* n:"BrtFileSharingIso" */
  },
  /*::[*/
  677: {
    /* n:"BrtBookProtectionIso" */
  },
  /*::[*/
  678: {
    /* n:"BrtSheetProtectionIso" */
  },
  /*::[*/
  679: {
    /* n:"BrtCsProtectionIso" */
  },
  /*::[*/
  680: {
    /* n:"BrtRangeProtectionIso" */
  },
  /*::[*/
  681: {
    /* n:"BrtDValList" */
  },
  /*::[*/
  1024: {
    /* n:"BrtRwDescent" */
  },
  /*::[*/
  1025: {
    /* n:"BrtKnownFonts" */
  },
  /*::[*/
  1026: {
    /* n:"BrtBeginSXTupleSet", */
    T: 1
  },
  /*::[*/
  1027: {
    /* n:"BrtEndSXTupleSet", */
    T: -1
  },
  /*::[*/
  1028: {
    /* n:"BrtBeginSXTupleSetHeader", */
    T: 1
  },
  /*::[*/
  1029: {
    /* n:"BrtEndSXTupleSetHeader", */
    T: -1
  },
  /*::[*/
  1030: {
    /* n:"BrtSXTupleSetHeaderItem" */
  },
  /*::[*/
  1031: {
    /* n:"BrtBeginSXTupleSetData", */
    T: 1
  },
  /*::[*/
  1032: {
    /* n:"BrtEndSXTupleSetData", */
    T: -1
  },
  /*::[*/
  1033: {
    /* n:"BrtBeginSXTupleSetRow", */
    T: 1
  },
  /*::[*/
  1034: {
    /* n:"BrtEndSXTupleSetRow", */
    T: -1
  },
  /*::[*/
  1035: {
    /* n:"BrtSXTupleSetRowItem" */
  },
  /*::[*/
  1036: {
    /* n:"BrtNameExt" */
  },
  /*::[*/
  1037: {
    /* n:"BrtPCDH14" */
  },
  /*::[*/
  1038: {
    /* n:"BrtBeginPCDCalcMem14", */
    T: 1
  },
  /*::[*/
  1039: {
    /* n:"BrtEndPCDCalcMem14", */
    T: -1
  },
  /*::[*/
  1040: {
    /* n:"BrtSXTH14" */
  },
  /*::[*/
  1041: {
    /* n:"BrtBeginSparklineGroup", */
    T: 1
  },
  /*::[*/
  1042: {
    /* n:"BrtEndSparklineGroup", */
    T: -1
  },
  /*::[*/
  1043: {
    /* n:"BrtSparkline" */
  },
  /*::[*/
  1044: {
    /* n:"BrtSXDI14" */
  },
  /*::[*/
  1045: {
    /* n:"BrtWsFmtInfoEx14" */
  },
  /*::[*/
  1046: {
    /* n:"BrtBeginConditionalFormatting14", */
    T: 1
  },
  /*::[*/
  1047: {
    /* n:"BrtEndConditionalFormatting14", */
    T: -1
  },
  /*::[*/
  1048: {
    /* n:"BrtBeginCFRule14", */
    T: 1
  },
  /*::[*/
  1049: {
    /* n:"BrtEndCFRule14", */
    T: -1
  },
  /*::[*/
  1050: {
    /* n:"BrtCFVO14" */
  },
  /*::[*/
  1051: {
    /* n:"BrtBeginDatabar14", */
    T: 1
  },
  /*::[*/
  1052: {
    /* n:"BrtBeginIconSet14", */
    T: 1
  },
  /*::[*/
  1053: {
    /* n:"BrtDVal14", */
    f: tp
  },
  /*::[*/
  1054: {
    /* n:"BrtBeginDVals14", */
    T: 1
  },
  /*::[*/
  1055: {
    /* n:"BrtColor14" */
  },
  /*::[*/
  1056: {
    /* n:"BrtBeginSparklines", */
    T: 1
  },
  /*::[*/
  1057: {
    /* n:"BrtEndSparklines", */
    T: -1
  },
  /*::[*/
  1058: {
    /* n:"BrtBeginSparklineGroups", */
    T: 1
  },
  /*::[*/
  1059: {
    /* n:"BrtEndSparklineGroups", */
    T: -1
  },
  /*::[*/
  1061: {
    /* n:"BrtSXVD14" */
  },
  /*::[*/
  1062: {
    /* n:"BrtBeginSXView14", */
    T: 1
  },
  /*::[*/
  1063: {
    /* n:"BrtEndSXView14", */
    T: -1
  },
  /*::[*/
  1064: {
    /* n:"BrtBeginSXView16", */
    T: 1
  },
  /*::[*/
  1065: {
    /* n:"BrtEndSXView16", */
    T: -1
  },
  /*::[*/
  1066: {
    /* n:"BrtBeginPCD14", */
    T: 1
  },
  /*::[*/
  1067: {
    /* n:"BrtEndPCD14", */
    T: -1
  },
  /*::[*/
  1068: {
    /* n:"BrtBeginExtConn14", */
    T: 1
  },
  /*::[*/
  1069: {
    /* n:"BrtEndExtConn14", */
    T: -1
  },
  /*::[*/
  1070: {
    /* n:"BrtBeginSlicerCacheIDs", */
    T: 1
  },
  /*::[*/
  1071: {
    /* n:"BrtEndSlicerCacheIDs", */
    T: -1
  },
  /*::[*/
  1072: {
    /* n:"BrtBeginSlicerCacheID", */
    T: 1
  },
  /*::[*/
  1073: {
    /* n:"BrtEndSlicerCacheID", */
    T: -1
  },
  /*::[*/
  1075: {
    /* n:"BrtBeginSlicerCache", */
    T: 1
  },
  /*::[*/
  1076: {
    /* n:"BrtEndSlicerCache", */
    T: -1
  },
  /*::[*/
  1077: {
    /* n:"BrtBeginSlicerCacheDef", */
    T: 1
  },
  /*::[*/
  1078: {
    /* n:"BrtEndSlicerCacheDef", */
    T: -1
  },
  /*::[*/
  1079: {
    /* n:"BrtBeginSlicersEx", */
    T: 1
  },
  /*::[*/
  1080: {
    /* n:"BrtEndSlicersEx", */
    T: -1
  },
  /*::[*/
  1081: {
    /* n:"BrtBeginSlicerEx", */
    T: 1
  },
  /*::[*/
  1082: {
    /* n:"BrtEndSlicerEx", */
    T: -1
  },
  /*::[*/
  1083: {
    /* n:"BrtBeginSlicer", */
    T: 1
  },
  /*::[*/
  1084: {
    /* n:"BrtEndSlicer", */
    T: -1
  },
  /*::[*/
  1085: {
    /* n:"BrtSlicerCachePivotTables" */
  },
  /*::[*/
  1086: {
    /* n:"BrtBeginSlicerCacheOlapImpl", */
    T: 1
  },
  /*::[*/
  1087: {
    /* n:"BrtEndSlicerCacheOlapImpl", */
    T: -1
  },
  /*::[*/
  1088: {
    /* n:"BrtBeginSlicerCacheLevelsData", */
    T: 1
  },
  /*::[*/
  1089: {
    /* n:"BrtEndSlicerCacheLevelsData", */
    T: -1
  },
  /*::[*/
  1090: {
    /* n:"BrtBeginSlicerCacheLevelData", */
    T: 1
  },
  /*::[*/
  1091: {
    /* n:"BrtEndSlicerCacheLevelData", */
    T: -1
  },
  /*::[*/
  1092: {
    /* n:"BrtBeginSlicerCacheSiRanges", */
    T: 1
  },
  /*::[*/
  1093: {
    /* n:"BrtEndSlicerCacheSiRanges", */
    T: -1
  },
  /*::[*/
  1094: {
    /* n:"BrtBeginSlicerCacheSiRange", */
    T: 1
  },
  /*::[*/
  1095: {
    /* n:"BrtEndSlicerCacheSiRange", */
    T: -1
  },
  /*::[*/
  1096: {
    /* n:"BrtSlicerCacheOlapItem" */
  },
  /*::[*/
  1097: {
    /* n:"BrtBeginSlicerCacheSelections", */
    T: 1
  },
  /*::[*/
  1098: {
    /* n:"BrtSlicerCacheSelection" */
  },
  /*::[*/
  1099: {
    /* n:"BrtEndSlicerCacheSelections", */
    T: -1
  },
  /*::[*/
  1100: {
    /* n:"BrtBeginSlicerCacheNative", */
    T: 1
  },
  /*::[*/
  1101: {
    /* n:"BrtEndSlicerCacheNative", */
    T: -1
  },
  /*::[*/
  1102: {
    /* n:"BrtSlicerCacheNativeItem" */
  },
  /*::[*/
  1103: {
    /* n:"BrtRangeProtection14" */
  },
  /*::[*/
  1104: {
    /* n:"BrtRangeProtectionIso14" */
  },
  /*::[*/
  1105: {
    /* n:"BrtCellIgnoreEC14" */
  },
  /*::[*/
  1111: {
    /* n:"BrtList14" */
  },
  /*::[*/
  1112: {
    /* n:"BrtCFIcon" */
  },
  /*::[*/
  1113: {
    /* n:"BrtBeginSlicerCachesPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  1114: {
    /* n:"BrtEndSlicerCachesPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  1115: {
    /* n:"BrtBeginSlicers", */
    T: 1
  },
  /*::[*/
  1116: {
    /* n:"BrtEndSlicers", */
    T: -1
  },
  /*::[*/
  1117: {
    /* n:"BrtWbProp14" */
  },
  /*::[*/
  1118: {
    /* n:"BrtBeginSXEdit", */
    T: 1
  },
  /*::[*/
  1119: {
    /* n:"BrtEndSXEdit", */
    T: -1
  },
  /*::[*/
  1120: {
    /* n:"BrtBeginSXEdits", */
    T: 1
  },
  /*::[*/
  1121: {
    /* n:"BrtEndSXEdits", */
    T: -1
  },
  /*::[*/
  1122: {
    /* n:"BrtBeginSXChange", */
    T: 1
  },
  /*::[*/
  1123: {
    /* n:"BrtEndSXChange", */
    T: -1
  },
  /*::[*/
  1124: {
    /* n:"BrtBeginSXChanges", */
    T: 1
  },
  /*::[*/
  1125: {
    /* n:"BrtEndSXChanges", */
    T: -1
  },
  /*::[*/
  1126: {
    /* n:"BrtSXTupleItems" */
  },
  /*::[*/
  1128: {
    /* n:"BrtBeginSlicerStyle", */
    T: 1
  },
  /*::[*/
  1129: {
    /* n:"BrtEndSlicerStyle", */
    T: -1
  },
  /*::[*/
  1130: {
    /* n:"BrtSlicerStyleElement" */
  },
  /*::[*/
  1131: {
    /* n:"BrtBeginStyleSheetExt14", */
    T: 1
  },
  /*::[*/
  1132: {
    /* n:"BrtEndStyleSheetExt14", */
    T: -1
  },
  /*::[*/
  1133: {
    /* n:"BrtBeginSlicerCachesPivotCacheID", */
    T: 1
  },
  /*::[*/
  1134: {
    /* n:"BrtEndSlicerCachesPivotCacheID", */
    T: -1
  },
  /*::[*/
  1135: {
    /* n:"BrtBeginConditionalFormattings", */
    T: 1
  },
  /*::[*/
  1136: {
    /* n:"BrtEndConditionalFormattings", */
    T: -1
  },
  /*::[*/
  1137: {
    /* n:"BrtBeginPCDCalcMemExt", */
    T: 1
  },
  /*::[*/
  1138: {
    /* n:"BrtEndPCDCalcMemExt", */
    T: -1
  },
  /*::[*/
  1139: {
    /* n:"BrtBeginPCDCalcMemsExt", */
    T: 1
  },
  /*::[*/
  1140: {
    /* n:"BrtEndPCDCalcMemsExt", */
    T: -1
  },
  /*::[*/
  1141: {
    /* n:"BrtPCDField14" */
  },
  /*::[*/
  1142: {
    /* n:"BrtBeginSlicerStyles", */
    T: 1
  },
  /*::[*/
  1143: {
    /* n:"BrtEndSlicerStyles", */
    T: -1
  },
  /*::[*/
  1144: {
    /* n:"BrtBeginSlicerStyleElements", */
    T: 1
  },
  /*::[*/
  1145: {
    /* n:"BrtEndSlicerStyleElements", */
    T: -1
  },
  /*::[*/
  1146: {
    /* n:"BrtCFRuleExt" */
  },
  /*::[*/
  1147: {
    /* n:"BrtBeginSXCondFmt14", */
    T: 1
  },
  /*::[*/
  1148: {
    /* n:"BrtEndSXCondFmt14", */
    T: -1
  },
  /*::[*/
  1149: {
    /* n:"BrtBeginSXCondFmts14", */
    T: 1
  },
  /*::[*/
  1150: {
    /* n:"BrtEndSXCondFmts14", */
    T: -1
  },
  /*::[*/
  1152: {
    /* n:"BrtBeginSortCond14", */
    T: 1
  },
  /*::[*/
  1153: {
    /* n:"BrtEndSortCond14", */
    T: -1
  },
  /*::[*/
  1154: {
    /* n:"BrtEndDVals14", */
    T: -1
  },
  /*::[*/
  1155: {
    /* n:"BrtEndIconSet14", */
    T: -1
  },
  /*::[*/
  1156: {
    /* n:"BrtEndDatabar14", */
    T: -1
  },
  /*::[*/
  1157: {
    /* n:"BrtBeginColorScale14", */
    T: 1
  },
  /*::[*/
  1158: {
    /* n:"BrtEndColorScale14", */
    T: -1
  },
  /*::[*/
  1159: {
    /* n:"BrtBeginSxrules14", */
    T: 1
  },
  /*::[*/
  1160: {
    /* n:"BrtEndSxrules14", */
    T: -1
  },
  /*::[*/
  1161: {
    /* n:"BrtBeginPRule14", */
    T: 1
  },
  /*::[*/
  1162: {
    /* n:"BrtEndPRule14", */
    T: -1
  },
  /*::[*/
  1163: {
    /* n:"BrtBeginPRFilters14", */
    T: 1
  },
  /*::[*/
  1164: {
    /* n:"BrtEndPRFilters14", */
    T: -1
  },
  /*::[*/
  1165: {
    /* n:"BrtBeginPRFilter14", */
    T: 1
  },
  /*::[*/
  1166: {
    /* n:"BrtEndPRFilter14", */
    T: -1
  },
  /*::[*/
  1167: {
    /* n:"BrtBeginPRFItem14", */
    T: 1
  },
  /*::[*/
  1168: {
    /* n:"BrtEndPRFItem14", */
    T: -1
  },
  /*::[*/
  1169: {
    /* n:"BrtBeginCellIgnoreECs14", */
    T: 1
  },
  /*::[*/
  1170: {
    /* n:"BrtEndCellIgnoreECs14", */
    T: -1
  },
  /*::[*/
  1171: {
    /* n:"BrtDxf14" */
  },
  /*::[*/
  1172: {
    /* n:"BrtBeginDxF14s", */
    T: 1
  },
  /*::[*/
  1173: {
    /* n:"BrtEndDxf14s", */
    T: -1
  },
  /*::[*/
  1177: {
    /* n:"BrtFilter14" */
  },
  /*::[*/
  1178: {
    /* n:"BrtBeginCustomFilters14", */
    T: 1
  },
  /*::[*/
  1180: {
    /* n:"BrtCustomFilter14" */
  },
  /*::[*/
  1181: {
    /* n:"BrtIconFilter14" */
  },
  /*::[*/
  1182: {
    /* n:"BrtPivotCacheConnectionName" */
  },
  /*::[*/
  2048: {
    /* n:"BrtBeginDecoupledPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2049: {
    /* n:"BrtEndDecoupledPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2050: {
    /* n:"BrtDecoupledPivotCacheID" */
  },
  /*::[*/
  2051: {
    /* n:"BrtBeginPivotTableRefs", */
    T: 1
  },
  /*::[*/
  2052: {
    /* n:"BrtEndPivotTableRefs", */
    T: -1
  },
  /*::[*/
  2053: {
    /* n:"BrtPivotTableRef" */
  },
  /*::[*/
  2054: {
    /* n:"BrtSlicerCacheBookPivotTables" */
  },
  /*::[*/
  2055: {
    /* n:"BrtBeginSxvcells", */
    T: 1
  },
  /*::[*/
  2056: {
    /* n:"BrtEndSxvcells", */
    T: -1
  },
  /*::[*/
  2057: {
    /* n:"BrtBeginSxRow", */
    T: 1
  },
  /*::[*/
  2058: {
    /* n:"BrtEndSxRow", */
    T: -1
  },
  /*::[*/
  2060: {
    /* n:"BrtPcdCalcMem15" */
  },
  /*::[*/
  2067: {
    /* n:"BrtQsi15" */
  },
  /*::[*/
  2068: {
    /* n:"BrtBeginWebExtensions", */
    T: 1
  },
  /*::[*/
  2069: {
    /* n:"BrtEndWebExtensions", */
    T: -1
  },
  /*::[*/
  2070: {
    /* n:"BrtWebExtension" */
  },
  /*::[*/
  2071: {
    /* n:"BrtAbsPath15" */
  },
  /*::[*/
  2072: {
    /* n:"BrtBeginPivotTableUISettings", */
    T: 1
  },
  /*::[*/
  2073: {
    /* n:"BrtEndPivotTableUISettings", */
    T: -1
  },
  /*::[*/
  2075: {
    /* n:"BrtTableSlicerCacheIDs" */
  },
  /*::[*/
  2076: {
    /* n:"BrtTableSlicerCacheID" */
  },
  /*::[*/
  2077: {
    /* n:"BrtBeginTableSlicerCache", */
    T: 1
  },
  /*::[*/
  2078: {
    /* n:"BrtEndTableSlicerCache", */
    T: -1
  },
  /*::[*/
  2079: {
    /* n:"BrtSxFilter15" */
  },
  /*::[*/
  2080: {
    /* n:"BrtBeginTimelineCachePivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2081: {
    /* n:"BrtEndTimelineCachePivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2082: {
    /* n:"BrtTimelineCachePivotCacheID" */
  },
  /*::[*/
  2083: {
    /* n:"BrtBeginTimelineCacheIDs", */
    T: 1
  },
  /*::[*/
  2084: {
    /* n:"BrtEndTimelineCacheIDs", */
    T: -1
  },
  /*::[*/
  2085: {
    /* n:"BrtBeginTimelineCacheID", */
    T: 1
  },
  /*::[*/
  2086: {
    /* n:"BrtEndTimelineCacheID", */
    T: -1
  },
  /*::[*/
  2087: {
    /* n:"BrtBeginTimelinesEx", */
    T: 1
  },
  /*::[*/
  2088: {
    /* n:"BrtEndTimelinesEx", */
    T: -1
  },
  /*::[*/
  2089: {
    /* n:"BrtBeginTimelineEx", */
    T: 1
  },
  /*::[*/
  2090: {
    /* n:"BrtEndTimelineEx", */
    T: -1
  },
  /*::[*/
  2091: {
    /* n:"BrtWorkBookPr15" */
  },
  /*::[*/
  2092: {
    /* n:"BrtPCDH15" */
  },
  /*::[*/
  2093: {
    /* n:"BrtBeginTimelineStyle", */
    T: 1
  },
  /*::[*/
  2094: {
    /* n:"BrtEndTimelineStyle", */
    T: -1
  },
  /*::[*/
  2095: {
    /* n:"BrtTimelineStyleElement" */
  },
  /*::[*/
  2096: {
    /* n:"BrtBeginTimelineStylesheetExt15", */
    T: 1
  },
  /*::[*/
  2097: {
    /* n:"BrtEndTimelineStylesheetExt15", */
    T: -1
  },
  /*::[*/
  2098: {
    /* n:"BrtBeginTimelineStyles", */
    T: 1
  },
  /*::[*/
  2099: {
    /* n:"BrtEndTimelineStyles", */
    T: -1
  },
  /*::[*/
  2100: {
    /* n:"BrtBeginTimelineStyleElements", */
    T: 1
  },
  /*::[*/
  2101: {
    /* n:"BrtEndTimelineStyleElements", */
    T: -1
  },
  /*::[*/
  2102: {
    /* n:"BrtDxf15" */
  },
  /*::[*/
  2103: {
    /* n:"BrtBeginDxfs15", */
    T: 1
  },
  /*::[*/
  2104: {
    /* n:"BrtEndDxfs15", */
    T: -1
  },
  /*::[*/
  2105: {
    /* n:"BrtSlicerCacheHideItemsWithNoData" */
  },
  /*::[*/
  2106: {
    /* n:"BrtBeginItemUniqueNames", */
    T: 1
  },
  /*::[*/
  2107: {
    /* n:"BrtEndItemUniqueNames", */
    T: -1
  },
  /*::[*/
  2108: {
    /* n:"BrtItemUniqueName" */
  },
  /*::[*/
  2109: {
    /* n:"BrtBeginExtConn15", */
    T: 1
  },
  /*::[*/
  2110: {
    /* n:"BrtEndExtConn15", */
    T: -1
  },
  /*::[*/
  2111: {
    /* n:"BrtBeginOledbPr15", */
    T: 1
  },
  /*::[*/
  2112: {
    /* n:"BrtEndOledbPr15", */
    T: -1
  },
  /*::[*/
  2113: {
    /* n:"BrtBeginDataFeedPr15", */
    T: 1
  },
  /*::[*/
  2114: {
    /* n:"BrtEndDataFeedPr15", */
    T: -1
  },
  /*::[*/
  2115: {
    /* n:"BrtTextPr15" */
  },
  /*::[*/
  2116: {
    /* n:"BrtRangePr15" */
  },
  /*::[*/
  2117: {
    /* n:"BrtDbCommand15" */
  },
  /*::[*/
  2118: {
    /* n:"BrtBeginDbTables15", */
    T: 1
  },
  /*::[*/
  2119: {
    /* n:"BrtEndDbTables15", */
    T: -1
  },
  /*::[*/
  2120: {
    /* n:"BrtDbTable15" */
  },
  /*::[*/
  2121: {
    /* n:"BrtBeginDataModel", */
    T: 1
  },
  /*::[*/
  2122: {
    /* n:"BrtEndDataModel", */
    T: -1
  },
  /*::[*/
  2123: {
    /* n:"BrtBeginModelTables", */
    T: 1
  },
  /*::[*/
  2124: {
    /* n:"BrtEndModelTables", */
    T: -1
  },
  /*::[*/
  2125: {
    /* n:"BrtModelTable" */
  },
  /*::[*/
  2126: {
    /* n:"BrtBeginModelRelationships", */
    T: 1
  },
  /*::[*/
  2127: {
    /* n:"BrtEndModelRelationships", */
    T: -1
  },
  /*::[*/
  2128: {
    /* n:"BrtModelRelationship" */
  },
  /*::[*/
  2129: {
    /* n:"BrtBeginECTxtWiz15", */
    T: 1
  },
  /*::[*/
  2130: {
    /* n:"BrtEndECTxtWiz15", */
    T: -1
  },
  /*::[*/
  2131: {
    /* n:"BrtBeginECTWFldInfoLst15", */
    T: 1
  },
  /*::[*/
  2132: {
    /* n:"BrtEndECTWFldInfoLst15", */
    T: -1
  },
  /*::[*/
  2133: {
    /* n:"BrtBeginECTWFldInfo15", */
    T: 1
  },
  /*::[*/
  2134: {
    /* n:"BrtFieldListActiveItem" */
  },
  /*::[*/
  2135: {
    /* n:"BrtPivotCacheIdVersion" */
  },
  /*::[*/
  2136: {
    /* n:"BrtSXDI15" */
  },
  /*::[*/
  2137: {
    /* n:"BrtBeginModelTimeGroupings", */
    T: 1
  },
  /*::[*/
  2138: {
    /* n:"BrtEndModelTimeGroupings", */
    T: -1
  },
  /*::[*/
  2139: {
    /* n:"BrtBeginModelTimeGrouping", */
    T: 1
  },
  /*::[*/
  2140: {
    /* n:"BrtEndModelTimeGrouping", */
    T: -1
  },
  /*::[*/
  2141: {
    /* n:"BrtModelTimeGroupingCalcCol" */
  },
  /*::[*/
  3072: {
    /* n:"BrtUid" */
  },
  /*::[*/
  3073: {
    /* n:"BrtRevisionPtr" */
  },
  /*::[*/
  4096: {
    /* n:"BrtBeginDynamicArrayPr", */
    T: 1
  },
  /*::[*/
  4097: {
    /* n:"BrtEndDynamicArrayPr", */
    T: -1
  },
  /*::[*/
  5002: {
    /* n:"BrtBeginRichValueBlock", */
    T: 1
  },
  /*::[*/
  5003: {
    /* n:"BrtEndRichValueBlock", */
    T: -1
  },
  /*::[*/
  5081: {
    /* n:"BrtBeginRichFilters", */
    T: 1
  },
  /*::[*/
  5082: {
    /* n:"BrtEndRichFilters", */
    T: -1
  },
  /*::[*/
  5083: {
    /* n:"BrtRichFilter" */
  },
  /*::[*/
  5084: {
    /* n:"BrtBeginRichFilterColumn", */
    T: 1
  },
  /*::[*/
  5085: {
    /* n:"BrtEndRichFilterColumn", */
    T: -1
  },
  /*::[*/
  5086: {
    /* n:"BrtBeginCustomRichFilters", */
    T: 1
  },
  /*::[*/
  5087: {
    /* n:"BrtEndCustomRichFilters", */
    T: -1
  },
  /*::[*/
  5088: {
    /* n:"BrtCustomRichFilter" */
  },
  /*::[*/
  5089: {
    /* n:"BrtTop10RichFilter" */
  },
  /*::[*/
  5090: {
    /* n:"BrtDynamicRichFilter" */
  },
  /*::[*/
  5092: {
    /* n:"BrtBeginRichSortCondition", */
    T: 1
  },
  /*::[*/
  5093: {
    /* n:"BrtEndRichSortCondition", */
    T: -1
  },
  /*::[*/
  5094: {
    /* n:"BrtRichFilterDateGroupItem" */
  },
  /*::[*/
  5095: {
    /* n:"BrtBeginCalcFeatures", */
    T: 1
  },
  /*::[*/
  5096: {
    /* n:"BrtEndCalcFeatures", */
    T: -1
  },
  /*::[*/
  5097: {
    /* n:"BrtCalcFeature" */
  },
  /*::[*/
  5099: {
    /* n:"BrtExternalLinksPr" */
  },
  /*::[*/
  65535: { n: "" }
}, Pn = {
  /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
  /*::[*/
  6: {
    /* n:"Formula", */
    f: wn
  },
  /*::[*/
  10: {
    /* n:"EOF", */
    f: et
  },
  /*::[*/
  12: {
    /* n:"CalcCount", */
    f: We
  },
  //
  /*::[*/
  13: {
    /* n:"CalcMode", */
    f: We
  },
  //
  /*::[*/
  14: {
    /* n:"CalcPrecision", */
    f: $e
  },
  //
  /*::[*/
  15: {
    /* n:"CalcRefMode", */
    f: $e
  },
  //
  /*::[*/
  16: {
    /* n:"CalcDelta", */
    f: nr
  },
  //
  /*::[*/
  17: {
    /* n:"CalcIter", */
    f: $e
  },
  //
  /*::[*/
  18: {
    /* n:"Protect", */
    f: $e
  },
  /*::[*/
  19: {
    /* n:"Password", */
    f: We
  },
  /*::[*/
  20: {
    /* n:"Header", */
    f: oi
  },
  /*::[*/
  21: {
    /* n:"Footer", */
    f: oi
  },
  /*::[*/
  23: {
    /* n:"ExternSheet", */
    f: ec
  },
  /*::[*/
  24: {
    /* n:"Lbl", */
    f: li
  },
  /*::[*/
  25: {
    /* n:"WinProtect", */
    f: $e
  },
  /*::[*/
  26: {
    /* n:"VerticalPageBreaks", */
  },
  /*::[*/
  27: {
    /* n:"HorizontalPageBreaks", */
  },
  /*::[*/
  28: {
    /* n:"Note", */
    f: wl
  },
  /*::[*/
  29: {
    /* n:"Selection", */
  },
  /*::[*/
  34: {
    /* n:"Date1904", */
    f: $e
  },
  /*::[*/
  35: {
    /* n:"ExternName", */
    f: ui
  },
  /*::[*/
  38: {
    /* n:"LeftMargin", */
    f: nr
  },
  // *
  /*::[*/
  39: {
    /* n:"RightMargin", */
    f: nr
  },
  // *
  /*::[*/
  40: {
    /* n:"TopMargin", */
    f: nr
  },
  // *
  /*::[*/
  41: {
    /* n:"BottomMargin", */
    f: nr
  },
  // *
  /*::[*/
  42: {
    /* n:"PrintRowCol", */
    f: $e
  },
  /*::[*/
  43: {
    /* n:"PrintGrid", */
    f: $e
  },
  /*::[*/
  47: {
    /* n:"FilePass", */
    f: yh
  },
  /*::[*/
  49: {
    /* n:"Font", */
    f: nl
  },
  /*::[*/
  51: {
    /* n:"PrintSize", */
    f: We
  },
  /*::[*/
  60: {
    /* n:"Continue", */
  },
  /*::[*/
  61: {
    /* n:"Window1", */
    f: rl
  },
  /*::[*/
  64: {
    /* n:"Backup", */
    f: $e
  },
  /*::[*/
  65: {
    /* n:"Pane", */
    f: al
  },
  /*::[*/
  66: {
    /* n:"CodePage", */
    f: We
  },
  /*::[*/
  77: {
    /* n:"Pls", */
  },
  /*::[*/
  80: {
    /* n:"DCon", */
  },
  /*::[*/
  81: {
    /* n:"DConRef", */
  },
  /*::[*/
  82: {
    /* n:"DConName", */
  },
  /*::[*/
  85: {
    /* n:"DefColWidth", */
    f: We
  },
  /*::[*/
  89: {
    /* n:"XCT", */
  },
  /*::[*/
  90: {
    /* n:"CRN", */
  },
  /*::[*/
  91: {
    /* n:"FileSharing", */
  },
  /*::[*/
  92: {
    /* n:"WriteAccess", */
    f: ju
  },
  /*::[*/
  93: {
    /* n:"Obj", */
    f: Fl
  },
  /*::[*/
  94: {
    /* n:"Uncalced", */
  },
  /*::[*/
  95: {
    /* n:"CalcSaveRecalc", */
    f: $e
  },
  //
  /*::[*/
  96: {
    /* n:"Template", */
  },
  /*::[*/
  97: {
    /* n:"Intl", */
  },
  /*::[*/
  99: {
    /* n:"ObjProtect", */
    f: $e
  },
  /*::[*/
  125: {
    /* n:"ColInfo", */
    f: rc
  },
  /*::[*/
  128: {
    /* n:"Guts", */
    f: dl
  },
  /*::[*/
  129: {
    /* n:"WsBool", */
    f: Xu
  },
  /*::[*/
  130: {
    /* n:"GridSet", */
    f: We
  },
  /*::[*/
  131: {
    /* n:"HCenter", */
    f: $e
  },
  /*::[*/
  132: {
    /* n:"VCenter", */
    f: $e
  },
  /*::[*/
  133: {
    /* n:"BoundSheet8", */
    f: Ku
  },
  /*::[*/
  134: {
    /* n:"WriteProtect", */
  },
  /*::[*/
  140: {
    /* n:"Country", */
    f: Dl
  },
  /*::[*/
  141: {
    /* n:"HideObj", */
    f: We
  },
  /*::[*/
  144: {
    /* n:"Sort", */
  },
  /*::[*/
  146: {
    /* n:"Palette", */
    f: Nl
  },
  /*::[*/
  151: {
    /* n:"Sync", */
  },
  /*::[*/
  152: {
    /* n:"LPr", */
  },
  /*::[*/
  153: {
    /* n:"DxGCol", */
  },
  /*::[*/
  154: {
    /* n:"FnGroupName", */
  },
  /*::[*/
  155: {
    /* n:"FilterMode", */
  },
  /*::[*/
  156: {
    /* n:"BuiltInFnGroupCount", */
    f: We
  },
  /*::[*/
  157: {
    /* n:"AutoFilterInfo", */
  },
  /*::[*/
  158: {
    /* n:"AutoFilter", */
  },
  /*::[*/
  160: {
    /* n:"Scl", */
    f: Bl
  },
  /*::[*/
  161: {
    /* n:"Setup", */
    f: Pl
  },
  /*::[*/
  174: {
    /* n:"ScenMan", */
  },
  /*::[*/
  175: {
    /* n:"SCENARIO", */
  },
  /*::[*/
  176: {
    /* n:"SxView", */
  },
  /*::[*/
  177: {
    /* n:"Sxvd", */
  },
  /*::[*/
  178: {
    /* n:"SXVI", */
  },
  /*::[*/
  180: {
    /* n:"SxIvd", */
  },
  /*::[*/
  181: {
    /* n:"SXLI", */
  },
  /*::[*/
  182: {
    /* n:"SXPI", */
  },
  /*::[*/
  184: {
    /* n:"DocRoute", */
  },
  /*::[*/
  185: {
    /* n:"RecipName", */
  },
  /*::[*/
  189: {
    /* n:"MulRk", */
    f: ul
  },
  /*::[*/
  190: {
    /* n:"MulBlank", */
    f: ll
  },
  /*::[*/
  193: {
    /* n:"Mms", */
    f: et
  },
  /*::[*/
  197: {
    /* n:"SXDI", */
  },
  /*::[*/
  198: {
    /* n:"SXDB", */
  },
  /*::[*/
  199: {
    /* n:"SXFDB", */
  },
  /*::[*/
  200: {
    /* n:"SXDBB", */
  },
  /*::[*/
  201: {
    /* n:"SXNum", */
  },
  /*::[*/
  202: {
    /* n:"SxBool", */
    f: $e
  },
  /*::[*/
  203: {
    /* n:"SxErr", */
  },
  /*::[*/
  204: {
    /* n:"SXInt", */
  },
  /*::[*/
  205: {
    /* n:"SXString", */
  },
  /*::[*/
  206: {
    /* n:"SXDtr", */
  },
  /*::[*/
  207: {
    /* n:"SxNil", */
  },
  /*::[*/
  208: {
    /* n:"SXTbl", */
  },
  /*::[*/
  209: {
    /* n:"SXTBRGIITM", */
  },
  /*::[*/
  210: {
    /* n:"SxTbpg", */
  },
  /*::[*/
  211: {
    /* n:"ObProj", */
  },
  /*::[*/
  213: {
    /* n:"SXStreamID", */
  },
  /*::[*/
  215: {
    /* n:"DBCell", */
  },
  /*::[*/
  216: {
    /* n:"SXRng", */
  },
  /*::[*/
  217: {
    /* n:"SxIsxoper", */
  },
  /*::[*/
  218: {
    /* n:"BookBool", */
    f: We
  },
  /*::[*/
  220: {
    /* n:"DbOrParamQry", */
  },
  /*::[*/
  221: {
    /* n:"ScenarioProtect", */
    f: $e
  },
  /*::[*/
  222: {
    /* n:"OleObjectSize", */
  },
  /*::[*/
  224: {
    /* n:"XF", */
    f: xl
  },
  /*::[*/
  225: {
    /* n:"InterfaceHdr", */
    f: Gu
  },
  /*::[*/
  226: {
    /* n:"InterfaceEnd", */
    f: et
  },
  /*::[*/
  227: {
    /* n:"SXVS", */
  },
  /*::[*/
  229: {
    /* n:"MergeCells", */
    f: Al
  },
  /*::[*/
  233: {
    /* n:"BkHim", */
  },
  /*::[*/
  235: {
    /* n:"MsoDrawingGroup", */
  },
  /*::[*/
  236: {
    /* n:"MsoDrawing", */
  },
  /*::[*/
  237: {
    /* n:"MsoDrawingSelection", */
  },
  /*::[*/
  239: {
    /* n:"PhoneticInfo", */
  },
  /*::[*/
  240: {
    /* n:"SxRule", */
  },
  /*::[*/
  241: {
    /* n:"SXEx", */
  },
  /*::[*/
  242: {
    /* n:"SxFilt", */
  },
  /*::[*/
  244: {
    /* n:"SxDXF", */
  },
  /*::[*/
  245: {
    /* n:"SxItm", */
  },
  /*::[*/
  246: {
    /* n:"SxName", */
  },
  /*::[*/
  247: {
    /* n:"SxSelect", */
  },
  /*::[*/
  248: {
    /* n:"SXPair", */
  },
  /*::[*/
  249: {
    /* n:"SxFmla", */
  },
  /*::[*/
  251: {
    /* n:"SxFormat", */
  },
  /*::[*/
  252: {
    /* n:"SST", */
    f: Yu
  },
  /*::[*/
  253: {
    /* n:"LabelSst", */
    f: il
  },
  /*::[*/
  255: {
    /* n:"ExtSST", */
    f: Ju
  },
  /*::[*/
  256: {
    /* n:"SXVDEx", */
  },
  /*::[*/
  259: {
    /* n:"SXFormula", */
  },
  /*::[*/
  290: {
    /* n:"SXDBEx", */
  },
  /*::[*/
  311: {
    /* n:"RRDInsDel", */
  },
  /*::[*/
  312: {
    /* n:"RRDHead", */
  },
  /*::[*/
  315: {
    /* n:"RRDChgCell", */
  },
  /*::[*/
  317: {
    /* n:"RRTabId", */
    f: Xs
  },
  /*::[*/
  318: {
    /* n:"RRDRenSheet", */
  },
  /*::[*/
  319: {
    /* n:"RRSort", */
  },
  /*::[*/
  320: {
    /* n:"RRDMove", */
  },
  /*::[*/
  330: {
    /* n:"RRFormat", */
  },
  /*::[*/
  331: {
    /* n:"RRAutoFmt", */
  },
  /*::[*/
  333: {
    /* n:"RRInsertSh", */
  },
  /*::[*/
  334: {
    /* n:"RRDMoveBegin", */
  },
  /*::[*/
  335: {
    /* n:"RRDMoveEnd", */
  },
  /*::[*/
  336: {
    /* n:"RRDInsDelBegin", */
  },
  /*::[*/
  337: {
    /* n:"RRDInsDelEnd", */
  },
  /*::[*/
  338: {
    /* n:"RRDConflict", */
  },
  /*::[*/
  339: {
    /* n:"RRDDefName", */
  },
  /*::[*/
  340: {
    /* n:"RRDRstEtxp", */
  },
  /*::[*/
  351: {
    /* n:"LRng", */
  },
  /*::[*/
  352: {
    /* n:"UsesELFs", */
    f: $e
  },
  /*::[*/
  353: {
    /* n:"DSF", */
    f: et
  },
  /*::[*/
  401: {
    /* n:"CUsr", */
  },
  /*::[*/
  402: {
    /* n:"CbUsr", */
  },
  /*::[*/
  403: {
    /* n:"UsrInfo", */
  },
  /*::[*/
  404: {
    /* n:"UsrExcl", */
  },
  /*::[*/
  405: {
    /* n:"FileLock", */
  },
  /*::[*/
  406: {
    /* n:"RRDInfo", */
  },
  /*::[*/
  407: {
    /* n:"BCUsrs", */
  },
  /*::[*/
  408: {
    /* n:"UsrChk", */
  },
  /*::[*/
  425: {
    /* n:"UserBView", */
  },
  /*::[*/
  426: {
    /* n:"UserSViewBegin", */
  },
  /*::[*/
  427: {
    /* n:"UserSViewEnd", */
  },
  /*::[*/
  428: {
    /* n:"RRDUserView", */
  },
  /*::[*/
  429: {
    /* n:"Qsi", */
  },
  /*::[*/
  430: {
    /* n:"SupBook", */
    f: vl
  },
  /*::[*/
  431: {
    /* n:"Prot4Rev", */
    f: $e
  },
  /*::[*/
  432: {
    /* n:"CondFmt", */
  },
  /*::[*/
  433: {
    /* n:"CF", */
  },
  /*::[*/
  434: {
    /* n:"DVal", */
  },
  /*::[*/
  437: {
    /* n:"DConBin", */
  },
  /*::[*/
  438: {
    /* n:"TxO", */
    f: Cl
  },
  /*::[*/
  439: {
    /* n:"RefreshAll", */
    f: $e
  },
  //
  /*::[*/
  440: {
    /* n:"HLink", */
    f: Ol
  },
  /*::[*/
  441: {
    /* n:"Lel", */
  },
  /*::[*/
  442: {
    /* n:"CodeName", */
    f: Ea
  },
  /*::[*/
  443: {
    /* n:"SXFDBType", */
  },
  /*::[*/
  444: {
    /* n:"Prot4RevPass", */
    f: We
  },
  /*::[*/
  445: {
    /* n:"ObNoMacros", */
  },
  /*::[*/
  446: {
    /* n:"Dv", */
  },
  /*::[*/
  448: {
    /* n:"Excel9File", */
    f: et
  },
  /*::[*/
  449: {
    /* n:"RecalcId", */
    f: el,
    r: 2
  },
  /*::[*/
  450: {
    /* n:"EntExU2", */
    f: et
  },
  /*::[*/
  512: {
    /* n:"Dimensions", */
    f: ci
  },
  /*::[*/
  513: {
    /* n:"Blank", */
    f: Ml
  },
  /*::[*/
  515: {
    /* n:"Number", */
    f: pl
  },
  /*::[*/
  516: {
    /* n:"Label", */
    f: sl
  },
  /*::[*/
  517: {
    /* n:"BoolErr", */
    f: fi
  },
  /*::[*/
  519: {
    /* n:"String", */
    f: Ul
  },
  /*::[*/
  520: {
    /* n:"Row", */
    f: qu
  },
  /*::[*/
  523: {
    /* n:"Index", */
  },
  /*::[*/
  545: {
    /* n:"Array", */
    f: hi
  },
  /*::[*/
  549: {
    /* n:"DefaultRowHeight", */
    f: si
  },
  /*::[*/
  566: {
    /* n:"Table", */
  },
  /*::[*/
  574: {
    /* n:"Window2", */
    f: tl
  },
  /*::[*/
  638: {
    /* n:"RK", */
    f: ol
  },
  /*::[*/
  659: {
    /* n:"Style", */
  },
  /*::[*/
  1048: {
    /* n:"BigName", */
  },
  /*::[*/
  1054: {
    /* n:"Format", */
    f: cl
  },
  /*::[*/
  1084: {
    /* n:"ContinueBigName", */
  },
  /*::[*/
  1212: {
    /* n:"ShrFmla", */
    f: kl
  },
  /*::[*/
  2048: {
    /* n:"HLinkTooltip", */
    f: Il
  },
  /*::[*/
  2049: {
    /* n:"WebPub", */
  },
  /*::[*/
  2050: {
    /* n:"QsiSXTag", */
  },
  /*::[*/
  2051: {
    /* n:"DBQueryExt", */
  },
  /*::[*/
  2052: {
    /* n:"ExtString", */
  },
  /*::[*/
  2053: {
    /* n:"TxtQry", */
  },
  /*::[*/
  2054: {
    /* n:"Qsir", */
  },
  /*::[*/
  2055: {
    /* n:"Qsif", */
  },
  /*::[*/
  2056: {
    /* n:"RRDTQSIF", */
  },
  /*::[*/
  2057: {
    /* n:"BOF", */
    f: Na
  },
  /*::[*/
  2058: {
    /* n:"OleDbConn", */
  },
  /*::[*/
  2059: {
    /* n:"WOpt", */
  },
  /*::[*/
  2060: {
    /* n:"SXViewEx", */
  },
  /*::[*/
  2061: {
    /* n:"SXTH", */
  },
  /*::[*/
  2062: {
    /* n:"SXPIEx", */
  },
  /*::[*/
  2063: {
    /* n:"SXVDTEx", */
  },
  /*::[*/
  2064: {
    /* n:"SXViewEx9", */
  },
  /*::[*/
  2066: {
    /* n:"ContinueFrt", */
  },
  /*::[*/
  2067: {
    /* n:"RealTimeData", */
  },
  /*::[*/
  2128: {
    /* n:"ChartFrtInfo", */
  },
  /*::[*/
  2129: {
    /* n:"FrtWrapper", */
  },
  /*::[*/
  2130: {
    /* n:"StartBlock", */
  },
  /*::[*/
  2131: {
    /* n:"EndBlock", */
  },
  /*::[*/
  2132: {
    /* n:"StartObject", */
  },
  /*::[*/
  2133: {
    /* n:"EndObject", */
  },
  /*::[*/
  2134: {
    /* n:"CatLab", */
  },
  /*::[*/
  2135: {
    /* n:"YMult", */
  },
  /*::[*/
  2136: {
    /* n:"SXViewLink", */
  },
  /*::[*/
  2137: {
    /* n:"PivotChartBits", */
  },
  /*::[*/
  2138: {
    /* n:"FrtFontList", */
  },
  /*::[*/
  2146: {
    /* n:"SheetExt", */
  },
  /*::[*/
  2147: {
    /* n:"BookExt", */
    r: 12
  },
  /*::[*/
  2148: {
    /* n:"SXAddl", */
  },
  /*::[*/
  2149: {
    /* n:"CrErr", */
  },
  /*::[*/
  2150: {
    /* n:"HFPicture", */
  },
  /*::[*/
  2151: {
    /* n:"FeatHdr", */
    f: et
  },
  /*::[*/
  2152: {
    /* n:"Feat", */
  },
  /*::[*/
  2154: {
    /* n:"DataLabExt", */
  },
  /*::[*/
  2155: {
    /* n:"DataLabExtContents", */
  },
  /*::[*/
  2156: {
    /* n:"CellWatch", */
  },
  /*::[*/
  2161: {
    /* n:"FeatHdr11", */
  },
  /*::[*/
  2162: {
    /* n:"Feature11", */
  },
  /*::[*/
  2164: {
    /* n:"DropDownObjIds", */
  },
  /*::[*/
  2165: {
    /* n:"ContinueFrt11", */
  },
  /*::[*/
  2166: {
    /* n:"DConn", */
  },
  /*::[*/
  2167: {
    /* n:"List12", */
  },
  /*::[*/
  2168: {
    /* n:"Feature12", */
  },
  /*::[*/
  2169: {
    /* n:"CondFmt12", */
  },
  /*::[*/
  2170: {
    /* n:"CF12", */
  },
  /*::[*/
  2171: {
    /* n:"CFEx", */
  },
  /*::[*/
  2172: {
    /* n:"XFCRC", */
    f: bl,
    r: 12
  },
  /*::[*/
  2173: {
    /* n:"XFExt", */
    f: u1,
    r: 12
  },
  /*::[*/
  2174: {
    /* n:"AutoFilter12", */
  },
  /*::[*/
  2175: {
    /* n:"ContinueFrt12", */
  },
  /*::[*/
  2180: {
    /* n:"MDTInfo", */
  },
  /*::[*/
  2181: {
    /* n:"MDXStr", */
  },
  /*::[*/
  2182: {
    /* n:"MDXTuple", */
  },
  /*::[*/
  2183: {
    /* n:"MDXSet", */
  },
  /*::[*/
  2184: {
    /* n:"MDXProp", */
  },
  /*::[*/
  2185: {
    /* n:"MDXKPI", */
  },
  /*::[*/
  2186: {
    /* n:"MDB", */
  },
  /*::[*/
  2187: {
    /* n:"PLV", */
  },
  /*::[*/
  2188: {
    /* n:"Compat12", */
    f: $e,
    r: 12
  },
  /*::[*/
  2189: {
    /* n:"DXF", */
  },
  /*::[*/
  2190: {
    /* n:"TableStyles", */
    r: 12
  },
  /*::[*/
  2191: {
    /* n:"TableStyle", */
  },
  /*::[*/
  2192: {
    /* n:"TableStyleElement", */
  },
  /*::[*/
  2194: {
    /* n:"StyleExt", */
  },
  /*::[*/
  2195: {
    /* n:"NamePublish", */
  },
  /*::[*/
  2196: {
    /* n:"NameCmt", */
    f: _l,
    r: 12
  },
  /*::[*/
  2197: {
    /* n:"SortData", */
  },
  /*::[*/
  2198: {
    /* n:"Theme", */
    f: n1,
    r: 12
  },
  /*::[*/
  2199: {
    /* n:"GUIDTypeLib", */
  },
  /*::[*/
  2200: {
    /* n:"FnGrp12", */
  },
  /*::[*/
  2201: {
    /* n:"NameFnGrp12", */
  },
  /*::[*/
  2202: {
    /* n:"MTRSettings", */
    f: El,
    r: 12
  },
  /*::[*/
  2203: {
    /* n:"CompressPictures", */
    f: et
  },
  /*::[*/
  2204: {
    /* n:"HeaderFooter", */
  },
  /*::[*/
  2205: {
    /* n:"CrtLayout12", */
  },
  /*::[*/
  2206: {
    /* n:"CrtMlFrt", */
  },
  /*::[*/
  2207: {
    /* n:"CrtMlFrtContinue", */
  },
  /*::[*/
  2211: {
    /* n:"ForceFullCalculation", */
    f: Qu
  },
  /*::[*/
  2212: {
    /* n:"ShapePropsStream", */
  },
  /*::[*/
  2213: {
    /* n:"TextPropsStream", */
  },
  /*::[*/
  2214: {
    /* n:"RichTextStream", */
  },
  /*::[*/
  2215: {
    /* n:"CrtLayout12A", */
  },
  /*::[*/
  4097: {
    /* n:"Units", */
  },
  /*::[*/
  4098: {
    /* n:"Chart", */
  },
  /*::[*/
  4099: {
    /* n:"Series", */
  },
  /*::[*/
  4102: {
    /* n:"DataFormat", */
  },
  /*::[*/
  4103: {
    /* n:"LineFormat", */
  },
  /*::[*/
  4105: {
    /* n:"MarkerFormat", */
  },
  /*::[*/
  4106: {
    /* n:"AreaFormat", */
  },
  /*::[*/
  4107: {
    /* n:"PieFormat", */
  },
  /*::[*/
  4108: {
    /* n:"AttachedLabel", */
  },
  /*::[*/
  4109: {
    /* n:"SeriesText", */
  },
  /*::[*/
  4116: {
    /* n:"ChartFormat", */
  },
  /*::[*/
  4117: {
    /* n:"Legend", */
  },
  /*::[*/
  4118: {
    /* n:"SeriesList", */
  },
  /*::[*/
  4119: {
    /* n:"Bar", */
  },
  /*::[*/
  4120: {
    /* n:"Line", */
  },
  /*::[*/
  4121: {
    /* n:"Pie", */
  },
  /*::[*/
  4122: {
    /* n:"Area", */
  },
  /*::[*/
  4123: {
    /* n:"Scatter", */
  },
  /*::[*/
  4124: {
    /* n:"CrtLine", */
  },
  /*::[*/
  4125: {
    /* n:"Axis", */
  },
  /*::[*/
  4126: {
    /* n:"Tick", */
  },
  /*::[*/
  4127: {
    /* n:"ValueRange", */
  },
  /*::[*/
  4128: {
    /* n:"CatSerRange", */
  },
  /*::[*/
  4129: {
    /* n:"AxisLine", */
  },
  /*::[*/
  4130: {
    /* n:"CrtLink", */
  },
  /*::[*/
  4132: {
    /* n:"DefaultText", */
  },
  /*::[*/
  4133: {
    /* n:"Text", */
  },
  /*::[*/
  4134: {
    /* n:"FontX", */
    f: We
  },
  /*::[*/
  4135: {
    /* n:"ObjectLink", */
  },
  /*::[*/
  4146: {
    /* n:"Frame", */
  },
  /*::[*/
  4147: {
    /* n:"Begin", */
  },
  /*::[*/
  4148: {
    /* n:"End", */
  },
  /*::[*/
  4149: {
    /* n:"PlotArea", */
  },
  /*::[*/
  4154: {
    /* n:"Chart3d", */
  },
  /*::[*/
  4156: {
    /* n:"PicF", */
  },
  /*::[*/
  4157: {
    /* n:"DropBar", */
  },
  /*::[*/
  4158: {
    /* n:"Radar", */
  },
  /*::[*/
  4159: {
    /* n:"Surf", */
  },
  /*::[*/
  4160: {
    /* n:"RadarArea", */
  },
  /*::[*/
  4161: {
    /* n:"AxisParent", */
  },
  /*::[*/
  4163: {
    /* n:"LegendException", */
  },
  /*::[*/
  4164: {
    /* n:"ShtProps", */
    f: Ll
  },
  /*::[*/
  4165: {
    /* n:"SerToCrt", */
  },
  /*::[*/
  4166: {
    /* n:"AxesUsed", */
  },
  /*::[*/
  4168: {
    /* n:"SBaseRef", */
  },
  /*::[*/
  4170: {
    /* n:"SerParent", */
  },
  /*::[*/
  4171: {
    /* n:"SerAuxTrend", */
  },
  /*::[*/
  4174: {
    /* n:"IFmtRecord", */
  },
  /*::[*/
  4175: {
    /* n:"Pos", */
  },
  /*::[*/
  4176: {
    /* n:"AlRuns", */
  },
  /*::[*/
  4177: {
    /* n:"BRAI", */
  },
  /*::[*/
  4187: {
    /* n:"SerAuxErrBar", */
  },
  /*::[*/
  4188: {
    /* n:"ClrtClient", */
    f: Rl
  },
  /*::[*/
  4189: {
    /* n:"SerFmt", */
  },
  /*::[*/
  4191: {
    /* n:"Chart3DBarShape", */
  },
  /*::[*/
  4192: {
    /* n:"Fbi", */
  },
  /*::[*/
  4193: {
    /* n:"BopPop", */
  },
  /*::[*/
  4194: {
    /* n:"AxcExt", */
  },
  /*::[*/
  4195: {
    /* n:"Dat", */
  },
  /*::[*/
  4196: {
    /* n:"PlotGrowth", */
  },
  /*::[*/
  4197: {
    /* n:"SIIndex", */
  },
  /*::[*/
  4198: {
    /* n:"GelFrame", */
  },
  /*::[*/
  4199: {
    /* n:"BopPopCustom", */
  },
  /*::[*/
  4200: {
    /* n:"Fbi2", */
  },
  /*::[*/
  0: {
    /* n:"Dimensions", */
    f: ci
  },
  /*::[*/
  1: {
    /* n:"BIFF2BLANK", */
  },
  /*::[*/
  2: {
    /* n:"BIFF2INT", */
    f: Hl
  },
  /*::[*/
  3: {
    /* n:"BIFF2NUM", */
    f: Vl
  },
  /*::[*/
  4: {
    /* n:"BIFF2STR", */
    f: $l
  },
  /*::[*/
  5: {
    /* n:"BoolErr", */
    f: fi
  },
  /*::[*/
  7: {
    /* n:"String", */
    f: Wl
  },
  /*::[*/
  8: {
    /* n:"BIFF2ROW", */
  },
  /*::[*/
  9: {
    /* n:"BOF", */
    f: Na
  },
  /*::[*/
  11: {
    /* n:"Index", */
  },
  /*::[*/
  22: {
    /* n:"ExternCount", */
    f: We
  },
  /*::[*/
  30: {
    /* n:"BIFF2FORMAT", */
    f: fl
  },
  /*::[*/
  31: {
    /* n:"BIFF2FMTCNT", */
  },
  /* 16-bit cnt of BIFF2FORMAT records */
  /*::[*/
  32: {
    /* n:"BIFF2COLINFO", */
  },
  /*::[*/
  33: {
    /* n:"Array", */
    f: hi
  },
  /*::[*/
  36: {
    /* n:"COLWIDTH", */
  },
  /*::[*/
  37: {
    /* n:"DefaultRowHeight", */
    f: si
  },
  // 0x2c ??
  // 0x2d ??
  // 0x2e ??
  // 0x30 FONTCOUNT: number of fonts
  /*::[*/
  50: {
    /* n:"BIFF2FONTXTRA", */
    f: Zl
  },
  // 0x35: INFOOPTS
  // 0x36: TABLE (BIFF2 only)
  // 0x37: TABLE2 (BIFF2 only)
  // 0x38: WNDESK
  // 0x39 ??
  // 0x3a: BEGINPREF
  // 0x3b: ENDPREF
  /*::[*/
  62: {
    /* n:"BIFF2WINDOW2", */
  },
  // 0x3f ??
  // 0x46: SHOWSCROLL
  // 0x47: SHOWFORMULA
  // 0x48: STATUSBAR
  // 0x49: SHORTMENUS
  // 0x4A:
  // 0x4B:
  // 0x4C:
  // 0x4E:
  // 0x4F:
  // 0x58: TOOLBAR (BIFF3)
  /* - - - */
  /*::[*/
  52: {
    /* n:"DDEObjName", */
  },
  /*::[*/
  67: {
    /* n:"BIFF2XF", */
  },
  /*::[*/
  68: {
    /* n:"BIFF2XFINDEX", */
    f: We
  },
  /*::[*/
  69: {
    /* n:"BIFF2FONTCLR", */
  },
  /*::[*/
  86: {
    /* n:"BIFF4FMTCNT", */
  },
  /* 16-bit cnt, similar to BIFF2 */
  /*::[*/
  126: {
    /* n:"RK", */
  },
  /* Not necessarily same as 0x027e */
  /*::[*/
  127: {
    /* n:"ImData", */
    f: zl
  },
  /*::[*/
  135: {
    /* n:"Addin", */
  },
  /*::[*/
  136: {
    /* n:"Edg", */
  },
  /*::[*/
  137: {
    /* n:"Pub", */
  },
  // 0x8A
  // 0x8B LH: alternate menu key flag (BIFF3/4)
  // 0x8E
  // 0x8F
  /*::[*/
  145: {
    /* n:"Sub", */
  },
  // 0x93 STYLE
  /*::[*/
  148: {
    /* n:"LHRecord", */
  },
  /*::[*/
  149: {
    /* n:"LHNGraph", */
  },
  /*::[*/
  150: {
    /* n:"Sound", */
  },
  // 0xA2 FNPROTO: function prototypes (BIFF4)
  // 0xA3
  // 0xA8
  /*::[*/
  169: {
    /* n:"CoordList", */
  },
  /*::[*/
  171: {
    /* n:"GCW", */
  },
  /*::[*/
  188: {
    /* n:"ShrFmla", */
  },
  /* Not necessarily same as 0x04bc */
  /*::[*/
  191: {
    /* n:"ToolbarHdr", */
  },
  /*::[*/
  192: {
    /* n:"ToolbarEnd", */
  },
  /*::[*/
  194: {
    /* n:"AddMenu", */
  },
  /*::[*/
  195: {
    /* n:"DelMenu", */
  },
  /*::[*/
  214: {
    /* n:"RString", */
    f: Gl
  },
  /*::[*/
  223: {
    /* n:"UDDesc", */
  },
  /*::[*/
  234: {
    /* n:"TabIdConf", */
  },
  /*::[*/
  354: {
    /* n:"XL5Modify", */
  },
  /*::[*/
  421: {
    /* n:"FileSharing2", */
  },
  /*::[*/
  518: {
    /* n:"Formula", */
    f: wn
  },
  /*::[*/
  521: {
    /* n:"BOF", */
    f: Na
  },
  /*::[*/
  536: {
    /* n:"Lbl", */
    f: li
  },
  /*::[*/
  547: {
    /* n:"ExternName", */
    f: ui
  },
  /*::[*/
  561: {
    /* n:"Font", */
  },
  /*::[*/
  579: {
    /* n:"BIFF3XF", */
  },
  /*::[*/
  1030: {
    /* n:"Formula", */
    f: wn
  },
  /*::[*/
  1033: {
    /* n:"BOF", */
    f: Na
  },
  /*::[*/
  1091: {
    /* n:"BIFF4XF", */
  },
  /*::[*/
  2157: {
    /* n:"FeatInfo", */
  },
  /*::[*/
  2163: {
    /* n:"FeatInfo11", */
  },
  /*::[*/
  2177: {
    /* n:"SXAddl12", */
  },
  /*::[*/
  2240: {
    /* n:"AutoWebPub", */
  },
  /*::[*/
  2241: {
    /* n:"ListObj", */
  },
  /*::[*/
  2242: {
    /* n:"ListField", */
  },
  /*::[*/
  2243: {
    /* n:"ListDV", */
  },
  /*::[*/
  2244: {
    /* n:"ListCondFmt", */
  },
  /*::[*/
  2245: {
    /* n:"ListCF", */
  },
  /*::[*/
  2246: {
    /* n:"FMQry", */
  },
  /*::[*/
  2247: {
    /* n:"FMSQry", */
  },
  /*::[*/
  2248: {
    /* n:"PLV", */
  },
  /*::[*/
  2249: {
    /* n:"LnExt", */
  },
  /*::[*/
  2250: {
    /* n:"MkrExt", */
  },
  /*::[*/
  2251: {
    /* n:"CrtCoopt", */
  },
  /*::[*/
  2262: {
    /* n:"FRTArchId$", */
    r: 12
  },
  /*::[*/
  29282: {}
};
function Dr(e, t, r, a) {
  var n = t;
  if (!isNaN(n)) {
    var i = (r || []).length || 0, s = e.next(4);
    s.write_shift(2, n), s.write_shift(2, i), /*:: len != null &&*/
    i > 0 && Ps(r) && e.push(r);
  }
}
function wi(e, t) {
  var r = t || {}, a = r.dense ? [] : {};
  e = e.replace(/<!--.*?-->/g, "");
  var n = e.match(/<table/i);
  if (!n) throw new Error("Invalid HTML: could not find <table>");
  var i = e.match(/<\/table/i), s = n.index, c = i && i.index || e.length, f = po(e.slice(s, c), /(:?<tr[^>]*>)/i, "<tr>"), o = -1, u = 0, l = 0, h = 0, d = { s: { r: 1e7, c: 1e7 }, e: { r: 0, c: 0 } }, p = [];
  for (s = 0; s < f.length; ++s) {
    var x = f[s].trim(), g = x.slice(0, 3).toLowerCase();
    if (g == "<tr") {
      if (++o, r.sheetRows && r.sheetRows <= o) {
        --o;
        break;
      }
      u = 0;
      continue;
    }
    if (!(g != "<td" && g != "<th")) {
      var F = x.split(/<\/t[dh]>/i);
      for (c = 0; c < F.length; ++c) {
        var C = F[c].trim();
        if (C.match(/<t[dh]/i)) {
          for (var _ = C, I = 0; _.charAt(0) == "<" && (I = _.indexOf(">")) > -1; ) _ = _.slice(I + 1);
          for (var P = 0; P < p.length; ++P) {
            var O = p[P];
            O.s.c == u && O.s.r < o && o <= O.e.r && (u = O.e.c + 1, P = -1);
          }
          var A = le(C.slice(0, C.indexOf(">")));
          h = A.colspan ? +A.colspan : 1, ((l = +A.rowspan) > 1 || h > 1) && p.push({ s: { r: o, c: u }, e: { r: o + (l || 1) - 1, c: u + h - 1 } });
          var V = A.t || A["data-t"] || "";
          if (!_.length) {
            u += h;
            continue;
          }
          if (_ = Ts(_), d.s.r > o && (d.s.r = o), d.e.r < o && (d.e.r = o), d.s.c > u && (d.s.c = u), d.e.c < u && (d.e.c = u), !_.length) {
            u += h;
            continue;
          }
          var D = { t: "s", v: _ };
          r.raw || !_.trim().length || V == "s" || (_ === "TRUE" ? D = { t: "b", v: !0 } : _ === "FALSE" ? D = { t: "b", v: !1 } : isNaN(Lr(_)) ? isNaN(Lt(_).getDate()) || (D = { t: "d", v: Ye(_) }, r.cellDates || (D = { t: "n", v: pr(D.v) }), D.z = r.dateNF || ve[14]) : D = { t: "n", v: Lr(_) }), r.dense ? (a[o] || (a[o] = []), a[o][u] = D) : a[de({ r: o, c: u })] = D, u += h;
        }
      }
    }
  }
  return a["!ref"] = Ee(d), p.length && (a["!merges"] = p), a;
}
function Zp(e, t, r, a) {
  for (var n = e["!merges"] || [], i = [], s = t.s.c; s <= t.e.c; ++s) {
    for (var c = 0, f = 0, o = 0; o < n.length; ++o)
      if (!(n[o].s.r > r || n[o].s.c > s) && !(n[o].e.r < r || n[o].e.c < s)) {
        if (n[o].s.r < r || n[o].s.c < s) {
          c = -1;
          break;
        }
        c = n[o].e.r - n[o].s.r + 1, f = n[o].e.c - n[o].s.c + 1;
        break;
      }
    if (!(c < 0)) {
      var u = de({ r, c: s }), l = a.dense ? (e[r] || [])[s] : e[u], h = l && l.v != null && (l.h || Yn(l.w || (Yr(l), l.w) || "")) || "", d = {};
      c > 1 && (d.rowspan = c), f > 1 && (d.colspan = f), a.editable ? h = '<span contenteditable="true">' + h + "</span>" : l && (d["data-t"] = l && l.t || "z", l.v != null && (d["data-v"] = l.v), l.z != null && (d["data-z"] = l.z), l.l && (l.l.Target || "#").charAt(0) != "#" && (h = '<a href="' + l.l.Target + '">' + h + "</a>")), d.id = (a.id || "sjs") + "-" + u, i.push(Do("td", h, d));
    }
  }
  var p = "<tr>";
  return p + i.join("") + "</tr>";
}
var Gp = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>', jp = "</body></html>";
function Xp(e, t) {
  var r = e.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
  if (!r || r.length == 0) throw new Error("Invalid HTML: could not find <table>");
  if (r.length == 1) return ct(wi(r[0], t), t);
  var a = d0();
  return r.forEach(function(n, i) {
    p0(a, wi(n, t), "Sheet" + (i + 1));
  }), a;
}
function Kp(e, t, r) {
  var a = [];
  return a.join("") + "<table" + (r && r.id ? ' id="' + r.id + '"' : "") + ">";
}
function Yp(e, t) {
  var r = t || {}, a = r.header != null ? r.header : Gp, n = r.footer != null ? r.footer : jp, i = [a], s = Ut(e["!ref"]);
  r.dense = Array.isArray(e), i.push(Kp(e, s, r));
  for (var c = s.s.r; c <= s.e.r; ++c) i.push(Zp(e, s, c, r));
  return i.push("</table>" + n), i.join("");
}
function yc(e, t, r) {
  var a = r || {}, n = 0, i = 0;
  if (a.origin != null)
    if (typeof a.origin == "number") n = a.origin;
    else {
      var s = typeof a.origin == "string" ? xr(a.origin) : a.origin;
      n = s.r, i = s.c;
    }
  var c = t.getElementsByTagName("tr"), f = Math.min(a.sheetRows || 1e7, c.length), o = { s: { r: 0, c: 0 }, e: { r: n, c: i } };
  if (e["!ref"]) {
    var u = Ut(e["!ref"]);
    o.s.r = Math.min(o.s.r, u.s.r), o.s.c = Math.min(o.s.c, u.s.c), o.e.r = Math.max(o.e.r, u.e.r), o.e.c = Math.max(o.e.c, u.e.c), n == -1 && (o.e.r = n = u.e.r + 1);
  }
  var l = [], h = 0, d = e["!rows"] || (e["!rows"] = []), p = 0, x = 0, g = 0, F = 0, C = 0, _ = 0;
  for (e["!cols"] || (e["!cols"] = []); p < c.length && x < f; ++p) {
    var I = c[p];
    if (Ai(I)) {
      if (a.display) continue;
      d[x] = { hidden: !0 };
    }
    var P = I.children;
    for (g = F = 0; g < P.length; ++g) {
      var O = P[g];
      if (!(a.display && Ai(O))) {
        var A = O.hasAttribute("data-v") ? O.getAttribute("data-v") : O.hasAttribute("v") ? O.getAttribute("v") : Ts(O.innerHTML), V = O.getAttribute("data-z") || O.getAttribute("z");
        for (h = 0; h < l.length; ++h) {
          var D = l[h];
          D.s.c == F + i && D.s.r < x + n && x + n <= D.e.r && (F = D.e.c + 1 - i, h = -1);
        }
        _ = +O.getAttribute("colspan") || 1, ((C = +O.getAttribute("rowspan") || 1) > 1 || _ > 1) && l.push({ s: { r: x + n, c: F + i }, e: { r: x + n + (C || 1) - 1, c: F + i + (_ || 1) - 1 } });
        var G = { t: "s", v: A }, W = O.getAttribute("data-t") || O.getAttribute("t") || "";
        A != null && (A.length == 0 ? G.t = W || "z" : a.raw || A.trim().length == 0 || W == "s" || (A === "TRUE" ? G = { t: "b", v: !0 } : A === "FALSE" ? G = { t: "b", v: !1 } : isNaN(Lr(A)) ? isNaN(Lt(A).getDate()) || (G = { t: "d", v: Ye(A) }, a.cellDates || (G = { t: "n", v: pr(G.v) }), G.z = a.dateNF || ve[14]) : G = { t: "n", v: Lr(A) })), G.z === void 0 && V != null && (G.z = V);
        var b = "", J = O.getElementsByTagName("A");
        if (J && J.length) for (var oe = 0; oe < J.length && !(J[oe].hasAttribute("href") && (b = J[oe].getAttribute("href"), b.charAt(0) != "#")); ++oe) ;
        b && b.charAt(0) != "#" && (G.l = { Target: b }), a.dense ? (e[x + n] || (e[x + n] = []), e[x + n][F + i] = G) : e[de({ c: F + i, r: x + n })] = G, o.e.c < F + i && (o.e.c = F + i), F += _;
      }
    }
    ++x;
  }
  return l.length && (e["!merges"] = (e["!merges"] || []).concat(l)), o.e.r = Math.max(o.e.r, x - 1 + n), e["!ref"] = Ee(o), x >= f && (e["!fullref"] = Ee((o.e.r = c.length - p + x - 1 + n, o))), e;
}
function Cc(e, t) {
  var r = t || {}, a = r.dense ? [] : {};
  return yc(a, e, t);
}
function Jp(e, t) {
  return ct(Cc(e, t), t);
}
function Ai(e) {
  var t = "", r = qp(e);
  return r && (t = r(e).getPropertyValue("display")), t || (t = e.style && e.style.display), t === "none";
}
function qp(e) {
  return e.ownerDocument.defaultView && typeof e.ownerDocument.defaultView.getComputedStyle == "function" ? e.ownerDocument.defaultView.getComputedStyle : typeof getComputedStyle == "function" ? getComputedStyle : null;
}
function Qp(e) {
  var t = e.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function(a, n) {
    return Array(parseInt(n, 10) + 1).join(" ");
  }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, `
`), r = we(t.replace(/<[^>]*>/g, ""));
  return [r];
}
var Fi = {
  /* ods name: [short ssf fmt, long ssf fmt] */
  day: ["d", "dd"],
  month: ["m", "mm"],
  year: ["y", "yy"],
  hours: ["h", "hh"],
  minutes: ["m", "mm"],
  seconds: ["s", "ss"],
  "am-pm": ["A/P", "AM/PM"],
  "day-of-week": ["ddd", "dddd"],
  era: ["e", "ee"],
  /* there is no native representation of LO "Q" format */
  quarter: ["\\Qm", 'm\\"th quarter"']
};
function Oc(e, t) {
  var r = t || {}, a = Jn(e), n = [], i, s, c = { name: "" }, f = "", o = 0, u, l, h = {}, d = [], p = r.dense ? [] : {}, x, g, F = { value: "" }, C = "", _ = 0, I = [], P = -1, O = -1, A = { s: { r: 1e6, c: 1e7 }, e: { r: 0, c: 0 } }, V = 0, D = {}, G = [], W = {}, b = 0, J = 0, oe = [], te = 1, fe = 1, ce = [], Ce = { Names: [] }, H = {}, he = ["", ""], xe = [], S = {}, U = "", N = 0, R = !1, X = !1, re = 0;
  for (la.lastIndex = 0, a = a.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ""); x = la.exec(a); ) switch (x[3] = x[3].replace(/_.*$/, "")) {
    case "table":
    case "工作表":
      x[1] === "/" ? (A.e.c >= A.s.c && A.e.r >= A.s.r ? p["!ref"] = Ee(A) : p["!ref"] = "A1:A1", r.sheetRows > 0 && r.sheetRows <= A.e.r && (p["!fullref"] = p["!ref"], A.e.r = r.sheetRows - 1, p["!ref"] = Ee(A)), G.length && (p["!merges"] = G), oe.length && (p["!rows"] = oe), u.name = u.名称 || u.name, typeof JSON < "u" && JSON.stringify(u), d.push(u.name), h[u.name] = p, X = !1) : x[0].charAt(x[0].length - 2) !== "/" && (u = le(x[0], !1), P = O = -1, A.s.r = A.s.c = 1e7, A.e.r = A.e.c = 0, p = r.dense ? [] : {}, G = [], oe = [], X = !0);
      break;
    case "table-row-group":
      x[1] === "/" ? --V : ++V;
      break;
    case "table-row":
    case "行":
      if (x[1] === "/") {
        P += te, te = 1;
        break;
      }
      if (l = le(x[0], !1), l.行号 ? P = l.行号 - 1 : P == -1 && (P = 0), te = +l["number-rows-repeated"] || 1, te < 10) for (re = 0; re < te; ++re) V > 0 && (oe[P + re] = { level: V });
      O = -1;
      break;
    case "covered-table-cell":
      x[1] !== "/" && ++O, r.sheetStubs && (r.dense ? (p[P] || (p[P] = []), p[P][O] = { t: "z" }) : p[de({ r: P, c: O })] = { t: "z" }), C = "", I = [];
      break;
    case "table-cell":
    case "数据":
      if (x[0].charAt(x[0].length - 2) === "/")
        ++O, F = le(x[0], !1), fe = parseInt(F["number-columns-repeated"] || "1", 10), g = {
          t: "z",
          v: null
          /*:: , z:null, w:"",c:[]*/
        }, F.formula && r.cellFormula != !1 && (g.f = _i(we(F.formula))), (F.数据类型 || F["value-type"]) == "string" && (g.t = "s", g.v = we(F["string-value"] || ""), r.dense ? (p[P] || (p[P] = []), p[P][O] = g) : p[de({ r: P, c: O })] = g), O += fe - 1;
      else if (x[1] !== "/") {
        ++O, C = "", _ = 0, I = [], fe = 1;
        var ie = te ? P + te - 1 : P;
        if (O > A.e.c && (A.e.c = O), O < A.s.c && (A.s.c = O), P < A.s.r && (A.s.r = P), ie > A.e.r && (A.e.r = ie), F = le(x[0], !1), xe = [], S = {}, g = {
          t: F.数据类型 || F["value-type"],
          v: null
          /*:: , z:null, w:"",c:[]*/
        }, r.cellFormula)
          if (F.formula && (F.formula = we(F.formula)), F["number-matrix-columns-spanned"] && F["number-matrix-rows-spanned"] && (b = parseInt(F["number-matrix-rows-spanned"], 10) || 0, J = parseInt(F["number-matrix-columns-spanned"], 10) || 0, W = { s: { r: P, c: O }, e: { r: P + b - 1, c: O + J - 1 } }, g.F = Ee(W), ce.push([W, g.F])), F.formula) g.f = _i(F.formula);
          else for (re = 0; re < ce.length; ++re)
            P >= ce[re][0].s.r && P <= ce[re][0].e.r && O >= ce[re][0].s.c && O <= ce[re][0].e.c && (g.F = ce[re][1]);
        switch ((F["number-columns-spanned"] || F["number-rows-spanned"]) && (b = parseInt(F["number-rows-spanned"], 10) || 0, J = parseInt(F["number-columns-spanned"], 10) || 0, W = { s: { r: P, c: O }, e: { r: P + b - 1, c: O + J - 1 } }, G.push(W)), F["number-columns-repeated"] && (fe = parseInt(F["number-columns-repeated"], 10)), g.t) {
          case "boolean":
            g.t = "b", g.v = Oe(F["boolean-value"]);
            break;
          case "float":
            g.t = "n", g.v = parseFloat(F.value);
            break;
          case "percentage":
            g.t = "n", g.v = parseFloat(F.value);
            break;
          case "currency":
            g.t = "n", g.v = parseFloat(F.value);
            break;
          case "date":
            g.t = "d", g.v = Ye(F["date-value"]), r.cellDates || (g.t = "n", g.v = pr(g.v)), g.z = "m/d/yy";
            break;
          case "time":
            g.t = "n", g.v = lo(F["time-value"]) / 86400, r.cellDates && (g.t = "d", g.v = sn(g.v)), g.z = "HH:MM:SS";
            break;
          case "number":
            g.t = "n", g.v = parseFloat(F.数据数值);
            break;
          default:
            if (g.t === "string" || g.t === "text" || !g.t)
              g.t = "s", F["string-value"] != null && (C = we(F["string-value"]), I = []);
            else throw new Error("Unsupported value type " + g.t);
        }
      } else {
        if (R = !1, g.t === "s" && (g.v = C || "", I.length && (g.R = I), R = _ == 0), H.Target && (g.l = H), xe.length > 0 && (g.c = xe, xe = []), C && r.cellText !== !1 && (g.w = C), R && (g.t = "z", delete g.v), (!R || r.sheetStubs) && !(r.sheetRows && r.sheetRows <= P))
          for (var Q = 0; Q < te; ++Q) {
            if (fe = parseInt(F["number-columns-repeated"] || "1", 10), r.dense)
              for (p[P + Q] || (p[P + Q] = []), p[P + Q][O] = Q == 0 ? g : qe(g); --fe > 0; ) p[P + Q][O + fe] = qe(g);
            else
              for (p[de({ r: P + Q, c: O })] = g; --fe > 0; ) p[de({ r: P + Q, c: O + fe })] = qe(g);
            A.e.c <= O && (A.e.c = O);
          }
        fe = parseInt(F["number-columns-repeated"] || "1", 10), O += fe - 1, fe = 0, g = {
          /*:: t:"", v:null, z:null, w:"",c:[]*/
        }, C = "", I = [];
      }
      H = {};
      break;
    case "document":
    case "document-content":
    case "电子表格文档":
    case "spreadsheet":
    case "主体":
    case "scripts":
    case "styles":
    case "font-face-decls":
    case "master-styles":
      if (x[1] === "/") {
        if ((i = n.pop())[0] !== x[3]) throw "Bad state: " + i;
      } else x[0].charAt(x[0].length - 2) !== "/" && n.push([x[3], !0]);
      break;
    case "annotation":
      if (x[1] === "/") {
        if ((i = n.pop())[0] !== x[3]) throw "Bad state: " + i;
        S.t = C, I.length && (S.R = I), S.a = U, xe.push(S);
      } else x[0].charAt(x[0].length - 2) !== "/" && n.push([x[3], !1]);
      U = "", N = 0, C = "", _ = 0, I = [];
      break;
    case "creator":
      x[1] === "/" ? U = a.slice(N, x.index) : N = x.index + x[0].length;
      break;
    case "meta":
    case "元数据":
    case "settings":
    case "config-item-set":
    case "config-item-map-indexed":
    case "config-item-map-entry":
    case "config-item-map-named":
    case "shapes":
    case "frame":
    case "text-box":
    case "image":
    case "data-pilot-tables":
    case "list-style":
    case "form":
    case "dde-links":
    case "event-listeners":
    case "chart":
      if (x[1] === "/") {
        if ((i = n.pop())[0] !== x[3]) throw "Bad state: " + i;
      } else x[0].charAt(x[0].length - 2) !== "/" && n.push([x[3], !1]);
      C = "", _ = 0, I = [];
      break;
    case "scientific-number":
      break;
    case "currency-symbol":
      break;
    case "currency-style":
      break;
    case "number-style":
    case "percentage-style":
    case "date-style":
    case "time-style":
      if (x[1] === "/") {
        if (D[c.name] = f, (i = n.pop())[0] !== x[3]) throw "Bad state: " + i;
      } else x[0].charAt(x[0].length - 2) !== "/" && (f = "", c = le(x[0], !1), n.push([x[3], !0]));
      break;
    case "script":
      break;
    case "libraries":
      break;
    case "automatic-styles":
      break;
    case "default-style":
    case "page-layout":
      break;
    case "style":
      break;
    case "map":
      break;
    case "font-face":
      break;
    case "paragraph-properties":
      break;
    case "table-properties":
      break;
    case "table-column-properties":
      break;
    case "table-row-properties":
      break;
    case "table-cell-properties":
      break;
    case "number":
      switch (n[n.length - 1][0]) {
        case "time-style":
        case "date-style":
          s = le(x[0], !1), f += Fi[x[3]][s.style === "long" ? 1 : 0];
          break;
      }
      break;
    case "fraction":
      break;
    case "day":
    case "month":
    case "year":
    case "era":
    case "day-of-week":
    case "week-of-year":
    case "quarter":
    case "hours":
    case "minutes":
    case "seconds":
    case "am-pm":
      switch (n[n.length - 1][0]) {
        case "time-style":
        case "date-style":
          s = le(x[0], !1), f += Fi[x[3]][s.style === "long" ? 1 : 0];
          break;
      }
      break;
    case "boolean-style":
      break;
    case "boolean":
      break;
    case "text-style":
      break;
    case "text":
      if (x[0].slice(-2) === "/>") break;
      if (x[1] === "/") switch (n[n.length - 1][0]) {
        case "number-style":
        case "date-style":
        case "time-style":
          f += a.slice(o, x.index);
          break;
      }
      else o = x.index + x[0].length;
      break;
    case "named-range":
      s = le(x[0], !1), he = An(s["cell-range-address"]);
      var Y = { Name: s.name, Ref: he[0] + "!" + he[1] };
      X && (Y.Sheet = d.length), Ce.Names.push(Y);
      break;
    case "text-content":
      break;
    case "text-properties":
      break;
    case "embedded-text":
      break;
    case "body":
    case "电子表格":
      break;
    case "forms":
      break;
    case "table-column":
      break;
    case "table-header-rows":
      break;
    case "table-rows":
      break;
    case "table-column-group":
      break;
    case "table-header-columns":
      break;
    case "table-columns":
      break;
    case "null-date":
      break;
    case "graphic-properties":
      break;
    case "calculation-settings":
      break;
    case "named-expressions":
      break;
    case "label-range":
      break;
    case "label-ranges":
      break;
    case "named-expression":
      break;
    case "sort":
      break;
    case "sort-by":
      break;
    case "sort-groups":
      break;
    case "tab":
      break;
    case "line-break":
      break;
    case "span":
      break;
    case "p":
    case "文本串":
      if (["master-styles"].indexOf(n[n.length - 1][0]) > -1) break;
      if (x[1] === "/" && (!F || !F["string-value"])) {
        var Te = Qp(a.slice(_, x.index));
        C = (C.length > 0 ? C + `
` : "") + Te[0];
      } else
        le(x[0], !1), _ = x.index + x[0].length;
      break;
    case "s":
      break;
    case "database-range":
      if (x[1] === "/") break;
      try {
        he = An(le(x[0])["target-range-address"]), h[he[0]]["!autofilter"] = { ref: he[1] };
      } catch {
      }
      break;
    case "date":
      break;
    case "object":
      break;
    case "title":
    case "标题":
      break;
    case "desc":
      break;
    case "binary-data":
      break;
    case "table-source":
      break;
    case "scenario":
      break;
    case "iteration":
      break;
    case "content-validations":
      break;
    case "content-validation":
      break;
    case "help-message":
      break;
    case "error-message":
      break;
    case "database-ranges":
      break;
    case "filter":
      break;
    case "filter-and":
      break;
    case "filter-or":
      break;
    case "filter-condition":
      break;
    case "list-level-style-bullet":
      break;
    case "list-level-style-number":
      break;
    case "list-level-properties":
      break;
    case "sender-firstname":
    case "sender-lastname":
    case "sender-initials":
    case "sender-title":
    case "sender-position":
    case "sender-email":
    case "sender-phone-private":
    case "sender-fax":
    case "sender-company":
    case "sender-phone-work":
    case "sender-street":
    case "sender-city":
    case "sender-postal-code":
    case "sender-country":
    case "sender-state-or-province":
    case "author-name":
    case "author-initials":
    case "chapter":
    case "file-name":
    case "template-name":
    case "sheet-name":
      break;
    case "event-listener":
      break;
    case "initial-creator":
    case "creation-date":
    case "print-date":
    case "generator":
    case "document-statistic":
    case "user-defined":
    case "editing-duration":
    case "editing-cycles":
      break;
    case "config-item":
      break;
    case "page-number":
      break;
    case "page-count":
      break;
    case "time":
      break;
    case "cell-range-source":
      break;
    case "detective":
      break;
    case "operation":
      break;
    case "highlighted-range":
      break;
    case "data-pilot-table":
    case "source-cell-range":
    case "source-service":
    case "data-pilot-field":
    case "data-pilot-level":
    case "data-pilot-subtotals":
    case "data-pilot-subtotal":
    case "data-pilot-members":
    case "data-pilot-member":
    case "data-pilot-display-info":
    case "data-pilot-sort-info":
    case "data-pilot-layout-info":
    case "data-pilot-field-reference":
    case "data-pilot-groups":
    case "data-pilot-group":
    case "data-pilot-group-member":
      break;
    case "rect":
      break;
    case "dde-connection-decls":
    case "dde-connection-decl":
    case "dde-link":
    case "dde-source":
      break;
    case "properties":
      break;
    case "property":
      break;
    case "a":
      if (x[1] !== "/") {
        if (H = le(x[0], !1), !H.href) break;
        H.Target = we(H.href), delete H.href, H.Target.charAt(0) == "#" && H.Target.indexOf(".") > -1 ? (he = An(H.Target.slice(1)), H.Target = "#" + he[0] + "!" + he[1]) : H.Target.match(/^\.\.[\\\/]/) && (H.Target = H.Target.slice(3));
      }
      break;
    case "table-protection":
      break;
    case "data-pilot-grand-total":
      break;
    case "office-document-common-attrs":
      break;
    default:
      switch (x[2]) {
        case "dc:":
        case "calcext:":
        case "loext:":
        case "ooo:":
        case "chartooo:":
        case "draw:":
        case "style:":
        case "chart:":
        case "form:":
        case "uof:":
        case "表:":
        case "字:":
          break;
        default:
          if (r.WTF) throw new Error(x);
      }
  }
  var y = {
    Sheets: h,
    SheetNames: d,
    Workbook: Ce
  };
  return r.bookSheets && delete /*::(*/
  y.Sheets, y;
}
function Si(e, t) {
  t = t || {}, Sr(e, "META-INF/manifest.xml") && pu(He(e, "META-INF/manifest.xml"), t);
  var r = kr(e, "content.xml");
  if (!r) throw new Error("Missing content.xml in ODS / UOF file");
  var a = Oc(ye(r), t);
  return Sr(e, "meta.xml") && (a.Props = Vs(He(e, "meta.xml"))), a;
}
function yi(e, t) {
  return Oc(e, t);
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
function u0(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function Ln(e) {
  return typeof TextDecoder < "u" ? new TextDecoder().decode(e) : ye(Tt(e));
}
function Mn(e) {
  var t = e.reduce(function(n, i) {
    return n + i.length;
  }, 0), r = new Uint8Array(t), a = 0;
  return e.forEach(function(n) {
    r.set(n, a), a += n.length;
  }), r;
}
function Ci(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), (e + (e >> 4) & 252645135) * 16843009 >>> 24;
}
function ev(e, t) {
  for (var r = (e[t + 15] & 127) << 7 | e[t + 14] >> 1, a = e[t + 14] & 1, n = t + 13; n >= t; --n)
    a = a * 256 + e[n];
  return (e[t + 15] & 128 ? -a : a) * Math.pow(10, r - 6176);
}
function pa(e, t) {
  var r = t ? t[0] : 0, a = e[r] & 127;
  e:
    if (e[r++] >= 128 && (a |= (e[r] & 127) << 7, e[r++] < 128 || (a |= (e[r] & 127) << 14, e[r++] < 128) || (a |= (e[r] & 127) << 21, e[r++] < 128) || (a += (e[r] & 127) * Math.pow(2, 28), ++r, e[r++] < 128) || (a += (e[r] & 127) * Math.pow(2, 35), ++r, e[r++] < 128) || (a += (e[r] & 127) * Math.pow(2, 42), ++r, e[r++] < 128)))
      break e;
  return t && (t[0] = r), a;
}
function Xe(e) {
  var t = 0, r = e[t] & 127;
  e:
    if (e[t++] >= 128) {
      if (r |= (e[t] & 127) << 7, e[t++] < 128 || (r |= (e[t] & 127) << 14, e[t++] < 128) || (r |= (e[t] & 127) << 21, e[t++] < 128))
        break e;
      r |= (e[t] & 127) << 28;
    }
  return r;
}
function ir(e) {
  for (var t = [], r = [0]; r[0] < e.length; ) {
    var a = r[0], n = pa(e, r), i = n & 7;
    n = Math.floor(n / 8);
    var s = 0, c;
    if (n == 0)
      break;
    switch (i) {
      case 0:
        {
          for (var f = r[0]; e[r[0]++] >= 128; )
            ;
          c = e.slice(f, r[0]);
        }
        break;
      case 5:
        s = 4, c = e.slice(r[0], r[0] + s), r[0] += s;
        break;
      case 1:
        s = 8, c = e.slice(r[0], r[0] + s), r[0] += s;
        break;
      case 2:
        s = pa(e, r), c = e.slice(r[0], r[0] + s), r[0] += s;
        break;
      case 3:
      case 4:
      default:
        throw new Error("PB Type ".concat(i, " for Field ").concat(n, " at offset ").concat(a));
    }
    var o = { data: c, type: i };
    t[n] == null ? t[n] = [o] : t[n].push(o);
  }
  return t;
}
function l0(e, t) {
  return (e == null ? void 0 : e.map(function(r) {
    return t(r.data);
  })) || [];
}
function rv(e) {
  for (var t, r = [], a = [0]; a[0] < e.length; ) {
    var n = pa(e, a), i = ir(e.slice(a[0], a[0] + n));
    a[0] += n;
    var s = {
      id: Xe(i[1][0].data),
      messages: []
    };
    i[2].forEach(function(c) {
      var f = ir(c.data), o = Xe(f[3][0].data);
      s.messages.push({
        meta: f,
        data: e.slice(a[0], a[0] + o)
      }), a[0] += o;
    }), (t = i[3]) != null && t[0] && (s.merge = Xe(i[3][0].data) >>> 0 > 0), r.push(s);
  }
  return r;
}
function tv(e, t) {
  if (e != 0)
    throw new Error("Unexpected Snappy chunk type ".concat(e));
  for (var r = [0], a = pa(t, r), n = []; r[0] < t.length; ) {
    var i = t[r[0]] & 3;
    if (i == 0) {
      var s = t[r[0]++] >> 2;
      if (s < 60)
        ++s;
      else {
        var c = s - 59;
        s = t[r[0]], c > 1 && (s |= t[r[0] + 1] << 8), c > 2 && (s |= t[r[0] + 2] << 16), c > 3 && (s |= t[r[0] + 3] << 24), s >>>= 0, s++, r[0] += c;
      }
      n.push(t.slice(r[0], r[0] + s)), r[0] += s;
      continue;
    } else {
      var f = 0, o = 0;
      if (i == 1 ? (o = (t[r[0]] >> 2 & 7) + 4, f = (t[r[0]++] & 224) << 3, f |= t[r[0]++]) : (o = (t[r[0]++] >> 2) + 1, i == 2 ? (f = t[r[0]] | t[r[0] + 1] << 8, r[0] += 2) : (f = (t[r[0]] | t[r[0] + 1] << 8 | t[r[0] + 2] << 16 | t[r[0] + 3] << 24) >>> 0, r[0] += 4)), n = [Mn(n)], f == 0)
        throw new Error("Invalid offset 0");
      if (f > n[0].length)
        throw new Error("Invalid offset beyond length");
      if (o >= f)
        for (n.push(n[0].slice(-f)), o -= f; o >= n[n.length - 1].length; )
          n.push(n[n.length - 1]), o -= n[n.length - 1].length;
      n.push(n[0].slice(-f, -f + o));
    }
  }
  var u = Mn(n);
  if (u.length != a)
    throw new Error("Unexpected length: ".concat(u.length, " != ").concat(a));
  return u;
}
function av(e) {
  for (var t = [], r = 0; r < e.length; ) {
    var a = e[r++], n = e[r] | e[r + 1] << 8 | e[r + 2] << 16;
    r += 3, t.push(tv(a, e.slice(r, r + n))), r += n;
  }
  if (r !== e.length)
    throw new Error("data is not a valid framed stream!");
  return Mn(t);
}
function nv(e, t, r, a) {
  var n = u0(e), i = n.getUint32(4, !0), s = (a > 1 ? 12 : 8) + Ci(i & (a > 1 ? 3470 : 398)) * 4, c = -1, f = -1, o = NaN, u = new Date(2001, 0, 1);
  i & 512 && (c = n.getUint32(s, !0), s += 4), s += Ci(i & (a > 1 ? 12288 : 4096)) * 4, i & 16 && (f = n.getUint32(s, !0), s += 4), i & 32 && (o = n.getFloat64(s, !0), s += 8), i & 64 && (u.setTime(u.getTime() + n.getFloat64(s, !0) * 1e3), s += 8);
  var l;
  switch (e[2]) {
    case 0:
      break;
    case 2:
      l = { t: "n", v: o };
      break;
    case 3:
      l = { t: "s", v: t[f] };
      break;
    case 5:
      l = { t: "d", v: u };
      break;
    case 6:
      l = { t: "b", v: o > 0 };
      break;
    case 7:
      l = { t: "n", v: o / 86400 };
      break;
    case 8:
      l = { t: "e", v: 0 };
      break;
    case 9:
      if (c > -1)
        l = { t: "s", v: r[c] };
      else if (f > -1)
        l = { t: "s", v: t[f] };
      else if (!isNaN(o))
        l = { t: "n", v: o };
      else
        throw new Error("Unsupported cell type ".concat(e.slice(0, 4)));
      break;
    default:
      throw new Error("Unsupported cell type ".concat(e.slice(0, 4)));
  }
  return l;
}
function iv(e, t, r) {
  var a = u0(e), n = a.getUint32(8, !0), i = 12, s = -1, c = -1, f = NaN, o = NaN, u = new Date(2001, 0, 1);
  n & 1 && (f = ev(e, i), i += 16), n & 2 && (o = a.getFloat64(i, !0), i += 8), n & 4 && (u.setTime(u.getTime() + a.getFloat64(i, !0) * 1e3), i += 8), n & 8 && (c = a.getUint32(i, !0), i += 4), n & 16 && (s = a.getUint32(i, !0), i += 4);
  var l;
  switch (e[1]) {
    case 0:
      break;
    case 2:
      l = { t: "n", v: f };
      break;
    case 3:
      l = { t: "s", v: t[c] };
      break;
    case 5:
      l = { t: "d", v: u };
      break;
    case 6:
      l = { t: "b", v: o > 0 };
      break;
    case 7:
      l = { t: "n", v: o / 86400 };
      break;
    case 8:
      l = { t: "e", v: 0 };
      break;
    case 9:
      if (s > -1)
        l = { t: "s", v: r[s] };
      else
        throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(n & 31, " : ").concat(e.slice(0, 4)));
      break;
    case 10:
      l = { t: "n", v: f };
      break;
    default:
      throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(n & 31, " : ").concat(e.slice(0, 4)));
  }
  return l;
}
function sv(e, t, r) {
  switch (e[0]) {
    case 0:
    case 1:
    case 2:
    case 3:
      return nv(e, t, r, e[0]);
    case 5:
      return iv(e, t, r);
    default:
      throw new Error("Unsupported payload version ".concat(e[0]));
  }
}
function nt(e) {
  var t = ir(e);
  return pa(t[1][0].data);
}
function Oi(e, t) {
  var r = ir(t.data), a = Xe(r[1][0].data), n = r[3], i = [];
  return (n || []).forEach(function(s) {
    var c = ir(s.data), f = Xe(c[1][0].data) >>> 0;
    switch (a) {
      case 1:
        i[f] = Ln(c[3][0].data);
        break;
      case 8:
        {
          var o = e[nt(c[9][0].data)][0], u = ir(o.data), l = e[nt(u[1][0].data)][0], h = Xe(l.meta[1][0].data);
          if (h != 2001)
            throw new Error("2000 unexpected reference to ".concat(h));
          var d = ir(l.data);
          i[f] = d[3].map(function(p) {
            return Ln(p.data);
          }).join("");
        }
        break;
    }
  }), i;
}
function cv(e, t) {
  var r, a, n, i, s, c, f, o, u, l, h, d, p, x, g = ir(e), F = Xe(g[1][0].data) >>> 0, C = Xe(g[2][0].data) >>> 0, _ = ((a = (r = g[8]) == null ? void 0 : r[0]) == null ? void 0 : a.data) && Xe(g[8][0].data) > 0 || !1, I, P;
  if ((i = (n = g[7]) == null ? void 0 : n[0]) != null && i.data && t != 0)
    I = (c = (s = g[7]) == null ? void 0 : s[0]) == null ? void 0 : c.data, P = (o = (f = g[6]) == null ? void 0 : f[0]) == null ? void 0 : o.data;
  else if ((l = (u = g[4]) == null ? void 0 : u[0]) != null && l.data && t != 1)
    I = (d = (h = g[4]) == null ? void 0 : h[0]) == null ? void 0 : d.data, P = (x = (p = g[3]) == null ? void 0 : p[0]) == null ? void 0 : x.data;
  else
    throw "NUMBERS Tile missing ".concat(t, " cell storage");
  for (var O = _ ? 4 : 1, A = u0(I), V = [], D = 0; D < I.length / 2; ++D) {
    var G = A.getUint16(D * 2, !0);
    G < 65535 && V.push([D, G]);
  }
  if (V.length != C)
    throw "Expected ".concat(C, " cells, found ").concat(V.length);
  var W = [];
  for (D = 0; D < V.length - 1; ++D)
    W[V[D][0]] = P.subarray(V[D][1] * O, V[D + 1][1] * O);
  return V.length >= 1 && (W[V[V.length - 1][0]] = P.subarray(V[V.length - 1][1] * O)), { R: F, cells: W };
}
function fv(e, t) {
  var r, a = ir(t.data), n = (r = a == null ? void 0 : a[7]) != null && r[0] ? Xe(a[7][0].data) >>> 0 > 0 ? 1 : 0 : -1, i = l0(a[5], function(s) {
    return cv(s, n);
  });
  return {
    nrows: Xe(a[4][0].data) >>> 0,
    data: i.reduce(function(s, c) {
      return s[c.R] || (s[c.R] = []), c.cells.forEach(function(f, o) {
        if (s[c.R][o])
          throw new Error("Duplicate cell r=".concat(c.R, " c=").concat(o));
        s[c.R][o] = f;
      }), s;
    }, [])
  };
}
function ov(e, t, r) {
  var a, n = ir(t.data), i = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
  if (i.e.r = (Xe(n[6][0].data) >>> 0) - 1, i.e.r < 0)
    throw new Error("Invalid row varint ".concat(n[6][0].data));
  if (i.e.c = (Xe(n[7][0].data) >>> 0) - 1, i.e.c < 0)
    throw new Error("Invalid col varint ".concat(n[7][0].data));
  r["!ref"] = Ee(i);
  var s = ir(n[4][0].data), c = Oi(e, e[nt(s[4][0].data)][0]), f = (a = s[17]) != null && a[0] ? Oi(e, e[nt(s[17][0].data)][0]) : [], o = ir(s[3][0].data), u = 0;
  o[1].forEach(function(l) {
    var h = ir(l.data), d = e[nt(h[2][0].data)][0], p = Xe(d.meta[1][0].data);
    if (p != 6002)
      throw new Error("6001 unexpected reference to ".concat(p));
    var x = fv(e, d);
    x.data.forEach(function(g, F) {
      g.forEach(function(C, _) {
        var I = de({ r: u + F, c: _ }), P = sv(C, c, f);
        P && (r[I] = P);
      });
    }), u += x.nrows;
  });
}
function uv(e, t) {
  var r = ir(t.data), a = { "!ref": "A1" }, n = e[nt(r[2][0].data)], i = Xe(n[0].meta[1][0].data);
  if (i != 6001)
    throw new Error("6000 unexpected reference to ".concat(i));
  return ov(e, n[0], a), a;
}
function lv(e, t) {
  var r, a = ir(t.data), n = {
    name: (r = a[1]) != null && r[0] ? Ln(a[1][0].data) : "",
    sheets: []
  }, i = l0(a[2], nt);
  return i.forEach(function(s) {
    e[s].forEach(function(c) {
      var f = Xe(c.meta[1][0].data);
      f == 6e3 && n.sheets.push(uv(e, c));
    });
  }), n;
}
function hv(e, t) {
  var r = d0(), a = ir(t.data), n = l0(a[1], nt);
  if (n.forEach(function(i) {
    e[i].forEach(function(s) {
      var c = Xe(s.meta[1][0].data);
      if (c == 2) {
        var f = lv(e, s);
        f.sheets.forEach(function(o, u) {
          p0(r, o, u == 0 ? f.name : f.name + "_" + u, !0);
        });
      }
    });
  }), r.SheetNames.length == 0)
    throw new Error("Empty NUMBERS file");
  return r;
}
function Sn(e) {
  var t, r, a, n, i = {}, s = [];
  if (e.FullPaths.forEach(function(f) {
    if (f.match(/\.iwpv2/))
      throw new Error("Unsupported password protection");
  }), e.FileIndex.forEach(function(f) {
    if (f.name.match(/\.iwa$/)) {
      var o;
      try {
        o = av(f.content);
      } catch (l) {
        return console.log("?? " + f.content.length + " " + (l.message || l));
      }
      var u;
      try {
        u = rv(o);
      } catch (l) {
        return console.log("## " + (l.message || l));
      }
      u.forEach(function(l) {
        i[l.id] = l.messages, s.push(l.id);
      });
    }
  }), !s.length)
    throw new Error("File has no messages");
  var c = ((n = (a = (r = (t = i == null ? void 0 : i[1]) == null ? void 0 : t[0]) == null ? void 0 : r.meta) == null ? void 0 : a[1]) == null ? void 0 : n[0].data) && Xe(i[1][0].meta[1][0].data) == 1 && i[1][0];
  if (c || s.forEach(function(f) {
    i[f].forEach(function(o) {
      var u = Xe(o.meta[1][0].data) >>> 0;
      if (u == 1)
        if (!c)
          c = o;
        else
          throw new Error("Document has multiple roots");
    });
  }), !c)
    throw new Error("Cannot find Document root");
  return hv(i, c);
}
function xv(e) {
  return function(r) {
    for (var a = 0; a != e.length; ++a) {
      var n = e[a];
      r[n[0]] === void 0 && (r[n[0]] = n[1]), n[2] === "n" && (r[n[0]] = Number(r[n[0]]));
    }
  };
}
function h0(e) {
  xv([
    ["cellNF", !1],
    /* emit cell number format string as .z */
    ["cellHTML", !0],
    /* emit html string as .h */
    ["cellFormula", !0],
    /* emit formulae as .f */
    ["cellStyles", !1],
    /* emits style/theme as .s */
    ["cellText", !0],
    /* emit formatted text as .w */
    ["cellDates", !1],
    /* emit date cells with type `d` */
    ["sheetStubs", !1],
    /* emit empty cells */
    ["sheetRows", 0, "n"],
    /* read n rows (0 = read all rows) */
    ["bookDeps", !1],
    /* parse calculation chains */
    ["bookSheets", !1],
    /* only try to get sheet names (no Sheets) */
    ["bookProps", !1],
    /* only try to get properties (no Sheets) */
    ["bookFiles", !1],
    /* include raw file structure (keys, files, cfb) */
    ["bookVBA", !1],
    /* include vba raw data (vbaraw) */
    ["password", ""],
    /* password */
    ["WTF", !1]
    /* WTF mode (throws errors) */
  ])(e);
}
function dv(e) {
  return It.WS.indexOf(e) > -1 ? "sheet" : e == It.CS ? "chart" : e == It.DS ? "dialog" : e == It.MS ? "macro" : e && e.length ? e : "sheet";
}
function pv(e, t) {
  if (!e) return 0;
  try {
    e = t.map(function(a) {
      return a.id || (a.id = a.strRelID), [a.name, e["!id"][a.id].Target, dv(e["!id"][a.id].Type)];
    });
  } catch {
    return null;
  }
  return !e || e.length === 0 ? null : e;
}
function vv(e, t, r, a, n, i, s, c, f, o, u, l) {
  try {
    i[a] = ra(kr(e, r, !0), t);
    var h = He(e, t), d;
    switch (c) {
      case "sheet":
        d = Tp(h, t, n, f, i[a], o, u, l);
        break;
      case "chart":
        if (d = wp(h, t, n, f, i[a], o, u, l), !d || !d["!drawel"]) break;
        var p = Kt(d["!drawel"].Target, t), x = Dn(p), g = E1(kr(e, p, !0), ra(kr(e, x, !0), p)), F = Kt(g, p), C = Dn(F);
        d = ip(kr(e, F, !0), F, f, ra(kr(e, C, !0), F), o, d);
        break;
      case "macro":
        d = Ap(h, t, n, f, i[a], o, u, l);
        break;
      case "dialog":
        d = Fp(h, t, n, f, i[a], o, u, l);
        break;
      default:
        throw new Error("Unrecognized sheet type " + c);
    }
    s[a] = d;
    var _ = [];
    i && i[a] && $r(i[a]).forEach(function(I) {
      var P = "";
      if (i[a][I].Type == It.CMNT) {
        P = Kt(i[a][I].Target, t);
        var O = Op(He(e, P, !0), P, f);
        if (!O || !O.length) return;
        di(d, O, !1);
      }
      i[a][I].Type == It.TCMNT && (P = Kt(i[a][I].Target, t), _ = _.concat(w1(He(e, P, !0), f)));
    }), _ && _.length && di(d, _, !0, f.people || []);
  } catch (I) {
    if (f.WTF) throw I;
  }
}
function Ar(e) {
  return e.charAt(0) == "/" ? e.slice(1) : e;
}
function gv(e, t) {
  if (xs(), t = t || {}, h0(t), Sr(e, "META-INF/manifest.xml") || Sr(e, "objectdata.xml")) return Si(e, t);
  if (Sr(e, "Index/Document.iwa")) {
    if (typeof Uint8Array > "u") throw new Error("NUMBERS file parsing requires Uint8Array support");
    if (typeof Sn < "u") {
      if (e.FileIndex) return Sn(e);
      var r = ke.utils.cfb_new();
      return $0(e).forEach(function(oe) {
        mo(r, oe, go(e, oe));
      }), Sn(r);
    }
    throw new Error("Unsupported NUMBERS file");
  }
  if (!Sr(e, "[Content_Types].xml"))
    throw Sr(e, "index.xml.gz") ? new Error("Unsupported NUMBERS 08 file") : Sr(e, "index.xml") ? new Error("Unsupported NUMBERS 09 file") : new Error("Unsupported ZIP file");
  var a = $0(e), n = xu(kr(e, "[Content_Types].xml")), i = !1, s, c;
  if (n.workbooks.length === 0 && (c = "xl/workbook.xml", He(e, c, !0) && n.workbooks.push(c)), n.workbooks.length === 0) {
    if (c = "xl/workbook.bin", !He(e, c, !0)) throw new Error("Could not find workbook");
    n.workbooks.push(c), i = !0;
  }
  n.workbooks[0].slice(-3) == "bin" && (i = !0);
  var f = {}, o = {};
  if (!t.bookSheets && !t.bookProps) {
    if (na = [], n.sst) try {
      na = Cp(He(e, Ar(n.sst)), n.sst, t);
    } catch (oe) {
      if (t.WTF) throw oe;
    }
    t.cellStyles && n.themes.length && (f = yp(kr(e, n.themes[0].replace(/^\//, ""), !0) || "", n.themes[0], t)), n.style && (o = Sp(He(e, Ar(n.style)), n.style, f, t));
  }
  n.links.map(function(oe) {
    try {
      var te = ra(kr(e, Dn(Ar(oe))), oe);
      return Dp(He(e, Ar(oe)), te, oe, t);
    } catch {
    }
  });
  var u = Ep(He(e, Ar(n.workbooks[0])), n.workbooks[0], t), l = {}, h = "";
  n.coreprops.length && (h = He(e, Ar(n.coreprops[0]), !0), h && (l = Vs(h)), n.extprops.length !== 0 && (h = He(e, Ar(n.extprops[0]), !0), h && mu(h, l, t)));
  var d = {};
  (!t.bookSheets || t.bookProps) && n.custprops.length !== 0 && (h = kr(e, Ar(n.custprops[0]), !0), h && (d = ku(h, t)));
  var p = {};
  if ((t.bookSheets || t.bookProps) && (u.Sheets ? s = u.Sheets.map(function(te) {
    return te.name;
  }) : l.Worksheets && l.SheetNames.length > 0 && (s = l.SheetNames), t.bookProps && (p.Props = l, p.Custprops = d), t.bookSheets && typeof s < "u" && (p.SheetNames = s), t.bookSheets ? p.SheetNames : t.bookProps))
    return p;
  s = {};
  var x = {};
  t.bookDeps && n.calcchain && (x = Ip(He(e, Ar(n.calcchain)), n.calcchain));
  var g = 0, F = {}, C, _;
  {
    var I = u.Sheets;
    l.Worksheets = I.length, l.SheetNames = [];
    for (var P = 0; P != I.length; ++P)
      l.SheetNames[P] = I[P].name;
  }
  var O = i ? "bin" : "xml", A = n.workbooks[0].lastIndexOf("/"), V = (n.workbooks[0].slice(0, A + 1) + "_rels/" + n.workbooks[0].slice(A + 1) + ".rels").replace(/^\//, "");
  Sr(e, V) || (V = "xl/_rels/workbook." + O + ".rels");
  var D = ra(kr(e, V, !0), V.replace(/_rels.*/, "s5s"));
  (n.metadata || []).length >= 1 && (t.xlmeta = Rp(He(e, Ar(n.metadata[0])), n.metadata[0], t)), (n.people || []).length >= 1 && (t.people = A1(He(e, Ar(n.people[0])), t)), D && (D = pv(D, u.Sheets));
  var G = He(e, "xl/worksheets/sheet.xml", !0) ? 1 : 0;
  e: for (g = 0; g != l.Worksheets; ++g) {
    var W = "sheet";
    if (D && D[g] ? (C = "xl/" + D[g][1].replace(/[\/]?xl\//, ""), Sr(e, C) || (C = D[g][1]), Sr(e, C) || (C = V.replace(/_rels\/.*$/, "") + D[g][1]), W = D[g][2]) : (C = "xl/worksheets/sheet" + (g + 1 - G) + "." + O, C = C.replace(/sheet0\./, "sheet.")), _ = C.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"), t && t.sheets != null) switch (typeof t.sheets) {
      case "number":
        if (g != t.sheets) continue e;
        break;
      case "string":
        if (l.SheetNames[g].toLowerCase() != t.sheets.toLowerCase()) continue e;
        break;
      default:
        if (Array.isArray && Array.isArray(t.sheets)) {
          for (var b = !1, J = 0; J != t.sheets.length; ++J)
            typeof t.sheets[J] == "number" && t.sheets[J] == g && (b = 1), typeof t.sheets[J] == "string" && t.sheets[J].toLowerCase() == l.SheetNames[g].toLowerCase() && (b = 1);
          if (!b) continue e;
        }
    }
    vv(e, C, _, l.SheetNames[g], g, F, s, W, t, u, f, o);
  }
  return p = {
    Directory: n,
    Workbook: u,
    Props: l,
    Custprops: d,
    Deps: x,
    Sheets: s,
    SheetNames: l.SheetNames,
    Strings: na,
    Styles: o,
    Themes: f,
    SSF: qe(ve)
  }, t && t.bookFiles && (e.files ? (p.keys = a, p.files = e.files) : (p.keys = [], p.files = {}, e.FullPaths.forEach(function(oe, te) {
    oe = oe.replace(/^Root Entry[\/]/, ""), p.keys.push(oe), p.files[oe] = e.FileIndex[te];
  }))), t && t.bookVBA && (n.vba.length > 0 ? p.vbaraw = He(e, Ar(n.vba[0]), !0) : n.defaults && n.defaults.bin === C1 && (p.vbaraw = He(e, "xl/vbaProject.bin", !0))), p;
}
function mv(e, t) {
  var r = t || {}, a = "Workbook", n = ke.find(e, a);
  try {
    if (a = "/!DataSpaces/Version", n = ke.find(e, a), !n || !n.content) throw new Error("ECMA-376 Encrypted file missing " + a);
    if (uh(n.content), a = "/!DataSpaces/DataSpaceMap", n = ke.find(e, a), !n || !n.content) throw new Error("ECMA-376 Encrypted file missing " + a);
    var i = hh(n.content);
    if (i.length !== 1 || i[0].comps.length !== 1 || i[0].comps[0].t !== 0 || i[0].name !== "StrongEncryptionDataSpace" || i[0].comps[0].v !== "EncryptedPackage")
      throw new Error("ECMA-376 Encrypted file bad " + a);
    if (a = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace", n = ke.find(e, a), !n || !n.content) throw new Error("ECMA-376 Encrypted file missing " + a);
    var s = xh(n.content);
    if (s.length != 1 || s[0] != "StrongEncryptionTransform")
      throw new Error("ECMA-376 Encrypted file bad " + a);
    if (a = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary", n = ke.find(e, a), !n || !n.content) throw new Error("ECMA-376 Encrypted file missing " + a);
    ph(n.content);
  } catch {
  }
  if (a = "/EncryptionInfo", n = ke.find(e, a), !n || !n.content) throw new Error("ECMA-376 Encrypted file missing " + a);
  var c = vh(n.content);
  if (a = "/EncryptedPackage", n = ke.find(e, a), !n || !n.content) throw new Error("ECMA-376 Encrypted file missing " + a);
  if (c[0] == 4 && typeof decrypt_agile < "u") return decrypt_agile(c[1], n.content, r.password || "", r);
  if (c[0] == 2 && typeof decrypt_std76 < "u") return decrypt_std76(c[1], n.content, r.password || "", r);
  throw new Error("File is password-protected");
}
function x0(e, t) {
  var r = "";
  switch ((t || {}).type || "base64") {
    case "buffer":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    case "base64":
      r = Er(e.slice(0, 12));
      break;
    case "binary":
      r = e;
      break;
    case "array":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    default:
      throw new Error("Unrecognized type " + (t && t.type || "undefined"));
  }
  return [r.charCodeAt(0), r.charCodeAt(1), r.charCodeAt(2), r.charCodeAt(3), r.charCodeAt(4), r.charCodeAt(5), r.charCodeAt(6), r.charCodeAt(7)];
}
function _v(e, t) {
  return ke.find(e, "EncryptedPackage") ? mv(e, t) : Sc(e, t);
}
function kv(e, t) {
  var r, a = e, n = t || {};
  return n.type || (n.type = _e && Buffer.isBuffer(e) ? "buffer" : "base64"), r = _s(a, n), gv(r, n);
}
function Ic(e, t) {
  var r = 0;
  e: for (; r < e.length; ) switch (e.charCodeAt(r)) {
    case 10:
    case 13:
    case 32:
      ++r;
      break;
    case 60:
      return bn(e.slice(r), t);
    default:
      break e;
  }
  return ha.to_workbook(e, t);
}
function Ev(e, t) {
  var r = "", a = x0(e, t);
  switch (t.type) {
    case "base64":
      r = Er(e);
      break;
    case "binary":
      r = e;
      break;
    case "buffer":
      r = e.toString("binary");
      break;
    case "array":
      r = gt(e);
      break;
    default:
      throw new Error("Unrecognized type " + t.type);
  }
  return a[0] == 239 && a[1] == 187 && a[2] == 191 && (r = ye(r)), t.type = "binary", Ic(r, t);
}
function Tv(e, t) {
  var r = e;
  return t.type == "base64" && (r = Er(r)), r = fa.utils.decode(1200, r.slice(2), "str"), t.type = "binary", Ic(r, t);
}
function wv(e) {
  return e.match(/[^\x00-\x7F]/) ? Yt(e) : e;
}
function yn(e, t, r, a) {
  return a ? (r.type = "string", ha.to_workbook(e, r)) : ha.to_workbook(t, r);
}
function Bn(e, t) {
  rs();
  var r = t || {};
  if (typeof ArrayBuffer < "u" && e instanceof ArrayBuffer) return Bn(new Uint8Array(e), (r = qe(r), r.type = "array", r));
  typeof Uint8Array < "u" && e instanceof Uint8Array && !r.type && (r.type = typeof Deno < "u" ? "buffer" : "array");
  var a = e, n = [0, 0, 0, 0], i = !1;
  if (r.cellStyles && (r.cellNF = !0, r.sheetStubs = !0), bt = {}, r.dateNF && (bt.dateNF = r.dateNF), r.type || (r.type = _e && Buffer.isBuffer(e) ? "buffer" : "base64"), r.type == "file" && (r.type = _e ? "buffer" : "binary", a = oo(e), typeof Uint8Array < "u" && !_e && (r.type = "array")), r.type == "string" && (i = !0, r.type = "binary", r.codepage = 65001, a = wv(e)), r.type == "array" && typeof Uint8Array < "u" && e instanceof Uint8Array && typeof ArrayBuffer < "u") {
    var s = new ArrayBuffer(3), c = new Uint8Array(s);
    if (c.foo = "bar", !c.foo)
      return r = qe(r), r.type = "array", Bn(Zn(a), r);
  }
  switch ((n = x0(a, r))[0]) {
    case 208:
      if (n[1] === 207 && n[2] === 17 && n[3] === 224 && n[4] === 161 && n[5] === 177 && n[6] === 26 && n[7] === 225) return _v(ke.read(a, r), r);
      break;
    case 9:
      if (n[1] <= 8) return Sc(a, r);
      break;
    case 60:
      return bn(a, r);
    case 73:
      if (n[1] === 73 && n[2] === 42 && n[3] === 0) throw new Error("TIFF Image File is not a spreadsheet");
      if (n[1] === 68) return Jl(a, r);
      break;
    case 84:
      if (n[1] === 65 && n[2] === 66 && n[3] === 76) return Kl.to_workbook(a, r);
      break;
    case 80:
      return n[1] === 75 && n[2] < 9 && n[3] < 9 ? kv(a, r) : yn(e, a, r, i);
    case 239:
      return n[3] === 60 ? bn(a, r) : yn(e, a, r, i);
    case 255:
      if (n[1] === 254)
        return Tv(a, r);
      if (n[1] === 0 && n[2] === 2 && n[3] === 0) return aa.to_workbook(a, r);
      break;
    case 0:
      if (n[1] === 0 && (n[2] >= 2 && n[3] === 0 || n[2] === 0 && (n[3] === 8 || n[3] === 9)))
        return aa.to_workbook(a, r);
      break;
    case 3:
    case 131:
    case 139:
    case 140:
      return xi.to_workbook(a, r);
    case 123:
      if (n[1] === 92 && n[2] === 114 && n[3] === 116) return Ch.to_workbook(a, r);
      break;
    case 10:
    case 13:
    case 32:
      return Ev(a, r);
    case 137:
      if (n[1] === 80 && n[2] === 78 && n[3] === 71) throw new Error("PNG Image File is not a spreadsheet");
      break;
  }
  return jl.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31 ? xi.to_workbook(a, r) : yn(e, a, r, i);
}
function Av(e, t, r, a, n, i, s, c) {
  var f = Qe(r), o = c.defval, u = c.raw || !Object.prototype.hasOwnProperty.call(c, "raw"), l = !0, h = n === 1 ? [] : {};
  if (n !== 1)
    if (Object.defineProperty) try {
      Object.defineProperty(h, "__rowNum__", { value: r, enumerable: !1 });
    } catch {
      h.__rowNum__ = r;
    }
    else h.__rowNum__ = r;
  if (!s || e[r]) for (var d = t.s.c; d <= t.e.c; ++d) {
    var p = s ? e[r][d] : e[a[d] + f];
    if (p === void 0 || p.t === void 0) {
      if (o === void 0) continue;
      i[d] != null && (h[i[d]] = o);
      continue;
    }
    var x = p.v;
    switch (p.t) {
      case "z":
        if (x == null) break;
        continue;
      case "e":
        x = x == 0 ? null : void 0;
        break;
      case "s":
      case "d":
      case "b":
      case "n":
        break;
      default:
        throw new Error("unrecognized type " + p.t);
    }
    if (i[d] != null) {
      if (x == null)
        if (p.t == "e" && x === null) h[i[d]] = null;
        else if (o !== void 0) h[i[d]] = o;
        else if (u && x === null) h[i[d]] = null;
        else continue;
      else
        h[i[d]] = u && (p.t !== "n" || p.t === "n" && c.rawNumbers !== !1) ? x : Yr(p, x, c);
      x != null && (l = !1);
    }
  }
  return { row: h, isempty: l };
}
function Un(e, t) {
  if (e == null || e["!ref"] == null) return [];
  var r = { t: "n", v: 0 }, a = 0, n = 1, i = [], s = 0, c = "", f = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, o = t || {}, u = o.range != null ? o.range : e["!ref"];
  switch (o.header === 1 ? a = 1 : o.header === "A" ? a = 2 : Array.isArray(o.header) ? a = 3 : o.header == null && (a = 0), typeof u) {
    case "string":
      f = Pe(u);
      break;
    case "number":
      f = Pe(e["!ref"]), f.s.r = u;
      break;
    default:
      f = u;
  }
  a > 0 && (n = 0);
  var l = Qe(f.s.r), h = [], d = [], p = 0, x = 0, g = Array.isArray(e), F = f.s.r, C = 0, _ = {};
  g && !e[F] && (e[F] = []);
  var I = o.skipHidden && e["!cols"] || [], P = o.skipHidden && e["!rows"] || [];
  for (C = f.s.c; C <= f.e.c; ++C)
    if (!(I[C] || {}).hidden)
      switch (h[C] = je(C), r = g ? e[F][C] : e[h[C] + l], a) {
        case 1:
          i[C] = C - f.s.c;
          break;
        case 2:
          i[C] = h[C];
          break;
        case 3:
          i[C] = o.header[C - f.s.c];
          break;
        default:
          if (r == null && (r = { w: "__EMPTY", t: "s" }), c = s = Yr(r, null, o), x = _[s] || 0, !x) _[s] = 1;
          else {
            do
              c = s + "_" + x++;
            while (_[c]);
            _[s] = x, _[c] = 1;
          }
          i[C] = c;
      }
  for (F = f.s.r + n; F <= f.e.r; ++F)
    if (!(P[F] || {}).hidden) {
      var O = Av(e, f, F, h, a, i, g, o);
      (O.isempty === !1 || (a === 1 ? o.blankrows !== !1 : o.blankrows)) && (d[p++] = O.row);
    }
  return d.length = p, d;
}
var Ii = /"/g;
function Fv(e, t, r, a, n, i, s, c) {
  for (var f = !0, o = [], u = "", l = Qe(r), h = t.s.c; h <= t.e.c; ++h)
    if (a[h]) {
      var d = c.dense ? (e[r] || [])[h] : e[a[h] + l];
      if (d == null) u = "";
      else if (d.v != null) {
        f = !1, u = "" + (c.rawNumbers && d.t == "n" ? d.v : Yr(d, null, c));
        for (var p = 0, x = 0; p !== u.length; ++p) if ((x = u.charCodeAt(p)) === n || x === i || x === 34 || c.forceQuotes) {
          u = '"' + u.replace(Ii, '""') + '"';
          break;
        }
        u == "ID" && (u = '"ID"');
      } else d.f != null && !d.F ? (f = !1, u = "=" + d.f, u.indexOf(",") >= 0 && (u = '"' + u.replace(Ii, '""') + '"')) : u = "";
      o.push(u);
    }
  return c.blankrows === !1 && f ? null : o.join(s);
}
function Dc(e, t) {
  var r = [], a = t ?? {};
  if (e == null || e["!ref"] == null) return "";
  var n = Pe(e["!ref"]), i = a.FS !== void 0 ? a.FS : ",", s = i.charCodeAt(0), c = a.RS !== void 0 ? a.RS : `
`, f = c.charCodeAt(0), o = new RegExp((i == "|" ? "\\|" : i) + "+$"), u = "", l = [];
  a.dense = Array.isArray(e);
  for (var h = a.skipHidden && e["!cols"] || [], d = a.skipHidden && e["!rows"] || [], p = n.s.c; p <= n.e.c; ++p) (h[p] || {}).hidden || (l[p] = je(p));
  for (var x = 0, g = n.s.r; g <= n.e.r; ++g)
    (d[g] || {}).hidden || (u = Fv(e, n, g, l, s, f, i, a), u != null && (a.strip && (u = u.replace(o, "")), (u || a.blankrows !== !1) && r.push((x++ ? c : "") + u)));
  return delete a.dense, r.join("");
}
function Sv(e, t) {
  t || (t = {}), t.FS = "	", t.RS = `
`;
  var r = Dc(e, t);
  return r;
}
function yv(e) {
  var t = "", r, a = "";
  if (e == null || e["!ref"] == null) return [];
  var n = Pe(e["!ref"]), i = "", s = [], c, f = [], o = Array.isArray(e);
  for (c = n.s.c; c <= n.e.c; ++c) s[c] = je(c);
  for (var u = n.s.r; u <= n.e.r; ++u)
    for (i = Qe(u), c = n.s.c; c <= n.e.c; ++c)
      if (t = s[c] + i, r = o ? (e[u] || [])[c] : e[t], a = "", r !== void 0) {
        if (r.F != null) {
          if (t = r.F, !r.f) continue;
          a = r.f, t.indexOf(":") == -1 && (t = t + ":" + t);
        }
        if (r.f != null) a = r.f;
        else {
          if (r.t == "z") continue;
          if (r.t == "n" && r.v != null) a = "" + r.v;
          else if (r.t == "b") a = r.v ? "TRUE" : "FALSE";
          else if (r.w !== void 0) a = "'" + r.w;
          else {
            if (r.v === void 0) continue;
            r.t == "s" ? a = "'" + r.v : a = "" + r.v;
          }
        }
        f[f.length] = t + "=" + a;
      }
  return f;
}
function Rc(e, t, r) {
  var a = r || {}, n = +!a.skipHeader, i = e || {}, s = 0, c = 0;
  if (i && a.origin != null)
    if (typeof a.origin == "number") s = a.origin;
    else {
      var f = typeof a.origin == "string" ? xr(a.origin) : a.origin;
      s = f.r, c = f.c;
    }
  var o, u = { s: { c: 0, r: 0 }, e: { c, r: s + t.length - 1 + n } };
  if (i["!ref"]) {
    var l = Pe(i["!ref"]);
    u.e.c = Math.max(u.e.c, l.e.c), u.e.r = Math.max(u.e.r, l.e.r), s == -1 && (s = l.e.r + 1, u.e.r = s + t.length - 1 + n);
  } else
    s == -1 && (s = 0, u.e.r = t.length - 1 + n);
  var h = a.header || [], d = 0;
  t.forEach(function(x, g) {
    $r(x).forEach(function(F) {
      (d = h.indexOf(F)) == -1 && (h[d = h.length] = F);
      var C = x[F], _ = "z", I = "", P = de({ c: c + d, r: s + g + n });
      o = va(i, P), C && typeof C == "object" && !(C instanceof Date) ? i[P] = C : (typeof C == "number" ? _ = "n" : typeof C == "boolean" ? _ = "b" : typeof C == "string" ? _ = "s" : C instanceof Date ? (_ = "d", a.cellDates || (_ = "n", C = pr(C)), I = a.dateNF || ve[14]) : C === null && a.nullError && (_ = "e", C = 0), o ? (o.t = _, o.v = C, delete o.w, delete o.R, I && (o.z = I)) : i[P] = o = { t: _, v: C }, I && (o.z = I));
    });
  }), u.e.c = Math.max(u.e.c, c + h.length - 1);
  var p = Qe(s);
  if (n) for (d = 0; d < h.length; ++d) i[je(d + c) + p] = { t: "s", v: h[d] };
  return i["!ref"] = Ee(u), i;
}
function Cv(e, t) {
  return Rc(null, e, t);
}
function va(e, t, r) {
  if (typeof t == "string") {
    if (Array.isArray(e)) {
      var a = xr(t);
      return e[a.r] || (e[a.r] = []), e[a.r][a.c] || (e[a.r][a.c] = { t: "z" });
    }
    return e[t] || (e[t] = { t: "z" });
  }
  return typeof t != "number" ? va(e, de(t)) : va(e, de({ r: t, c: r || 0 }));
}
function Ov(e, t) {
  if (typeof t == "number") {
    if (t >= 0 && e.SheetNames.length > t) return t;
    throw new Error("Cannot find sheet # " + t);
  } else if (typeof t == "string") {
    var r = e.SheetNames.indexOf(t);
    if (r > -1) return r;
    throw new Error("Cannot find sheet name |" + t + "|");
  } else throw new Error("Cannot find sheet |" + t + "|");
}
function d0() {
  return { SheetNames: [], Sheets: {} };
}
function p0(e, t, r, a) {
  var n = 1;
  if (!r) for (; n <= 65535 && e.SheetNames.indexOf(r = "Sheet" + n) != -1; ++n, r = void 0) ;
  if (!r || e.SheetNames.length >= 65535) throw new Error("Too many worksheets");
  if (a && e.SheetNames.indexOf(r) >= 0) {
    var i = r.match(/(^.*?)(\d+)$/);
    n = i && +i[2] || 0;
    var s = i && i[1] || r;
    for (++n; n <= 65535 && e.SheetNames.indexOf(r = s + n) != -1; ++n) ;
  }
  if (xp(r), e.SheetNames.indexOf(r) >= 0) throw new Error("Worksheet with name |" + r + "| already exists!");
  return e.SheetNames.push(r), e.Sheets[r] = t, r;
}
function Iv(e, t, r) {
  e.Workbook || (e.Workbook = {}), e.Workbook.Sheets || (e.Workbook.Sheets = []);
  var a = Ov(e, t);
  switch (e.Workbook.Sheets[a] || (e.Workbook.Sheets[a] = {}), r) {
    case 0:
    case 1:
    case 2:
      break;
    default:
      throw new Error("Bad sheet visibility setting " + r);
  }
  e.Workbook.Sheets[a].Hidden = r;
}
function Dv(e, t) {
  return e.z = t, e;
}
function Nc(e, t, r) {
  return t ? (e.l = { Target: t }, r && (e.l.Tooltip = r)) : delete e.l, e;
}
function Rv(e, t, r) {
  return Nc(e, "#" + t, r);
}
function Nv(e, t, r) {
  e.c || (e.c = []), e.c.push({ t, a: r || "SheetJS" });
}
function bv(e, t, r, a) {
  for (var n = typeof t != "string" ? t : Pe(t), i = typeof t == "string" ? t : Ee(t), s = n.s.r; s <= n.e.r; ++s) for (var c = n.s.c; c <= n.e.c; ++c) {
    var f = va(e, s, c);
    f.t = "n", f.F = i, delete f.v, s == n.s.r && c == n.s.c && (f.f = r, a && (f.D = !0));
  }
  return e;
}
var Pv = {
  encode_col: je,
  encode_row: Qe,
  encode_cell: de,
  encode_range: Ee,
  decode_col: e0,
  decode_row: Qn,
  split_cell: Go,
  decode_cell: xr,
  decode_range: Ut,
  format_cell: Yr,
  sheet_add_aoa: Ms,
  sheet_add_json: Rc,
  sheet_add_dom: yc,
  aoa_to_sheet: zt,
  json_to_sheet: Cv,
  table_to_sheet: Cc,
  table_to_book: Jp,
  sheet_to_csv: Dc,
  sheet_to_txt: Sv,
  sheet_to_json: Un,
  sheet_to_html: Yp,
  sheet_to_formulae: yv,
  sheet_to_row_object_array: Un,
  sheet_get_cell: va,
  book_new: d0,
  book_append_sheet: p0,
  book_set_sheet_visibility: Iv,
  cell_set_number_format: Dv,
  cell_set_hyperlink: Nc,
  cell_set_internal_link: Rv,
  cell_add_comment: Nv,
  sheet_set_array_formula: bv,
  consts: {
    SHEET_VISIBLE: 0,
    SHEET_HIDDEN: 1,
    SHEET_VERY_HIDDEN: 2
  }
};
function Lv(e) {
  return e.toLowerCase().trim().replace(/\s+/g, " ");
}
function Mv(e) {
  if (e == null || e === 0)
    return;
  const t = String(e).trim();
  return t !== "" ? t : void 0;
}
function Bv(e) {
  const t = Bn(e, { type: "array" });
  if (!t.SheetNames.includes("Event results"))
    throw new Error('Sheet "Event results" not found in the uploaded file');
  const r = t.Sheets["Event results"];
  return Pv.sheet_to_json(r, { defval: null });
}
const Bk = {
  normalizeName: Lv,
  toPdgaString: Mv,
  parseFile: Bv
};
function j(e, t, r) {
  function a(c, f) {
    if (c._zod || Object.defineProperty(c, "_zod", {
      value: {
        def: f,
        constr: s,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), c._zod.traits.has(e))
      return;
    c._zod.traits.add(e), t(c, f);
    const o = s.prototype, u = Object.keys(o);
    for (let l = 0; l < u.length; l++) {
      const h = u[l];
      h in c || (c[h] = o[h].bind(c));
    }
  }
  const n = (r == null ? void 0 : r.Parent) ?? Object;
  class i extends n {
  }
  Object.defineProperty(i, "name", { value: e });
  function s(c) {
    var f;
    const o = r != null && r.Parent ? new i() : this;
    a(o, c), (f = o._zod).deferred ?? (f.deferred = []);
    for (const u of o._zod.deferred)
      u();
    return o;
  }
  return Object.defineProperty(s, "init", { value: a }), Object.defineProperty(s, Symbol.hasInstance, {
    value: (c) => {
      var f, o;
      return r != null && r.Parent && c instanceof r.Parent ? !0 : (o = (f = c == null ? void 0 : c._zod) == null ? void 0 : f.traits) == null ? void 0 : o.has(e);
    }
  }), Object.defineProperty(s, "name", { value: e }), s;
}
class Pt extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class bc extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Pc = {};
function _t(e) {
  return Pc;
}
function Lc(e) {
  const t = Object.values(e).filter((a) => typeof a == "number");
  return Object.entries(e).filter(([a, n]) => t.indexOf(+a) === -1).map(([a, n]) => n);
}
function zn(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function v0(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function g0(e) {
  return e == null;
}
function m0(e) {
  const t = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, r);
}
function Uv(e, t) {
  const r = (e.toString().split(".")[1] || "").length, a = t.toString();
  let n = (a.split(".")[1] || "").length;
  if (n === 0 && /\d?e-\d?/.test(a)) {
    const f = a.match(/\d?e-(\d?)/);
    f != null && f[1] && (n = Number.parseInt(f[1]));
  }
  const i = r > n ? r : n, s = Number.parseInt(e.toFixed(i).replace(".", "")), c = Number.parseInt(t.toFixed(i).replace(".", ""));
  return s % c / 10 ** i;
}
const Di = Symbol("evaluating");
function Fe(e, t, r) {
  let a;
  Object.defineProperty(e, t, {
    get() {
      if (a !== Di)
        return a === void 0 && (a = Di, a = r()), a;
    },
    set(n) {
      Object.defineProperty(e, t, {
        value: n
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function yt(e, t, r) {
  Object.defineProperty(e, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function ft(...e) {
  const t = {};
  for (const r of e) {
    const a = Object.getOwnPropertyDescriptors(r);
    Object.assign(t, a);
  }
  return Object.defineProperties({}, t);
}
function Ri(e) {
  return JSON.stringify(e);
}
function zv(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const Mc = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function rn(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const $v = v0(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function ga(e) {
  if (rn(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const r = t.prototype;
  return !(rn(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function Bc(e) {
  return ga(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Vv = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function un(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function ot(e, t, r) {
  const a = new e._zod.constr(t ?? e._zod.def);
  return (!t || r != null && r.parent) && (a._zod.parent = e), a;
}
function ue(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Hv(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const Wv = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Zv(e, t) {
  const r = e._zod.def, a = r.checks;
  if (a && a.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = ft(e._zod.def, {
    get shape() {
      const s = {};
      for (const c in t) {
        if (!(c in r.shape))
          throw new Error(`Unrecognized key: "${c}"`);
        t[c] && (s[c] = r.shape[c]);
      }
      return yt(this, "shape", s), s;
    },
    checks: []
  });
  return ot(e, i);
}
function Gv(e, t) {
  const r = e._zod.def, a = r.checks;
  if (a && a.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = ft(e._zod.def, {
    get shape() {
      const s = { ...e._zod.def.shape };
      for (const c in t) {
        if (!(c in r.shape))
          throw new Error(`Unrecognized key: "${c}"`);
        t[c] && delete s[c];
      }
      return yt(this, "shape", s), s;
    },
    checks: []
  });
  return ot(e, i);
}
function jv(e, t) {
  if (!ga(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = e._zod.def.checks;
  if (r && r.length > 0) {
    const i = e._zod.def.shape;
    for (const s in t)
      if (Object.getOwnPropertyDescriptor(i, s) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const n = ft(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return yt(this, "shape", i), i;
    }
  });
  return ot(e, n);
}
function Xv(e, t) {
  if (!ga(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const r = ft(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape, ...t };
      return yt(this, "shape", a), a;
    }
  });
  return ot(e, r);
}
function Kv(e, t) {
  const r = ft(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape, ...t._zod.def.shape };
      return yt(this, "shape", a), a;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return ot(e, r);
}
function Yv(e, t, r) {
  const n = t._zod.def.checks;
  if (n && n.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const s = ft(t._zod.def, {
    get shape() {
      const c = t._zod.def.shape, f = { ...c };
      if (r)
        for (const o in r) {
          if (!(o in c))
            throw new Error(`Unrecognized key: "${o}"`);
          r[o] && (f[o] = e ? new e({
            type: "optional",
            innerType: c[o]
          }) : c[o]);
        }
      else
        for (const o in c)
          f[o] = e ? new e({
            type: "optional",
            innerType: c[o]
          }) : c[o];
      return yt(this, "shape", f), f;
    },
    checks: []
  });
  return ot(t, s);
}
function Jv(e, t, r) {
  const a = ft(t._zod.def, {
    get shape() {
      const n = t._zod.def.shape, i = { ...n };
      if (r)
        for (const s in r) {
          if (!(s in i))
            throw new Error(`Unrecognized key: "${s}"`);
          r[s] && (i[s] = new e({
            type: "nonoptional",
            innerType: n[s]
          }));
        }
      else
        for (const s in n)
          i[s] = new e({
            type: "nonoptional",
            innerType: n[s]
          });
      return yt(this, "shape", i), i;
    }
  });
  return ot(t, a);
}
function Dt(e, t = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let a = t; a < e.issues.length; a++)
    if (((r = e.issues[a]) == null ? void 0 : r.continue) !== !0)
      return !0;
  return !1;
}
function Uc(e, t) {
  return t.map((r) => {
    var a;
    return (a = r).path ?? (a.path = []), r.path.unshift(e), r;
  });
}
function Ma(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function kt(e, t, r) {
  var n, i, s, c, f, o;
  const a = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const u = Ma((s = (i = (n = e.inst) == null ? void 0 : n._zod.def) == null ? void 0 : i.error) == null ? void 0 : s.call(i, e)) ?? Ma((c = t == null ? void 0 : t.error) == null ? void 0 : c.call(t, e)) ?? Ma((f = r.customError) == null ? void 0 : f.call(r, e)) ?? Ma((o = r.localeError) == null ? void 0 : o.call(r, e)) ?? "Invalid input";
    a.message = u;
  }
  return delete a.inst, delete a.continue, t != null && t.reportInput || delete a.input, a;
}
function _0(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function ma(...e) {
  const [t, r, a] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: a
  } : { ...t };
}
const zc = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, zn, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, $c = j("$ZodError", zc), Vc = j("$ZodError", zc, { Parent: Error });
function qv(e, t = (r) => r.message) {
  const r = {}, a = [];
  for (const n of e.issues)
    n.path.length > 0 ? (r[n.path[0]] = r[n.path[0]] || [], r[n.path[0]].push(t(n))) : a.push(t(n));
  return { formErrors: a, fieldErrors: r };
}
function Qv(e, t = (r) => r.message) {
  const r = { _errors: [] }, a = (n) => {
    for (const i of n.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((s) => a({ issues: s }));
      else if (i.code === "invalid_key")
        a({ issues: i.issues });
      else if (i.code === "invalid_element")
        a({ issues: i.issues });
      else if (i.path.length === 0)
        r._errors.push(t(i));
      else {
        let s = r, c = 0;
        for (; c < i.path.length; ) {
          const f = i.path[c];
          c === i.path.length - 1 ? (s[f] = s[f] || { _errors: [] }, s[f]._errors.push(t(i))) : s[f] = s[f] || { _errors: [] }, s = s[f], c++;
        }
      }
  };
  return a(e), r;
}
const k0 = (e) => (t, r, a, n) => {
  const i = a ? Object.assign(a, { async: !1 }) : { async: !1 }, s = t._zod.run({ value: r, issues: [] }, i);
  if (s instanceof Promise)
    throw new Pt();
  if (s.issues.length) {
    const c = new ((n == null ? void 0 : n.Err) ?? e)(s.issues.map((f) => kt(f, i, _t())));
    throw Mc(c, n == null ? void 0 : n.callee), c;
  }
  return s.value;
}, E0 = (e) => async (t, r, a, n) => {
  const i = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let s = t._zod.run({ value: r, issues: [] }, i);
  if (s instanceof Promise && (s = await s), s.issues.length) {
    const c = new ((n == null ? void 0 : n.Err) ?? e)(s.issues.map((f) => kt(f, i, _t())));
    throw Mc(c, n == null ? void 0 : n.callee), c;
  }
  return s.value;
}, ln = (e) => (t, r, a) => {
  const n = a ? { ...a, async: !1 } : { async: !1 }, i = t._zod.run({ value: r, issues: [] }, n);
  if (i instanceof Promise)
    throw new Pt();
  return i.issues.length ? {
    success: !1,
    error: new (e ?? $c)(i.issues.map((s) => kt(s, n, _t())))
  } : { success: !0, data: i.value };
}, eg = /* @__PURE__ */ ln(Vc), hn = (e) => async (t, r, a) => {
  const n = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: r, issues: [] }, n);
  return i instanceof Promise && (i = await i), i.issues.length ? {
    success: !1,
    error: new e(i.issues.map((s) => kt(s, n, _t())))
  } : { success: !0, data: i.value };
}, rg = /* @__PURE__ */ hn(Vc), tg = (e) => (t, r, a) => {
  const n = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return k0(e)(t, r, n);
}, ag = (e) => (t, r, a) => k0(e)(t, r, a), ng = (e) => async (t, r, a) => {
  const n = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return E0(e)(t, r, n);
}, ig = (e) => async (t, r, a) => E0(e)(t, r, a), sg = (e) => (t, r, a) => {
  const n = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return ln(e)(t, r, n);
}, cg = (e) => (t, r, a) => ln(e)(t, r, a), fg = (e) => async (t, r, a) => {
  const n = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return hn(e)(t, r, n);
}, og = (e) => async (t, r, a) => hn(e)(t, r, a), ug = /^[cC][^\s-]{8,}$/, lg = /^[0-9a-z]+$/, hg = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, xg = /^[0-9a-vA-V]{20}$/, dg = /^[A-Za-z0-9]{27}$/, pg = /^[a-zA-Z0-9_-]{21}$/, vg = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, gg = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Ni = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, mg = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, _g = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function kg() {
  return new RegExp(_g, "u");
}
const Eg = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Tg = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, wg = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Ag = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Fg = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Hc = /^[A-Za-z0-9_-]*$/, Sg = /^\+[1-9]\d{6,14}$/, Wc = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", yg = /* @__PURE__ */ new RegExp(`^${Wc}$`);
function Zc(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Cg(e) {
  return new RegExp(`^${Zc(e)}$`);
}
function Og(e) {
  const t = Zc({ precision: e.precision }), r = ["Z"];
  e.local && r.push(""), e.offset && r.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const a = `${t}(?:${r.join("|")})`;
  return new RegExp(`^${Wc}T(?:${a})$`);
}
const Ig = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Dg = /^-?\d+$/, Rg = /^-?\d+(?:\.\d+)?$/, Ng = /^(?:true|false)$/i, bg = /^[^A-Z]*$/, Pg = /^[^a-z]*$/, gr = /* @__PURE__ */ j("$ZodCheck", (e, t) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = t, (r = e._zod).onattach ?? (r.onattach = []);
}), Gc = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, jc = /* @__PURE__ */ j("$ZodCheckLessThan", (e, t) => {
  gr.init(e, t);
  const r = Gc[typeof t.value];
  e._zod.onattach.push((a) => {
    const n = a._zod.bag, i = (t.inclusive ? n.maximum : n.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < i && (t.inclusive ? n.maximum = t.value : n.exclusiveMaximum = t.value);
  }), e._zod.check = (a) => {
    (t.inclusive ? a.value <= t.value : a.value < t.value) || a.issues.push({
      origin: r,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: a.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Xc = /* @__PURE__ */ j("$ZodCheckGreaterThan", (e, t) => {
  gr.init(e, t);
  const r = Gc[typeof t.value];
  e._zod.onattach.push((a) => {
    const n = a._zod.bag, i = (t.inclusive ? n.minimum : n.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > i && (t.inclusive ? n.minimum = t.value : n.exclusiveMinimum = t.value);
  }), e._zod.check = (a) => {
    (t.inclusive ? a.value >= t.value : a.value > t.value) || a.issues.push({
      origin: r,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: a.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Lg = /* @__PURE__ */ j("$ZodCheckMultipleOf", (e, t) => {
  gr.init(e, t), e._zod.onattach.push((r) => {
    var a;
    (a = r._zod.bag).multipleOf ?? (a.multipleOf = t.value);
  }), e._zod.check = (r) => {
    if (typeof r.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? r.value % t.value === BigInt(0) : Uv(r.value, t.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Mg = /* @__PURE__ */ j("$ZodCheckNumberFormat", (e, t) => {
  var s;
  gr.init(e, t), t.format = t.format || "float64";
  const r = (s = t.format) == null ? void 0 : s.includes("int"), a = r ? "int" : "number", [n, i] = Wv[t.format];
  e._zod.onattach.push((c) => {
    const f = c._zod.bag;
    f.format = t.format, f.minimum = n, f.maximum = i, r && (f.pattern = Dg);
  }), e._zod.check = (c) => {
    const f = c.value;
    if (r) {
      if (!Number.isInteger(f)) {
        c.issues.push({
          expected: a,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: f,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(f)) {
        f > 0 ? c.issues.push({
          input: f,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: a,
          inclusive: !0,
          continue: !t.abort
        }) : c.issues.push({
          input: f,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: a,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    f < n && c.issues.push({
      origin: "number",
      input: f,
      code: "too_small",
      minimum: n,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), f > i && c.issues.push({
      origin: "number",
      input: f,
      code: "too_big",
      maximum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), Bg = /* @__PURE__ */ j("$ZodCheckMaxLength", (e, t) => {
  var r;
  gr.init(e, t), (r = e._zod.def).when ?? (r.when = (a) => {
    const n = a.value;
    return !g0(n) && n.length !== void 0;
  }), e._zod.onattach.push((a) => {
    const n = a._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < n && (a._zod.bag.maximum = t.maximum);
  }), e._zod.check = (a) => {
    const n = a.value;
    if (n.length <= t.maximum)
      return;
    const s = _0(n);
    a.issues.push({
      origin: s,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), Ug = /* @__PURE__ */ j("$ZodCheckMinLength", (e, t) => {
  var r;
  gr.init(e, t), (r = e._zod.def).when ?? (r.when = (a) => {
    const n = a.value;
    return !g0(n) && n.length !== void 0;
  }), e._zod.onattach.push((a) => {
    const n = a._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > n && (a._zod.bag.minimum = t.minimum);
  }), e._zod.check = (a) => {
    const n = a.value;
    if (n.length >= t.minimum)
      return;
    const s = _0(n);
    a.issues.push({
      origin: s,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), zg = /* @__PURE__ */ j("$ZodCheckLengthEquals", (e, t) => {
  var r;
  gr.init(e, t), (r = e._zod.def).when ?? (r.when = (a) => {
    const n = a.value;
    return !g0(n) && n.length !== void 0;
  }), e._zod.onattach.push((a) => {
    const n = a._zod.bag;
    n.minimum = t.length, n.maximum = t.length, n.length = t.length;
  }), e._zod.check = (a) => {
    const n = a.value, i = n.length;
    if (i === t.length)
      return;
    const s = _0(n), c = i > t.length;
    a.issues.push({
      origin: s,
      ...c ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), xn = /* @__PURE__ */ j("$ZodCheckStringFormat", (e, t) => {
  var r, a;
  gr.init(e, t), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.format = t.format, t.pattern && (i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(t.pattern));
  }), t.pattern ? (r = e._zod).check ?? (r.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: n.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (a = e._zod).check ?? (a.check = () => {
  });
}), $g = /* @__PURE__ */ j("$ZodCheckRegex", (e, t) => {
  xn.init(e, t), e._zod.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Vg = /* @__PURE__ */ j("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = bg), xn.init(e, t);
}), Hg = /* @__PURE__ */ j("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Pg), xn.init(e, t);
}), Wg = /* @__PURE__ */ j("$ZodCheckIncludes", (e, t) => {
  gr.init(e, t);
  const r = un(t.includes), a = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${r}` : r);
  t.pattern = a, e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(a);
  }), e._zod.check = (n) => {
    n.value.includes(t.includes, t.position) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Zg = /* @__PURE__ */ j("$ZodCheckStartsWith", (e, t) => {
  gr.init(e, t);
  const r = new RegExp(`^${un(t.prefix)}.*`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((a) => {
    const n = a._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(r);
  }), e._zod.check = (a) => {
    a.value.startsWith(t.prefix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Gg = /* @__PURE__ */ j("$ZodCheckEndsWith", (e, t) => {
  gr.init(e, t);
  const r = new RegExp(`.*${un(t.suffix)}$`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((a) => {
    const n = a._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(r);
  }), e._zod.check = (a) => {
    a.value.endsWith(t.suffix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), jg = /* @__PURE__ */ j("$ZodCheckOverwrite", (e, t) => {
  gr.init(e, t), e._zod.check = (r) => {
    r.value = t.tx(r.value);
  };
});
class Xg {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const a = t.split(`
`).filter((s) => s), n = Math.min(...a.map((s) => s.length - s.trimStart().length)), i = a.map((s) => s.slice(n)).map((s) => " ".repeat(this.indent * 2) + s);
    for (const s of i)
      this.content.push(s);
  }
  compile() {
    const t = Function, r = this == null ? void 0 : this.args, n = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...r, n.join(`
`));
  }
}
const Kg = {
  major: 4,
  minor: 3,
  patch: 6
}, Le = /* @__PURE__ */ j("$ZodType", (e, t) => {
  var n;
  var r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Kg;
  const a = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && a.unshift(e);
  for (const i of a)
    for (const s of i._zod.onattach)
      s(e);
  if (a.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (n = e._zod.deferred) == null || n.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const i = (c, f, o) => {
      let u = Dt(c), l;
      for (const h of f) {
        if (h._zod.def.when) {
          if (!h._zod.def.when(c))
            continue;
        } else if (u)
          continue;
        const d = c.issues.length, p = h._zod.check(c);
        if (p instanceof Promise && (o == null ? void 0 : o.async) === !1)
          throw new Pt();
        if (l || p instanceof Promise)
          l = (l ?? Promise.resolve()).then(async () => {
            await p, c.issues.length !== d && (u || (u = Dt(c, d)));
          });
        else {
          if (c.issues.length === d)
            continue;
          u || (u = Dt(c, d));
        }
      }
      return l ? l.then(() => c) : c;
    }, s = (c, f, o) => {
      if (Dt(c))
        return c.aborted = !0, c;
      const u = i(f, a, o);
      if (u instanceof Promise) {
        if (o.async === !1)
          throw new Pt();
        return u.then((l) => e._zod.parse(l, o));
      }
      return e._zod.parse(u, o);
    };
    e._zod.run = (c, f) => {
      if (f.skipChecks)
        return e._zod.parse(c, f);
      if (f.direction === "backward") {
        const u = e._zod.parse({ value: c.value, issues: [] }, { ...f, skipChecks: !0 });
        return u instanceof Promise ? u.then((l) => s(l, c, f)) : s(u, c, f);
      }
      const o = e._zod.parse(c, f);
      if (o instanceof Promise) {
        if (f.async === !1)
          throw new Pt();
        return o.then((u) => i(u, a, f));
      }
      return i(o, a, f);
    };
  }
  Fe(e, "~standard", () => ({
    validate: (i) => {
      var s;
      try {
        const c = eg(e, i);
        return c.success ? { value: c.data } : { issues: (s = c.error) == null ? void 0 : s.issues };
      } catch {
        return rg(e, i).then((f) => {
          var o;
          return f.success ? { value: f.data } : { issues: (o = f.error) == null ? void 0 : o.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), T0 = /* @__PURE__ */ j("$ZodString", (e, t) => {
  var r;
  Le.init(e, t), e._zod.pattern = [...((r = e == null ? void 0 : e._zod.bag) == null ? void 0 : r.patterns) ?? []].pop() ?? Ig(e._zod.bag), e._zod.parse = (a, n) => {
    if (t.coerce)
      try {
        a.value = String(a.value);
      } catch {
      }
    return typeof a.value == "string" || a.issues.push({
      expected: "string",
      code: "invalid_type",
      input: a.value,
      inst: e
    }), a;
  };
}), Ie = /* @__PURE__ */ j("$ZodStringFormat", (e, t) => {
  xn.init(e, t), T0.init(e, t);
}), Yg = /* @__PURE__ */ j("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = gg), Ie.init(e, t);
}), Jg = /* @__PURE__ */ j("$ZodUUID", (e, t) => {
  if (t.version) {
    const a = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (a === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Ni(a));
  } else
    t.pattern ?? (t.pattern = Ni());
  Ie.init(e, t);
}), qg = /* @__PURE__ */ j("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = mg), Ie.init(e, t);
}), Qg = /* @__PURE__ */ j("$ZodURL", (e, t) => {
  Ie.init(e, t), e._zod.check = (r) => {
    try {
      const a = r.value.trim(), n = new URL(a);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(n.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(n.protocol.endsWith(":") ? n.protocol.slice(0, -1) : n.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? r.value = n.href : r.value = a;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), e2 = /* @__PURE__ */ j("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = kg()), Ie.init(e, t);
}), r2 = /* @__PURE__ */ j("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = pg), Ie.init(e, t);
}), t2 = /* @__PURE__ */ j("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = ug), Ie.init(e, t);
}), a2 = /* @__PURE__ */ j("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = lg), Ie.init(e, t);
}), n2 = /* @__PURE__ */ j("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = hg), Ie.init(e, t);
}), i2 = /* @__PURE__ */ j("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = xg), Ie.init(e, t);
}), s2 = /* @__PURE__ */ j("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = dg), Ie.init(e, t);
}), c2 = /* @__PURE__ */ j("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Og(t)), Ie.init(e, t);
}), f2 = /* @__PURE__ */ j("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = yg), Ie.init(e, t);
}), o2 = /* @__PURE__ */ j("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Cg(t)), Ie.init(e, t);
}), u2 = /* @__PURE__ */ j("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = vg), Ie.init(e, t);
}), l2 = /* @__PURE__ */ j("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Eg), Ie.init(e, t), e._zod.bag.format = "ipv4";
}), h2 = /* @__PURE__ */ j("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Tg), Ie.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), x2 = /* @__PURE__ */ j("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = wg), Ie.init(e, t);
}), d2 = /* @__PURE__ */ j("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Ag), Ie.init(e, t), e._zod.check = (r) => {
    const a = r.value.split("/");
    try {
      if (a.length !== 2)
        throw new Error();
      const [n, i] = a;
      if (!i)
        throw new Error();
      const s = Number(i);
      if (`${s}` !== i)
        throw new Error();
      if (s < 0 || s > 128)
        throw new Error();
      new URL(`http://[${n}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Kc(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const p2 = /* @__PURE__ */ j("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Fg), Ie.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (r) => {
    Kc(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function v2(e) {
  if (!Hc.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (a) => a === "-" ? "+" : "/"), r = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Kc(r);
}
const g2 = /* @__PURE__ */ j("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = Hc), Ie.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (r) => {
    v2(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), m2 = /* @__PURE__ */ j("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Sg), Ie.init(e, t);
});
function _2(e, t = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3)
      return !1;
    const [a] = r;
    if (!a)
      return !1;
    const n = JSON.parse(atob(a));
    return !("typ" in n && (n == null ? void 0 : n.typ) !== "JWT" || !n.alg || t && (!("alg" in n) || n.alg !== t));
  } catch {
    return !1;
  }
}
const k2 = /* @__PURE__ */ j("$ZodJWT", (e, t) => {
  Ie.init(e, t), e._zod.check = (r) => {
    _2(r.value, t.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Yc = /* @__PURE__ */ j("$ZodNumber", (e, t) => {
  Le.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Rg, e._zod.parse = (r, a) => {
    if (t.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const n = r.value;
    if (typeof n == "number" && !Number.isNaN(n) && Number.isFinite(n))
      return r;
    const i = typeof n == "number" ? Number.isNaN(n) ? "NaN" : Number.isFinite(n) ? void 0 : "Infinity" : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: n,
      inst: e,
      ...i ? { received: i } : {}
    }), r;
  };
}), E2 = /* @__PURE__ */ j("$ZodNumberFormat", (e, t) => {
  Mg.init(e, t), Yc.init(e, t);
}), T2 = /* @__PURE__ */ j("$ZodBoolean", (e, t) => {
  Le.init(e, t), e._zod.pattern = Ng, e._zod.parse = (r, a) => {
    if (t.coerce)
      try {
        r.value = !!r.value;
      } catch {
      }
    const n = r.value;
    return typeof n == "boolean" || r.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: n,
      inst: e
    }), r;
  };
}), w2 = /* @__PURE__ */ j("$ZodUnknown", (e, t) => {
  Le.init(e, t), e._zod.parse = (r) => r;
}), A2 = /* @__PURE__ */ j("$ZodNever", (e, t) => {
  Le.init(e, t), e._zod.parse = (r, a) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
}), F2 = /* @__PURE__ */ j("$ZodDate", (e, t) => {
  Le.init(e, t), e._zod.parse = (r, a) => {
    if (t.coerce)
      try {
        r.value = new Date(r.value);
      } catch {
      }
    const n = r.value, i = n instanceof Date;
    return i && !Number.isNaN(n.getTime()) || r.issues.push({
      expected: "date",
      code: "invalid_type",
      input: n,
      ...i ? { received: "Invalid Date" } : {},
      inst: e
    }), r;
  };
});
function bi(e, t, r) {
  e.issues.length && t.issues.push(...Uc(r, e.issues)), t.value[r] = e.value;
}
const S2 = /* @__PURE__ */ j("$ZodArray", (e, t) => {
  Le.init(e, t), e._zod.parse = (r, a) => {
    const n = r.value;
    if (!Array.isArray(n))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: n,
        inst: e
      }), r;
    r.value = Array(n.length);
    const i = [];
    for (let s = 0; s < n.length; s++) {
      const c = n[s], f = t.element._zod.run({
        value: c,
        issues: []
      }, a);
      f instanceof Promise ? i.push(f.then((o) => bi(o, r, s))) : bi(f, r, s);
    }
    return i.length ? Promise.all(i).then(() => r) : r;
  };
});
function tn(e, t, r, a, n) {
  if (e.issues.length) {
    if (n && !(r in a))
      return;
    t.issues.push(...Uc(r, e.issues));
  }
  e.value === void 0 ? r in a && (t.value[r] = void 0) : t.value[r] = e.value;
}
function Jc(e) {
  var a, n, i, s;
  const t = Object.keys(e.shape);
  for (const c of t)
    if (!((s = (i = (n = (a = e.shape) == null ? void 0 : a[c]) == null ? void 0 : n._zod) == null ? void 0 : i.traits) != null && s.has("$ZodType")))
      throw new Error(`Invalid element at key "${c}": expected a Zod schema`);
  const r = Hv(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(r)
  };
}
function qc(e, t, r, a, n, i) {
  const s = [], c = n.keySet, f = n.catchall._zod, o = f.def.type, u = f.optout === "optional";
  for (const l in t) {
    if (c.has(l))
      continue;
    if (o === "never") {
      s.push(l);
      continue;
    }
    const h = f.run({ value: t[l], issues: [] }, a);
    h instanceof Promise ? e.push(h.then((d) => tn(d, r, l, t, u))) : tn(h, r, l, t, u);
  }
  return s.length && r.issues.push({
    code: "unrecognized_keys",
    keys: s,
    input: t,
    inst: i
  }), e.length ? Promise.all(e).then(() => r) : r;
}
const y2 = /* @__PURE__ */ j("$ZodObject", (e, t) => {
  Le.init(e, t);
  const r = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(r != null && r.get)) {
    const c = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const f = { ...c };
        return Object.defineProperty(t, "shape", {
          value: f
        }), f;
      }
    });
  }
  const a = v0(() => Jc(t));
  Fe(e._zod, "propValues", () => {
    const c = t.shape, f = {};
    for (const o in c) {
      const u = c[o]._zod;
      if (u.values) {
        f[o] ?? (f[o] = /* @__PURE__ */ new Set());
        for (const l of u.values)
          f[o].add(l);
      }
    }
    return f;
  });
  const n = rn, i = t.catchall;
  let s;
  e._zod.parse = (c, f) => {
    s ?? (s = a.value);
    const o = c.value;
    if (!n(o))
      return c.issues.push({
        expected: "object",
        code: "invalid_type",
        input: o,
        inst: e
      }), c;
    c.value = {};
    const u = [], l = s.shape;
    for (const h of s.keys) {
      const d = l[h], p = d._zod.optout === "optional", x = d._zod.run({ value: o[h], issues: [] }, f);
      x instanceof Promise ? u.push(x.then((g) => tn(g, c, h, o, p))) : tn(x, c, h, o, p);
    }
    return i ? qc(u, o, c, f, a.value, e) : u.length ? Promise.all(u).then(() => c) : c;
  };
}), C2 = /* @__PURE__ */ j("$ZodObjectJIT", (e, t) => {
  y2.init(e, t);
  const r = e._zod.parse, a = v0(() => Jc(t)), n = (h) => {
    var _;
    const d = new Xg(["shape", "payload", "ctx"]), p = a.value, x = (I) => {
      const P = Ri(I);
      return `shape[${P}]._zod.run({ value: input[${P}], issues: [] }, ctx)`;
    };
    d.write("const input = payload.value;");
    const g = /* @__PURE__ */ Object.create(null);
    let F = 0;
    for (const I of p.keys)
      g[I] = `key_${F++}`;
    d.write("const newResult = {};");
    for (const I of p.keys) {
      const P = g[I], O = Ri(I), A = h[I], V = ((_ = A == null ? void 0 : A._zod) == null ? void 0 : _.optout) === "optional";
      d.write(`const ${P} = ${x(I)};`), V ? d.write(`
        if (${P}.issues.length) {
          if (${O} in input) {
            payload.issues = payload.issues.concat(${P}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${O}, ...iss.path] : [${O}]
            })));
          }
        }
        
        if (${P}.value === undefined) {
          if (${O} in input) {
            newResult[${O}] = undefined;
          }
        } else {
          newResult[${O}] = ${P}.value;
        }
        
      `) : d.write(`
        if (${P}.issues.length) {
          payload.issues = payload.issues.concat(${P}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${O}, ...iss.path] : [${O}]
          })));
        }
        
        if (${P}.value === undefined) {
          if (${O} in input) {
            newResult[${O}] = undefined;
          }
        } else {
          newResult[${O}] = ${P}.value;
        }
        
      `);
    }
    d.write("payload.value = newResult;"), d.write("return payload;");
    const C = d.compile();
    return (I, P) => C(h, I, P);
  };
  let i;
  const s = rn, c = !Pc.jitless, o = c && $v.value, u = t.catchall;
  let l;
  e._zod.parse = (h, d) => {
    l ?? (l = a.value);
    const p = h.value;
    return s(p) ? c && o && (d == null ? void 0 : d.async) === !1 && d.jitless !== !0 ? (i || (i = n(t.shape)), h = i(h, d), u ? qc([], p, h, d, l, e) : h) : r(h, d) : (h.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), h);
  };
});
function Pi(e, t, r, a) {
  for (const i of e)
    if (i.issues.length === 0)
      return t.value = i.value, t;
  const n = e.filter((i) => !Dt(i));
  return n.length === 1 ? (t.value = n[0].value, n[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: r,
    errors: e.map((i) => i.issues.map((s) => kt(s, a, _t())))
  }), t);
}
const O2 = /* @__PURE__ */ j("$ZodUnion", (e, t) => {
  Le.init(e, t), Fe(e._zod, "optin", () => t.options.some((n) => n._zod.optin === "optional") ? "optional" : void 0), Fe(e._zod, "optout", () => t.options.some((n) => n._zod.optout === "optional") ? "optional" : void 0), Fe(e._zod, "values", () => {
    if (t.options.every((n) => n._zod.values))
      return new Set(t.options.flatMap((n) => Array.from(n._zod.values)));
  }), Fe(e._zod, "pattern", () => {
    if (t.options.every((n) => n._zod.pattern)) {
      const n = t.options.map((i) => i._zod.pattern);
      return new RegExp(`^(${n.map((i) => m0(i.source)).join("|")})$`);
    }
  });
  const r = t.options.length === 1, a = t.options[0]._zod.run;
  e._zod.parse = (n, i) => {
    if (r)
      return a(n, i);
    let s = !1;
    const c = [];
    for (const f of t.options) {
      const o = f._zod.run({
        value: n.value,
        issues: []
      }, i);
      if (o instanceof Promise)
        c.push(o), s = !0;
      else {
        if (o.issues.length === 0)
          return o;
        c.push(o);
      }
    }
    return s ? Promise.all(c).then((f) => Pi(f, n, e, i)) : Pi(c, n, e, i);
  };
}), I2 = /* @__PURE__ */ j("$ZodIntersection", (e, t) => {
  Le.init(e, t), e._zod.parse = (r, a) => {
    const n = r.value, i = t.left._zod.run({ value: n, issues: [] }, a), s = t.right._zod.run({ value: n, issues: [] }, a);
    return i instanceof Promise || s instanceof Promise ? Promise.all([i, s]).then(([f, o]) => Li(r, f, o)) : Li(r, i, s);
  };
});
function $n(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (ga(e) && ga(t)) {
    const r = Object.keys(t), a = Object.keys(e).filter((i) => r.indexOf(i) !== -1), n = { ...e, ...t };
    for (const i of a) {
      const s = $n(e[i], t[i]);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...s.mergeErrorPath]
        };
      n[i] = s.data;
    }
    return { valid: !0, data: n };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let a = 0; a < e.length; a++) {
      const n = e[a], i = t[a], s = $n(n, i);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...s.mergeErrorPath]
        };
      r.push(s.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Li(e, t, r) {
  const a = /* @__PURE__ */ new Map();
  let n;
  for (const c of t.issues)
    if (c.code === "unrecognized_keys") {
      n ?? (n = c);
      for (const f of c.keys)
        a.has(f) || a.set(f, {}), a.get(f).l = !0;
    } else
      e.issues.push(c);
  for (const c of r.issues)
    if (c.code === "unrecognized_keys")
      for (const f of c.keys)
        a.has(f) || a.set(f, {}), a.get(f).r = !0;
    else
      e.issues.push(c);
  const i = [...a].filter(([, c]) => c.l && c.r).map(([c]) => c);
  if (i.length && n && e.issues.push({ ...n, keys: i }), Dt(e))
    return e;
  const s = $n(t.value, r.value);
  if (!s.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(s.mergeErrorPath)}`);
  return e.value = s.data, e;
}
const D2 = /* @__PURE__ */ j("$ZodEnum", (e, t) => {
  Le.init(e, t);
  const r = Lc(t.entries), a = new Set(r);
  e._zod.values = a, e._zod.pattern = new RegExp(`^(${r.filter((n) => Vv.has(typeof n)).map((n) => typeof n == "string" ? un(n) : n.toString()).join("|")})$`), e._zod.parse = (n, i) => {
    const s = n.value;
    return a.has(s) || n.issues.push({
      code: "invalid_value",
      values: r,
      input: s,
      inst: e
    }), n;
  };
}), R2 = /* @__PURE__ */ j("$ZodTransform", (e, t) => {
  Le.init(e, t), e._zod.parse = (r, a) => {
    if (a.direction === "backward")
      throw new bc(e.constructor.name);
    const n = t.transform(r.value, r);
    if (a.async)
      return (n instanceof Promise ? n : Promise.resolve(n)).then((s) => (r.value = s, r));
    if (n instanceof Promise)
      throw new Pt();
    return r.value = n, r;
  };
});
function Mi(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Qc = /* @__PURE__ */ j("$ZodOptional", (e, t) => {
  Le.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", Fe(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), Fe(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${m0(r.source)})?$`) : void 0;
  }), e._zod.parse = (r, a) => {
    if (t.innerType._zod.optin === "optional") {
      const n = t.innerType._zod.run(r, a);
      return n instanceof Promise ? n.then((i) => Mi(i, r.value)) : Mi(n, r.value);
    }
    return r.value === void 0 ? r : t.innerType._zod.run(r, a);
  };
}), N2 = /* @__PURE__ */ j("$ZodExactOptional", (e, t) => {
  Qc.init(e, t), Fe(e._zod, "values", () => t.innerType._zod.values), Fe(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (r, a) => t.innerType._zod.run(r, a);
}), b2 = /* @__PURE__ */ j("$ZodNullable", (e, t) => {
  Le.init(e, t), Fe(e._zod, "optin", () => t.innerType._zod.optin), Fe(e._zod, "optout", () => t.innerType._zod.optout), Fe(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${m0(r.source)}|null)$`) : void 0;
  }), Fe(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (r, a) => r.value === null ? r : t.innerType._zod.run(r, a);
}), P2 = /* @__PURE__ */ j("$ZodDefault", (e, t) => {
  Le.init(e, t), e._zod.optin = "optional", Fe(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(r, a);
    if (r.value === void 0)
      return r.value = t.defaultValue, r;
    const n = t.innerType._zod.run(r, a);
    return n instanceof Promise ? n.then((i) => Bi(i, t)) : Bi(n, t);
  };
});
function Bi(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const L2 = /* @__PURE__ */ j("$ZodPrefault", (e, t) => {
  Le.init(e, t), e._zod.optin = "optional", Fe(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, a) => (a.direction === "backward" || r.value === void 0 && (r.value = t.defaultValue), t.innerType._zod.run(r, a));
}), M2 = /* @__PURE__ */ j("$ZodNonOptional", (e, t) => {
  Le.init(e, t), Fe(e._zod, "values", () => {
    const r = t.innerType._zod.values;
    return r ? new Set([...r].filter((a) => a !== void 0)) : void 0;
  }), e._zod.parse = (r, a) => {
    const n = t.innerType._zod.run(r, a);
    return n instanceof Promise ? n.then((i) => Ui(i, e)) : Ui(n, e);
  };
});
function Ui(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const B2 = /* @__PURE__ */ j("$ZodCatch", (e, t) => {
  Le.init(e, t), Fe(e._zod, "optin", () => t.innerType._zod.optin), Fe(e._zod, "optout", () => t.innerType._zod.optout), Fe(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(r, a);
    const n = t.innerType._zod.run(r, a);
    return n instanceof Promise ? n.then((i) => (r.value = i.value, i.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: i.issues.map((s) => kt(s, a, _t()))
      },
      input: r.value
    }), r.issues = []), r)) : (r.value = n.value, n.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: n.issues.map((i) => kt(i, a, _t()))
      },
      input: r.value
    }), r.issues = []), r);
  };
}), U2 = /* @__PURE__ */ j("$ZodPipe", (e, t) => {
  Le.init(e, t), Fe(e._zod, "values", () => t.in._zod.values), Fe(e._zod, "optin", () => t.in._zod.optin), Fe(e._zod, "optout", () => t.out._zod.optout), Fe(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (r, a) => {
    if (a.direction === "backward") {
      const i = t.out._zod.run(r, a);
      return i instanceof Promise ? i.then((s) => Ba(s, t.in, a)) : Ba(i, t.in, a);
    }
    const n = t.in._zod.run(r, a);
    return n instanceof Promise ? n.then((i) => Ba(i, t.out, a)) : Ba(n, t.out, a);
  };
});
function Ba(e, t, r) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, r);
}
const z2 = /* @__PURE__ */ j("$ZodReadonly", (e, t) => {
  Le.init(e, t), Fe(e._zod, "propValues", () => t.innerType._zod.propValues), Fe(e._zod, "values", () => t.innerType._zod.values), Fe(e._zod, "optin", () => {
    var r, a;
    return (a = (r = t.innerType) == null ? void 0 : r._zod) == null ? void 0 : a.optin;
  }), Fe(e._zod, "optout", () => {
    var r, a;
    return (a = (r = t.innerType) == null ? void 0 : r._zod) == null ? void 0 : a.optout;
  }), e._zod.parse = (r, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(r, a);
    const n = t.innerType._zod.run(r, a);
    return n instanceof Promise ? n.then(zi) : zi(n);
  };
});
function zi(e) {
  return e.value = Object.freeze(e.value), e;
}
const $2 = /* @__PURE__ */ j("$ZodCustom", (e, t) => {
  gr.init(e, t), Le.init(e, t), e._zod.parse = (r, a) => r, e._zod.check = (r) => {
    const a = r.value, n = t.fn(a);
    if (n instanceof Promise)
      return n.then((i) => $i(i, r, a, e));
    $i(n, r, a, e);
  };
});
function $i(e, t, r, a) {
  if (!e) {
    const n = {
      code: "custom",
      input: r,
      inst: a,
      // incorporates params.error into issue reporting
      path: [...a._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !a._zod.def.abort
      // params: inst._zod.def.params,
    };
    a._zod.def.params && (n.params = a._zod.def.params), t.issues.push(ma(n));
  }
}
var Vi;
class V2 {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...r) {
    const a = r[0];
    return this._map.set(t, a), a && typeof a == "object" && "id" in a && this._idmap.set(a.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const r = this._map.get(t);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(t), this;
  }
  get(t) {
    const r = t._zod.parent;
    if (r) {
      const a = { ...this.get(r) ?? {} };
      delete a.id;
      const n = { ...a, ...this._map.get(t) };
      return Object.keys(n).length ? n : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function H2() {
  return new V2();
}
(Vi = globalThis).__zod_globalRegistry ?? (Vi.__zod_globalRegistry = H2());
const Jt = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function W2(e, t) {
  return new e({
    type: "string",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Z2(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Hi(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function G2(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function j2(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function X2(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function K2(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Y2(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function J2(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function q2(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Q2(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function em(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rm(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tm(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function am(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nm(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function im(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sm(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cm(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fm(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function om(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function um(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lm(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hm(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xm(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dm(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pm(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function vm(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function gm(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function mm(e, t) {
  return new e({
    type: "boolean",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _m(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function km(e, t) {
  return new e({
    type: "never",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Em(e, t) {
  return new e({
    type: "date",
    ...ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Wi(e, t) {
  return new jc({
    check: "less_than",
    ...ue(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function $a(e, t) {
  return new jc({
    check: "less_than",
    ...ue(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Zi(e, t) {
  return new Xc({
    check: "greater_than",
    ...ue(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Va(e, t) {
  return new Xc({
    check: "greater_than",
    ...ue(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Gi(e, t) {
  return new Lg({
    check: "multiple_of",
    ...ue(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function ef(e, t) {
  return new Bg({
    check: "max_length",
    ...ue(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function an(e, t) {
  return new Ug({
    check: "min_length",
    ...ue(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function rf(e, t) {
  return new zg({
    check: "length_equals",
    ...ue(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function Tm(e, t) {
  return new $g({
    check: "string_format",
    format: "regex",
    ...ue(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function wm(e) {
  return new Vg({
    check: "string_format",
    format: "lowercase",
    ...ue(e)
  });
}
// @__NO_SIDE_EFFECTS__
function Am(e) {
  return new Hg({
    check: "string_format",
    format: "uppercase",
    ...ue(e)
  });
}
// @__NO_SIDE_EFFECTS__
function Fm(e, t) {
  return new Wg({
    check: "string_format",
    format: "includes",
    ...ue(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function Sm(e, t) {
  return new Zg({
    check: "string_format",
    format: "starts_with",
    ...ue(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function ym(e, t) {
  return new Gg({
    check: "string_format",
    format: "ends_with",
    ...ue(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function $t(e) {
  return new jg({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function Cm(e) {
  return /* @__PURE__ */ $t((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function Om() {
  return /* @__PURE__ */ $t((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function Im() {
  return /* @__PURE__ */ $t((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Dm() {
  return /* @__PURE__ */ $t((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Rm() {
  return /* @__PURE__ */ $t((e) => zv(e));
}
// @__NO_SIDE_EFFECTS__
function Nm(e, t, r) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...ue(r)
  });
}
// @__NO_SIDE_EFFECTS__
function bm(e, t, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...ue(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Pm(e) {
  const t = /* @__PURE__ */ Lm((r) => (r.addIssue = (a) => {
    if (typeof a == "string")
      r.issues.push(ma(a, r.value, t._zod.def));
    else {
      const n = a;
      n.fatal && (n.continue = !1), n.code ?? (n.code = "custom"), n.input ?? (n.input = r.value), n.inst ?? (n.inst = t), n.continue ?? (n.continue = !t._zod.def.abort), r.issues.push(ma(n));
    }
  }, e(r.value, r)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function Lm(e, t) {
  const r = new gr({
    check: "custom",
    ...ue(t)
  });
  return r._zod.check = e, r;
}
function tf(e) {
  let t = (e == null ? void 0 : e.target) ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: (e == null ? void 0 : e.metadata) ?? Jt,
    target: t,
    unrepresentable: (e == null ? void 0 : e.unrepresentable) ?? "throw",
    override: (e == null ? void 0 : e.override) ?? (() => {
    }),
    io: (e == null ? void 0 : e.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: (e == null ? void 0 : e.cycles) ?? "ref",
    reused: (e == null ? void 0 : e.reused) ?? "inline",
    external: (e == null ? void 0 : e.external) ?? void 0
  };
}
function er(e, t, r = { path: [], schemaPath: [] }) {
  var u, l;
  var a;
  const n = e._zod.def, i = t.seen.get(e);
  if (i)
    return i.count++, r.schemaPath.includes(e) && (i.cycle = r.path), i.schema;
  const s = { schema: {}, count: 1, cycle: void 0, path: r.path };
  t.seen.set(e, s);
  const c = (l = (u = e._zod).toJSONSchema) == null ? void 0 : l.call(u);
  if (c)
    s.schema = c;
  else {
    const h = {
      ...r,
      schemaPath: [...r.schemaPath, e],
      path: r.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, s.schema, h);
    else {
      const p = s.schema, x = t.processors[n.type];
      if (!x)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${n.type}`);
      x(e, t, p, h);
    }
    const d = e._zod.parent;
    d && (s.ref || (s.ref = d), er(d, t, h), t.seen.get(d).isParent = !0);
  }
  const f = t.metadataRegistry.get(e);
  return f && Object.assign(s.schema, f), t.io === "input" && ur(e) && (delete s.schema.examples, delete s.schema.default), t.io === "input" && s.schema._prefault && ((a = s.schema).default ?? (a.default = s.schema._prefault)), delete s.schema._prefault, t.seen.get(e).schema;
}
function af(e, t) {
  var s, c, f, o;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = /* @__PURE__ */ new Map();
  for (const u of e.seen.entries()) {
    const l = (s = e.metadataRegistry.get(u[0])) == null ? void 0 : s.id;
    if (l) {
      const h = a.get(l);
      if (h && h !== u[0])
        throw new Error(`Duplicate schema id "${l}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      a.set(l, u[0]);
    }
  }
  const n = (u) => {
    var x;
    const l = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const g = (x = e.external.registry.get(u[0])) == null ? void 0 : x.id, F = e.external.uri ?? ((_) => _);
      if (g)
        return { ref: F(g) };
      const C = u[1].defId ?? u[1].schema.id ?? `schema${e.counter++}`;
      return u[1].defId = C, { defId: C, ref: `${F("__shared")}#/${l}/${C}` };
    }
    if (u[1] === r)
      return { ref: "#" };
    const d = `#/${l}/`, p = u[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: p, ref: d + p };
  }, i = (u) => {
    if (u[1].schema.$ref)
      return;
    const l = u[1], { ref: h, defId: d } = n(u);
    l.def = { ...l.schema }, d && (l.defId = d);
    const p = l.schema;
    for (const x in p)
      delete p[x];
    p.$ref = h;
  };
  if (e.cycles === "throw")
    for (const u of e.seen.entries()) {
      const l = u[1];
      if (l.cycle)
        throw new Error(`Cycle detected: #/${(c = l.cycle) == null ? void 0 : c.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const u of e.seen.entries()) {
    const l = u[1];
    if (t === u[0]) {
      i(u);
      continue;
    }
    if (e.external) {
      const d = (f = e.external.registry.get(u[0])) == null ? void 0 : f.id;
      if (t !== u[0] && d) {
        i(u);
        continue;
      }
    }
    if ((o = e.metadataRegistry.get(u[0])) == null ? void 0 : o.id) {
      i(u);
      continue;
    }
    if (l.cycle) {
      i(u);
      continue;
    }
    if (l.count > 1 && e.reused === "ref") {
      i(u);
      continue;
    }
  }
}
function nf(e, t) {
  var s, c, f;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (o) => {
    const u = e.seen.get(o);
    if (u.ref === null)
      return;
    const l = u.def ?? u.schema, h = { ...l }, d = u.ref;
    if (u.ref = null, d) {
      a(d);
      const x = e.seen.get(d), g = x.schema;
      if (g.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (l.allOf = l.allOf ?? [], l.allOf.push(g)) : Object.assign(l, g), Object.assign(l, h), o._zod.parent === d)
        for (const C in l)
          C === "$ref" || C === "allOf" || C in h || delete l[C];
      if (g.$ref && x.def)
        for (const C in l)
          C === "$ref" || C === "allOf" || C in x.def && JSON.stringify(l[C]) === JSON.stringify(x.def[C]) && delete l[C];
    }
    const p = o._zod.parent;
    if (p && p !== d) {
      a(p);
      const x = e.seen.get(p);
      if (x != null && x.schema.$ref && (l.$ref = x.schema.$ref, x.def))
        for (const g in l)
          g === "$ref" || g === "allOf" || g in x.def && JSON.stringify(l[g]) === JSON.stringify(x.def[g]) && delete l[g];
    }
    e.override({
      zodSchema: o,
      jsonSchema: l,
      path: u.path ?? []
    });
  };
  for (const o of [...e.seen.entries()].reverse())
    a(o[0]);
  const n = {};
  if (e.target === "draft-2020-12" ? n.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? n.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? n.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (s = e.external) != null && s.uri) {
    const o = (c = e.external.registry.get(t)) == null ? void 0 : c.id;
    if (!o)
      throw new Error("Schema is missing an `id` property");
    n.$id = e.external.uri(o);
  }
  Object.assign(n, r.def ?? r.schema);
  const i = ((f = e.external) == null ? void 0 : f.defs) ?? {};
  for (const o of e.seen.entries()) {
    const u = o[1];
    u.def && u.defId && (i[u.defId] = u.def);
  }
  e.external || Object.keys(i).length > 0 && (e.target === "draft-2020-12" ? n.$defs = i : n.definitions = i);
  try {
    const o = JSON.parse(JSON.stringify(n));
    return Object.defineProperty(o, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: nn(t, "input", e.processors),
          output: nn(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), o;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function ur(e, t) {
  const r = t ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(e))
    return !1;
  r.seen.add(e);
  const a = e._zod.def;
  if (a.type === "transform")
    return !0;
  if (a.type === "array")
    return ur(a.element, r);
  if (a.type === "set")
    return ur(a.valueType, r);
  if (a.type === "lazy")
    return ur(a.getter(), r);
  if (a.type === "promise" || a.type === "optional" || a.type === "nonoptional" || a.type === "nullable" || a.type === "readonly" || a.type === "default" || a.type === "prefault")
    return ur(a.innerType, r);
  if (a.type === "intersection")
    return ur(a.left, r) || ur(a.right, r);
  if (a.type === "record" || a.type === "map")
    return ur(a.keyType, r) || ur(a.valueType, r);
  if (a.type === "pipe")
    return ur(a.in, r) || ur(a.out, r);
  if (a.type === "object") {
    for (const n in a.shape)
      if (ur(a.shape[n], r))
        return !0;
    return !1;
  }
  if (a.type === "union") {
    for (const n of a.options)
      if (ur(n, r))
        return !0;
    return !1;
  }
  if (a.type === "tuple") {
    for (const n of a.items)
      if (ur(n, r))
        return !0;
    return !!(a.rest && ur(a.rest, r));
  }
  return !1;
}
const Mm = (e, t = {}) => (r) => {
  const a = tf({ ...r, processors: t });
  return er(e, a), af(a, e), nf(a, e);
}, nn = (e, t, r = {}) => (a) => {
  const { libraryOptions: n, target: i } = a ?? {}, s = tf({ ...n ?? {}, target: i, io: t, processors: r });
  return er(e, s), af(s, e), nf(s, e);
}, Bm = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Um = (e, t, r, a) => {
  const n = r;
  n.type = "string";
  const { minimum: i, maximum: s, format: c, patterns: f, contentEncoding: o } = e._zod.bag;
  if (typeof i == "number" && (n.minLength = i), typeof s == "number" && (n.maxLength = s), c && (n.format = Bm[c] ?? c, n.format === "" && delete n.format, c === "time" && delete n.format), o && (n.contentEncoding = o), f && f.size > 0) {
    const u = [...f];
    u.length === 1 ? n.pattern = u[0].source : u.length > 1 && (n.allOf = [
      ...u.map((l) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: l.source
      }))
    ]);
  }
}, zm = (e, t, r, a) => {
  const n = r, { minimum: i, maximum: s, format: c, multipleOf: f, exclusiveMaximum: o, exclusiveMinimum: u } = e._zod.bag;
  typeof c == "string" && c.includes("int") ? n.type = "integer" : n.type = "number", typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (n.minimum = u, n.exclusiveMinimum = !0) : n.exclusiveMinimum = u), typeof i == "number" && (n.minimum = i, typeof u == "number" && t.target !== "draft-04" && (u >= i ? delete n.minimum : delete n.exclusiveMinimum)), typeof o == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (n.maximum = o, n.exclusiveMaximum = !0) : n.exclusiveMaximum = o), typeof s == "number" && (n.maximum = s, typeof o == "number" && t.target !== "draft-04" && (o <= s ? delete n.maximum : delete n.exclusiveMaximum)), typeof f == "number" && (n.multipleOf = f);
}, $m = (e, t, r, a) => {
  r.type = "boolean";
}, Vm = (e, t, r, a) => {
  r.not = {};
}, Hm = (e, t, r, a) => {
}, Wm = (e, t, r, a) => {
  if (t.unrepresentable === "throw")
    throw new Error("Date cannot be represented in JSON Schema");
}, Zm = (e, t, r, a) => {
  const n = e._zod.def, i = Lc(n.entries);
  i.every((s) => typeof s == "number") && (r.type = "number"), i.every((s) => typeof s == "string") && (r.type = "string"), r.enum = i;
}, Gm = (e, t, r, a) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, jm = (e, t, r, a) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Xm = (e, t, r, a) => {
  const n = r, i = e._zod.def, { minimum: s, maximum: c } = e._zod.bag;
  typeof s == "number" && (n.minItems = s), typeof c == "number" && (n.maxItems = c), n.type = "array", n.items = er(i.element, t, { ...a, path: [...a.path, "items"] });
}, Km = (e, t, r, a) => {
  var o;
  const n = r, i = e._zod.def;
  n.type = "object", n.properties = {};
  const s = i.shape;
  for (const u in s)
    n.properties[u] = er(s[u], t, {
      ...a,
      path: [...a.path, "properties", u]
    });
  const c = new Set(Object.keys(s)), f = new Set([...c].filter((u) => {
    const l = i.shape[u]._zod;
    return t.io === "input" ? l.optin === void 0 : l.optout === void 0;
  }));
  f.size > 0 && (n.required = Array.from(f)), ((o = i.catchall) == null ? void 0 : o._zod.def.type) === "never" ? n.additionalProperties = !1 : i.catchall ? i.catchall && (n.additionalProperties = er(i.catchall, t, {
    ...a,
    path: [...a.path, "additionalProperties"]
  })) : t.io === "output" && (n.additionalProperties = !1);
}, Ym = (e, t, r, a) => {
  const n = e._zod.def, i = n.inclusive === !1, s = n.options.map((c, f) => er(c, t, {
    ...a,
    path: [...a.path, i ? "oneOf" : "anyOf", f]
  }));
  i ? r.oneOf = s : r.anyOf = s;
}, Jm = (e, t, r, a) => {
  const n = e._zod.def, i = er(n.left, t, {
    ...a,
    path: [...a.path, "allOf", 0]
  }), s = er(n.right, t, {
    ...a,
    path: [...a.path, "allOf", 1]
  }), c = (o) => "allOf" in o && Object.keys(o).length === 1, f = [
    ...c(i) ? i.allOf : [i],
    ...c(s) ? s.allOf : [s]
  ];
  r.allOf = f;
}, qm = (e, t, r, a) => {
  const n = e._zod.def, i = er(n.innerType, t, a), s = t.seen.get(e);
  t.target === "openapi-3.0" ? (s.ref = n.innerType, r.nullable = !0) : r.anyOf = [i, { type: "null" }];
}, Qm = (e, t, r, a) => {
  const n = e._zod.def;
  er(n.innerType, t, a);
  const i = t.seen.get(e);
  i.ref = n.innerType;
}, e_ = (e, t, r, a) => {
  const n = e._zod.def;
  er(n.innerType, t, a);
  const i = t.seen.get(e);
  i.ref = n.innerType, r.default = JSON.parse(JSON.stringify(n.defaultValue));
}, r_ = (e, t, r, a) => {
  const n = e._zod.def;
  er(n.innerType, t, a);
  const i = t.seen.get(e);
  i.ref = n.innerType, t.io === "input" && (r._prefault = JSON.parse(JSON.stringify(n.defaultValue)));
}, t_ = (e, t, r, a) => {
  const n = e._zod.def;
  er(n.innerType, t, a);
  const i = t.seen.get(e);
  i.ref = n.innerType;
  let s;
  try {
    s = n.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  r.default = s;
}, a_ = (e, t, r, a) => {
  const n = e._zod.def, i = t.io === "input" ? n.in._zod.def.type === "transform" ? n.out : n.in : n.out;
  er(i, t, a);
  const s = t.seen.get(e);
  s.ref = i;
}, n_ = (e, t, r, a) => {
  const n = e._zod.def;
  er(n.innerType, t, a);
  const i = t.seen.get(e);
  i.ref = n.innerType, r.readOnly = !0;
}, sf = (e, t, r, a) => {
  const n = e._zod.def;
  er(n.innerType, t, a);
  const i = t.seen.get(e);
  i.ref = n.innerType;
}, i_ = /* @__PURE__ */ j("ZodISODateTime", (e, t) => {
  c2.init(e, t), Ne.init(e, t);
});
function s_(e) {
  return /* @__PURE__ */ hm(i_, e);
}
const c_ = /* @__PURE__ */ j("ZodISODate", (e, t) => {
  f2.init(e, t), Ne.init(e, t);
});
function f_(e) {
  return /* @__PURE__ */ xm(c_, e);
}
const o_ = /* @__PURE__ */ j("ZodISOTime", (e, t) => {
  o2.init(e, t), Ne.init(e, t);
});
function u_(e) {
  return /* @__PURE__ */ dm(o_, e);
}
const l_ = /* @__PURE__ */ j("ZodISODuration", (e, t) => {
  u2.init(e, t), Ne.init(e, t);
});
function h_(e) {
  return /* @__PURE__ */ pm(l_, e);
}
const x_ = (e, t) => {
  $c.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (r) => Qv(e, r)
      // enumerable: false,
    },
    flatten: {
      value: (r) => qv(e, r)
      // enumerable: false,
    },
    addIssue: {
      value: (r) => {
        e.issues.push(r), e.message = JSON.stringify(e.issues, zn, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (r) => {
        e.issues.push(...r), e.message = JSON.stringify(e.issues, zn, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Or = j("ZodError", x_, {
  Parent: Error
}), d_ = /* @__PURE__ */ k0(Or), p_ = /* @__PURE__ */ E0(Or), v_ = /* @__PURE__ */ ln(Or), g_ = /* @__PURE__ */ hn(Or), m_ = /* @__PURE__ */ tg(Or), __ = /* @__PURE__ */ ag(Or), k_ = /* @__PURE__ */ ng(Or), E_ = /* @__PURE__ */ ig(Or), T_ = /* @__PURE__ */ sg(Or), w_ = /* @__PURE__ */ cg(Or), A_ = /* @__PURE__ */ fg(Or), F_ = /* @__PURE__ */ og(Or), Me = /* @__PURE__ */ j("ZodType", (e, t) => (Le.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: nn(e, "input"),
    output: nn(e, "output")
  }
}), e.toJSONSchema = Mm(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...r) => e.clone(ft(t, {
  checks: [
    ...t.checks ?? [],
    ...r.map((a) => typeof a == "function" ? { _zod: { check: a, def: { check: "custom" }, onattach: [] } } : a)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (r, a) => ot(e, r, a), e.brand = () => e, e.register = (r, a) => (r.add(e, a), e), e.parse = (r, a) => d_(e, r, a, { callee: e.parse }), e.safeParse = (r, a) => v_(e, r, a), e.parseAsync = async (r, a) => p_(e, r, a, { callee: e.parseAsync }), e.safeParseAsync = async (r, a) => g_(e, r, a), e.spa = e.safeParseAsync, e.encode = (r, a) => m_(e, r, a), e.decode = (r, a) => __(e, r, a), e.encodeAsync = async (r, a) => k_(e, r, a), e.decodeAsync = async (r, a) => E_(e, r, a), e.safeEncode = (r, a) => T_(e, r, a), e.safeDecode = (r, a) => w_(e, r, a), e.safeEncodeAsync = async (r, a) => A_(e, r, a), e.safeDecodeAsync = async (r, a) => F_(e, r, a), e.refine = (r, a) => e.check(kk(r, a)), e.superRefine = (r) => e.check(Ek(r)), e.overwrite = (r) => e.check(/* @__PURE__ */ $t(r)), e.optional = () => Ji(e), e.exactOptional = () => ck(e), e.nullable = () => qi(e), e.nullish = () => Ji(qi(e)), e.nonoptional = (r) => xk(e, r), e.array = () => Ha(e), e.or = (r) => ek([e, r]), e.and = (r) => tk(e, r), e.transform = (r) => Qi(e, ik(r)), e.default = (r) => uk(e, r), e.prefault = (r) => hk(e, r), e.catch = (r) => pk(e, r), e.pipe = (r) => Qi(e, r), e.readonly = () => mk(e), e.describe = (r) => {
  const a = e.clone();
  return Jt.add(a, { description: r }), a;
}, Object.defineProperty(e, "description", {
  get() {
    var r;
    return (r = Jt.get(e)) == null ? void 0 : r.description;
  },
  configurable: !0
}), e.meta = (...r) => {
  if (r.length === 0)
    return Jt.get(e);
  const a = e.clone();
  return Jt.add(a, r[0]), a;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (r) => r(e), e)), cf = /* @__PURE__ */ j("_ZodString", (e, t) => {
  T0.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (a, n, i) => Um(e, a, n);
  const r = e._zod.bag;
  e.format = r.format ?? null, e.minLength = r.minimum ?? null, e.maxLength = r.maximum ?? null, e.regex = (...a) => e.check(/* @__PURE__ */ Tm(...a)), e.includes = (...a) => e.check(/* @__PURE__ */ Fm(...a)), e.startsWith = (...a) => e.check(/* @__PURE__ */ Sm(...a)), e.endsWith = (...a) => e.check(/* @__PURE__ */ ym(...a)), e.min = (...a) => e.check(/* @__PURE__ */ an(...a)), e.max = (...a) => e.check(/* @__PURE__ */ ef(...a)), e.length = (...a) => e.check(/* @__PURE__ */ rf(...a)), e.nonempty = (...a) => e.check(/* @__PURE__ */ an(1, ...a)), e.lowercase = (a) => e.check(/* @__PURE__ */ wm(a)), e.uppercase = (a) => e.check(/* @__PURE__ */ Am(a)), e.trim = () => e.check(/* @__PURE__ */ Om()), e.normalize = (...a) => e.check(/* @__PURE__ */ Cm(...a)), e.toLowerCase = () => e.check(/* @__PURE__ */ Im()), e.toUpperCase = () => e.check(/* @__PURE__ */ Dm()), e.slugify = () => e.check(/* @__PURE__ */ Rm());
}), S_ = /* @__PURE__ */ j("ZodString", (e, t) => {
  T0.init(e, t), cf.init(e, t), e.email = (r) => e.check(/* @__PURE__ */ Z2(y_, r)), e.url = (r) => e.check(/* @__PURE__ */ Y2(C_, r)), e.jwt = (r) => e.check(/* @__PURE__ */ lm(H_, r)), e.emoji = (r) => e.check(/* @__PURE__ */ J2(O_, r)), e.guid = (r) => e.check(/* @__PURE__ */ Hi(ji, r)), e.uuid = (r) => e.check(/* @__PURE__ */ G2(Ua, r)), e.uuidv4 = (r) => e.check(/* @__PURE__ */ j2(Ua, r)), e.uuidv6 = (r) => e.check(/* @__PURE__ */ X2(Ua, r)), e.uuidv7 = (r) => e.check(/* @__PURE__ */ K2(Ua, r)), e.nanoid = (r) => e.check(/* @__PURE__ */ q2(I_, r)), e.guid = (r) => e.check(/* @__PURE__ */ Hi(ji, r)), e.cuid = (r) => e.check(/* @__PURE__ */ Q2(D_, r)), e.cuid2 = (r) => e.check(/* @__PURE__ */ em(R_, r)), e.ulid = (r) => e.check(/* @__PURE__ */ rm(N_, r)), e.base64 = (r) => e.check(/* @__PURE__ */ fm(z_, r)), e.base64url = (r) => e.check(/* @__PURE__ */ om($_, r)), e.xid = (r) => e.check(/* @__PURE__ */ tm(b_, r)), e.ksuid = (r) => e.check(/* @__PURE__ */ am(P_, r)), e.ipv4 = (r) => e.check(/* @__PURE__ */ nm(L_, r)), e.ipv6 = (r) => e.check(/* @__PURE__ */ im(M_, r)), e.cidrv4 = (r) => e.check(/* @__PURE__ */ sm(B_, r)), e.cidrv6 = (r) => e.check(/* @__PURE__ */ cm(U_, r)), e.e164 = (r) => e.check(/* @__PURE__ */ um(V_, r)), e.datetime = (r) => e.check(s_(r)), e.date = (r) => e.check(f_(r)), e.time = (r) => e.check(u_(r)), e.duration = (r) => e.check(h_(r));
});
function Pr(e) {
  return /* @__PURE__ */ W2(S_, e);
}
const Ne = /* @__PURE__ */ j("ZodStringFormat", (e, t) => {
  Ie.init(e, t), cf.init(e, t);
}), y_ = /* @__PURE__ */ j("ZodEmail", (e, t) => {
  qg.init(e, t), Ne.init(e, t);
}), ji = /* @__PURE__ */ j("ZodGUID", (e, t) => {
  Yg.init(e, t), Ne.init(e, t);
}), Ua = /* @__PURE__ */ j("ZodUUID", (e, t) => {
  Jg.init(e, t), Ne.init(e, t);
}), C_ = /* @__PURE__ */ j("ZodURL", (e, t) => {
  Qg.init(e, t), Ne.init(e, t);
}), O_ = /* @__PURE__ */ j("ZodEmoji", (e, t) => {
  e2.init(e, t), Ne.init(e, t);
}), I_ = /* @__PURE__ */ j("ZodNanoID", (e, t) => {
  r2.init(e, t), Ne.init(e, t);
}), D_ = /* @__PURE__ */ j("ZodCUID", (e, t) => {
  t2.init(e, t), Ne.init(e, t);
}), R_ = /* @__PURE__ */ j("ZodCUID2", (e, t) => {
  a2.init(e, t), Ne.init(e, t);
}), N_ = /* @__PURE__ */ j("ZodULID", (e, t) => {
  n2.init(e, t), Ne.init(e, t);
}), b_ = /* @__PURE__ */ j("ZodXID", (e, t) => {
  i2.init(e, t), Ne.init(e, t);
}), P_ = /* @__PURE__ */ j("ZodKSUID", (e, t) => {
  s2.init(e, t), Ne.init(e, t);
}), L_ = /* @__PURE__ */ j("ZodIPv4", (e, t) => {
  l2.init(e, t), Ne.init(e, t);
}), M_ = /* @__PURE__ */ j("ZodIPv6", (e, t) => {
  h2.init(e, t), Ne.init(e, t);
}), B_ = /* @__PURE__ */ j("ZodCIDRv4", (e, t) => {
  x2.init(e, t), Ne.init(e, t);
}), U_ = /* @__PURE__ */ j("ZodCIDRv6", (e, t) => {
  d2.init(e, t), Ne.init(e, t);
}), z_ = /* @__PURE__ */ j("ZodBase64", (e, t) => {
  p2.init(e, t), Ne.init(e, t);
}), $_ = /* @__PURE__ */ j("ZodBase64URL", (e, t) => {
  g2.init(e, t), Ne.init(e, t);
}), V_ = /* @__PURE__ */ j("ZodE164", (e, t) => {
  m2.init(e, t), Ne.init(e, t);
}), H_ = /* @__PURE__ */ j("ZodJWT", (e, t) => {
  k2.init(e, t), Ne.init(e, t);
}), ff = /* @__PURE__ */ j("ZodNumber", (e, t) => {
  Yc.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (a, n, i) => zm(e, a, n), e.gt = (a, n) => e.check(/* @__PURE__ */ Zi(a, n)), e.gte = (a, n) => e.check(/* @__PURE__ */ Va(a, n)), e.min = (a, n) => e.check(/* @__PURE__ */ Va(a, n)), e.lt = (a, n) => e.check(/* @__PURE__ */ Wi(a, n)), e.lte = (a, n) => e.check(/* @__PURE__ */ $a(a, n)), e.max = (a, n) => e.check(/* @__PURE__ */ $a(a, n)), e.int = (a) => e.check(Xi(a)), e.safe = (a) => e.check(Xi(a)), e.positive = (a) => e.check(/* @__PURE__ */ Zi(0, a)), e.nonnegative = (a) => e.check(/* @__PURE__ */ Va(0, a)), e.negative = (a) => e.check(/* @__PURE__ */ Wi(0, a)), e.nonpositive = (a) => e.check(/* @__PURE__ */ $a(0, a)), e.multipleOf = (a, n) => e.check(/* @__PURE__ */ Gi(a, n)), e.step = (a, n) => e.check(/* @__PURE__ */ Gi(a, n)), e.finite = () => e;
  const r = e._zod.bag;
  e.minValue = Math.max(r.minimum ?? Number.NEGATIVE_INFINITY, r.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(r.maximum ?? Number.POSITIVE_INFINITY, r.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (r.format ?? "").includes("int") || Number.isSafeInteger(r.multipleOf ?? 0.5), e.isFinite = !0, e.format = r.format ?? null;
});
function ca(e) {
  return /* @__PURE__ */ vm(ff, e);
}
const W_ = /* @__PURE__ */ j("ZodNumberFormat", (e, t) => {
  E2.init(e, t), ff.init(e, t);
});
function Xi(e) {
  return /* @__PURE__ */ gm(W_, e);
}
const Z_ = /* @__PURE__ */ j("ZodBoolean", (e, t) => {
  T2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => $m(e, r, a);
});
function Ki(e) {
  return /* @__PURE__ */ mm(Z_, e);
}
const G_ = /* @__PURE__ */ j("ZodUnknown", (e, t) => {
  w2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => Hm();
});
function Yi() {
  return /* @__PURE__ */ _m(G_);
}
const j_ = /* @__PURE__ */ j("ZodNever", (e, t) => {
  A2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => Vm(e, r, a);
});
function X_(e) {
  return /* @__PURE__ */ km(j_, e);
}
const K_ = /* @__PURE__ */ j("ZodDate", (e, t) => {
  F2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (a, n, i) => Wm(e, a), e.min = (a, n) => e.check(/* @__PURE__ */ Va(a, n)), e.max = (a, n) => e.check(/* @__PURE__ */ $a(a, n));
  const r = e._zod.bag;
  e.minDate = r.minimum ? new Date(r.minimum) : null, e.maxDate = r.maximum ? new Date(r.maximum) : null;
});
function Y_(e) {
  return /* @__PURE__ */ Em(K_, e);
}
const J_ = /* @__PURE__ */ j("ZodArray", (e, t) => {
  S2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => Xm(e, r, a, n), e.element = t.element, e.min = (r, a) => e.check(/* @__PURE__ */ an(r, a)), e.nonempty = (r) => e.check(/* @__PURE__ */ an(1, r)), e.max = (r, a) => e.check(/* @__PURE__ */ ef(r, a)), e.length = (r, a) => e.check(/* @__PURE__ */ rf(r, a)), e.unwrap = () => e.element;
});
function Ha(e, t) {
  return /* @__PURE__ */ Nm(J_, e, t);
}
const q_ = /* @__PURE__ */ j("ZodObject", (e, t) => {
  C2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => Km(e, r, a, n), Fe(e, "shape", () => t.shape), e.keyof = () => ak(Object.keys(e._zod.def.shape)), e.catchall = (r) => e.clone({ ...e._zod.def, catchall: r }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Yi() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Yi() }), e.strict = () => e.clone({ ...e._zod.def, catchall: X_() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (r) => jv(e, r), e.safeExtend = (r) => Xv(e, r), e.merge = (r) => Kv(e, r), e.pick = (r) => Zv(e, r), e.omit = (r) => Gv(e, r), e.partial = (...r) => Yv(of, e, r[0]), e.required = (...r) => Jv(uf, e, r[0]);
});
function Fa(e, t) {
  const r = {
    type: "object",
    shape: e ?? {},
    ...ue(t)
  };
  return new q_(r);
}
const Q_ = /* @__PURE__ */ j("ZodUnion", (e, t) => {
  O2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => Ym(e, r, a, n), e.options = t.options;
});
function ek(e, t) {
  return new Q_({
    type: "union",
    options: e,
    ...ue(t)
  });
}
const rk = /* @__PURE__ */ j("ZodIntersection", (e, t) => {
  I2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => Jm(e, r, a, n);
});
function tk(e, t) {
  return new rk({
    type: "intersection",
    left: e,
    right: t
  });
}
const Vn = /* @__PURE__ */ j("ZodEnum", (e, t) => {
  D2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (a, n, i) => Zm(e, a, n), e.enum = t.entries, e.options = Object.values(t.entries);
  const r = new Set(Object.keys(t.entries));
  e.extract = (a, n) => {
    const i = {};
    for (const s of a)
      if (r.has(s))
        i[s] = t.entries[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new Vn({
      ...t,
      checks: [],
      ...ue(n),
      entries: i
    });
  }, e.exclude = (a, n) => {
    const i = { ...t.entries };
    for (const s of a)
      if (r.has(s))
        delete i[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new Vn({
      ...t,
      checks: [],
      ...ue(n),
      entries: i
    });
  };
});
function ak(e, t) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((a) => [a, a])) : e;
  return new Vn({
    type: "enum",
    entries: r,
    ...ue(t)
  });
}
const nk = /* @__PURE__ */ j("ZodTransform", (e, t) => {
  R2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => jm(e, r), e._zod.parse = (r, a) => {
    if (a.direction === "backward")
      throw new bc(e.constructor.name);
    r.addIssue = (i) => {
      if (typeof i == "string")
        r.issues.push(ma(i, r.value, t));
      else {
        const s = i;
        s.fatal && (s.continue = !1), s.code ?? (s.code = "custom"), s.input ?? (s.input = r.value), s.inst ?? (s.inst = e), r.issues.push(ma(s));
      }
    };
    const n = t.transform(r.value, r);
    return n instanceof Promise ? n.then((i) => (r.value = i, r)) : (r.value = n, r);
  };
});
function ik(e) {
  return new nk({
    type: "transform",
    transform: e
  });
}
const of = /* @__PURE__ */ j("ZodOptional", (e, t) => {
  Qc.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => sf(e, r, a, n), e.unwrap = () => e._zod.def.innerType;
});
function Ji(e) {
  return new of({
    type: "optional",
    innerType: e
  });
}
const sk = /* @__PURE__ */ j("ZodExactOptional", (e, t) => {
  N2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => sf(e, r, a, n), e.unwrap = () => e._zod.def.innerType;
});
function ck(e) {
  return new sk({
    type: "optional",
    innerType: e
  });
}
const fk = /* @__PURE__ */ j("ZodNullable", (e, t) => {
  b2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => qm(e, r, a, n), e.unwrap = () => e._zod.def.innerType;
});
function qi(e) {
  return new fk({
    type: "nullable",
    innerType: e
  });
}
const ok = /* @__PURE__ */ j("ZodDefault", (e, t) => {
  P2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => e_(e, r, a, n), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function uk(e, t) {
  return new ok({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Bc(t);
    }
  });
}
const lk = /* @__PURE__ */ j("ZodPrefault", (e, t) => {
  L2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => r_(e, r, a, n), e.unwrap = () => e._zod.def.innerType;
});
function hk(e, t) {
  return new lk({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Bc(t);
    }
  });
}
const uf = /* @__PURE__ */ j("ZodNonOptional", (e, t) => {
  M2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => Qm(e, r, a, n), e.unwrap = () => e._zod.def.innerType;
});
function xk(e, t) {
  return new uf({
    type: "nonoptional",
    innerType: e,
    ...ue(t)
  });
}
const dk = /* @__PURE__ */ j("ZodCatch", (e, t) => {
  B2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => t_(e, r, a, n), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function pk(e, t) {
  return new dk({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const vk = /* @__PURE__ */ j("ZodPipe", (e, t) => {
  U2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => a_(e, r, a, n), e.in = t.in, e.out = t.out;
});
function Qi(e, t) {
  return new vk({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const gk = /* @__PURE__ */ j("ZodReadonly", (e, t) => {
  z2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => n_(e, r, a, n), e.unwrap = () => e._zod.def.innerType;
});
function mk(e) {
  return new gk({
    type: "readonly",
    innerType: e
  });
}
const _k = /* @__PURE__ */ j("ZodCustom", (e, t) => {
  $2.init(e, t), Me.init(e, t), e._zod.processJSONSchema = (r, a, n) => Gm(e, r);
});
function kk(e, t = {}) {
  return /* @__PURE__ */ bm(_k, e, t);
}
function Ek(e) {
  return /* @__PURE__ */ Pm(e);
}
const za = ca().optional().transform((e) => e == null ? void 0 : Math.round(e * 100)), Tk = Fa({
  userId: Pr().nonempty({ message: "User is required" }),
  inForCtp: Ki().optional(),
  inForAce: Ki().optional(),
  score: ca().optional(),
  incomingTagId: ca({ message: "Incoming tag is required" }),
  outgoingTagId: ca().optional()
}), Uk = Fa({
  name: Pr().nonempty({ message: "Name is required" }),
  notes: Pr().optional(),
  completed: Y_().optional(),
  players: Ha(Tk).optional(),
  ctpStartingBalance: za,
  aceStartingBalance: za,
  ctpPerPlayer: za,
  acePerPlayer: za,
  ctpUserIds: Ha(Pr()).optional(),
  aceUserIds: Ha(Pr()).optional(),
  ctpHole: ca().optional()
}), zk = Fa({
  phoneNumber: Pr().nonempty({ message: "Phone number is required" }).regex(/^\d{10}$/, { message: "Invalid phone number" })
}), $k = Fa({
  code: Pr().nonempty({ message: "Code is required" })
}), Vk = Fa({
  name: Pr().nonempty({ message: "Name is required" }),
  udiscId: Pr().optional(),
  pdgaNumber: Pr().optional(),
  imageUrl: Pr().optional()
}), wk = 1e3, Ak = 60 * wk, Hk = 60 * Ak;
function Wk(e) {
  const t = e.replace(/\D/g, "");
  return t.startsWith("1") && t.length === 11 ? `+${t}` : t.length === 10 ? `+1${t}` : e.startsWith("+") ? e : `+${t}`;
}
function Zk(e) {
  return typeof e != "string" ? !1 : (
    // @ts-expect-error this function DOES accept strings
    !isNaN(e) && !isNaN(parseFloat(e))
  );
}
function Fk(e, t, r = "en") {
  if (typeof t == "string")
    return Fk(e, [t, `${t}s`], r);
  const a = new Intl.PluralRules(r).select(e), [n, i] = t;
  return a === "one" ? n : i;
}
function Gk(e, t = {}) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...t
  }).format(e / 100);
}
export {
  Cf as ApiError,
  yk as FetchHttpClient,
  Hk as HOUR,
  Ak as MINUTE,
  wk as SECOND,
  Rf as calculateEventAcePot,
  Rk as calculateEventAcePotIfNoWinners,
  Df as calculateEventCtpPot,
  Dk as calculateEventCtpPotIfNoWinners,
  bk as calculatePayoutSplit,
  Ok as createAuthApi,
  Ik as createEventApi,
  Lk as createImageKitApi,
  Mk as createUserApi,
  Tk as eventPlayerSchema,
  Uk as eventSchema,
  Ck as getNextCtpHole,
  Nk as isActiveEvent,
  Zk as isNumber,
  $k as loginCodeSchema,
  zk as loginPhoneSchema,
  ya as mapEvent,
  Of as mapEventPlayer,
  If as mapSeason,
  Cn as mapUser,
  gn as mapUserAuth,
  y0 as mapUserSeason,
  Wk as normalizePhoneNumber,
  Gk as penniesToUSD,
  Fk as pluralize,
  Pk as toEventSchemaInput,
  Bk as udisc,
  Vk as userSchema
};
